import { ɵɵdefineInjectable, Injectable, ElementRef, Directive, Renderer2, HostListener, HostBinding, forwardRef, Inject, Input, ContentChildren, EventEmitter, Optional, Self, Output, ChangeDetectorRef, ContentChild, Host, SkipSelf, SimpleChange, ɵɵinject, QueryList, NgZone, NgModule } from '@angular/core';
import { DOCUMENT, CommonModule } from '@angular/common';
import { util, MDCRippleFoundation } from '@material/ripple';
import { events, ponyfill, focusTrap } from '@material/dom';
import { NgControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject, ReplaySubject, merge } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { MDCCheckboxFoundation } from '@material/checkbox';
import { MDCChipFoundation, MDCChipSetFoundation } from '@material/chips';
import { util as util$1, cssClasses, MDCDialogFoundation } from '@material/dialog';
import { MDCDismissibleDrawerFoundation, MDCModalDrawerFoundation } from '@material/drawer';
import { strings, cssClasses as cssClasses$1, MDCListFoundation } from '@material/list';
import { MDCRadioFoundation } from '@material/radio';
import { MDCFloatingLabelFoundation } from '@material/floating-label';
import { MDCFormFieldFoundation } from '@material/form-field';
import { MDCIconButtonToggleFoundation } from '@material/icon-button';
import { MDCLinearProgressFoundation } from '@material/linear-progress';
import { strings as strings$1, cssClasses as cssClasses$3, DefaultFocusState, MDCMenuFoundation } from '@material/menu';
import { cssClasses as cssClasses$2, util as util$2, MDCMenuSurfaceFoundation, Corner } from '@material/menu-surface';
import { MDCNotchedOutlineFoundation } from '@material/notched-outline';
import { MDCLineRippleFoundation } from '@material/line-ripple';
import { strings as strings$2, cssClasses as cssClasses$4, MDCSelectFoundation } from '@material/select';
import { MDCSliderFoundation } from '@material/slider';
import { util as util$3, MDCSnackbarFoundation, numbers } from '@material/snackbar';
import { MDCSwitchFoundation } from '@material/switch';
import { MDCTabBarFoundation } from '@material/tab-bar';
import { util as util$4, MDCTabScrollerFoundation } from '@material/tab-scroller';
import { MDCTabFoundation } from '@material/tab';
import { MDCFadingTabIndicatorFoundation, MDCSlidingTabIndicatorFoundation } from '@material/tab-indicator';
import { NavigationEnd, Router, RouterLink, RouterLinkWithHref } from '@angular/router';
import { MDCTextFieldIconFoundation, MDCTextFieldHelperTextFoundation, MDCTextFieldFoundation } from '@material/textfield';
import { MDCShortTopAppBarFoundation, MDCFixedTopAppBarFoundation, MDCTopAppBarFoundation } from '@material/top-app-bar';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@angular/router';
function asBoolean(value) {
    return value != null && `${value}` !== 'false';
}
function asBooleanOrNull(value) {
    if (value == null)
        return value;
    return `${value}` !== 'false';
}
function asNumberOrNull(value) {
    if (value == null)
        return value;
    return +value;
}

const unlisteners = new Map();
class MdcEventRegistry {
    constructor() { }
    listen(renderer, type, listener, ref, options) {
        this.listenElm(renderer, type, listener, ref.nativeElement, options);
    }
    listenElm(renderer, type, listener, el, options) {
        el.addEventListener(type, listener, options);
        const unlistener = function () {
            el.removeEventListener(type, listener, options);
        };
        this.registerUnlisten(type, listener, unlistener);
    }
    registerUnlisten(type, listener, unlistener) {
        if (!unlisteners.has(type))
            unlisteners.set(type, new WeakMap());
        unlisteners.get(type).set(listener, unlistener);
    }
    unlisten(type, listener) {
        if (!unlisteners.has(type))
            return;
        const unlistenerMap = unlisteners.get(type);
        if (!unlistenerMap.has(listener))
            return;
        unlistenerMap.get(listener)();
        unlistenerMap.delete(listener);
    }
}
MdcEventRegistry.ɵfac = function MdcEventRegistry_Factory(t) { return new (t || MdcEventRegistry)(); };
MdcEventRegistry.ɵprov = ɵɵdefineInjectable({ factory: function MdcEventRegistry_Factory() { return new MdcEventRegistry(); }, token: MdcEventRegistry, providedIn: "root" });
MdcEventRegistry.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcEventRegistry, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/** @docs-private */
class AbstractMdcRipple {
    constructor(_rippleElm, _renderer, _registry, doc) {
        this._rippleElm = _rippleElm;
        this._renderer = _renderer;
        this._registry = _registry;
        this.mdcRippleAdapter = {
            browserSupportsCssVars: () => util.supportsCssVariables(this.document.defaultView),
            isUnbounded: () => this._unbounded,
            isSurfaceActive: () => this.isRippleSurfaceActive(),
            isSurfaceDisabled: () => this.isRippleSurfaceDisabled(),
            addClass: (className) => this.addClassToRipple(className),
            removeClass: (className) => this.removeClassFromRipple(className),
            containsEventTarget: (target) => this._rippleElm.nativeElement.contains(target),
            registerInteractionHandler: (type, handler) => {
                if (this.getRippleInteractionElement())
                    this._registry.listenElm(this._renderer, type, handler, this.getRippleInteractionElement().nativeElement, events.applyPassive());
            },
            deregisterInteractionHandler: (type, handler) => {
                this._registry.unlisten(type, handler);
            },
            registerDocumentInteractionHandler: (type, handler) => this._registry.listenElm(this._renderer, type, handler, this.document, events.applyPassive()),
            deregisterDocumentInteractionHandler: (type, handler) => this._registry.unlisten(type, handler),
            registerResizeHandler: (handler) => {
                this._registry.listenElm(this._renderer, 'resize', handler, this.document.defaultView);
            },
            deregisterResizeHandler: (handler) => {
                this._registry.unlisten('resize', handler);
            },
            updateCssVariable: (name, value) => { this.getRippleStylingElement().nativeElement.style.setProperty(name, value); },
            computeBoundingRect: () => this.computeRippleBoundingRect(),
            getWindowPageOffset: () => ({ x: this.document.defaultView.pageXOffset, y: this.document.defaultView.pageYOffset })
        };
        /** @internal */
        this._rippleFoundation = null;
        this._unbounded = false;
        this._rippleSurface = null;
        // workaround compiler bug when using ViewEngine. Type Document fails compilation
        this.document = doc;
    }
    /** @internal */
    initRipple(unbounded = false) {
        if (this._rippleFoundation)
            throw new Error('initRipple() is called multiple times');
        this._unbounded = unbounded;
        this._rippleFoundation = new MDCRippleFoundation(this.mdcRippleAdapter);
        this._rippleFoundation.init();
    }
    /** @internal */
    destroyRipple() {
        if (this._rippleFoundation) {
            this._rippleFoundation.destroy();
            this._rippleFoundation = null;
        }
    }
    /** @internal */
    reinitRipple() {
        if (this._rippleFoundation) {
            this.destroyRipple();
            this.initRipple(this._unbounded);
        }
    }
    /** @internal */
    isRippleInitialized() {
        return this._rippleFoundation != null;
    }
    /** @internal */
    addRippleSurface(clazz, firstElement = false) {
        this.destroyRippleSurface();
        this._rippleSurface = this._renderer.createElement('div');
        this._renderer.addClass(this._rippleSurface, clazz);
        if (firstElement && this._rippleElm.nativeElement.children.length > 0) {
            const firstChild = this._rippleElm.nativeElement.children.item(0);
            this._renderer.insertBefore(this._rippleElm.nativeElement, this._rippleSurface, firstChild);
        }
        else
            this._renderer.appendChild(this._rippleElm.nativeElement, this._rippleSurface);
        return this._rippleSurface;
    }
    /** @internal */
    destroyRippleSurface() {
        if (this._rippleSurface) {
            this._renderer.removeChild(this._rippleElm.nativeElement, this._rippleSurface);
            this._rippleSurface = null;
        }
    }
    activateRipple() {
        if (this._rippleFoundation)
            this._rippleFoundation.activate();
    }
    deactivateRipple() {
        if (this._rippleFoundation)
            this._rippleFoundation.deactivate();
    }
    layout() {
        if (this._rippleFoundation)
            this._rippleFoundation.layout();
    }
    get rippleSurface() {
        return new ElementRef(this._rippleSurface);
    }
    getRippleInteractionElement() {
        return this._rippleElm;
    }
    getRippleStylingElement() {
        return this._rippleElm;
    }
    isRippleUnbounded() {
        return this._unbounded;
    }
    /** @internal */
    setRippleUnbounded(value) {
        if (!!value !== this._unbounded) {
            this._unbounded = !!value;
            // despite what the documentation seems to indicate, you can't
            // just change the unbounded property of an already initialized
            // ripple. The initialization registers different handlers, and won't
            // change those registrations when you change the unbounded property.
            // Hence we destroy and re-init the whole thing:
            this.reinitRipple();
        }
    }
    isRippleSurfaceActive() {
        let interactionElm = this.getRippleInteractionElement();
        return !!interactionElm && this.isActiveElement(interactionElm.nativeElement);
    }
    isActiveElement(element) {
        return element == null ? false : ponyfill.matches(element, ':active');
    }
    isRippleSurfaceDisabled() {
        let interactionElm = this.getRippleInteractionElement();
        return !!interactionElm && !!interactionElm.nativeElement.attributes.getNamedItem('disabled');
    }
    /** @internal */
    addClassToRipple(name) {
        this._renderer.addClass(this.getRippleStylingElement().nativeElement, name);
    }
    /** @internal */
    removeClassFromRipple(name) {
        this._renderer.removeClass(this.getRippleStylingElement().nativeElement, name);
    }
    computeRippleBoundingRect() {
        return this._rippleElm.nativeElement.getBoundingClientRect();
    }
    /** @internal */
    onFocus() {
        if (this._rippleFoundation)
            this._rippleFoundation.handleFocus();
    }
    /** @internal */
    onBlur() {
        if (this._rippleFoundation)
            this._rippleFoundation.handleBlur();
    }
}
AbstractMdcRipple.ɵfac = function AbstractMdcRipple_Factory(t) { return new (t || AbstractMdcRipple)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(undefined)); };
AbstractMdcRipple.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AbstractMdcRipple, hostBindings: function AbstractMdcRipple_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focusin", function AbstractMdcRipple_focusin_HostBindingHandler() { return ctx.onFocus(); })("focusout", function AbstractMdcRipple_focusout_HostBindingHandler() { return ctx.onBlur(); });
    } } });
AbstractMdcRipple.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: MdcEventRegistry },
    { type: undefined }
];
AbstractMdcRipple.propDecorators = {
    onFocus: [{ type: HostListener, args: ['focusin',] }],
    onBlur: [{ type: HostListener, args: ['focusout',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbstractMdcRipple, [{
        type: Directive
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: MdcEventRegistry }, { type: undefined }]; }, { 
    /** @internal */
    onFocus: [{
            type: HostListener,
            args: ['focusin']
        }], 
    /** @internal */
    onBlur: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();

/**
 * Use this directive for adding an icon to an <code>mdcButton</code>. This directive can be
 * added to font-style icons (such as <a href="https://material.io/icons/" target="_blank">material icons</a>
 * from Google fonts), or with <code>svg</code> elements for svg based icons.
 */
class MdcButtonIconDirective {
    constructor() {
        /** @internal */
        this._cls = true;
        /** @internal */
        this._ariaHidden = true;
    }
}
MdcButtonIconDirective.ɵfac = function MdcButtonIconDirective_Factory(t) { return new (t || MdcButtonIconDirective)(); };
MdcButtonIconDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcButtonIconDirective, selectors: [["", "mdcButtonIcon", ""]], hostVars: 3, hostBindings: function MdcButtonIconDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-hidden", ctx._ariaHidden);
        ɵngcc0.ɵɵclassProp("mdc-button__icon", ctx._cls);
    } } });
MdcButtonIconDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-button__icon',] }],
    _ariaHidden: [{ type: HostBinding, args: ['attr.aria-hidden',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcButtonIconDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcButtonIcon]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-button__icon']
        }], _ariaHidden: [{
            type: HostBinding,
            args: ['attr.aria-hidden']
        }] }); })();
/**
 * Directive for the label of an <code>mdcButton</code>. Must be a direct child
 * of <code>mdcButton</code>.
 */
class MdcButtonLabelDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcButtonLabelDirective.ɵfac = function MdcButtonLabelDirective_Factory(t) { return new (t || MdcButtonLabelDirective)(); };
MdcButtonLabelDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcButtonLabelDirective, selectors: [["", "mdcButtonLabel", ""]], hostVars: 2, hostBindings: function MdcButtonLabelDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-button__label", ctx._cls);
    } } });
MdcButtonLabelDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-button__label',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcButtonLabelDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcButtonLabel]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-button__label']
        }] }); })();
/**
 * Material design button. Anchors can also be styled as buttons with this directive.
 * Defaults to a button that is flushed with the surface.
 * Use the input modifiers to alter the styling, or create your own style
 * based on the provided sass-mixins.
 *
 * For buttons with a trailing icon, you must put the label inside an `mdcButtonLabel`
 * directive. For all other buttons it is also recommnded to put the label inside
 * an `mdcButtonLabel`, because future version of material-components-web may make
 * it's use mandatory.
 *
 * A ripple (and the required DOM elements for the ripple) will be added automatically.
 */
class MdcButtonDirective extends AbstractMdcRipple {
    constructor(_elm, renderer, registry, doc) {
        super(_elm, renderer, registry, doc);
        this._elm = _elm;
        /** @internal */
        this._cls = true;
        this._raised = false;
        this._unelevated = false;
        this._outlined = false;
        this.addRippleSurface('mdc-button__ripple');
    }
    ngAfterContentInit() {
        this.initRipple();
    }
    ngOnDestroy() {
        this.destroyRipple();
    }
    /**
     * When this input is defined and does not have value false, the button will be elevated
     * upon the surface.
     */
    get raised() {
        return this._raised;
    }
    set raised(val) {
        this._raised = asBoolean(val);
    }
    /**
     * When this input is defined and does not have value false, the button will be styled
     * flush with the surface and have a visible border.
     */
    get outlined() {
        return this._outlined;
    }
    set outlined(val) {
        this._outlined = asBoolean(val);
    }
    /**
     * Set this property to a non false value for a contained button
     * flush with the surface.
     */
    get unelevated() {
        return this._unelevated;
    }
    set unelevated(val) {
        this._unelevated = asBoolean(val);
    }
}
MdcButtonDirective.ɵfac = function MdcButtonDirective_Factory(t) { return new (t || MdcButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcButtonDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcButtonDirective, selectors: [["button", "mdcButton", ""], ["a", "mdcButton", ""]], hostVars: 8, hostBindings: function MdcButtonDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-button", ctx._cls)("mdc-button--raised", ctx.raised)("mdc-button--outlined", ctx.outlined)("mdc-button--unelevated", ctx.unelevated);
    } }, inputs: { raised: "raised", outlined: "outlined", unelevated: "unelevated" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: AbstractMdcRipple, useExisting: forwardRef(() => MdcButtonDirective) }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcButtonDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: MdcEventRegistry },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcButtonDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-button',] }],
    raised: [{ type: HostBinding, args: ['class.mdc-button--raised',] }, { type: Input }],
    outlined: [{ type: HostBinding, args: ['class.mdc-button--outlined',] }, { type: Input }],
    unelevated: [{ type: HostBinding, args: ['class.mdc-button--unelevated',] }, { type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'button[mdcButton],a[mdcButton]',
                providers: [{ provide: AbstractMdcRipple, useExisting: forwardRef(() => MdcButtonDirective) }]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: MdcEventRegistry }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-button']
        }], raised: [{
            type: HostBinding,
            args: ['class.mdc-button--raised']
        }, {
            type: Input
        }], outlined: [{
            type: HostBinding,
            args: ['class.mdc-button--outlined']
        }, {
            type: Input
        }], unelevated: [{
            type: HostBinding,
            args: ['class.mdc-button--unelevated']
        }, {
            type: Input
        }] }); })();
const BUTTON_DIRECTIVES = [
    MdcButtonIconDirective,
    MdcButtonLabelDirective,
    MdcButtonDirective
];

/** @docs-private */
class AbstractMdcIcon extends AbstractMdcRipple {
    constructor(_elm, renderer, registry, doc) {
        super(_elm, renderer, registry, doc);
        this._elm = _elm;
    }
}
AbstractMdcIcon.ɵfac = function AbstractMdcIcon_Factory(t) { return new (t || AbstractMdcIcon)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
AbstractMdcIcon.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AbstractMdcIcon, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
AbstractMdcIcon.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: MdcEventRegistry },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbstractMdcIcon, [{
        type: Directive
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: MdcEventRegistry }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

/**
 * Directive for an area that displays a custom background-image. See the <code>size</code>
 * property for the sizing of the image.
 * If used, this directive should be put inside the card itself (<code>MdcCardDirective</code>).
 * Add an <code>mdcCardMediaContent</code> as sub-element for displaying a title, text,
 * or icon on top of the background image.
 */
class MdcCardMediaDirective {
    constructor() {
        /** @internal */
        this._cls = true;
        this._size = 'cover';
    }
    /** @internal */
    get _square() {
        return this._size === 'square';
    }
    /** @internal */
    get _size2() {
        return this._size === '16:9';
    }
    /**
     * Directive to select size to which this element's background-image should
     * be scaled. Can be one of 'cover', '16:9', or 'square'. The default value
     * is 'cover'.
     */
    get size() {
        return this._size;
    }
    set size(val) {
        this._size = val;
    }
}
MdcCardMediaDirective.ɵfac = function MdcCardMediaDirective_Factory(t) { return new (t || MdcCardMediaDirective)(); };
MdcCardMediaDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcCardMediaDirective, selectors: [["", "mdcCardMedia", ""]], hostVars: 6, hostBindings: function MdcCardMediaDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-card__media", ctx._cls)("mdc-card__media--square", ctx._square)("mdc-card__media--16-9", ctx._size2);
    } }, inputs: { size: "size" } });
MdcCardMediaDirective.ctorParameters = () => [];
MdcCardMediaDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-card__media',] }],
    _square: [{ type: HostBinding, args: ['class.mdc-card__media--square',] }],
    _size2: [{ type: HostBinding, args: ['class.mdc-card__media--16-9',] }],
    size: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcCardMediaDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcCardMedia]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-card__media']
        }], _square: [{
            type: HostBinding,
            args: ['class.mdc-card__media--square']
        }], _size2: [{
            type: HostBinding,
            args: ['class.mdc-card__media--16-9']
        }], size: [{
            type: Input
        }] }); })();
/**
 * Directive for displaying text on top of a <code>mdcCardMedia</code> element.
 * This directive should be used as child element of the <code>mdcCardMedia</code>, and
 * creates an absolutely positioned box the same size as the media area.
 */
class MdcCardMediaContentDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcCardMediaContentDirective.ɵfac = function MdcCardMediaContentDirective_Factory(t) { return new (t || MdcCardMediaContentDirective)(); };
MdcCardMediaContentDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcCardMediaContentDirective, selectors: [["", "mdcCardMediaContent", ""]], hostVars: 2, hostBindings: function MdcCardMediaContentDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-card__media-content", ctx._cls);
    } } });
MdcCardMediaContentDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-card__media-content',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcCardMediaContentDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcCardMediaContent]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-card__media-content']
        }] }); })();
/**
 * Directive for displaying the button card actions. Composed of one or more
 * card actions, which must be buttons that have the <code>MdcButtonDirective</code>.
 * This directive should be placed inside an <code>MdcCardActionsDirective</code>.
 */
class MdcCardActionButtonsDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcCardActionButtonsDirective.ɵfac = function MdcCardActionButtonsDirective_Factory(t) { return new (t || MdcCardActionButtonsDirective)(); };
MdcCardActionButtonsDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcCardActionButtonsDirective, selectors: [["", "mdcCardActionButtons", ""]], hostVars: 2, hostBindings: function MdcCardActionButtonsDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-card__action-buttons", ctx._cls);
    } } });
MdcCardActionButtonsDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-card__action-buttons',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcCardActionButtonsDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcCardActionButtons]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-card__action-buttons']
        }] }); })();
/**
 * Directive for displaying the icon card actions. Composed of one or more
 * card actions, which must be icons (for instance <code>mdcIconButton</code>.
 * This directive should be placed inside an <code>MdcCardActionsDirective</code>.
 */
class MdcCardActionIconsDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcCardActionIconsDirective.ɵfac = function MdcCardActionIconsDirective_Factory(t) { return new (t || MdcCardActionIconsDirective)(); };
MdcCardActionIconsDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcCardActionIconsDirective, selectors: [["", "mdcCardActionIcons", ""]], hostVars: 2, hostBindings: function MdcCardActionIconsDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-card__action-icons", ctx._cls);
    } } });
MdcCardActionIconsDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-card__action-icons',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcCardActionIconsDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcCardActionIcons]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-card__action-icons']
        }] }); })();
/**
 * Directive for showing the different actions a user can take. Use
 * <code>mdcButton</code>, or <code>mdcIconButton</code> as child elements.
 * If you want to use both buttons and icons in the same row, wrap them in
 * <code>mdcCardActionButtons</code>, and <code>mdcCardActionIcons</code> directives.
 */
class MdcCardActionsDirective {
    constructor(renderer) {
        this.renderer = renderer;
        /** @internal */
        this._cls = true;
        this._initialized = false;
        this._fullBleed = false;
    }
    ngAfterContentInit() {
        this._initialized = true;
        this._initButtons();
        this._initIcons();
        this._buttons.changes.subscribe(() => {
            this._initButtons();
        });
        this._icons.changes.subscribe(() => {
            this._initIcons();
        });
    }
    _initButtons() {
        if (this._initialized)
            this._buttons.forEach(btn => {
                this.renderer.addClass(btn._elm.nativeElement, 'mdc-card__action');
                this.renderer.addClass(btn._elm.nativeElement, 'mdc-card__action--button');
            });
    }
    _initIcons() {
        if (this._initialized)
            this._icons.forEach(icon => {
                this.renderer.addClass(icon._elm.nativeElement, 'mdc-card__action');
                this.renderer.addClass(icon._elm.nativeElement, 'mdc-card__action--icon');
            });
    }
    /**
     * When this input is defined and does not have value false, the contained
     * button takes up the entire width of the action row. This should be used only when
     * there is a single button contained in the directive.
     */
    get fullBleed() {
        return this._fullBleed;
    }
    set fullBleed(val) {
        this._fullBleed = asBoolean(val);
    }
}
MdcCardActionsDirective.ɵfac = function MdcCardActionsDirective_Factory(t) { return new (t || MdcCardActionsDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
MdcCardActionsDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcCardActionsDirective, selectors: [["", "mdcCardActions", ""]], contentQueries: function MdcCardActionsDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcButtonDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, AbstractMdcIcon, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._buttons = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._icons = _t);
    } }, hostVars: 4, hostBindings: function MdcCardActionsDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-card__actions", ctx._cls)("mdc-card__actions--full-bleed", ctx.fullBleed);
    } }, inputs: { fullBleed: "fullBleed" } });
MdcCardActionsDirective.ctorParameters = () => [
    { type: Renderer2 }
];
MdcCardActionsDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-card__actions',] }],
    _buttons: [{ type: ContentChildren, args: [MdcButtonDirective, { descendants: true },] }],
    _icons: [{ type: ContentChildren, args: [AbstractMdcIcon, { descendants: true },] }],
    fullBleed: [{ type: HostBinding, args: ['class.mdc-card__actions--full-bleed',] }, { type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcCardActionsDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcCardActions]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-card__actions']
        }], fullBleed: [{
            type: HostBinding,
            args: ['class.mdc-card__actions--full-bleed']
        }, {
            type: Input
        }], _buttons: [{
            type: ContentChildren,
            args: [MdcButtonDirective, { descendants: true }]
        }], _icons: [{
            type: ContentChildren,
            args: [AbstractMdcIcon, { descendants: true }]
        }] }); })();
/**
 * Directive for the main tappable area of the card (so should be a child of <code>mdcCard</code>).
 * Typically contains most (or all) card content except <code>mdcCardActions</code>.
 * Only applicable to cards that have a primary action that the main surface should trigger.
 */
class MdcCardPrimaryActionDirective extends AbstractMdcRipple {
    constructor(elm, renderer, registry, doc) {
        super(elm, renderer, registry, doc);
        this.elm = elm;
        /** @internal */
        this._cls = true;
    }
    ngAfterContentInit() {
        if (!this.elm.nativeElement.hasAttribute('tabindex'))
            // unless overridden, make the action tabbable:
            this.elm.nativeElement.tabIndex = 0;
        this.initRipple();
    }
    ngOnDestroy() {
        this.destroyRipple();
    }
}
MdcCardPrimaryActionDirective.ɵfac = function MdcCardPrimaryActionDirective_Factory(t) { return new (t || MdcCardPrimaryActionDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcCardPrimaryActionDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcCardPrimaryActionDirective, selectors: [["", "mdcCardPrimaryAction", ""]], hostVars: 2, hostBindings: function MdcCardPrimaryActionDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-card__primary-action", ctx._cls);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcCardPrimaryActionDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: MdcEventRegistry },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcCardPrimaryActionDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-card__primary-action',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcCardPrimaryActionDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcCardPrimaryAction]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: MdcEventRegistry }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-card__primary-action']
        }] }); })();
/**
 * Directive for a material designed card. The card can be composed with the following directives:
 * <code>MdcCardMediaDirective</code>, <code>MdcCardActionsDirective</code>
 */
class MdcCardDirective {
    constructor() {
        /** @internal */
        this._cls = true;
        this._outlined = false;
    }
    /**
     * When this input is set to a value other than false, the card will have a
     * hairline stroke instead of a shadow.
     */
    get outlined() {
        return this._outlined;
    }
    set outlined(val) {
        this._outlined = asBoolean(val);
    }
}
MdcCardDirective.ɵfac = function MdcCardDirective_Factory(t) { return new (t || MdcCardDirective)(); };
MdcCardDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcCardDirective, selectors: [["", "mdcCard", ""]], hostVars: 4, hostBindings: function MdcCardDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-card", ctx._cls)("mdc-card--outlined", ctx.outlined);
    } }, inputs: { outlined: "outlined" } });
MdcCardDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-card',] }],
    outlined: [{ type: HostBinding, args: ['class.mdc-card--outlined',] }, { type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcCardDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcCard]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-card']
        }], outlined: [{
            type: HostBinding,
            args: ['class.mdc-card--outlined']
        }, {
            type: Input
        }] }); })();
const CARD_DIRECTIVES = [
    MdcCardMediaDirective,
    MdcCardMediaContentDirective,
    MdcCardActionButtonsDirective,
    MdcCardActionIconsDirective,
    MdcCardActionsDirective,
    MdcCardPrimaryActionDirective,
    MdcCardDirective
];

/** @docs-private */
class AbstractMdcInput {
}

/**
 * Directive for the input element of an <code>MdcCheckboxDirective</code>.
 */
class MdcCheckboxInputDirective extends AbstractMdcInput {
    constructor(_elm, _cntr) {
        super();
        this._elm = _elm;
        this._cntr = _cntr;
        /** @internal */
        this._cls = true;
        this.onDestroy$ = new Subject();
        this._id = null;
        this._disabled = false;
        this._checked = false;
        this._indeterminate = false;
        /** @internal */
        this._checkedChange = new EventEmitter();
        /** @internal */
        this._indeterminateChange = new EventEmitter();
        /** @internal */
        this._disabledChange = new EventEmitter();
    }
    ngOnInit() {
        var _a;
        (_a = this._cntr) === null || _a === void 0 ? void 0 : _a.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe((value) => {
            this.updateValue(value, true);
        });
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
    /** @docs-private */
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    /** @docs-private */
    get disabled() {
        return this._cntr ? !!this._cntr.disabled : this._disabled;
    }
    set disabled(value) {
        const newVal = asBoolean(value);
        if (newVal != this._disabled) {
            this._disabled = asBoolean(newVal);
            this._disabledChange.emit(newVal);
        }
    }
    /** @docs-private */
    get checked() {
        return this._checked;
    }
    set checked(value) {
        this.updateValue(value, false);
    }
    updateValue(value, fromControl) {
        // When the 'checked' property is the source of the change, we want to coerce boolean
        // values using asBoolean, so that initializing with an attribute with no value works
        // as expected.
        // When the NgControl is the source of the change we don't want that. The value should
        // be interpreted like NgControl/NgForms handles non-boolean values when binding.
        const newVal = fromControl ? !!value : asBoolean(value);
        if (newVal !== this._checked) {
            this._checked = newVal;
            this._checkedChange.emit(newVal);
        }
        if (!fromControl && this._cntr && newVal !== this._cntr.value) {
            this._cntr.control.setValue(newVal);
        }
    }
    /** @docs-private */
    get indeterminate() {
        return this._indeterminate;
    }
    set indeterminate(value) {
        const newVal = asBoolean(value);
        if (newVal !== this._indeterminate) {
            this._indeterminate = newVal;
            Promise.resolve().then(() => this._indeterminateChange.emit(newVal));
        }
    }
    // We listen to click-event instead of change-event, because IE doesn't fire the
    // change-event when an indeterminate checkbox is clicked. There's no need to
    // also listen to change-events.
    _onChange() {
        // only update the checked state from click if there is no control for which we already
        // listen to value changes:
        if (!this._cntr)
            this.checked = this._elm.nativeElement.checked;
        this.indeterminate = this._elm.nativeElement.indeterminate;
    }
}
MdcCheckboxInputDirective.ɵfac = function MdcCheckboxInputDirective_Factory(t) { return new (t || MdcCheckboxInputDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgControl, 10)); };
MdcCheckboxInputDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcCheckboxInputDirective, selectors: [["input", "mdcCheckboxInput", "", "type", "checkbox"]], hostVars: 6, hostBindings: function MdcCheckboxInputDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MdcCheckboxInputDirective_click_HostBindingHandler() { return ctx._onChange(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("id", ctx.id)("disabled", ctx.disabled)("checked", ctx.checked)("indeterminate", ctx.indeterminate);
        ɵngcc0.ɵɵclassProp("mdc-checkbox__native-control", ctx._cls);
    } }, inputs: { id: "id", disabled: "disabled", checked: "checked", indeterminate: "indeterminate" }, outputs: { _checkedChange: "_checkedChange", _indeterminateChange: "_indeterminateChange", _disabledChange: "_disabledChange" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: AbstractMdcInput, useExisting: forwardRef(() => MdcCheckboxInputDirective) }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcCheckboxInputDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }] }
];
MdcCheckboxInputDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-checkbox__native-control',] }],
    _checkedChange: [{ type: Output }],
    _indeterminateChange: [{ type: Output }],
    _disabledChange: [{ type: Output }],
    id: [{ type: HostBinding }, { type: Input }],
    disabled: [{ type: HostBinding }, { type: Input }],
    checked: [{ type: HostBinding }, { type: Input }],
    indeterminate: [{ type: HostBinding }, { type: Input }],
    _onChange: [{ type: HostListener, args: ['click',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcCheckboxInputDirective, [{
        type: Directive,
        args: [{
                selector: 'input[mdcCheckboxInput][type=checkbox]',
                providers: [{ provide: AbstractMdcInput, useExisting: forwardRef(() => MdcCheckboxInputDirective) }]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-checkbox__native-control']
        }], _checkedChange: [{
            type: Output
        }], _indeterminateChange: [{
            type: Output
        }], _disabledChange: [{
            type: Output
        }], id: [{
            type: HostBinding
        }, {
            type: Input
        }], disabled: [{
            type: HostBinding
        }, {
            type: Input
        }], checked: [{
            type: HostBinding
        }, {
            type: Input
        }], indeterminate: [{
            type: HostBinding
        }, {
            type: Input
        }], 
    // We listen to click-event instead of change-event, because IE doesn't fire the
    // change-event when an indeterminate checkbox is clicked. There's no need to
    // also listen to change-events.
    _onChange: [{
            type: HostListener,
            args: ['click']
        }] }); })();
/**
 * Directive for creating a Material Design checkbox. The checkbox is driven by an
 * underlying native checkbox input, which must use the <code>MdcCheckboxInputDirective</code>
 * directive.
 * The current implementation will add all other required DOM elements (such as the
 * background and ripple).
 * Future implementations will also support supplying (customized) background
 * elements.
 *
 * This directive can be used together with an <code>mdcFormField</code> to
 * easily position checkboxes and their labels, see
 * <a href="/components/form-field">mdcFormField</a>.
 */
class MdcCheckboxDirective extends AbstractMdcRipple {
    constructor(renderer, root, registry, doc) {
        super(root, renderer, registry, doc);
        this.root = root;
        /** @internal */
        this._cls = true;
        this.onDestroy$ = new Subject();
        this.onInputChange$ = new Subject();
        this.mdcAdapter = {
            addClass: (className) => this._renderer.addClass(this.root.nativeElement, className),
            removeClass: (className) => this._renderer.removeClass(this.root.nativeElement, className),
            setNativeControlAttr: (attr, value) => this._renderer.setAttribute(this._input._elm.nativeElement, attr, value),
            removeNativeControlAttr: (attr) => this._renderer.removeAttribute(this._input._elm.nativeElement, attr),
            forceLayout: () => this.root.nativeElement.offsetWidth,
            isAttachedToDOM: () => !!this._input,
            hasNativeControl: () => !!this._input,
            isChecked: () => this._input._elm.nativeElement.checked,
            isIndeterminate: () => this._input._elm.nativeElement.indeterminate,
            setNativeControlDisabled: (disabled) => this._input.disabled = disabled
        };
        /** @internal */
        this._foundation = null;
        this.addRippleSurface('mdc-checkbox__ripple');
    }
    ngAfterContentInit() {
        MdcCheckboxDirective.addBackground(this._rippleElm, this._renderer);
        this.initRipple(true);
        if (this._input) {
            this._foundation = new MDCCheckboxFoundation(this.mdcAdapter);
            this._foundation.init();
        }
        this._inputs.changes.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.reinitRipple();
            if (this._foundation)
                this._foundation.destroy();
            if (this._input) {
                this._foundation = new MDCCheckboxFoundation(this.mdcAdapter);
                this._foundation.init();
            }
            else
                this._foundation = null;
            this.subscribeInputChanges();
        });
        this.subscribeInputChanges();
    }
    ngOnDestroy() {
        this.onInputChange$.next();
        this.onInputChange$.complete();
        this.onDestroy$.next();
        this.onDestroy$.complete();
        if (this._foundation) {
            this._foundation.destroy();
            this._foundation = null;
        }
        this.destroyRipple();
    }
    subscribeInputChanges() {
        var _a, _b, _c;
        this.onInputChange$.next();
        (_a = this._input) === null || _a === void 0 ? void 0 : _a._indeterminateChange.asObservable().pipe(takeUntil(this.onInputChange$)).subscribe(() => { var _a; return (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.handleChange(); });
        (_b = this._input) === null || _b === void 0 ? void 0 : _b._checkedChange.asObservable().pipe(takeUntil(this.onInputChange$)).subscribe(() => { var _a; return (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.handleChange(); });
        (_c = this._input) === null || _c === void 0 ? void 0 : _c._disabledChange.asObservable().pipe(takeUntil(this.onInputChange$)).subscribe(val => { var _a; return (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.setDisabled(val); });
    }
    static addBackground(elm, renderer) {
        let path = renderer.createElement('path', 'svg');
        renderer.addClass(path, 'mdc-checkbox__checkmark-path');
        renderer.setAttribute(path, 'fill', 'none');
        renderer.setAttribute(path, 'd', 'M1.73,12.91 8.1,19.28 22.79,4.59');
        let svg = renderer.createElement('svg', 'svg');
        renderer.appendChild(svg, path);
        renderer.addClass(svg, 'mdc-checkbox__checkmark');
        renderer.setAttribute(svg, 'viewBox', '0 0 24 24');
        let mixedmark = renderer.createElement('div');
        renderer.addClass(mixedmark, 'mdc-checkbox__mixedmark');
        let bg = renderer.createElement('div');
        renderer.appendChild(bg, svg);
        renderer.appendChild(bg, mixedmark);
        renderer.addClass(bg, 'mdc-checkbox__background');
        renderer.appendChild(elm.nativeElement, bg);
    }
    /** @internal */
    getRippleInteractionElement() {
        var _a;
        return (_a = this._input) === null || _a === void 0 ? void 0 : _a._elm;
    }
    /** @internal */
    onAnimationEnd() {
        var _a;
        (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.handleAnimationEnd();
    }
    /** @internal */
    get _input() {
        return this._inputs && this._inputs.length > 0 ? this._inputs.first : null;
    }
}
MdcCheckboxDirective.ɵfac = function MdcCheckboxDirective_Factory(t) { return new (t || MdcCheckboxDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcCheckboxDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcCheckboxDirective, selectors: [["", "mdcCheckbox", ""]], contentQueries: function MdcCheckboxDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcCheckboxInputDirective, false);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._inputs = _t);
    } }, hostVars: 2, hostBindings: function MdcCheckboxDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("animationend", function MdcCheckboxDirective_animationend_HostBindingHandler() { return ctx.onAnimationEnd(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-checkbox", ctx._cls);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcCheckboxDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: MdcEventRegistry },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcCheckboxDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-checkbox',] }],
    _inputs: [{ type: ContentChildren, args: [MdcCheckboxInputDirective,] }],
    onAnimationEnd: [{ type: HostListener, args: ['animationend',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcCheckboxDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcCheckbox]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: MdcEventRegistry }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-checkbox']
        }], 
    /** @internal */
    onAnimationEnd: [{
            type: HostListener,
            args: ['animationend']
        }], _inputs: [{
            type: ContentChildren,
            args: [MdcCheckboxInputDirective]
        }] }); })();
const CHECKBOX_DIRECTIVES = [
    MdcCheckboxInputDirective,
    MdcCheckboxDirective
];

/**
 * @license
 * Copyright 2020 Google Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
/**
 * Priorities for the announce function
 */
var AnnouncerPriority;
(function (AnnouncerPriority) {
    AnnouncerPriority["POLITE"] = "polite";
    AnnouncerPriority["ASSERTIVE"] = "assertive";
})(AnnouncerPriority || (AnnouncerPriority = {}));
/**
 * Data attribute added to live region element.
 */
const DATA_MDC_DOM_ANNOUNCE = 'data-mdc-dom-announce';
/**
 * Announces the given message with optional priority, defaulting to "polite"
 */
function announce(message, priority) {
    Announcer.getInstance().say(message, priority);
}
class Announcer {
    // Constructor made private to ensure only the singleton is used
    constructor() {
        this.liveRegions = new Map();
    }
    static getInstance() {
        if (!Announcer.instance) {
            Announcer.instance = new Announcer();
        }
        return Announcer.instance;
    }
    say(message, priority = AnnouncerPriority.POLITE) {
        const liveRegion = this.getLiveRegion(priority);
        // Reset the region to pick up the message, even if the message is the
        // exact same as before.
        liveRegion.textContent = '';
        // Timeout is necessary for screen readers like NVDA and VoiceOver.
        setTimeout(() => {
            liveRegion.textContent = message;
            document.addEventListener('click', clearLiveRegion);
        }, 1);
        function clearLiveRegion() {
            liveRegion.textContent = '';
            document.removeEventListener('click', clearLiveRegion);
        }
    }
    getLiveRegion(priority) {
        const existingLiveRegion = this.liveRegions.get(priority);
        if (existingLiveRegion &&
            document.body.contains(existingLiveRegion)) {
            return existingLiveRegion;
        }
        const liveRegion = this.createLiveRegion(priority);
        this.liveRegions.set(priority, liveRegion);
        return liveRegion;
    }
    createLiveRegion(priority) {
        const el = document.createElement('div');
        el.style.position = 'absolute';
        el.style.top = '-9999px';
        el.style.left = '-9999px';
        el.style.height = '1px';
        el.style.overflow = 'hidden';
        el.setAttribute('aria-atomic', 'true');
        el.setAttribute('aria-live', priority);
        el.setAttribute(DATA_MDC_DOM_ANNOUNCE, 'true');
        document.body.appendChild(el);
        return el;
    }
}

var ChipEventSource;
(function (ChipEventSource) {
    ChipEventSource[ChipEventSource["primary"] = 0] = "primary";
    ChipEventSource[ChipEventSource["trailing"] = 1] = "trailing";
    ChipEventSource[ChipEventSource["none"] = 2] = "none";
})(ChipEventSource || (ChipEventSource = {}));
;
/**
 * Directive for the (optional) leading or trailing icon of an `mdcChip`.
 * Depending on the position within the `mdcChip` the icon will determine
 * whether it is a leading or trailing icon.
 * Trailing icons must implement the functionality to remove the chip from the set, and
 * must only be added to input chips (`mdcChipSet="input"`). Chips with a trailing
 * icon must implement the `remove` event. Trailing icons should be wrapped
 * inside an `mdcChipCell`.
 */
class MdcChipIconDirective {
    constructor(_elm, _rndr, _cdRef) {
        this._elm = _elm;
        this._rndr = _rndr;
        this._cdRef = _cdRef;
        /** @internal */
        this._cls = true;
        /** @internal */
        this._leading = false;
        /**
         * Event emitted for trailing icon user interactions. Please note that chip removal should be
         * handled by the `remove` output of the chip, *not* by a handler for this output.
         */
        this.interact = new EventEmitter();
        /** @internal */
        this._trailing = false;
        this._originalTabindex = null;
        this.__tabindex = -1;
        this.__role = null;
        /** @internal */
        this._chip = null;
        this.__role = _elm.nativeElement.getAttribute('role');
        let tabIndex = _elm.nativeElement.getAttribute('tabindex');
        if (tabIndex) {
            this._originalTabindex = +tabIndex;
            this.__tabindex = +tabIndex;
        }
    }
    ngOnDestroy() {
        this._chip = null;
    }
    /** @internal */
    get _tabindex() {
        return this._trailing ? this.__tabindex : this._originalTabindex;
    }
    /** @internal */
    set _tabindex(val) {
        this.__tabindex = val == null ? -1 : val;
    }
    /** @internal */
    get _role() {
        if (this.__role)
            return this.__role;
        return this._trailing ? 'button' : null;
    }
    /** @internal */
    _handleClick(event) {
        var _a;
        if (this._chip && this._trailing)
            (_a = this._chip._foundation) === null || _a === void 0 ? void 0 : _a.handleTrailingIconInteraction(event);
    }
    /** @internal */
    _handleInteraction(event) {
        var _a;
        if (this._chip && this._trailing)
            (_a = this._chip._foundation) === null || _a === void 0 ? void 0 : _a.handleTrailingIconInteraction(event);
    }
}
MdcChipIconDirective.ɵfac = function MdcChipIconDirective_Factory(t) { return new (t || MdcChipIconDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
MdcChipIconDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcChipIconDirective, selectors: [["", "mdcChipIcon", ""]], hostVars: 8, hostBindings: function MdcChipIconDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MdcChipIconDirective_click_HostBindingHandler($event) { return ctx._handleClick($event); })("keydown", function MdcChipIconDirective_keydown_HostBindingHandler($event) { return ctx._handleInteraction($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("tabindex", ctx._tabindex)("role", ctx._role);
        ɵngcc0.ɵɵclassProp("mdc-chip__icon", ctx._cls)("mdc-chip__icon--leading", ctx._leading)("mdc-chip__icon--trailing", ctx._trailing);
    } }, outputs: { interact: "interact" } });
MdcChipIconDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: ChangeDetectorRef }
];
MdcChipIconDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-chip__icon',] }],
    _leading: [{ type: HostBinding, args: ['class.mdc-chip__icon--leading',] }],
    interact: [{ type: Output }],
    _trailing: [{ type: HostBinding, args: ['class.mdc-chip__icon--trailing',] }],
    _tabindex: [{ type: HostBinding, args: ['attr.tabindex',] }],
    _role: [{ type: HostBinding, args: ['attr.role',] }],
    _handleClick: [{ type: HostListener, args: ['click', ['$event'],] }],
    _handleInteraction: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcChipIconDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcChipIcon]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-chip__icon']
        }], _leading: [{
            type: HostBinding,
            args: ['class.mdc-chip__icon--leading']
        }], interact: [{
            type: Output
        }], _trailing: [{
            type: HostBinding,
            args: ['class.mdc-chip__icon--trailing']
        }], _tabindex: [{
            type: HostBinding,
            args: ['attr.tabindex']
        }], _role: [{
            type: HostBinding,
            args: ['attr.role']
        }], 
    /** @internal */
    _handleClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], 
    /** @internal */
    _handleInteraction: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }] }); })();
/**
 * Directive for the text of an `mdcChip`. Must be contained in an `mdcChipPrimaryAction`
 * directive.
 */
class MdcChipTextDirective {
    constructor(_elm) {
        this._elm = _elm;
        this._cls = true;
    }
}
MdcChipTextDirective.ɵfac = function MdcChipTextDirective_Factory(t) { return new (t || MdcChipTextDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcChipTextDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcChipTextDirective, selectors: [["", "mdcChipText", ""]], hostVars: 2, hostBindings: function MdcChipTextDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-chip__text", ctx._cls);
    } } });
MdcChipTextDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcChipTextDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-chip__text',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcChipTextDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcChipText]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-chip__text']
        }] }); })();
/**
 * Directive for the primary action element of a chip. The `mdcChipPrimaryAction` must
 * contain the `mdcChipText` directive, and be contained by an `mdcChipCell` directive.
 */
class MdcChipPrimaryActionDirective {
    constructor(_elm) {
        this._elm = _elm;
        /** @internal */
        this._cls = true;
        this.__tabindex = -1;
        /** @internal */
        this.__role = 'button';
        this.__tabindex = +(this._elm.nativeElement.getAttribute('tabindex') || -1);
    }
    /** @internal */
    get _role() {
        return this.__role;
    }
    /** @internal */
    get _tabindex() {
        return this.__tabindex;
    }
    /** @internal */
    set _tabindex(val) {
        this.__tabindex = val;
    }
}
MdcChipPrimaryActionDirective.ɵfac = function MdcChipPrimaryActionDirective_Factory(t) { return new (t || MdcChipPrimaryActionDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcChipPrimaryActionDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcChipPrimaryActionDirective, selectors: [["", "mdcChipPrimaryAction", ""]], hostVars: 4, hostBindings: function MdcChipPrimaryActionDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx._role)("tabindex", ctx._tabindex);
        ɵngcc0.ɵɵclassProp("mdc-chip__primary-action", ctx._cls);
    } } });
MdcChipPrimaryActionDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcChipPrimaryActionDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-chip__primary-action',] }],
    _role: [{ type: HostBinding, args: ['attr.role',] }],
    _tabindex: [{ type: HostBinding, args: ['attr.tabindex',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcChipPrimaryActionDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcChipPrimaryAction]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-chip__primary-action']
        }], _role: [{
            type: HostBinding,
            args: ['attr.role']
        }], _tabindex: [{
            type: HostBinding,
            args: ['attr.tabindex']
        }] }); })();
/**
 * Directive for the main content of a chip, or for an optional trailing
 * action on `input` chips. This directive must contain an
 * `mdcChipPrimaryActione` or an `mdcChipIcon` (when used for the trailing action).
 * An `mdcChipCell` must always be the direct child of an `mdcChip`.
 */
class MdcChipCellDirective {
    constructor(_elm) {
        this._elm = _elm;
        /** @internal */
        this._role = 'gridcell';
    }
}
MdcChipCellDirective.ɵfac = function MdcChipCellDirective_Factory(t) { return new (t || MdcChipCellDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcChipCellDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcChipCellDirective, selectors: [["", "mdcChipCell", ""]], hostVars: 1, hostBindings: function MdcChipCellDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx._role);
    } } });
MdcChipCellDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcChipCellDirective.propDecorators = {
    _role: [{ type: HostBinding, args: ['attr.role',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcChipCellDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcChipCell]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _role: [{
            type: HostBinding,
            args: ['attr.role']
        }] }); })();
/**
 * Directive for a chip. Chips must be child elements of an `mdcChipSet`,
 * and must contain an `mdcChipCell`, and may additionally contain an `mdcChipIcon` for
 * the leading icon. An optional trailing icon must be wrapped in a second `mdcChipCell`.
 */
class MdcChipDirective extends AbstractMdcRipple {
    constructor(_elm, rndr, registry, doc) {
        super(_elm, rndr, registry, doc);
        this._elm = _elm;
        /** @internal */
        this._cls = true;
        /** @internal */
        this._role = 'row';
        this.initialized = false;
        this.selectedMem = false;
        this.removableMem = true;
        this._value = null;
        /**
         * Event emitted for user interaction with the chip.
         */
        this.interact = new EventEmitter();
        /**
         * Event emitted when the user has removed (by clicking the trailing icon) the chip.
         * This event must be implemented when the `removable` property is set, and the chip
         * has a trailing icon. The implementation must remove the chip from the set.
         * Without such implementation the directive will animate the chip out of vision,
         * but will not remove the chip from the DOM.
         */
        this.remove = new EventEmitter();
        /**
         * Event emitted when a navigation event has occured.
         */
        this.navigation = new EventEmitter();
        /**
         * Event emitted when the chip changes from not-selected to selected state or vice versa
         * (for filter and choice chips).
         */
        this.selectedChange = new EventEmitter();
        // Like selectedChange, but only the events that should go to the chipset (i.e. not including the ones initiated by the chipset)
        /** @internal */
        this._selectedForChipSet = new EventEmitter();
        /** @internal */
        this._notifyRemoval = new EventEmitter();
        /** @internal */
        this._set = null;
        this._checkmark = null;
        this._leadingIcon = null;
        this._trailingIcon = null;
        this._adapter = {
            addClass: (className) => {
                const hasClass = this._elm.nativeElement.classList.contains(className);
                this._renderer.addClass(this._elm.nativeElement, className);
                if (!hasClass && className === 'mdc-chip--selected') {
                    this.selectedMem = true;
                    this.selectedChange.emit(true);
                }
            },
            removeClass: (className) => {
                const hasClass = this._elm.nativeElement.classList.contains(className);
                this._renderer.removeClass(this._elm.nativeElement, className);
                if (hasClass && className === 'mdc-chip--selected') {
                    this.selectedMem = false;
                    this.selectedChange.emit(false);
                }
            },
            hasClass: (className) => this._elm.nativeElement.classList.contains(className),
            addClassToLeadingIcon: (className) => this._leadingIcon && this._renderer.addClass(this._leadingIcon._elm.nativeElement, className),
            removeClassFromLeadingIcon: (className) => this._leadingIcon && this._renderer.removeClass(this._leadingIcon._elm.nativeElement, className),
            eventTargetHasClass: (target, className) => !!target && target.classList.contains(className),
            getAttribute: (attr) => this._elm.nativeElement.getAttribute(attr),
            notifyInteraction: () => this.interact.emit(),
            notifySelection: (selected, chipSetShouldIgnore) => {
                if (!chipSetShouldIgnore)
                    this._selectedForChipSet.emit(selected);
            },
            notifyTrailingIconInteraction: () => this._trailingIcon.interact.emit(),
            notifyRemoval: (removedAnnouncement) => this._notifyRemoval.emit({ removedAnnouncement }),
            notifyNavigation: (key, source) => this.navigation.emit({ key, source: source }),
            getComputedStyleValue: (propertyName) => getComputedStyle(this._elm.nativeElement).getPropertyValue(propertyName),
            setStyleProperty: (style, value) => this._renderer.setStyle(this._elm.nativeElement, style, value),
            hasLeadingIcon: () => !!this._leadingIcon,
            getRootBoundingClientRect: () => this._elm.nativeElement.getBoundingClientRect(),
            getCheckmarkBoundingClientRect: () => { var _a; return ((_a = this._checkmark) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) || null; },
            setPrimaryActionAttr: (attr, value) => this._primaryAction && this._renderer.setAttribute(this._primaryAction._elm.nativeElement, attr, value),
            focusPrimaryAction: () => { var _a; return (_a = this._primaryAction) === null || _a === void 0 ? void 0 : _a._elm.nativeElement.focus(); },
            hasTrailingAction: () => !!this._trailingIcon,
            setTrailingActionAttr: (attr, value) => this._trailingIcon && this._renderer.setAttribute(this._trailingIcon._elm.nativeElement, attr, value),
            focusTrailingAction: () => { var _a; return (_a = this._trailingIcon) === null || _a === void 0 ? void 0 : _a._elm.nativeElement.focus(); },
            isRTL: () => getComputedStyle(this._elm.nativeElement).getPropertyValue('direction') === 'rtl'
        };
        /** @internal */
        this._foundation = new MDCChipFoundation(this._adapter);
        this._uniqueValue = `mdc-chip-${MdcChipDirective.nextValue++}`;
    }
    ngAfterContentInit() {
        this.initActions();
        this.initIcons();
        this._icons.changes.subscribe(() => this._reInit());
        this._texts.changes.subscribe(() => this._reInit());
        this._primaryActions.changes.subscribe(() => this._reInit());
        this._chipCells.changes.subscribe(() => this._reInit());
        this.addRippleSurface('mdc-chip__ripple');
        this.initCheckMark();
        this.initRipple();
        this._foundation.init();
        if (this.selectedMem)
            // triggers setting the foundation selected state (and possibly for other [choice] chips too):
            this.selected = this.selectedMem;
        if (!this.removableMem)
            this._foundation.setShouldRemoveOnTrailingIconClick(this.removableMem);
        this.initialized = true;
    }
    ngOnDestroy() {
        this.destroyRipple();
        this._foundation.destroy();
    }
    /** @internal */
    _reInit() {
        // if icons have changed, the foundation must be reinitialized, because
        // trailingIconInteractionHandler might have to be removed and/or attached
        // to another icon:
        this._foundation.destroy();
        this._foundation = new MDCChipFoundation(this._adapter);
        this.initActions();
        this.initIcons();
        this.initCheckMark();
        this._foundation.init();
        if (!this.removableMem)
            this._foundation.setShouldRemoveOnTrailingIconClick(this.removableMem);
        // no need to call setSelected again, as the previous state will still be available via
        // the mdc-chip--selected class
    }
    initActions() {
        if (this._set) {
            let role = 'button';
            if (this._set._type === 'choice')
                role = 'radio';
            else if (this._set._type === 'filter')
                role = 'checkbox';
            this._primaryActions.forEach(action => {
                action.__role = role;
            });
        }
    }
    initIcons() {
        let newLeading = this.computeLeadingIcon();
        let newTrailing = this.computeTrailingIcon(newLeading);
        if (newLeading !== this._leadingIcon || newTrailing !== this._trailingIcon) {
            this._leadingIcon = newLeading;
            this._trailingIcon = newTrailing;
            this._icons.forEach(icon => {
                icon._chip = this;
                let leading = icon === this._leadingIcon;
                let trailing = icon === this._trailingIcon;
                let changed = leading !== icon._leading || trailing !== icon._trailing;
                icon._leading = icon === this._leadingIcon;
                icon._trailing = icon === this._trailingIcon;
                if (changed) // if we don't do this we get ExpressionChangedAfterItHasBeenCheckedError:
                    icon._cdRef.detectChanges();
            });
            this.removeCheckMark(); // checkmark may have changed position, will be readded later (for filter chips)
        }
    }
    get _text() {
        var _a;
        return (_a = this._texts) === null || _a === void 0 ? void 0 : _a.first;
    }
    get _primaryAction() {
        var _a;
        return (_a = this._primaryActions) === null || _a === void 0 ? void 0 : _a.first;
    }
    get _chipCell() {
        var _a;
        return (_a = this._chipCells) === null || _a === void 0 ? void 0 : _a.first;
    }
    computeLeadingIcon() {
        if (this._icons && this._icons.length > 0) {
            let icon = this._icons.first;
            let prev = this.previousElement(icon._elm.nativeElement);
            let last = icon._elm.nativeElement;
            while (true) {
                // if it is contained in another element, check the siblings of the container too:
                if (prev == null && last != null && last.parentElement !== this._elm.nativeElement)
                    prev = last.parentElement;
                // no more elements before, must be the leading icon:
                if (prev == null)
                    return icon;
                // comes after the text, so it's not the leading icon:
                if (this._text && (prev === this._text._elm.nativeElement || prev.contains(this._text._elm.nativeElement)))
                    return null;
                last = prev;
                prev = this.previousElement(prev);
            }
        }
        return null;
    }
    computeTrailingIcon(leading) {
        if (this._icons.length > 0) {
            let icon = this._icons.last;
            if (icon === leading)
                return null;
            // if not the leading icon, it must be the trailing icon:
            return icon;
        }
        return null;
    }
    previousElement(el) {
        let result = el.previousSibling;
        while (result != null && !(result instanceof Element))
            result = result.previousSibling;
        return result;
    }
    initCheckMark() {
        if (this._set && this._set._type === 'filter')
            this.addCheckMark();
        else
            this.removeCheckMark();
    }
    addCheckMark() {
        if (!this._checkmark && this._chipCell) {
            let path = this._renderer.createElement('path', 'svg');
            this._renderer.addClass(path, 'mdc-chip__checkmark-path');
            this._renderer.setAttribute(path, 'fill', 'none');
            this._renderer.setAttribute(path, 'stroke', 'black');
            this._renderer.setAttribute(path, 'd', 'M1.73,12.91 8.1,19.28 22.79,4.59');
            let svg = this._renderer.createElement('svg', 'svg');
            this._renderer.appendChild(svg, path);
            this._renderer.addClass(svg, 'mdc-chip__checkmark-svg');
            this._renderer.setAttribute(svg, 'viewBox', '-2 -3 30 30');
            this._checkmark = this._renderer.createElement('div');
            this._renderer.appendChild(this._checkmark, svg);
            this._renderer.addClass(this._checkmark, 'mdc-chip__checkmark');
            this._renderer.insertBefore(this._elm.nativeElement, this._checkmark, this._chipCell._elm.nativeElement);
        }
    }
    removeCheckMark() {
        if (this._checkmark) {
            this._checkmark.parentElement.removeChild(this._checkmark);
            this._checkmark = null;
        }
    }
    /**
     * The value the chip represents. The value must be unique for the `mdcChipSet`. If you do not provide a value
     * a unique value will be computed automatically.
     */
    get value() {
        return this._value ? this._value : this._uniqueValue;
    }
    set value(val) {
        this._value = val;
    }
    /**
     * The 'selected' state of the chip. Filter and choice chips are either selected or
     * not selected. Making a choice chip selected, will make all other chips in that set
     * not selected.
     */
    get selected() {
        return this.initialized ? this._foundation.isSelected() : this.selectedMem;
    }
    set selected(val) {
        let value = asBoolean(val);
        this.selectedMem = value;
        if (this.initialized && value !== this._foundation.isSelected())
            this._foundation.setSelected(value);
        // when not initialized the selectedChange will be emitted via the foundation after
        // initialization
    }
    /**
     * If set to a value other than `false`, clicking the trailing icon will animate the
     * chip out of view, and then emit the `remove` output.
     */
    get removable() {
        return this.initialized ? this._foundation.getShouldRemoveOnTrailingIconClick() : this.removableMem;
    }
    set removable(val) {
        let value = asBoolean(val);
        this.removableMem = value;
        if (this.initialized && value !== this._foundation.getShouldRemoveOnTrailingIconClick())
            this._foundation.setShouldRemoveOnTrailingIconClick(value);
        // when not initialized the removable change will be set on the foundation after
        // initialization
    }
    /** @docs-private */
    computeRippleBoundingRect() {
        return this._foundation.getDimensions();
    }
    /** @internal */
    _handleInteraction(event) {
        var _a;
        (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.handleInteraction(event);
    }
    /** @internal */
    _handleTransitionEnd(event) {
        var _a;
        (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.handleTransitionEnd(event);
    }
    /** @internal */
    _handleKeydown(event) {
        var _a, _b;
        (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.handleKeydown(event);
        (_b = this._foundation) === null || _b === void 0 ? void 0 : _b.handleInteraction(event);
    }
    /** @internal */
    _untabbable() {
        if (this._primaryAction)
            this._primaryAction._tabindex = -1;
        if (this._trailingIcon)
            this._trailingIcon._tabindex = -1;
    }
    /** @internal */
    _allowtabbable() {
        let result = !!this._primaryAction && this._primaryAction._tabindex !== -1;
        if (result && this._trailingIcon)
            this._trailingIcon._tabindex = -1;
        if (!result)
            result = !!this._trailingIcon && this._trailingIcon._tabindex != null && this._trailingIcon._tabindex !== -1;
        return result;
    }
    /** @internal */
    _forceTabbable() {
        if (this._primaryAction)
            this._primaryAction._tabindex = 0;
        else if (this._trailingIcon)
            this._trailingIcon._tabindex = 0;
    }
}
MdcChipDirective.ɵfac = function MdcChipDirective_Factory(t) { return new (t || MdcChipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcChipDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcChipDirective, selectors: [["", "mdcChip", ""]], contentQueries: function MdcChipDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcChipIconDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcChipTextDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcChipPrimaryActionDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcChipCellDirective, false);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._icons = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._texts = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._primaryActions = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._chipCells = _t);
    } }, hostVars: 5, hostBindings: function MdcChipDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MdcChipDirective_click_HostBindingHandler($event) { return ctx._handleInteraction($event); })("transitionend", function MdcChipDirective_transitionend_HostBindingHandler($event) { return ctx._handleTransitionEnd($event); })("keydown", function MdcChipDirective_keydown_HostBindingHandler($event) { return ctx._handleKeydown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx._role);
        ɵngcc0.ɵɵclassProp("mdc-chip", ctx._cls)("mdc-chip--deletable", ctx.removable);
    } }, inputs: { selected: "selected", value: "value", removable: "removable" }, outputs: { interact: "interact", remove: "remove", navigation: "navigation", selectedChange: "selectedChange", _selectedForChipSet: "_selectedForChipSet", _notifyRemoval: "_notifyRemoval" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @internal */
MdcChipDirective.nextValue = 1;
MdcChipDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: MdcEventRegistry },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcChipDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-chip',] }],
    _role: [{ type: HostBinding, args: ['attr.role',] }],
    interact: [{ type: Output }],
    remove: [{ type: Output }],
    navigation: [{ type: Output }],
    selectedChange: [{ type: Output }],
    _selectedForChipSet: [{ type: Output }],
    _notifyRemoval: [{ type: Output }],
    _icons: [{ type: ContentChildren, args: [MdcChipIconDirective, { descendants: true },] }],
    _texts: [{ type: ContentChildren, args: [MdcChipTextDirective, { descendants: true },] }],
    _primaryActions: [{ type: ContentChildren, args: [MdcChipPrimaryActionDirective, { descendants: true },] }],
    _chipCells: [{ type: ContentChildren, args: [MdcChipCellDirective,] }],
    value: [{ type: Input }],
    selected: [{ type: Input }],
    removable: [{ type: HostBinding, args: ['class.mdc-chip--deletable',] }, { type: Input }],
    _handleInteraction: [{ type: HostListener, args: ['click', ['$event'],] }],
    _handleTransitionEnd: [{ type: HostListener, args: ['transitionend', ['$event'],] }],
    _handleKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcChipDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcChip]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: MdcEventRegistry }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-chip']
        }], _role: [{
            type: HostBinding,
            args: ['attr.role']
        }], interact: [{
            type: Output
        }], remove: [{
            type: Output
        }], navigation: [{
            type: Output
        }], selectedChange: [{
            type: Output
        }], _selectedForChipSet: [{
            type: Output
        }], _notifyRemoval: [{
            type: Output
        }], selected: [{
            type: Input
        }], value: [{
            type: Input
        }], removable: [{
            type: HostBinding,
            args: ['class.mdc-chip--deletable']
        }, {
            type: Input
        }], 
    /** @internal */
    _handleInteraction: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], 
    /** @internal */
    _handleTransitionEnd: [{
            type: HostListener,
            args: ['transitionend', ['$event']]
        }], 
    /** @internal */
    _handleKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], _icons: [{
            type: ContentChildren,
            args: [MdcChipIconDirective, { descendants: true }]
        }], _texts: [{
            type: ContentChildren,
            args: [MdcChipTextDirective, { descendants: true }]
        }], _primaryActions: [{
            type: ContentChildren,
            args: [MdcChipPrimaryActionDirective, { descendants: true }]
        }], _chipCells: [{
            type: ContentChildren,
            args: [MdcChipCellDirective]
        }] }); })();
/**
 * Directive for a chip-set (a collection of <code>mdcChip</code>).
 */
class MdcChipSetDirective {
    constructor(_elm, cdRef) {
        this._elm = _elm;
        this.cdRef = cdRef;
        /** @internal */
        this._cls = true;
        /** @internal */
        this._role = 'grid';
        this._subscriptions = [];
        this._initialized = false;
        /** @internal */
        this._type = 'action';
        /** @internal */
        this._adapter = {
            hasClass: (className) => this._elm.nativeElement.classList.contains(className),
            removeChipAtIndex: (index) => {
                this.chip(index).remove.emit();
                // needed so that when focusChipTrailingActionAtIndex is called the
                // chip has already been removed from the DOM:
                this.cdRef.detectChanges();
            },
            selectChipAtIndex: (index, selected, shouldNotifyClients) => {
                var _a;
                (_a = this.chip(index)) === null || _a === void 0 ? void 0 : _a._foundation.setSelectedFromChipSet(selected, shouldNotifyClients);
            },
            getIndexOfChipById: (chipValue) => this.findChipIndex(chipValue),
            focusChipPrimaryActionAtIndex: (index) => { var _a; return (_a = this.chip(index)) === null || _a === void 0 ? void 0 : _a._foundation.focusPrimaryAction(); },
            focusChipTrailingActionAtIndex: (index) => { var _a; return (_a = this.chip(index)) === null || _a === void 0 ? void 0 : _a._foundation.focusTrailingAction(); },
            removeFocusFromChipAtIndex: (index) => { var _a; return (_a = this.chip(index)) === null || _a === void 0 ? void 0 : _a._foundation.removeFocus(); },
            isRTL: () => getComputedStyle(this._elm.nativeElement).getPropertyValue('direction') === 'rtl',
            getChipListCount: () => this._chips.length,
            announceMessage: (message) => announce(message)
        };
        /** @internal */
        this._foundation = new MDCChipSetFoundation(this._adapter);
    }
    ngAfterContentInit() {
        this._chips.changes.subscribe(() => {
            this.initSubscriptions();
            this.initChips();
            this.cdRef.detectChanges();
        });
        this.initSubscriptions();
        this.initChips();
        this._foundation.init();
        this._initialized = true;
        this.cdRef.detectChanges();
    }
    ngOnDestroy() {
        var _a;
        (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        this._foundation = null;
        this.destroySubscriptions();
        this._initialized = false;
    }
    /**
     * Chip sets by default contain 'action' chips. Set this value to <code>choice</code>,
     * <code>filter</code>, <code>input</code>, or <code>action</code> to determine the kind
     * of chips that are contained in the chip set.
     */
    get mdcChipSet() {
        return this._type;
    }
    set mdcChipSet(value) {
        if (value !== this._type) {
            if (value === 'choice' || value === 'filter' || value === 'input')
                this._type = value;
            else
                this._type = 'action';
            if (this._initialized)
                this.initChips(true);
        }
    }
    initChips(force = false) {
        let hasTabbableItem = false;
        this._chips.forEach(chip => {
            if (force || chip._set !== this) {
                chip._set = this;
                chip._reInit();
            }
            if (hasTabbableItem)
                chip._untabbable();
            else
                hasTabbableItem = chip._allowtabbable();
        });
        if (!hasTabbableItem && this._chips.length > 0)
            this._chips.first._forceTabbable();
    }
    destroySubscriptions() {
        try {
            this._subscriptions.forEach(sub => sub.unsubscribe());
        }
        finally {
            this._subscriptions = [];
        }
    }
    initSubscriptions() {
        this.destroySubscriptions();
        this._subscriptions = [];
        this._chips.forEach(chip => {
            this._subscriptions.push(chip.interact.subscribe(() => this._foundation.handleChipInteraction({ chipId: chip.value })));
            this._subscriptions.push(chip._selectedForChipSet.subscribe((selected) => this._foundation.handleChipSelection({ chipId: chip.value, selected, shouldIgnore: false })));
            this._subscriptions.push(chip._notifyRemoval.subscribe(({ removedAnnouncement }) => this._foundation.handleChipRemoval({ chipId: chip.value, removedAnnouncement })));
            this._subscriptions.push(chip.navigation.subscribe(({ key, source }) => this._foundation.handleChipNavigation({ chipId: chip.value, key, source })));
        });
    }
    chip(index) {
        if (index < 0 || index >= this._chips.length)
            return null;
        return this._chips.toArray()[index];
    }
    findChipIndex(chipValue) {
        return this._chips.toArray().findIndex(chip => chip.value === chipValue);
    }
    /** @internal */
    get _choice() {
        return this._type === 'choice';
    }
    /** @internal */
    get _filter() {
        return this._type === 'filter';
    }
    /** @internal */
    get _input() {
        return this._type === 'input';
    }
}
MdcChipSetDirective.ɵfac = function MdcChipSetDirective_Factory(t) { return new (t || MdcChipSetDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
MdcChipSetDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcChipSetDirective, selectors: [["", "mdcChipSet", ""]], contentQueries: function MdcChipSetDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcChipDirective, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._chips = _t);
    } }, hostVars: 9, hostBindings: function MdcChipSetDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx._role);
        ɵngcc0.ɵɵclassProp("mdc-chip-set", ctx._cls)("mdc-chip-set--choice", ctx._choice)("mdc-chip-set--filter", ctx._filter)("mdc-chip-set--input", ctx._input);
    } }, inputs: { mdcChipSet: "mdcChipSet" } });
MdcChipSetDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
MdcChipSetDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-chip-set',] }],
    _role: [{ type: HostBinding, args: ['attr.role',] }],
    _chips: [{ type: ContentChildren, args: [MdcChipDirective, { descendants: true },] }],
    mdcChipSet: [{ type: Input }],
    _choice: [{ type: HostBinding, args: ['class.mdc-chip-set--choice',] }],
    _filter: [{ type: HostBinding, args: ['class.mdc-chip-set--filter',] }],
    _input: [{ type: HostBinding, args: ['class.mdc-chip-set--input',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcChipSetDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcChipSet]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-chip-set']
        }], _role: [{
            type: HostBinding,
            args: ['attr.role']
        }], mdcChipSet: [{
            type: Input
        }], _choice: [{
            type: HostBinding,
            args: ['class.mdc-chip-set--choice']
        }], _filter: [{
            type: HostBinding,
            args: ['class.mdc-chip-set--filter']
        }], _input: [{
            type: HostBinding,
            args: ['class.mdc-chip-set--input']
        }], _chips: [{
            type: ContentChildren,
            args: [MdcChipDirective, { descendants: true }]
        }] }); })();
const CHIP_DIRECTIVES = [
    MdcChipIconDirective,
    MdcChipTextDirective,
    MdcChipPrimaryActionDirective,
    MdcChipCellDirective,
    MdcChipDirective,
    MdcChipSetDirective
];

/** @docs-private */
class AbstractMdcFocusInitial {
    constructor() {
        /** @internal */ this.priority = null;
        /** @internal */ this._elm = null;
    }
}
/** @docs-private */
class AbstractMdcFocusTrap {
    constructor() { }
}

let nextId = 1;
/** @docs-private */
class HasId {
    constructor() {
        this._id = null;
        this.cachedId = null;
        this._idChange = new Subject();
    }
    // TODO: member assignments above are never executed...
    /** @internal */
    initId() {
        // Force setter to be called in case id was not specified.
        this.id = this.id;
        this._idChange = new Subject();
    }
    /**
     * Mirrors the <code>id</code> attribute. If no id is assigned, this directive will
     * assign a unique id by itself.
     */
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value || this._newId();
        if (this._idChange)
            this._idChange.next();
    }
    /** @internal */
    _newId() {
        this.cachedId = this.cachedId || `mdc-u-id-${nextId++}`;
        return this.cachedId;
    }
    /**
     * @internal
     *
     * Subscribe to this observable to be informed of id changes.
     */
    idChange() {
        return this._idChange.asObservable();
    }
}
HasId.ɵfac = function HasId_Factory(t) { return new (t || HasId)(); };
HasId.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: HasId, hostVars: 1, hostBindings: function HasId_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("id", ctx.id);
    } }, inputs: { id: "id" } });
HasId.propDecorators = {
    id: [{ type: HostBinding }, { type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HasId, [{
        type: Directive
    }], function () { return []; }, { id: [{
            type: HostBinding
        }, {
            type: Input
        }] }); })();

function applyMixins(derivedCtor, baseCtors) {
    baseCtors.forEach(baseCtor => {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach(name => {
            Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name));
        });
    });
}

class MdcDialogTitleDirectiveBase {
}
MdcDialogTitleDirectiveBase.ɵfac = function MdcDialogTitleDirectiveBase_Factory(t) { return new (t || MdcDialogTitleDirectiveBase)(); };
MdcDialogTitleDirectiveBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDialogTitleDirectiveBase });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDialogTitleDirectiveBase, [{
        type: Directive
    }], null, null); })();
applyMixins(MdcDialogTitleDirectiveBase, [HasId]);
/**
 * Directive for the title of an `mdcDialog`.
 * A title is optional. If used, it should be the first child of an `mdcDialogSurface`.
 * Please note that there should be no whitespace separating the start/end tag and the title
 * itself. (The easiest way to achieve this is to *not* set the `preserveWhitespaces` option to
 * `true` the `angularCompilerOptions`).
 */
class MdcDialogTitleDirective extends MdcDialogTitleDirectiveBase {
    constructor() {
        super(...arguments);
        /** @internal */
        this._cls = true;
    }
    ngOnInit() {
        this.initId();
    }
}
MdcDialogTitleDirective.ɵfac = function MdcDialogTitleDirective_Factory(t) { return ɵMdcDialogTitleDirective_BaseFactory(t || MdcDialogTitleDirective); };
MdcDialogTitleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDialogTitleDirective, selectors: [["", "mdcDialogTitle", ""]], hostVars: 2, hostBindings: function MdcDialogTitleDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-dialog__title", ctx._cls);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcDialogTitleDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-dialog__title',] }]
};
const ɵMdcDialogTitleDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(MdcDialogTitleDirective);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDialogTitleDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcDialogTitle]'
            }]
    }], null, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-dialog__title']
        }] }); })();
class MdcDialogContentDirectiveBase {
}
MdcDialogContentDirectiveBase.ɵfac = function MdcDialogContentDirectiveBase_Factory(t) { return new (t || MdcDialogContentDirectiveBase)(); };
MdcDialogContentDirectiveBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDialogContentDirectiveBase });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDialogContentDirectiveBase, [{
        type: Directive
    }], null, null); })();
applyMixins(MdcDialogContentDirectiveBase, [HasId]);
/**
 * Directive for the content part of an `mdcDialog`.
 * This should be added as a child element of an `mdcDialogSurface`.
 */
class MdcDialogContentDirective extends MdcDialogContentDirectiveBase {
    constructor(_elm) {
        super();
        this._elm = _elm;
        /** @internal */
        this._cls = true;
    }
    ngOnInit() {
        this.initId();
    }
}
MdcDialogContentDirective.ɵfac = function MdcDialogContentDirective_Factory(t) { return new (t || MdcDialogContentDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcDialogContentDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDialogContentDirective, selectors: [["", "mdcDialogContent", ""]], hostVars: 2, hostBindings: function MdcDialogContentDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-dialog__content", ctx._cls);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcDialogContentDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcDialogContentDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-dialog__content',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDialogContentDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcDialogContent]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-dialog__content']
        }] }); })();
/**
 * Directive for the actions (footer) of an `mdcDialog`.
 * This is an (optional) last child of the `mdcDialogSurface` directive.
 * This directive should contain buttons, for that should use the `mdcButton`
 * directive.
 *
 * Action buttons should typically close the dialog, and should therefore
 * also set a value for the `mdcDialogTrigger` directive.
 */
class MdcDialogActionsDirective {
    constructor(_rndr) {
        this._rndr = _rndr;
        /** @internal */
        this._cls = true;
    }
    ngAfterContentInit() {
        this.initButtons();
        this._buttons.changes.subscribe(() => {
            this.initButtons();
        });
    }
    initButtons() {
        this._buttons.forEach(btn => {
            this._rndr.addClass(btn._elm.nativeElement, 'mdc-dialog__button');
        });
    }
}
MdcDialogActionsDirective.ɵfac = function MdcDialogActionsDirective_Factory(t) { return new (t || MdcDialogActionsDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
MdcDialogActionsDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDialogActionsDirective, selectors: [["", "mdcDialogActions", ""]], contentQueries: function MdcDialogActionsDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcButtonDirective, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._buttons = _t);
    } }, hostVars: 2, hostBindings: function MdcDialogActionsDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-dialog__actions", ctx._cls);
    } } });
MdcDialogActionsDirective.ctorParameters = () => [
    { type: Renderer2 }
];
MdcDialogActionsDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-dialog__actions',] }],
    _buttons: [{ type: ContentChildren, args: [MdcButtonDirective, { descendants: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDialogActionsDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcDialogActions]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-dialog__actions']
        }], _buttons: [{
            type: ContentChildren,
            args: [MdcButtonDirective, { descendants: true }]
        }] }); })();
/**
 * Any element within a dialog may include this directive (and assigne a non empty value to it)
 * to indicate that interacting with it should close the dialog with the specified action.
 *
 * This action is then reflected via the `action` field in the `closing` and `closed` events of
 * the dialog. A value of `close` will also trigger the `cancel` event of the dialog, and a value of
 * `accept` will trigger the `accept` event.
 *
 * Any action buttons within the dialog that equate to a dismissal with no further action should
 * use set `mdcDialogTrigger="close"`. This will make it easy to handle all such interactions consistently
 * (via either the `cancel`, `closing`, or `closed` events), while separately handling other actions.
 */
class MdcDialogTriggerDirective {
    constructor(_elm) {
        this._elm = _elm;
        /**
         * Set the `action` value that should be send to `closing` and `closed` events when a user
         * interacts with this element. (When set to an empty string the button/element will not be wired
         * to close the dialog).
         */
        this.mdcDialogTrigger = null;
    }
}
MdcDialogTriggerDirective.ɵfac = function MdcDialogTriggerDirective_Factory(t) { return new (t || MdcDialogTriggerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcDialogTriggerDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDialogTriggerDirective, selectors: [["", "mdcDialogTrigger", ""]], inputs: { mdcDialogTrigger: "mdcDialogTrigger" } });
MdcDialogTriggerDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcDialogTriggerDirective.propDecorators = {
    mdcDialogTrigger: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDialogTriggerDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcDialogTrigger]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { mdcDialogTrigger: [{
            type: Input
        }] }); })();
/**
 * This directive can be used to mark one of the dialogs action buttons as the default action.
 * This action will then be triggered by pressing the enter key while the dialog has focus.
 * The default action also will receive focus when the dialog is opened. Unless another
 * element within the dialog has the `mdcFocusInitial` directive.
 */
class MdcDialogDefaultDirective extends AbstractMdcFocusInitial {
    constructor(_elm) {
        super();
        this._elm = _elm;
        /** @internal */ this.priority = 0; // must be lower than prio of MdcFocusInitialDirective
    }
}
MdcDialogDefaultDirective.ɵfac = function MdcDialogDefaultDirective_Factory(t) { return new (t || MdcDialogDefaultDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcDialogDefaultDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDialogDefaultDirective, selectors: [["", "mdcDialogDefault", ""]], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: AbstractMdcFocusInitial, useExisting: forwardRef(() => MdcDialogDefaultDirective) }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcDialogDefaultDirective.ctorParameters = () => [
    { type: ElementRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDialogDefaultDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcDialogDefault]',
                providers: [{ provide: AbstractMdcFocusInitial, useExisting: forwardRef(() => MdcDialogDefaultDirective) }]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
/**
 * Directive for the surface of a dialog. The surface contains the actual content of a dialog,
 * wrapped in elements with the `mdcDialogHeader`, `mdcDialogContent`, and `mdcDialogActions`
 * directives.
 *
 * # Accessibility
 * * The role attribute will be set to `alertdialog` by default
 * * The `aria-modal` attribute will be set to `true` by default
 * * If there is an `mdcDialogTitle`, the `aria-labelledBy` attribute will be set to the id
 *   of that element (and a unique id will be assigned to it, if none was provided)
 * * If there is an `mdcDialogContent`, the `aria-describedby` attribute will be set to the
 *   id of that element (and a unique id will be assigned to it, if none was provided)
 */
class MdcDialogSurfaceDirective {
    constructor() {
        /** @internal */
        this._cls = true;
        /** @internal */
        this._role = 'alertdialog';
        /** @internal */
        this._modal = 'true';
        /** @internal */
        this._labelledBy = null;
        /** @internal */
        this._describedBy = null;
    }
    ngAfterContentInit() {
        this._titles.changes.subscribe(() => this.setAriaLabels());
        this._contents.changes.subscribe(() => this.setAriaLabels());
        this.setAriaLabels();
    }
    setAriaLabels() {
        var _a, _b;
        this._labelledBy = (_a = this._titles.first) === null || _a === void 0 ? void 0 : _a.id;
        this._describedBy = (_b = this._contents.first) === null || _b === void 0 ? void 0 : _b.id;
    }
}
MdcDialogSurfaceDirective.ɵfac = function MdcDialogSurfaceDirective_Factory(t) { return new (t || MdcDialogSurfaceDirective)(); };
MdcDialogSurfaceDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDialogSurfaceDirective, selectors: [["", "mdcDialogSurface", ""]], contentQueries: function MdcDialogSurfaceDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcDialogTitleDirective, false);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcDialogContentDirective, false);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._titles = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._contents = _t);
    } }, hostVars: 6, hostBindings: function MdcDialogSurfaceDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx._role)("aria-modal", ctx._modal)("aria-labelledby", ctx._labelledBy)("aria-describedby", ctx._describedBy);
        ɵngcc0.ɵɵclassProp("mdc-dialog__surface", ctx._cls);
    } } });
MdcDialogSurfaceDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-dialog__surface',] }],
    _role: [{ type: HostBinding, args: ['attr.role',] }],
    _modal: [{ type: HostBinding, args: ['attr.aria-modal',] }],
    _labelledBy: [{ type: HostBinding, args: ['attr.aria-labelledby',] }],
    _describedBy: [{ type: HostBinding, args: ['attr.aria-describedby',] }],
    _titles: [{ type: ContentChildren, args: [MdcDialogTitleDirective,] }],
    _contents: [{ type: ContentChildren, args: [MdcDialogContentDirective,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDialogSurfaceDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcDialogSurface]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-dialog__surface']
        }], _role: [{
            type: HostBinding,
            args: ['attr.role']
        }], _modal: [{
            type: HostBinding,
            args: ['attr.aria-modal']
        }], _labelledBy: [{
            type: HostBinding,
            args: ['attr.aria-labelledby']
        }], _describedBy: [{
            type: HostBinding,
            args: ['attr.aria-describedby']
        }], _titles: [{
            type: ContentChildren,
            args: [MdcDialogTitleDirective]
        }], _contents: [{
            type: ContentChildren,
            args: [MdcDialogContentDirective]
        }] }); })();
/**
 * This directive should be the first child of an `mdcDialog`, and contains the `mdcDialogSurface`.
 */
class MdcDialogContainerDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcDialogContainerDirective.ɵfac = function MdcDialogContainerDirective_Factory(t) { return new (t || MdcDialogContainerDirective)(); };
MdcDialogContainerDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDialogContainerDirective, selectors: [["", "mdcDialogContainer", ""]], hostVars: 2, hostBindings: function MdcDialogContainerDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-dialog__container", ctx._cls);
    } } });
MdcDialogContainerDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-dialog__container',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDialogContainerDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcDialogContainer]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-dialog__container']
        }] }); })();
/**
 * Directive for the backdrop of a dialog. The backdrop provides the styles for overlaying the
 * page content when the dialog is opened. This guides user attention to the dialog.
 */
class MdcDialogScrimDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcDialogScrimDirective.ɵfac = function MdcDialogScrimDirective_Factory(t) { return new (t || MdcDialogScrimDirective)(); };
MdcDialogScrimDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDialogScrimDirective, selectors: [["", "mdcDialogScrim", ""]], hostVars: 2, hostBindings: function MdcDialogScrimDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-dialog__scrim", ctx._cls);
    } } });
MdcDialogScrimDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-dialog__scrim',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDialogScrimDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcDialogScrim]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-dialog__scrim']
        }] }); })();
/**
 * Directive for creating a modal dialog with Material Design styling. The dialog should have two
 * child elements: a surface (marked with the <code>mdcDialogSurface</code> directive), and a
 * backdrop (marked with the <code>mdcDialogBackdrop</code> directive).
 *
 * When the dialog is opened, it will activate a focus trap on the elements within the dialog,
 * so that the surface behind the dialog is not accessible. See `mdcFocusTrap` for more information.
 */
class MdcDialogDirective {
    constructor(_elm, _rndr, _registry, _focusTrap, doc) {
        this._elm = _elm;
        this._rndr = _rndr;
        this._registry = _registry;
        this._focusTrap = _focusTrap;
        /** @internal */
        this._cls = true;
        /** @internal */
        this._surface = null;
        /**
         * Event emitted when the user accepts the dialog, e.g. by pressing enter or clicking the button
         * with `mdcDialogTrigger="accept"`.
         */
        this.accept = new EventEmitter();
        /**
         * Event emitted when the user cancels the dialog, e.g. by clicking outside the dialog, pressing the escape key,
         * or clicking an element with `mdcDialogTrigger="close"`.
         */
        this.cancel = new EventEmitter();
        /**
         * Event emitted when the dialog starts opening.
         */
        this.opening = new EventEmitter();
        /**
         * Event emitted when the dialog is opened.
         */
        this.opened = new EventEmitter();
        /**
         * Event emitted when the dialog starts closing. The 'action' field contains the reason for closing, see
         * `mdcDialogTrigger` for more information.
         */
        this.closing = new EventEmitter();
        /**
         * Event emitted when the dialog is closed. The 'action' field contains the reason for closing, see
         * `mdcDialogTrigger` for more information.
         */
        this.closed = new EventEmitter();
        this._onDocumentKeydown = (event) => this.onDocumentKeydown(event);
        this.focusTrapHandle = null;
        this.mdcAdapter = {
            addClass: (className) => this._rndr.addClass(this._elm.nativeElement, className),
            removeClass: (className) => this._rndr.removeClass(this._elm.nativeElement, className),
            addBodyClass: (className) => this._rndr.addClass(this.document.body, className),
            removeBodyClass: (className) => this._rndr.removeClass(this.document.body, className),
            areButtonsStacked: () => { var _a, _b; return ((_a = this._footers) === null || _a === void 0 ? void 0 : _a.first) ? util$1.areTopsMisaligned((_b = this._footers.first) === null || _b === void 0 ? void 0 : _b._buttons.map(b => b._elm.nativeElement)) : false; },
            clickDefaultButton: () => { var _a, _b; return (_b = (_a = this._defaultActions) === null || _a === void 0 ? void 0 : _a.first) === null || _b === void 0 ? void 0 : _b._elm.nativeElement.click(); },
            eventTargetMatches: (target, selector) => target ? ponyfill.matches(target, selector) : false,
            getActionFromEvent: (evt) => {
                const action = this.closest(evt.target, this._triggers.toArray());
                return (action === null || action === void 0 ? void 0 : action.mdcDialogTrigger) || null;
            },
            getInitialFocusEl: () => null,
            hasClass: (className) => {
                if (className === cssClasses.STACKED)
                    return false; // currently not supporting (auto-)stacking of buttons
                return this._elm.nativeElement.classList.contains(className);
            },
            isContentScrollable: () => { var _a; return util$1.isScrollable((_a = this._content) === null || _a === void 0 ? void 0 : _a._elm.nativeElement); },
            notifyClosed: (action) => {
                this.closed.emit({ action });
            },
            notifyClosing: (action) => {
                this.document.removeEventListener('keydown', this._onDocumentKeydown);
                this.closing.emit({ action });
                if (action === 'accept')
                    this.accept.emit();
                else if (action === 'close')
                    this.cancel.emit();
            },
            notifyOpened: () => {
                this.opened.emit();
            },
            notifyOpening: () => {
                this.document.addEventListener('keydown', this._onDocumentKeydown);
                this.opening.emit();
            },
            releaseFocus: () => this.untrapFocus(),
            // we're currently not supporting auto-stacking, cause we can't just reverse buttons in the dom
            // and expect that to not break stuff in angular:
            reverseButtons: () => undefined,
            trapFocus: () => this.trapFocus()
        };
        this.foundation = null;
        this.document = doc; // work around ngc issue https://github.com/angular/angular/issues/20351
    }
    ngAfterContentInit() {
        this.foundation = new MDCDialogFoundation(this.mdcAdapter);
        this.foundation.init();
        this.foundation.setAutoStackButtons(false); // currently not supported
    }
    ngOnDestroy() {
        var _a;
        this.document.removeEventListener('keydown', this._onDocumentKeydown);
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        this.foundation = null;
    }
    /**
     * Call this method to open the dialog.
     */
    open() {
        this.foundation.open();
    }
    /**
     * Call this method to close the dialog with the specified action, e.g. `accept` to indicate an acceptance action
     * (and trigger the `accept` event), or `close` to indicate dismissal (and trigger the `cancel` event).
     */
    close(action = 'close') {
        this.foundation.close(action);
    }
    /**
     * Recalculates layout and automatically adds/removes modifier classes (for instance to detect if the dialog content
     * should be scrollable)
     */
    layout() {
        this.foundation.layout();
    }
    trapFocus() {
        this.untrapFocus();
        if (this._focusTrap)
            this.focusTrapHandle = this._focusTrap.trapFocus();
    }
    untrapFocus() {
        if (this.focusTrapHandle && this.focusTrapHandle.active) {
            this.focusTrapHandle.untrap();
            this.focusTrapHandle = null;
        }
    }
    /** @internal */
    onClick(event) {
        var _a;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.handleClick(event);
    }
    /** @internal */
    onKeydown(event) {
        var _a;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.handleKeydown(event);
    }
    /** @internal */
    onDocumentKeydown(event) {
        var _a;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.handleDocumentKeydown(event);
    }
    get _content() {
        return this._contents.first;
    }
    closest(elm, choices) {
        let match = elm;
        while (match && match !== this._elm.nativeElement) {
            for (let i = 0; i != choices.length; ++i) {
                if (choices[i]._elm.nativeElement === match)
                    return choices[i];
            }
            match = match.parentElement;
        }
        return null;
    }
}
MdcDialogDirective.ɵfac = function MdcDialogDirective_Factory(t) { return new (t || MdcDialogDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(AbstractMdcFocusTrap, 10), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcDialogDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDialogDirective, selectors: [["", "mdcDialog", ""]], contentQueries: function MdcDialogDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcDialogSurfaceDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcDialogTriggerDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcDialogContentDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcDialogActionsDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcDialogDefaultDirective, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._surface = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._triggers = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._contents = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._footers = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._defaultActions = _t);
    } }, hostVars: 2, hostBindings: function MdcDialogDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MdcDialogDirective_click_HostBindingHandler($event) { return ctx.onClick($event); })("keydown", function MdcDialogDirective_keydown_HostBindingHandler($event) { return ctx.onKeydown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-dialog", ctx._cls);
    } }, outputs: { accept: "accept", cancel: "cancel", opening: "opening", opened: "opened", closing: "closing", closed: "closed" }, exportAs: ["mdcDialog"] });
MdcDialogDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: MdcEventRegistry },
    { type: AbstractMdcFocusTrap, decorators: [{ type: Optional }, { type: Self }] },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcDialogDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-dialog',] }],
    _surface: [{ type: ContentChild, args: [MdcDialogSurfaceDirective,] }],
    _triggers: [{ type: ContentChildren, args: [MdcDialogTriggerDirective, { descendants: true },] }],
    _contents: [{ type: ContentChildren, args: [MdcDialogContentDirective, { descendants: true },] }],
    _footers: [{ type: ContentChildren, args: [MdcDialogActionsDirective, { descendants: true },] }],
    _defaultActions: [{ type: ContentChildren, args: [MdcDialogDefaultDirective, { descendants: true },] }],
    accept: [{ type: Output }],
    cancel: [{ type: Output }],
    opening: [{ type: Output }],
    opened: [{ type: Output }],
    closing: [{ type: Output }],
    closed: [{ type: Output }],
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }],
    onKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDialogDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcDialog]',
                exportAs: 'mdcDialog'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: MdcEventRegistry }, { type: AbstractMdcFocusTrap, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-dialog']
        }], _surface: [{
            type: ContentChild,
            args: [MdcDialogSurfaceDirective]
        }], accept: [{
            type: Output
        }], cancel: [{
            type: Output
        }], opening: [{
            type: Output
        }], opened: [{
            type: Output
        }], closing: [{
            type: Output
        }], closed: [{
            type: Output
        }], 
    /** @internal */
    onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], 
    /** @internal */
    onKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], _triggers: [{
            type: ContentChildren,
            args: [MdcDialogTriggerDirective, { descendants: true }]
        }], _contents: [{
            type: ContentChildren,
            args: [MdcDialogContentDirective, { descendants: true }]
        }], _footers: [{
            type: ContentChildren,
            args: [MdcDialogActionsDirective, { descendants: true }]
        }], _defaultActions: [{
            type: ContentChildren,
            args: [MdcDialogDefaultDirective, { descendants: true }]
        }] }); })();
const DIALOG_DIRECTIVES = [
    MdcDialogDirective, MdcDialogTitleDirective, MdcDialogContentDirective, MdcDialogSurfaceDirective, MdcDialogContainerDirective,
    MdcDialogActionsDirective, MdcDialogTriggerDirective, MdcDialogDefaultDirective, MdcDialogScrimDirective
];

/**
 * Directive for the input element of an <code>MdcRadioDirective</code>.
 */
class MdcRadioInputDirective extends AbstractMdcInput {
    constructor(_elm, _cntr) {
        super();
        this._elm = _elm;
        this._cntr = _cntr;
        /** @internal */
        this._cls = true;
        this._id = null;
        this._disabled = false;
    }
    /** @docs-private */
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    /** @docs-private */
    get disabled() {
        return this._cntr ? !!this._cntr.disabled : this._disabled;
    }
    set disabled(value) {
        this._disabled = asBoolean(value);
    }
}
MdcRadioInputDirective.ɵfac = function MdcRadioInputDirective_Factory(t) { return new (t || MdcRadioInputDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgControl, 10)); };
MdcRadioInputDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcRadioInputDirective, selectors: [["input", "mdcRadioInput", "", "type", "radio"]], hostVars: 4, hostBindings: function MdcRadioInputDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("id", ctx.id)("disabled", ctx.disabled);
        ɵngcc0.ɵɵclassProp("mdc-radio__native-control", ctx._cls);
    } }, inputs: { id: "id", disabled: "disabled" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: AbstractMdcInput, useExisting: forwardRef(() => MdcRadioInputDirective) }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcRadioInputDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }] }
];
MdcRadioInputDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-radio__native-control',] }],
    id: [{ type: HostBinding }, { type: Input }],
    disabled: [{ type: HostBinding }, { type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcRadioInputDirective, [{
        type: Directive,
        args: [{
                selector: 'input[mdcRadioInput][type=radio]',
                providers: [{ provide: AbstractMdcInput, useExisting: forwardRef(() => MdcRadioInputDirective) }]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-radio__native-control']
        }], id: [{
            type: HostBinding
        }, {
            type: Input
        }], disabled: [{
            type: HostBinding
        }, {
            type: Input
        }] }); })();
/**
 * Directive for creating a Material Design radio button. The radio button is driven by an
 * underlying native radio input, which must use the <code>MdcRadioInputDirective</code>
 * directive.
 * The current implementation will add all other required DOM elements (such as the
 * background).
 * Future implementations will also support supplying (customized) background
 * elements.
 *
 * This directive can be used together with an <code>mdcFormField</code> to
 * easily position radio buttons and their labels, see
 * <a href="/components/form-field">mdcFormField</a>.
 */
class MdcRadioDirective extends AbstractMdcRipple {
    constructor(renderer, root, registry, doc) {
        super(root, renderer, registry, doc);
        this.renderer = renderer;
        this.root = root;
        /** @internal */
        this._cls = true;
        this.mdcAdapter = {
            // We can just ignore all adapter calls, since we have a HostBinding for the
            // disabled classes, and never call foundation.setDisabled
            addClass: () => undefined,
            removeClass: () => undefined,
            setNativeControlDisabled: () => undefined
        };
        this.foundation = new MDCRadioFoundation(this.mdcAdapter);
    }
    ngAfterContentInit() {
        this.addBackground();
        this.addRippleSurface('mdc-radio__ripple');
        this.initRipple(true);
        this.foundation.init();
        this._inputs.changes.subscribe(() => {
            this.reinitRipple();
        });
    }
    ngOnDestroy() {
        var _a;
        this.destroyRipple();
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        this.foundation = null;
    }
    addBackground() {
        let outerCircle = this.renderer.createElement('div');
        this.renderer.addClass(outerCircle, 'mdc-radio__outer-circle');
        let innerCircle = this.renderer.createElement('div');
        this.renderer.addClass(innerCircle, 'mdc-radio__inner-circle');
        let bg = this.renderer.createElement('div');
        this.renderer.appendChild(bg, outerCircle);
        this.renderer.appendChild(bg, innerCircle);
        this.renderer.addClass(bg, 'mdc-radio__background');
        this.renderer.appendChild(this.root.nativeElement, bg);
    }
    /** @internal */
    getRippleInteractionElement() {
        var _a;
        return (_a = this._input) === null || _a === void 0 ? void 0 : _a._elm;
    }
    /** @internal */
    isRippleSurfaceActive() {
        // This is what the @material/radio MDCRadio component does, with the following comment:
        // "Radio buttons technically go 'active' whenever there is *any* keyboard interaction.
        //  This is not the UI we desire."
        return false;
    }
    // instead of calling foundation.setDisabled on disabled state changes, we just
    // bind the class to the property:
    /** @internal */
    get _disabled() {
        return this._input == null || this._input.disabled;
    }
    /** @internal */
    get _input() {
        return this._inputs && this._inputs.length > 0 ? this._inputs.first : null;
    }
}
MdcRadioDirective.ɵfac = function MdcRadioDirective_Factory(t) { return new (t || MdcRadioDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcRadioDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcRadioDirective, selectors: [["", "mdcRadio", ""]], contentQueries: function MdcRadioDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcRadioInputDirective, false);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._inputs = _t);
    } }, hostVars: 4, hostBindings: function MdcRadioDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-radio", ctx._cls)("mdc-radio--disabled", ctx._disabled);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcRadioDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: MdcEventRegistry },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcRadioDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-radio',] }],
    _inputs: [{ type: ContentChildren, args: [MdcRadioInputDirective,] }],
    _disabled: [{ type: HostBinding, args: ['class.mdc-radio--disabled',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcRadioDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcRadio]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: MdcEventRegistry }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-radio']
        }], _disabled: [{
            type: HostBinding,
            args: ['class.mdc-radio--disabled']
        }], _inputs: [{
            type: ContentChildren,
            args: [MdcRadioInputDirective]
        }] }); })();
const RADIO_DIRECTIVES = [
    MdcRadioInputDirective,
    MdcRadioDirective
];

/**
 * Directive for a separator in a list (between list items), or as a separator in a
 * list group (between lists).
 *
 * # Accessibility
 * This directive adds a `role=separator` attribute when it is used as a separator
 * between list items.
 */
class MdcListDividerDirective {
    constructor(_elm) {
        /** @internal */
        this._cls = true;
        /** @internal */
        this._role = 'separator';
        /** @internal */
        this._disabled = false;
        this._inset = false;
        this._padded = false;
        if (_elm.nativeElement.nodeName.toUpperCase() !== 'LI')
            this._role = null;
    }
    /**
     * When this input is defined and does not have value false, the divider is styled with
     * an inset.
     */
    get inset() {
        return this._inset;
    }
    set inset(val) {
        this._inset = asBoolean(val);
    }
    /**
     * When this input is defined and does not have value false, the divider leaves
     * gaps on each site to match the padding of <code>mdcListItemMeta</code>.
     */
    get padded() {
        return this._padded;
    }
    set padded(val) {
        this._padded = asBoolean(val);
    }
}
MdcListDividerDirective.ɵfac = function MdcListDividerDirective_Factory(t) { return new (t || MdcListDividerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcListDividerDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcListDividerDirective, selectors: [["", "mdcListDivider", ""]], hostVars: 8, hostBindings: function MdcListDividerDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx._role)("disabled", ctx._disabled);
        ɵngcc0.ɵɵclassProp("mdc-list-divider", ctx._cls)("mdc-list-divider--inset", ctx.inset)("mdc-list-divider--padded", ctx.padded);
    } }, inputs: { inset: "inset", padded: "padded" } });
MdcListDividerDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcListDividerDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-list-divider',] }],
    _role: [{ type: HostBinding, args: ['attr.role',] }],
    _disabled: [{ type: HostBinding, args: ['attr.disabled',] }],
    inset: [{ type: Input }, { type: HostBinding, args: ['class.mdc-list-divider--inset',] }],
    padded: [{ type: Input }, { type: HostBinding, args: ['class.mdc-list-divider--padded',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcListDividerDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcListDivider]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-list-divider']
        }], _role: [{
            type: HostBinding,
            args: ['attr.role']
        }], _disabled: [{
            type: HostBinding,
            args: ['attr.disabled']
        }], inset: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.mdc-list-divider--inset']
        }], padded: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.mdc-list-divider--padded']
        }] }); })();
/**
 * Directive for the items of a material list.
 * This directive should be used for the direct children (list items) of an
 * `mdcList`.
 *
 * # Children
 * * Use `mdcListItemText` for the text content of the list. One line and two line
 *   lists are supported. See `mdcListItemText` for more info.
 * * Optional: `mdcListItemGraphic` for a starting detail (typically icon or image).
 * * Optional: `mdcListItemMeta` for the end detail (typically icon or image).
 *
 * # Accessibility
 * * All items in a list will get a `tabindex=-1` attribute to make them focusable,
 *   but not tabbable. The focused, active/current, or first (in that preference) item will
 *   get `tabindex=0`, so that the list can be tabbed into. Keyboard navigation
 *   between list items is done with arrow, home, and end keys. Keyboard based selection of
 *   an item (when items are selectable), can be done with the enter or space key.
 * * The `role` attribute with be set to `option` for single selection lists,
 *   `checkbox` for list items that can be selected with embedded checkbox inputs, `radio`
 *   for for list items that can be selected with embedded radio inputs, `menuitem` when the
 *   list is part of an `mdcMenu`. Otherwise there will be no `role` attribute, so the default
 *   role for a standard list item (`role=listitem`) will apply.
 * * Single selection lists set the `aria-selected` or `aria-current` attributes, based on the
 *   chosen `selectionMode` of the list. Please see [WAI-ARIA aria-current](https://www.w3.org/TR/wai-aria-1.1/#aria-current)
 *   for recommendations.
 * * `aria-checked` will be set for lists with embedded checkbox or radio inputs.
 * * Disabled list items will be included in the keyboard navigation. This follows
 *   [focusability of disabled controls](https://www.w3.org/TR/wai-aria-practices-1.1/#kbd_disabled_controls)
 *   recommendations in the ARIA practices article. Exception: when the list is part of an `mdcMenu` or `mdcSelect`,
 *   disabled items are not included in the keyboard navigation.
 * * As the user navigates through the list, any button and anchor elements within list items that are not focused
 *   will receive `tabindex=-1`. When the list item receives focus, those elements will receive `tabindex=0`.
 *   This allows for the user to tab through list item elements and then tab to the first element after the list.
 * * Lists are interactive by default (unless `nonInteractive` is set on the `mdcList`). List items will
 *   show ripples when interacted with.
 * * `aria-disabled` will be set for disabled list items. When the list uses checkbox or radio inputs to control
 *   the checked state, the disabled state will mirror the state of those inputs.
 */
class MdcListItemDirective extends AbstractMdcRipple {
    constructor(_elm, rndr, registry, doc) {
        super(_elm, rndr, registry, doc);
        this._elm = _elm;
        /** @internal */
        this._cls = true;
        /** @internal */
        this._role = null;
        /** @internal */
        this._ariaActive = null;
        this._initialized = false;
        this._interactive = true;
        this._disabled = false;
        this._active = false;
        /** @internal (called valueChanged instead of valueChange so that library consumers cannot by accident use
         * this for two-way binding) */
        this.valueChanged = new EventEmitter();
        /** @internal */
        this._activationRequest = new ReplaySubject(1);
        /**
         * Event emitted for user action on the list item, including keyboard and mouse actions.
         * This will not emit when the `mdcList` has `nonInteractive` set.
         */
        this.action = new EventEmitter();
        /**
         * Event emitted when the active state of a list item in a single-selection list
         * (`selectionMode` is `single` or `active`) is changed. This event does not emit
         * for lists that do not have the mentioned `selectionMode`, and therefore does also
         * not emit for lists where the active/selected state is controlled by embedded checkbox
         * or radio inputs. (Note that for lists controlled by an `mdcSelect`, the `selectionMode`
         * will be either `single` or `active`).
         */
        this.selectedChange = new EventEmitter();
        this._value = null;
    }
    ngAfterContentInit() {
        this._initialized = true;
        if (this._interactive)
            this.initRipple();
    }
    ngOnDestroy() {
        this.destroyRipple();
    }
    /** @internal */
    _setInteractive(interactive) {
        if (this._interactive !== interactive) {
            this._interactive = interactive;
            if (this._initialized) {
                if (this._interactive)
                    this.initRipple();
                else
                    this.destroyRipple();
            }
        }
    }
    /**
     * If set to a value other than false, the item will be disabled. This affects styling
     * and selectability, and may affect keyboard navigation.
     * This input is ignored for lists where the selection is controlled by embedded checkbox
     * or radio inputs. In those cases the disabled state of the input will be used instead.
     */
    get disabled() {
        if (this._ariaActive === 'checked') {
            const input = this._getInput();
            return input ? input._elm.nativeElement.disabled : false;
        }
        return this._disabled;
    }
    set disabled(val) {
        this._disabled = asBoolean(val);
    }
    /**
     * Assign this field with a value that should be reflected in the `value` property of
     * a `selectionMode=single|active` or and `mdcMenu` or `mdcSelect` for the active property.
     * Ignored for lists that don't offer a selection, and for lists that use checkbox/radio
     * inputs for selection.
     */
    get value() {
        return this._value;
    }
    set value(newValue) {
        if (this._value !== newValue) {
            this._value = newValue;
            this.valueChanged.emit(newValue);
        }
    }
    /**
     * This input can be used to change the active or selected state of the item. This should *not* be used for lists
     * inside an `mdcSelect`/`mdcMenu`, or for lists that use checkbox/radio inputs for selection.
     * Depending on the `selectionMode` of the list this will update the `selected` or `active` state of the item.
     */
    set selected(val) {
        let newValue = asBoolean(val);
        if (newValue !== this._active)
            this._activationRequest.next(val);
    }
    /** @internal */
    get _selected() {
        return (this._ariaActive === 'selected' && this._active)
            || (!this._role && this._active);
    }
    /** @internal */
    get _activated() {
        return this._ariaActive === 'current' && this._active;
    }
    /** @internal */
    get _ariaDisabled() {
        if (this.disabled) // checks checkbox/radio disabled state when appropriate
            return 'true';
        return null;
    }
    /** @internal */
    get _ariaCurrent() {
        if (this._ariaActive === 'current')
            return this._active ? 'true' : 'false';
        return null;
    }
    /** @internal */
    get _ariaSelected() {
        if (this._ariaActive === 'selected')
            return this._active ? 'true' : 'false';
        return null;
    }
    /** @internal */
    get _ariaChecked() {
        if (this._ariaActive === 'checked')
            // (this.active: returns checked value of embedded input if appropriate)
            return this.active ? 'true' : 'false';
        return null;
    }
    /** @internal */
    get active() {
        if (this._ariaActive === 'checked') {
            const input = this._getInput();
            return input ? input._elm.nativeElement.checked : false;
        }
        return this._active;
    }
    /** @internal */
    set active(value) {
        if (value !== this._active) {
            this._active = value;
            this.selectedChange.emit(value);
        }
    }
    /** @internal */
    _getRadio() {
        var _a;
        return (_a = this._radios) === null || _a === void 0 ? void 0 : _a.first;
    }
    /** @internal */
    _getCheckbox() {
        var _a;
        return (_a = this._checkBoxes) === null || _a === void 0 ? void 0 : _a.first;
    }
    /** @internal */
    _getInput() {
        var _a;
        return (_a = (this._getCheckbox() || this._getRadio())) === null || _a === void 0 ? void 0 : _a._input;
    }
}
MdcListItemDirective.ɵfac = function MdcListItemDirective_Factory(t) { return new (t || MdcListItemDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcListItemDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcListItemDirective, selectors: [["", "mdcListItem", ""]], contentQueries: function MdcListItemDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcRadioDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcCheckboxDirective, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._radios = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._checkBoxes = _t);
    } }, hostVars: 13, hostBindings: function MdcListItemDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx._role)("aria-disabled", ctx._ariaDisabled)("aria-current", ctx._ariaCurrent)("aria-selected", ctx._ariaSelected)("aria-checked", ctx._ariaChecked);
        ɵngcc0.ɵɵclassProp("mdc-list-item", ctx._cls)("mdc-list-item--disabled", ctx.disabled)("mdc-list-item--selected", ctx._selected)("mdc-list-item--activated", ctx._activated);
    } }, inputs: { disabled: "disabled", value: "value", selected: "selected" }, outputs: { valueChanged: "valueChanged", action: "action", selectedChange: "selectedChange" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcListItemDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: MdcEventRegistry },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcListItemDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-list-item',] }],
    _role: [{ type: HostBinding, args: ['attr.role',] }],
    _radios: [{ type: ContentChildren, args: [MdcRadioDirective, { descendants: true },] }],
    _checkBoxes: [{ type: ContentChildren, args: [MdcCheckboxDirective, { descendants: true },] }],
    valueChanged: [{ type: Output }],
    action: [{ type: Output }],
    selectedChange: [{ type: Output }],
    disabled: [{ type: HostBinding, args: ['class.mdc-list-item--disabled',] }, { type: Input }],
    value: [{ type: Input }],
    selected: [{ type: Input }],
    _selected: [{ type: HostBinding, args: ['class.mdc-list-item--selected',] }],
    _activated: [{ type: HostBinding, args: ['class.mdc-list-item--activated',] }],
    _ariaDisabled: [{ type: HostBinding, args: ['attr.aria-disabled',] }],
    _ariaCurrent: [{ type: HostBinding, args: ['attr.aria-current',] }],
    _ariaSelected: [{ type: HostBinding, args: ['attr.aria-selected',] }],
    _ariaChecked: [{ type: HostBinding, args: ['attr.aria-checked',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcListItemDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcListItem]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: MdcEventRegistry }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-list-item']
        }], _role: [{
            type: HostBinding,
            args: ['attr.role']
        }], valueChanged: [{
            type: Output
        }], action: [{
            type: Output
        }], selectedChange: [{
            type: Output
        }], disabled: [{
            type: HostBinding,
            args: ['class.mdc-list-item--disabled']
        }, {
            type: Input
        }], value: [{
            type: Input
        }], selected: [{
            type: Input
        }], _selected: [{
            type: HostBinding,
            args: ['class.mdc-list-item--selected']
        }], _activated: [{
            type: HostBinding,
            args: ['class.mdc-list-item--activated']
        }], _ariaDisabled: [{
            type: HostBinding,
            args: ['attr.aria-disabled']
        }], _ariaCurrent: [{
            type: HostBinding,
            args: ['attr.aria-current']
        }], _ariaSelected: [{
            type: HostBinding,
            args: ['attr.aria-selected']
        }], _ariaChecked: [{
            type: HostBinding,
            args: ['attr.aria-checked']
        }], _radios: [{
            type: ContentChildren,
            args: [MdcRadioDirective, { descendants: true }]
        }], _checkBoxes: [{
            type: ContentChildren,
            args: [MdcCheckboxDirective, { descendants: true }]
        }] }); })();
/**
 * Directive to mark the text portion(s) of an `mdcListItem`. This directive should be the child of an `mdcListItem`.
 * For single line lists, the text can be added directly to this directive.
 * For two line lists, add `mdcListItemPrimaryText` and `mdcListItemSecondaryText` children.
 */
class MdcListItemTextDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcListItemTextDirective.ɵfac = function MdcListItemTextDirective_Factory(t) { return new (t || MdcListItemTextDirective)(); };
MdcListItemTextDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcListItemTextDirective, selectors: [["", "mdcListItemText", ""]], hostVars: 2, hostBindings: function MdcListItemTextDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-list-item__text", ctx._cls);
    } } });
MdcListItemTextDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-list-item__text',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcListItemTextDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcListItemText]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-list-item__text']
        }] }); })();
/**
 * Directive to mark the first line of an item with "two line list" styling.
 * This directive, if used, should be the child of an `mdcListItemText`.
 * Using this directive will put the list "two line" mode.
 */
class MdcListItemPrimaryTextDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcListItemPrimaryTextDirective.ɵfac = function MdcListItemPrimaryTextDirective_Factory(t) { return new (t || MdcListItemPrimaryTextDirective)(); };
MdcListItemPrimaryTextDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcListItemPrimaryTextDirective, selectors: [["", "mdcListItemPrimaryText", ""]], hostVars: 2, hostBindings: function MdcListItemPrimaryTextDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-list-item__primary-text", ctx._cls);
    } } });
MdcListItemPrimaryTextDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-list-item__primary-text',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcListItemPrimaryTextDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcListItemPrimaryText]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-list-item__primary-text']
        }] }); })();
/**
 * Directive for the secondary text of an item with "two line list" styling.
 * This directive, if used, should be the child of an `mdcListItemText`, and
 * come after the `mdcListItemPrimaryText`.
 */
class MdcListItemSecondaryTextDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcListItemSecondaryTextDirective.ɵfac = function MdcListItemSecondaryTextDirective_Factory(t) { return new (t || MdcListItemSecondaryTextDirective)(); };
MdcListItemSecondaryTextDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcListItemSecondaryTextDirective, selectors: [["", "mdcListItemSecondaryText", ""]], hostVars: 2, hostBindings: function MdcListItemSecondaryTextDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-list-item__secondary-text", ctx._cls);
    } } });
MdcListItemSecondaryTextDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-list-item__secondary-text',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcListItemSecondaryTextDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcListItemSecondaryText]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-list-item__secondary-text']
        }] }); })();
/**
 * Directive for the start detail item of a list item.
 * This directive, if used, should be the child of an`mdcListItem`.
 */
class MdcListItemGraphicDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcListItemGraphicDirective.ɵfac = function MdcListItemGraphicDirective_Factory(t) { return new (t || MdcListItemGraphicDirective)(); };
MdcListItemGraphicDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcListItemGraphicDirective, selectors: [["", "mdcListItemGraphic", ""]], hostVars: 2, hostBindings: function MdcListItemGraphicDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-list-item__graphic", ctx._cls);
    } } });
MdcListItemGraphicDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-list-item__graphic',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcListItemGraphicDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcListItemGraphic]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-list-item__graphic']
        }] }); })();
/**
 * Directive for the end detail item of a list item.
 * This directive, if used, should be the child of an `mdcListItem`.
 */
class MdcListItemMetaDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcListItemMetaDirective.ɵfac = function MdcListItemMetaDirective_Factory(t) { return new (t || MdcListItemMetaDirective)(); };
MdcListItemMetaDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcListItemMetaDirective, selectors: [["", "mdcListItemMeta", ""]], hostVars: 2, hostBindings: function MdcListItemMetaDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-list-item__meta", ctx._cls);
    } } });
MdcListItemMetaDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-list-item__meta',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcListItemMetaDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcListItemMeta]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-list-item__meta']
        }] }); })();
/** @docs-private */
var MdcListFunction;
(function (MdcListFunction) {
    MdcListFunction[MdcListFunction["plain"] = 0] = "plain";
    MdcListFunction[MdcListFunction["menu"] = 1] = "menu";
    MdcListFunction[MdcListFunction["select"] = 2] = "select";
})(MdcListFunction || (MdcListFunction = {}));
;
// attributes on list-items that we maintain ourselves, so should be ignored
// in the adapter:
const ANGULAR_ITEM_ATTRIBUTES = [
    strings.ARIA_CHECKED, strings.ARIA_SELECTED, strings.ARIA_CURRENT, strings.ARIA_DISABLED
];
// classes on list-items that we maintain ourselves, so should be ignored
// in the adapter:
const ANGULAR_ITEM_CLASSES = [
    cssClasses$1.LIST_ITEM_DISABLED_CLASS, cssClasses$1.LIST_ITEM_ACTIVATED_CLASS, cssClasses$1.LIST_ITEM_SELECTED_CLASS
];
/**
 * Lists are continuous, vertical indexes of text or images. They can be interactive, and may support
 * selaction/activation of list of items. Single-line and Two-line lists are supported, as well as
 * starting and end details (images or controls) on a list. A list contains `mdcListItem` children,
 * and may also contain `mdcListDivider` children.
 *
 * A list can be used by itself, or contained inside `mdcListGroup`, `mdcMenu`, or `mdcSelect`.
 *
 * # Accessibility
 * * See Accessibility section of `mdcListItem` for navigation, focus, and tab(index) affordances.
 * * The `role` attribute will be set to `listbox` for single selection lists (`selectionMode` is `single`
 *   or `active`), to `radiogroup` when selection is triggered by embedded radio inputs, to
 *   `checkbox` when selection is triggered by embedded checkbox inputs, to `menu` when used inside
 *   `mdcMenu`. Otherwise there will be no `role` attribute, so the default role for a standard list
 *   (`role=list`) will apply.
 * * You should set an appropriate `label` for checkbox based selection lists. The
 *   `label` will be reflected to the `aria-label` attribute.
 */
class MdcListDirective {
    constructor(_elm, rndr, cdRef, doc) {
        this._elm = _elm;
        this.rndr = rndr;
        this.cdRef = cdRef;
        this.onDestroy$ = new Subject();
        /** @internal */
        this._cls = true;
        /** @internal */
        this.itemsChanged = new EventEmitter();
        /** @internal */
        this.itemValuesChanged = new EventEmitter();
        /** @internal */
        this.itemAction = new EventEmitter();
        /** @internal */
        this._twoLine = false;
        /**
         * Label announcing the purpose of the list. Should be set for lists that embed checkbox inputs
         * for activation/selection. The label is reflected in the `aria-label` attribute value.
         *
         * @internal
         */
        this.label = null;
        /**
         * Link to the id of an element that announces the purpose of the list. This will be set automatically
         * to the id of the `mdcFloatingLabel` when the list is part of an `mdcSelect`.
         *
         * @internal
         */
        this.labelledBy = null;
        this._function = MdcListFunction.plain;
        /** @internal */
        this._hidden = false;
        this._dense = false;
        this._avatar = false;
        this._nonInteractive = false;
        this._selectionMode = null;
        this._wrapFocus = false;
        this.mdcAdapter = {
            getAttributeForElementIndex: (index, attr) => {
                var _a, _b;
                if (attr === strings.ARIA_CURRENT)
                    return (_a = this.getItem(index)) === null || _a === void 0 ? void 0 : _a._ariaCurrent;
                return (_b = this.getItem(index)) === null || _b === void 0 ? void 0 : _b._elm.nativeElement.getAttribute(attr);
            },
            getListItemCount: () => this._items.length,
            getFocusedElementIndex: () => this._items.toArray().findIndex(i => i._elm.nativeElement === this.document.activeElement),
            setAttributeForElementIndex: (index, attribute, value) => {
                var _a;
                // ignore attributes we maintain ourselves
                if (!ANGULAR_ITEM_ATTRIBUTES.find(a => a === attribute)) {
                    const elm = (_a = this.getItem(index)) === null || _a === void 0 ? void 0 : _a._elm.nativeElement;
                    if (elm)
                        this.rndr.setAttribute(elm, attribute, value);
                }
            },
            addClassForElementIndex: (index, className) => {
                var _a;
                if (!ANGULAR_ITEM_CLASSES.find(c => c === className)) {
                    const elm = (_a = this.getItem(index)) === null || _a === void 0 ? void 0 : _a._elm.nativeElement;
                    if (elm)
                        this.rndr.addClass(elm, className);
                }
            },
            removeClassForElementIndex: (index, className) => {
                var _a;
                if (!ANGULAR_ITEM_CLASSES.find(c => c === className)) {
                    const elm = (_a = this.getItem(index)) === null || _a === void 0 ? void 0 : _a._elm.nativeElement;
                    if (elm)
                        this.rndr.addClass(elm, className);
                }
            },
            focusItemAtIndex: (index) => { var _a; return (_a = this.getItem(index)) === null || _a === void 0 ? void 0 : _a._elm.nativeElement.focus(); },
            setTabIndexForListItemChildren: (index, tabIndexValue) => {
                var _a;
                // TODO check this plays nice with our own components (mdcButton etc.)
                // TODO build this in an abstract class for our own elements?
                // TODO limit to our own elements/custom directive?
                const elm = (_a = this.getItem(index)) === null || _a === void 0 ? void 0 : _a._elm.nativeElement;
                const listItemChildren = [].slice.call(elm.querySelectorAll(strings.CHILD_ELEMENTS_TO_TOGGLE_TABINDEX));
                listItemChildren.forEach((el) => this.rndr.setAttribute(el, 'tabindex', tabIndexValue));
            },
            hasRadioAtIndex: () => this._role === 'radiogroup',
            hasCheckboxAtIndex: () => this._role === 'group',
            isCheckboxCheckedAtIndex: (index) => { var _a, _b, _c; return !!((_c = (_b = (_a = this.getItem(index)) === null || _a === void 0 ? void 0 : _a._getCheckbox()) === null || _b === void 0 ? void 0 : _b._input) === null || _c === void 0 ? void 0 : _c.checked); },
            isRootFocused: () => this.document.activeElement === this._elm.nativeElement,
            listItemAtIndexHasClass: (index, className) => {
                var _a, _b;
                if (className === cssClasses$1.LIST_ITEM_DISABLED_CLASS)
                    return !!((_a = this.getItem(index)) === null || _a === void 0 ? void 0 : _a.disabled);
                return !!((_b = this.getItem(index)) === null || _b === void 0 ? void 0 : _b._elm.nativeElement.classList.contains(className));
            },
            setCheckedCheckboxOrRadioAtIndex: (index, isChecked) => {
                var _a, _b, _c, _d;
                const item = this.getItem(index);
                const input = (_b = (_a = ((item === null || item === void 0 ? void 0 : item._getRadio()) || (item === null || item === void 0 ? void 0 : item._getCheckbox()))) === null || _a === void 0 ? void 0 : _a._input) === null || _b === void 0 ? void 0 : _b._elm.nativeElement;
                if (input) {
                    input.checked = isChecked;
                    // simulate user interaction, as this is triggered from a user interaction:
                    const event = this.document.createEvent('Event');
                    event.initEvent('change', true, true);
                    input.dispatchEvent(event);
                    // checkbox input listens to clicks, not changed events, so let it know about the change:
                    (_d = (_c = item === null || item === void 0 ? void 0 : item._getCheckbox()) === null || _c === void 0 ? void 0 : _c._input) === null || _d === void 0 ? void 0 : _d._onChange();
                }
            },
            notifyAction: (index) => {
                const item = this.getItem(index);
                if (item && !(item === null || item === void 0 ? void 0 : item.disabled)) {
                    item.action.emit();
                    this.itemAction.emit({ index, value: item.value });
                }
            },
            isFocusInsideList: () => {
                return this._elm.nativeElement.contains(this.document.activeElement);
            },
        };
        this.document = doc; // work around ngc issue https://github.com/angular/angular/issues/20351
    }
    ngAfterContentInit() {
        merge(this._checkboxes.changes, this._radios.changes).pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.updateItems();
            this.updateLayout();
            this.updateFoundationSelections();
        });
        this._items.changes.subscribe(() => {
            // when number of items changes, we have to reinitialize the foundation, because
            // the focusused item index that the foundation keeps may be invalidated:
            this.destroyFoundation();
            this.updateItems();
            this.initFoundation();
            this.itemsChanged.emit();
            this.itemValuesChanged.emit();
            merge(this._items.map(item => item.valueChanged.asObservable())).pipe(takeUntil(this.onDestroy$), takeUntil(this.itemsChanged), debounceTime(1)).subscribe(() => {
                this.itemValuesChanged.emit();
            });
            this.subscribeItemActivationRequests();
        });
        this._primaryTexts.changes.subscribe(_ => this._twoLine = this._primaryTexts.length > 0);
        this.updateItems();
        this._twoLine = this._primaryTexts.length > 0;
        this.initFoundation();
        this.subscribeItemActivationRequests();
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
        this.destroyFoundation();
    }
    initFoundation() {
        this.foundation = new MDCListFoundation(this.mdcAdapter);
        this.foundation.init();
        this.updateLayout();
        const focus = this.getListItemIndex({ target: this.document.activeElement });
        if (focus !== -1) // only way to restore focus when a list item already had focus:
            this.foundation['focusedItemIndex_'] = focus;
        this.updateFoundationSelections();
        this.foundation.setWrapFocus(this._wrapFocus);
    }
    destroyFoundation() {
        var _a;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        this.foundation = null;
    }
    subscribeItemActivationRequests() {
        this._items.map(item => {
            item._activationRequest.asObservable().pipe(takeUntil(this.onDestroy$), takeUntil(this.itemsChanged)).subscribe(active => this.activateOrSelectItem(item, active));
        });
    }
    updateItems() {
        let itemRole = {
            'menu': 'menuitem',
            'listbox': 'option',
            'group': 'checkbox',
            'radiogroup': 'radio'
        }[this._role] || null;
        let ariaActive = {
            'menu': null,
            'listbox': this._selectionMode === 'active' ? 'current' : 'selected',
            'group': 'checked',
            'radiogroup': 'checked'
        }[this._role] || null;
        if (this._items) {
            const firstTabbable = this._nonInteractive ? null :
                this._items.find(item => item._elm.nativeElement.tabIndex === 0) ||
                    this._items.find(item => item.active) ||
                    this._items.first;
            this._items.forEach(item => {
                item._role = itemRole;
                item._ariaActive = ariaActive;
                item._setInteractive(!this._nonInteractive);
                if (this._nonInteractive)
                    // not focusable if not interactive:
                    this.rndr.removeAttribute(item._elm.nativeElement, 'tabindex');
                this.rndr.setAttribute(item._elm.nativeElement, 'tabindex', item === firstTabbable ? '0' : '-1');
            });
            // child components were updated (in updateItems above)
            // let angular know to prevent ExpressionChangedAfterItHasBeenCheckedError:
            this.cdRef.detectChanges();
        }
    }
    updateLayout() {
        var _a;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.layout();
    }
    updateFoundationSelections() {
        var _a, _b;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setSingleSelection(this._role === 'listbox');
        (_b = this.foundation) === null || _b === void 0 ? void 0 : _b.setSelectedIndex(this.getSelection());
    }
    updateItemSelections(active) {
        const activeIndexes = typeof active === 'number' ? [active] : active;
        // first deactivate, then activate
        this._items.toArray().forEach((item, idx) => {
            if (activeIndexes.indexOf(idx) === -1)
                item.active = false;
        });
        this._items.toArray().forEach((item, idx) => {
            if (activeIndexes.indexOf(idx) !== -1)
                item.active = true;
        });
    }
    activateOrSelectItem(item, active) {
        var _a;
        let activeIndexes = -1;
        if (!active) {
            if (this._role === 'group' || !this._role)
                activeIndexes = this._items.toArray().map((v, i) => v.active && v !== item ? i : null).filter(i => i != null);
            else if (this._role === 'listbox' || this._role === 'radiogroup' || this._role === 'menu')
                activeIndexes = this._items.toArray().findIndex(i => i.active && i !== item);
        }
        else {
            if (this._role === 'group' || !this._role)
                activeIndexes = this._items.toArray().map((v, i) => v.active || v === item ? i : null).filter(i => i != null);
            else if (this._role === 'listbox' || this._role === 'radiogroup' || this._role === 'menu')
                activeIndexes = this._items.toArray().findIndex(i => i === item);
        }
        if (this._role === 'group' || this._role === 'listbox' || this._role === 'radiogroup' || this._role === 'menu')
            (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setSelectedIndex(activeIndexes);
        this.updateItemSelections(activeIndexes);
        this.cdRef.detectChanges();
    }
    getSelection(forFoundation = true) {
        if (this._role === 'listbox' || this._role === 'radiogroup' || this._role === 'menu')
            return this._items.toArray().findIndex(i => i.active);
        if (this._role === 'group')
            return this._items.toArray().map((v, i) => v.active ? i : null).filter(i => i != null);
        return forFoundation ? -1 : this._items.toArray().map((v, i) => v.active ? i : null).filter(i => i != null);
    }
    /** @internal */
    getSelectedItem() {
        if (this._role === 'listbox' || this._role === 'radiogroup' || this._role === 'menu')
            return this._items.find(i => i.active);
        return null;
    }
    /** @internal */
    get _role() {
        if (this._function === MdcListFunction.menu)
            return 'menu';
        if (this._function === MdcListFunction.select)
            return 'listbox';
        if (this._selectionMode === 'single' || this._selectionMode === 'active')
            return 'listbox';
        if (this._checkboxes && this._checkboxes.length > 0)
            return 'group';
        if (this._radios && this._radios.length > 0)
            return 'radiogroup';
        return null;
    }
    /** @internal */
    get _ariaHidden() {
        return (this._hidden && this._function === MdcListFunction.menu) ? 'true' : null;
    }
    /** @internal */
    get _ariaOrientation() {
        return this._function === MdcListFunction.menu ? 'vertical' : null;
    }
    /** @internal */
    get _isMenu() {
        return this._function === MdcListFunction.menu;
    }
    /** @internal */
    get _tabindex() {
        // the root of a menu should be focusable
        return this._function === MdcListFunction.menu ? "-1" : null;
    }
    /** @internal */
    _setFunction(val) {
        var _a;
        this._function = val;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setSingleSelection(this._role === 'listbox');
        this.updateItems();
    }
    /**
     * When this input is defined and does not have value false, the list will be styled more
     * compact.
     */
    get dense() {
        return this._dense;
    }
    set dense(val) {
        this._dense = asBoolean(val);
    }
    /**
     * When set to `single` or `active`, the list will act as a single-selection-list.
     * This enables the enter and space keys for selecting/deselecting a list item,
     * and sets the appropriate accessibility options.
     * When not set, the list will not act as a single-selection-list.
     *
     * When using `single`, the active selection is announced with `aria-selected`
     * attributes on the list elements. When using `active`, the active selection
     * is announced with `aria-current`. See [WAI-ARIA aria-current](https://www.w3.org/TR/wai-aria-1.1/#aria-current)
     * article for recommendations on usage.
     *
     * The selectionMode is ignored when there are embedded checkbox or radio inputs inside the list, in which case
     * those inputs will trigger selection of list items.
     */
    get selectionMode() {
        return this._selectionMode;
    }
    set selectionMode(val) {
        if (val !== this._selectionMode) {
            if (val === 'single' || val === 'active')
                this._selectionMode = val;
            else
                this._selectionMode = null;
            this.updateItems();
            if (this.foundation) {
                this.foundation.setSingleSelection(this._role === 'listbox');
                this.foundation.setSelectedIndex(this.getSelection());
                this.updateItemSelections(this.getSelection(false));
            }
        }
    }
    /**
     * When this input is defined and does not have value false, the list will be made
     * non-interactive. Users will not be able to interact with list items, and the styling will
     * reflect this (e.g. by not adding ripples to the items).
     */
    get nonInteractive() {
        return this._nonInteractive;
    }
    set nonInteractive(val) {
        let newValue = asBoolean(val);
        if (newValue !== this._nonInteractive) {
            this._nonInteractive = newValue;
            this.updateItems();
        }
    }
    /**
     * When this input is defined and does not have value false, focus will wrap from last to
     * first and vice versa when using keyboard navigation through list items.
     */
    get wrapFocus() {
        return this._wrapFocus;
    }
    set wrapFocus(val) {
        var _a;
        this._wrapFocus = asBoolean(val);
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setWrapFocus(this._wrapFocus);
    }
    /**
     * When this input is defined and does not have value false, elements with directive <code>mdcListItemGraphic</code>
     * will be styled for avatars: large, circular elements that lend themselves well to contact images, profile pictures, etc.
     */
    get avatarList() {
        return this._avatar;
    }
    set avatarList(val) {
        this._avatar = asBoolean(val);
    }
    /** @internal */
    _onFocusIn(event) {
        if (this.foundation && !this._nonInteractive) {
            this.foundation.setSelectedIndex(this.getSelection());
            const index = this.getListItemIndex(event);
            this.foundation.handleFocusIn(event, index);
        }
    }
    /** @internal */
    _onFocusOut(event) {
        if (this.foundation && !this._nonInteractive) {
            this.foundation.setSelectedIndex(this.getSelection());
            const index = this.getListItemIndex(event);
            this.foundation.handleFocusOut(event, index);
        }
    }
    /** @internal */
    _onKeydown(event) {
        var _a;
        if (this.foundation && !this._nonInteractive) {
            this.foundation.setSelectedIndex(this.getSelection());
            const index = this.getListItemIndex(event);
            const onRoot = ((_a = this.getItem(index)) === null || _a === void 0 ? void 0 : _a._elm.nativeElement) === event.target;
            this.foundation.handleKeydown(event, onRoot, index);
            if (this._role === 'listbox')
                this.updateItemSelections(this.foundation.getSelectedIndex());
        }
    }
    /** @internal */
    _onClick(event) {
        var _a, _b, _c, _d;
        if (this.foundation && !this._nonInteractive) {
            this.foundation.setSelectedIndex(this.getSelection());
            const index = this.getListItemIndex(event);
            // only toggle radio/checkbox input if it's not already toggled from the event:
            const inputElement = ((_b = (_a = this.getItem(index)) === null || _a === void 0 ? void 0 : _a._getCheckbox()) === null || _b === void 0 ? void 0 : _b._input._elm.nativeElement) || ((_d = (_c = this.getItem(index)) === null || _c === void 0 ? void 0 : _c._getRadio()) === null || _d === void 0 ? void 0 : _d._input._elm.nativeElement);
            const toggleInput = event.target !== inputElement;
            this.foundation.handleClick(index, toggleInput);
            if (this._role === 'listbox')
                this.updateItemSelections(this.foundation.getSelectedIndex());
        }
    }
    /** @internal */
    getItem(index) {
        if (index >= 0 && index < this._items.length)
            return this._items.toArray()[index];
        return null;
    }
    /** @internal */
    getItems() {
        var _a;
        return ((_a = this._items) === null || _a === void 0 ? void 0 : _a.toArray()) || [];
    }
    /** @internal */
    getItemByElement(element) {
        var _a;
        return ((_a = this._items) === null || _a === void 0 ? void 0 : _a.find(i => i._elm.nativeElement === element)) || null;
    }
    getListItemIndex(evt) {
        let eventTarget = evt.target;
        const itemElements = this._items.map(item => item._elm.nativeElement);
        while (eventTarget && eventTarget !== this._elm.nativeElement) {
            const index = itemElements.findIndex(e => e === eventTarget);
            if (index !== -1)
                return index;
            eventTarget = eventTarget.parentElement;
        }
        return -1;
    }
}
MdcListDirective.ɵfac = function MdcListDirective_Factory(t) { return new (t || MdcListDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcListDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcListDirective, selectors: [["", "mdcList", ""]], contentQueries: function MdcListDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcListItemDirective, false);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcListItemPrimaryTextDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcCheckboxDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcRadioDirective, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._items = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._primaryTexts = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._checkboxes = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._radios = _t);
    } }, hostVars: 18, hostBindings: function MdcListDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focusin", function MdcListDirective_focusin_HostBindingHandler($event) { return ctx._onFocusIn($event); })("focusout", function MdcListDirective_focusout_HostBindingHandler($event) { return ctx._onFocusOut($event); })("keydown", function MdcListDirective_keydown_HostBindingHandler($event) { return ctx._onKeydown($event); })("click", function MdcListDirective_click_HostBindingHandler($event) { return ctx._onClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.label)("aria-labelledBy", ctx.labelledBy)("role", ctx._role)("aria-hidden", ctx._ariaHidden)("aria-orientation", ctx._ariaOrientation)("tabindex", ctx._tabindex);
        ɵngcc0.ɵɵclassProp("mdc-list", ctx._cls)("mdc-list--two-line", ctx._twoLine)("mdc-menu__items", ctx._isMenu)("mdc-list--dense", ctx.dense)("mdc-list--non-interactive", ctx.nonInteractive)("mdc-list--avatar-list", ctx.avatarList);
    } }, inputs: { label: "label", labelledBy: "labelledBy", dense: "dense", selectionMode: "selectionMode", nonInteractive: "nonInteractive", wrapFocus: "wrapFocus", avatarList: "avatarList" }, outputs: { itemsChanged: "itemsChanged", itemValuesChanged: "itemValuesChanged", itemAction: "itemAction" } });
MdcListDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: ChangeDetectorRef },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcListDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-list',] }],
    _items: [{ type: ContentChildren, args: [MdcListItemDirective,] }],
    _primaryTexts: [{ type: ContentChildren, args: [MdcListItemPrimaryTextDirective, { descendants: true },] }],
    _checkboxes: [{ type: ContentChildren, args: [MdcCheckboxDirective, { descendants: true },] }],
    _radios: [{ type: ContentChildren, args: [MdcRadioDirective, { descendants: true },] }],
    itemsChanged: [{ type: Output }],
    itemValuesChanged: [{ type: Output }],
    itemAction: [{ type: Output }],
    _twoLine: [{ type: HostBinding, args: ['class.mdc-list--two-line',] }],
    label: [{ type: HostBinding, args: ['attr.aria-label',] }, { type: Input }],
    labelledBy: [{ type: HostBinding, args: ['attr.aria-labelledBy',] }, { type: Input }],
    _role: [{ type: HostBinding, args: ['attr.role',] }],
    _ariaHidden: [{ type: HostBinding, args: ['attr.aria-hidden',] }],
    _ariaOrientation: [{ type: HostBinding, args: ['attr.aria-orientation',] }],
    _isMenu: [{ type: HostBinding, args: ['class.mdc-menu__items',] }],
    _tabindex: [{ type: HostBinding, args: ['attr.tabindex',] }],
    dense: [{ type: Input }, { type: HostBinding, args: ['class.mdc-list--dense',] }],
    selectionMode: [{ type: Input }],
    nonInteractive: [{ type: Input }, { type: HostBinding, args: ['class.mdc-list--non-interactive',] }],
    wrapFocus: [{ type: Input }],
    avatarList: [{ type: Input }, { type: HostBinding, args: ['class.mdc-list--avatar-list',] }],
    _onFocusIn: [{ type: HostListener, args: ['focusin', ['$event'],] }],
    _onFocusOut: [{ type: HostListener, args: ['focusout', ['$event'],] }],
    _onKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
    _onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcListDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcList]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-list']
        }], itemsChanged: [{
            type: Output
        }], itemValuesChanged: [{
            type: Output
        }], itemAction: [{
            type: Output
        }], _twoLine: [{
            type: HostBinding,
            args: ['class.mdc-list--two-line']
        }], label: [{
            type: HostBinding,
            args: ['attr.aria-label']
        }, {
            type: Input
        }], labelledBy: [{
            type: HostBinding,
            args: ['attr.aria-labelledBy']
        }, {
            type: Input
        }], _role: [{
            type: HostBinding,
            args: ['attr.role']
        }], _ariaHidden: [{
            type: HostBinding,
            args: ['attr.aria-hidden']
        }], _ariaOrientation: [{
            type: HostBinding,
            args: ['attr.aria-orientation']
        }], _isMenu: [{
            type: HostBinding,
            args: ['class.mdc-menu__items']
        }], _tabindex: [{
            type: HostBinding,
            args: ['attr.tabindex']
        }], dense: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.mdc-list--dense']
        }], selectionMode: [{
            type: Input
        }], nonInteractive: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.mdc-list--non-interactive']
        }], wrapFocus: [{
            type: Input
        }], avatarList: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.mdc-list--avatar-list']
        }], 
    /** @internal */
    _onFocusIn: [{
            type: HostListener,
            args: ['focusin', ['$event']]
        }], 
    /** @internal */
    _onFocusOut: [{
            type: HostListener,
            args: ['focusout', ['$event']]
        }], 
    /** @internal */
    _onKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], 
    /** @internal */
    _onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], _items: [{
            type: ContentChildren,
            args: [MdcListItemDirective]
        }], _primaryTexts: [{
            type: ContentChildren,
            args: [MdcListItemPrimaryTextDirective, { descendants: true }]
        }], _checkboxes: [{
            type: ContentChildren,
            args: [MdcCheckboxDirective, { descendants: true }]
        }], _radios: [{
            type: ContentChildren,
            args: [MdcRadioDirective, { descendants: true }]
        }] }); })();
/**
 * Directive for a header inside a list group (<code>mdcListGroup</code>) directive.
 */
class MdcListGroupSubHeaderDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcListGroupSubHeaderDirective.ɵfac = function MdcListGroupSubHeaderDirective_Factory(t) { return new (t || MdcListGroupSubHeaderDirective)(); };
MdcListGroupSubHeaderDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcListGroupSubHeaderDirective, selectors: [["", "mdcListGroupSubHeader", ""]], hostVars: 2, hostBindings: function MdcListGroupSubHeaderDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-list-group__subheader", ctx._cls);
    } } });
MdcListGroupSubHeaderDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-list-group__subheader',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcListGroupSubHeaderDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcListGroupSubHeader]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-list-group__subheader']
        }] }); })();
/**
 * Directive for a material designed list group, grouping several `mdcList` lists.
 * List groups should contain elements with `mdcListGroupSubHeader`,
 * and `mdcList` directives. Lists may be separated by `mdcListSeparator` directives.
 */
class MdcListGroupDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcListGroupDirective.ɵfac = function MdcListGroupDirective_Factory(t) { return new (t || MdcListGroupDirective)(); };
MdcListGroupDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcListGroupDirective, selectors: [["", "mdcListGroup", ""]], hostVars: 2, hostBindings: function MdcListGroupDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-list-group", ctx._cls);
    } } });
MdcListGroupDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-list-group',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcListGroupDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcListGroup]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-list-group']
        }] }); })();
const LIST_DIRECTIVES = [
    MdcListDividerDirective,
    MdcListItemDirective,
    MdcListItemTextDirective,
    MdcListItemPrimaryTextDirective,
    MdcListItemSecondaryTextDirective,
    MdcListItemGraphicDirective,
    MdcListItemMetaDirective,
    MdcListDirective,
    MdcListGroupSubHeaderDirective,
    MdcListGroupDirective
];

/**
 * Directive for the title of a drawer. The use of this directive is optional.
 * If used, it should be placed as first element inside an `mdcDrawerHeader`
 */
class MdcDrawerTitleDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcDrawerTitleDirective.ɵfac = function MdcDrawerTitleDirective_Factory(t) { return new (t || MdcDrawerTitleDirective)(); };
MdcDrawerTitleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDrawerTitleDirective, selectors: [["", "mdcDrawerTitle", ""]], hostVars: 2, hostBindings: function MdcDrawerTitleDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-drawer__title", ctx._cls);
    } } });
MdcDrawerTitleDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-drawer__title',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDrawerTitleDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcDrawerTitle]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-drawer__title']
        }] }); })();
/**
 * Directive for the subtitle of a drawer. The use of this directive is optional.
 * If used, it should be placed as a sibling element of `mdcDrawerTitle`
 * inside an `mdcDrawerHeader`
 */
class MdcDrawerSubtitleDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcDrawerSubtitleDirective.ɵfac = function MdcDrawerSubtitleDirective_Factory(t) { return new (t || MdcDrawerSubtitleDirective)(); };
MdcDrawerSubtitleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDrawerSubtitleDirective, selectors: [["", "mdcDrawerSubtitle", ""]], hostVars: 2, hostBindings: function MdcDrawerSubtitleDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-drawer__subtitle", ctx._cls);
    } } });
MdcDrawerSubtitleDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-drawer__subtitle',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDrawerSubtitleDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcDrawerSubtitle]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-drawer__subtitle']
        }] }); })();
/**
 * A toolbar header is an optional first child of an `mdcDrawer`.
 * The header will not scroll with the rest of the drawer content, so is a
 * good place to place titles and account switchers.
 *
 * Directives that are typically used inside an `mdcDrawerHeader`:
 * `mdcDrawerTitle`, and `mdcDrawerSubTitle`
 */
class MdcDrawerHeaderDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcDrawerHeaderDirective.ɵfac = function MdcDrawerHeaderDirective_Factory(t) { return new (t || MdcDrawerHeaderDirective)(); };
MdcDrawerHeaderDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDrawerHeaderDirective, selectors: [["", "mdcDrawerHeader", ""]], hostVars: 2, hostBindings: function MdcDrawerHeaderDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-drawer__header", ctx._cls);
    } } });
MdcDrawerHeaderDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-drawer__header',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDrawerHeaderDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcDrawerHeader]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-drawer__header']
        }] }); })();
/**
 * Directive for the drawer content. You would typically also apply the `mdcList`
 * or `mdcListGroup` directive to the drawer content (see the examples).
 */
class MdcDrawerContentDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcDrawerContentDirective.ɵfac = function MdcDrawerContentDirective_Factory(t) { return new (t || MdcDrawerContentDirective)(); };
MdcDrawerContentDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDrawerContentDirective, selectors: [["", "mdcDrawerContent", ""]], hostVars: 2, hostBindings: function MdcDrawerContentDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-drawer__content", ctx._cls);
    } } });
MdcDrawerContentDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-drawer__content',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDrawerContentDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcDrawerContent]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-drawer__content']
        }] }); })();
class MdcDrawerScrimDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcDrawerScrimDirective.ɵfac = function MdcDrawerScrimDirective_Factory(t) { return new (t || MdcDrawerScrimDirective)(); };
MdcDrawerScrimDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDrawerScrimDirective, selectors: [["", "mdcDrawerScrim", ""]], hostVars: 2, hostBindings: function MdcDrawerScrimDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-drawer-scrim", ctx._cls);
    } } });
MdcDrawerScrimDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-drawer-scrim',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDrawerScrimDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcDrawerScrim]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-drawer-scrim']
        }] }); })();
/**
 * Directive for a (navigation) drawer. The following drawer types are
 * supported:
 * * `permanent`: the default type if none was specified.
 * * `dismissible`: the drawer is hidden by default, and can slide into view.
 *   Typically used when navigation is not common, and the main app content is
 *   prioritized.
 * * `modal`: the drawer is hidden by default. When activated, the drawer is elevated
 *   above the UI of the app. It uses a scrim to block interaction with the rest of
 *   the app with a scrim.
 *
 * Drawers may contain an `mdcDrawerHeader`, and should contain an `mdcDrawerContent`
 * directive.
 */
class MdcDrawerDirective {
    constructor(_elm, _rndr, doc, _focusTrap) {
        this._elm = _elm;
        this._rndr = _rndr;
        this._focusTrap = _focusTrap;
        /** @internal */
        this._cls = true;
        this._onDocumentClick = (event) => this.onDocumentClick(event);
        this.focusTrapHandle = null;
        this.type = 'permanent';
        this.previousFocus = null;
        this._open = null;
        this.mdcAdapter = {
            addClass: (className) => this._rndr.addClass(this._elm.nativeElement, className),
            removeClass: (className) => this._rndr.removeClass(this._elm.nativeElement, className),
            hasClass: (className) => this._elm.nativeElement.classList.contains(className),
            elementHasClass: (element, className) => element.classList.contains(className),
            saveFocus: () => this.previousFocus = this.document.activeElement,
            restoreFocus: () => {
                const prev = this.previousFocus;
                if (prev && prev.focus && this._elm.nativeElement.contains(this.document.activeElement))
                    prev.focus();
            },
            focusActiveNavigationItem: () => {
                const active = this._items.find(item => item.active);
                active === null || active === void 0 ? void 0 : active._elm.nativeElement.focus();
            },
            notifyClose: () => {
                this.fixOpenClose(false);
                this.afterClosed.emit();
                this.document.removeEventListener('click', this._onDocumentClick);
            },
            notifyOpen: () => {
                this.fixOpenClose(true);
                this.afterOpened.emit();
                if (this.type === 'modal')
                    this.document.addEventListener('click', this._onDocumentClick);
            },
            trapFocus: () => this.trapFocus(),
            releaseFocus: () => this.untrapFocus()
        };
        this.foundation = null; // MDCModalDrawerFoundation extends MDCDismissibleDrawerFoundation
        /**
         * Event emitted when the drawer is opened or closed. The event value will be
         * `true` when the drawer is opened, and `false` when the
         * drawer is closed. (When this event is triggered, the drawer is starting to open/close,
         * but the animation may not have fully completed yet)
         */
        this.openChange = new EventEmitter();
        /**
         * Event emitted after the drawer has fully opened. When this event is emitted the full
         * opening animation has completed, and the drawer is visible.
         */
        this.afterOpened = new EventEmitter();
        /**
         * Event emitted after the drawer has fully closed. When this event is emitted the full
         * closing animation has completed, and the drawer is not visible anymore.
         */
        this.afterClosed = new EventEmitter();
        this.document = doc; // work around ngc issue https://github.com/angular/angular/issues/20351
    }
    ngAfterContentInit() {
        this.initDrawer();
    }
    ngOnDestroy() {
        this.destroyDrawer();
    }
    destroyDrawer() {
        // when foundation is reconstructed and then .open() is called,
        // if these classes are still available the foundation assumes open was already called,
        // and it won't do anything:
        this._rndr.removeClass(this._elm.nativeElement, 'mdc-drawer--animate');
        this._rndr.removeClass(this._elm.nativeElement, 'mdc-drawer--closing');
        this._rndr.removeClass(this._elm.nativeElement, 'mdc-drawer--open');
        this._rndr.removeClass(this._elm.nativeElement, 'mdc-drawer--opening');
        if (this.foundation) {
            this.document.removeEventListener('click', this._onDocumentClick);
            this.foundation.destroy();
            this.foundation = null;
        }
    }
    initDrawer() {
        this.destroyDrawer();
        let newFoundation = null;
        const thiz = this;
        if (this.type === 'dismissible')
            newFoundation = new class extends MDCDismissibleDrawerFoundation {
                close() {
                    const emit = thiz._open;
                    thiz._open = false;
                    super.close();
                    emit ? thiz.openChange.emit(thiz._open) : undefined;
                }
                open() {
                    const emit = !thiz._open;
                    thiz._open = true;
                    super.open();
                    emit ? thiz.openChange.emit(thiz._open) : undefined;
                }
            }(this.mdcAdapter);
        else if (this.type === 'modal')
            newFoundation = new class extends MDCModalDrawerFoundation {
                close() {
                    const emit = thiz._open;
                    thiz._open = false;
                    super.close();
                    emit ? thiz.openChange.emit(thiz._open) : undefined;
                }
                open() {
                    const emit = !thiz._open;
                    thiz._open = true;
                    super.open();
                    emit ? thiz.openChange.emit(thiz._open) : undefined;
                }
            }(this.mdcAdapter);
        // else: permanent drawer -> doesn't need a foundation, just styling
        if (newFoundation) {
            this.foundation = newFoundation;
            newFoundation.init();
            if (this._open)
                newFoundation.open();
        }
    }
    /** @internal */
    get _isModal() {
        return this.type === 'modal';
    }
    /** @internal */
    get _isDismisible() {
        return this.type === 'dismissible';
    }
    /**
     * Set the type of drawer. Either `permanent`, `dismissible`, or `modal`.
     * The default type is `permanent`.
     */
    get mdcDrawer() {
        return this.type;
    }
    set mdcDrawer(value) {
        if (value !== 'dismissible' && value !== 'modal')
            value = 'permanent';
        if (value !== this.type) {
            this.type = value;
            this.initDrawer();
        }
    }
    /**
     * Input to open (assign value `true`) or close (assign value `false`)
     * the drawer.
     */
    get open() {
        return !!this._open;
    }
    set open(value) {
        let newValue = asBoolean(value);
        if (newValue !== this._open) {
            if (this.foundation) {
                newValue ? this.foundation.open() : this.foundation.close();
            }
            else {
                this._open = newValue;
                this.openChange.emit(newValue);
            }
        }
    }
    fixOpenClose(open) {
        // the foundation ignores calls to open/close while an opening/closing animation is running.
        // so when the animation ends, we're just going to try again
        // (needs to be done in the next micro cycle, because otherwise foundation will still think it's
        // running the opening/closing animation):
        Promise.resolve().then(() => {
            if (this._open !== open) {
                if (this._open)
                    this.foundation.open();
                else
                    this.foundation.close();
            }
        });
    }
    trapFocus() {
        this.untrapFocus();
        if (this._focusTrap)
            this.focusTrapHandle = this._focusTrap.trapFocus();
    }
    untrapFocus() {
        if (this.focusTrapHandle && this.focusTrapHandle.active) {
            this.focusTrapHandle.untrap();
            this.focusTrapHandle = null;
        }
    }
    /** @internal */
    onKeydown(event) {
        var _a;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.handleKeydown(event);
    }
    /** @internal */
    handleTransitionEnd(event) {
        var _a;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.handleTransitionEnd(event);
    }
    /** @internal */
    onDocumentClick(event) {
        var _a;
        if (this.type === 'modal') {
            // instead of listening to click event on mdcDrawerScrim (which would require wiring between
            // mdcDrawerScrim and mdcDrawer), we just listen to document clicks.
            let el = event.target;
            while (el) {
                if (el === this._elm.nativeElement)
                    return;
                el = el.parentElement;
            }
            (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.handleScrimClick();
        }
    }
}
MdcDrawerDirective.ɵfac = function MdcDrawerDirective_Factory(t) { return new (t || MdcDrawerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(AbstractMdcFocusTrap, 10)); };
MdcDrawerDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDrawerDirective, selectors: [["", "mdcDrawer", ""]], contentQueries: function MdcDrawerDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcListItemDirective, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._items = _t);
    } }, hostVars: 6, hostBindings: function MdcDrawerDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function MdcDrawerDirective_keydown_HostBindingHandler($event) { return ctx.onKeydown($event); })("transitionend", function MdcDrawerDirective_transitionend_HostBindingHandler($event) { return ctx.handleTransitionEnd($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-drawer", ctx._cls)("mdc-drawer--modal", ctx._isModal)("mdc-drawer--dismissible", ctx._isDismisible);
    } }, inputs: { mdcDrawer: "mdcDrawer", open: "open" }, outputs: { openChange: "openChange", afterOpened: "afterOpened", afterClosed: "afterClosed" } });
MdcDrawerDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: AbstractMdcFocusTrap, decorators: [{ type: Optional }, { type: Self }] }
];
MdcDrawerDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-drawer',] }],
    _items: [{ type: ContentChildren, args: [MdcListItemDirective, { descendants: true },] }],
    openChange: [{ type: Output }],
    afterOpened: [{ type: Output }],
    afterClosed: [{ type: Output }],
    _isModal: [{ type: HostBinding, args: ['class.mdc-drawer--modal',] }],
    _isDismisible: [{ type: HostBinding, args: ['class.mdc-drawer--dismissible',] }],
    mdcDrawer: [{ type: Input }],
    open: [{ type: Input }],
    onKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
    handleTransitionEnd: [{ type: HostListener, args: ['transitionend', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDrawerDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcDrawer]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: AbstractMdcFocusTrap, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-drawer']
        }], openChange: [{
            type: Output
        }], afterOpened: [{
            type: Output
        }], afterClosed: [{
            type: Output
        }], _isModal: [{
            type: HostBinding,
            args: ['class.mdc-drawer--modal']
        }], _isDismisible: [{
            type: HostBinding,
            args: ['class.mdc-drawer--dismissible']
        }], mdcDrawer: [{
            type: Input
        }], open: [{
            type: Input
        }], 
    /** @internal */
    onKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], 
    /** @internal */
    handleTransitionEnd: [{
            type: HostListener,
            args: ['transitionend', ['$event']]
        }], _items: [{
            type: ContentChildren,
            args: [MdcListItemDirective, { descendants: true }]
        }] }); })();
/**
 * Use this directive for marking the sibling element after a dismissible `mdcDrawer`.
 * This will apply styling so that the open/close animations work correctly.
 */
class MdcDrawerAppContent {
    constructor() {
        /** @internal */
        this._cls = true;
    }
    /**
     * Set this to false to disable the styling for sibbling app content of a dismissible drawer.
     * This is typically only used when your `mdcDrawer` type is dynamic. In those cases you can
     * disable the `mdcDrawerAppContent` when you set your drawer type to anything other than
     * `dismissible`.
     */
    get mdcDrawerAppContent() {
        return this._cls;
    }
    set mdcDrawerAppContent(value) {
        this._cls = asBoolean(value);
    }
}
MdcDrawerAppContent.ɵfac = function MdcDrawerAppContent_Factory(t) { return new (t || MdcDrawerAppContent)(); };
MdcDrawerAppContent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcDrawerAppContent, selectors: [["", "mdcDrawerAppContent", ""]], hostVars: 2, hostBindings: function MdcDrawerAppContent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-drawer-app-content", ctx._cls);
    } }, inputs: { mdcDrawerAppContent: "mdcDrawerAppContent" } });
MdcDrawerAppContent.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-drawer-app-content',] }],
    mdcDrawerAppContent: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcDrawerAppContent, [{
        type: Directive,
        args: [{
                selector: '[mdcDrawerAppContent]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-drawer-app-content']
        }], mdcDrawerAppContent: [{
            type: Input
        }] }); })();
const DRAWER_DIRECTIVES = [
    MdcDrawerTitleDirective,
    MdcDrawerSubtitleDirective,
    MdcDrawerHeaderDirective,
    MdcDrawerContentDirective,
    MdcDrawerScrimDirective,
    MdcDrawerDirective,
    MdcDrawerAppContent
];

/**
 * Directive for elevating an element above its surface.
 */
class MdcElevationDirective {
    constructor(rndr, _elm) {
        this.rndr = rndr;
        this._elm = _elm;
        this._z = null;
        this._transition = false;
    }
    /**
     * Input for setting the elevation (z-space). The value sould be in the range [0, 24].
     * When set to 0, the element will not be elevated! The default value is 1.
     */
    get mdcElevation() {
        return this._z == null ? 1 : this._z;
    }
    set mdcElevation(value) {
        let newValue = (value == null || value === '') ? 1 : +value;
        if (newValue < 0)
            newValue = 0;
        if (newValue > 24)
            newValue = 24;
        if (isNaN(newValue))
            newValue = 0;
        if (newValue !== this._z) {
            if (this._z != null)
                this.rndr.removeClass(this._elm.nativeElement, 'mdc-elevation--z' + this._z);
            this.rndr.addClass(this._elm.nativeElement, 'mdc-elevation--z' + newValue);
        }
        this._z = newValue;
    }
    /**
     * When this input is defined and does not have value false, changes of the elevation
     * will be animated.
     */
    get animateTransition() {
        return this._transition;
    }
    set animateTransition(value) {
        this._transition = asBoolean(value);
    }
}
MdcElevationDirective.ɵfac = function MdcElevationDirective_Factory(t) { return new (t || MdcElevationDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcElevationDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcElevationDirective, selectors: [["", "mdcElevation", ""]], hostVars: 2, hostBindings: function MdcElevationDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-elevation-transition", ctx.animateTransition);
    } }, inputs: { mdcElevation: "mdcElevation", animateTransition: "animateTransition" } });
MdcElevationDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
MdcElevationDirective.propDecorators = {
    mdcElevation: [{ type: Input }],
    animateTransition: [{ type: HostBinding, args: ['class.mdc-elevation-transition',] }, { type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcElevationDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcElevation]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { mdcElevation: [{
            type: Input
        }], animateTransition: [{
            type: HostBinding,
            args: ['class.mdc-elevation-transition']
        }, {
            type: Input
        }] }); })();

/**
 * Directive for the icon of a Floating Action Button
 * (`mdcFab`).
 */
class MdcFabIconDirective {
    constructor() {
        this._cls = true;
    }
}
MdcFabIconDirective.ɵfac = function MdcFabIconDirective_Factory(t) { return new (t || MdcFabIconDirective)(); };
MdcFabIconDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcFabIconDirective, selectors: [["", "mdcFabIcon", ""]], hostVars: 2, hostBindings: function MdcFabIconDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-fab__icon", ctx._cls);
    } } });
MdcFabIconDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-fab__icon',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcFabIconDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcFabIcon]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-fab__icon']
        }] }); })();
/**
 * Directive for the label of an extended Floating Action Button
 * (`mdcFab`). The label may be placed before or after the icon.
 * It is also possible to only have a label for an extended Floating Action
 * Button.
 */
class MdcFabLabelDirective {
    constructor() {
        this._cls = true;
    }
}
MdcFabLabelDirective.ɵfac = function MdcFabLabelDirective_Factory(t) { return new (t || MdcFabLabelDirective)(); };
MdcFabLabelDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcFabLabelDirective, selectors: [["", "mdcFabLabel", ""]], hostVars: 2, hostBindings: function MdcFabLabelDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-fab__label", ctx._cls);
    } } });
MdcFabLabelDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-fab__label',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcFabLabelDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcFabLabel]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-fab__label']
        }] }); })();
/**
 * Material design Floating Action Button. The element should embed
 * an icon element with the `mdcFabIcon`, or (to make it an extended floating action button)
 * a label with the `mdcFabLabel` directive. Extended floating actions button may (in addition
 * to the label) also add an `mdcFabIcon` before or after the label.
 */
class MdcFabDirective extends AbstractMdcRipple {
    constructor(_elm, renderer, registry, doc) {
        super(_elm, renderer, registry, doc);
        this._elm = _elm;
        /** @internal */
        this._cls = true;
        this._mini = false;
        this._exited = false;
        this.addRippleSurface('mdc-fab__ripple');
    }
    ngAfterContentInit() {
        this.initRipple();
    }
    ngOnDestroy() {
        this.destroyRipple();
    }
    /**
     * When this input is defined and does not have value false, the FAB will
     * be modified to a smaller size.
     */
    get mini() {
        return this._mini;
    }
    set mini(val) {
        this._mini = asBoolean(val);
    }
    /** @docs-private */
    get extended() {
        return !!this._label;
    }
    /**
     * Setting this property to true will animate the FAB out of view.
     * Setting it to false will animate the FAB back into view.
     */
    get exited() {
        return this._exited;
    }
    set exited(val) {
        this._exited = asBoolean(val);
    }
}
MdcFabDirective.ɵfac = function MdcFabDirective_Factory(t) { return new (t || MdcFabDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcFabDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcFabDirective, selectors: [["", "mdcFab", ""]], contentQueries: function MdcFabDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcFabLabelDirective, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._label = _t.first);
    } }, hostVars: 8, hostBindings: function MdcFabDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-fab", ctx._cls)("mdc-fab--mini", ctx.mini)("mdc-fab--extended", ctx.extended)("mdc-fab--exited", ctx.exited);
    } }, inputs: { mini: "mini", exited: "exited" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: AbstractMdcRipple, useExisting: forwardRef(() => MdcFabDirective) }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcFabDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: MdcEventRegistry },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcFabDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-fab',] }],
    _label: [{ type: ContentChild, args: [MdcFabLabelDirective,] }],
    mini: [{ type: HostBinding, args: ['class.mdc-fab--mini',] }, { type: Input }],
    extended: [{ type: HostBinding, args: ['class.mdc-fab--extended',] }],
    exited: [{ type: HostBinding, args: ['class.mdc-fab--exited',] }, { type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcFabDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcFab]',
                providers: [{ provide: AbstractMdcRipple, useExisting: forwardRef(() => MdcFabDirective) }]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: MdcEventRegistry }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-fab']
        }], mini: [{
            type: HostBinding,
            args: ['class.mdc-fab--mini']
        }, {
            type: Input
        }], extended: [{
            type: HostBinding,
            args: ['class.mdc-fab--extended']
        }], exited: [{
            type: HostBinding,
            args: ['class.mdc-fab--exited']
        }, {
            type: Input
        }], _label: [{
            type: ContentChild,
            args: [MdcFabLabelDirective]
        }] }); })();
const FAB_DIRECTIVES = [
    MdcFabIconDirective, MdcFabLabelDirective, MdcFabDirective
];

/** @docs-private */
class AbstractMdcLabel {
}

class MdcFloatingLabelDirectiveBase {
}
MdcFloatingLabelDirectiveBase.ɵfac = function MdcFloatingLabelDirectiveBase_Factory(t) { return new (t || MdcFloatingLabelDirectiveBase)(); };
MdcFloatingLabelDirectiveBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcFloatingLabelDirectiveBase });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcFloatingLabelDirectiveBase, [{
        type: Directive
    }], null, null); })();
applyMixins(MdcFloatingLabelDirectiveBase, [HasId]);
/**
 * Directive for the floating label of input fields. Floating labels are used by
 * <code>mdcTextField</code> and <code>mdcSelect</code> to display the type of input
 * the field requires. Floating labels are resting when the field is inactive, and
 * float when the field is active.
 * For an <code>mdcTextField</code> the label must be added just after the
 * <code>mdcTextFieldInput</code> as a direct child of an
 * <code>mdcTextField</code>. There is no need to assign the <code>for</code>
 * attribute, as the label will automatically get its <code>for</code> attribute assigned
 * to the id of the parent <code>mdcInput</code>.
 */
class MdcFloatingLabelDirective extends MdcFloatingLabelDirectiveBase {
    constructor(_rndr, _elm, registry) {
        super();
        this._rndr = _rndr;
        this._elm = _elm;
        this.registry = registry;
        /** @internal */
        this.for = null;
        /** @internal */
        this._cls = true;
        this._mdcAdapter = {
            addClass: (className) => {
                this._rndr.addClass(this._elm.nativeElement, className);
            },
            removeClass: (className) => {
                this._rndr.removeClass(this._elm.nativeElement, className);
            },
            getWidth: () => ponyfill.estimateScrollWidth(this._elm.nativeElement),
            registerInteractionHandler: (type, handler) => {
                this.registry.listen(this._rndr, type, handler, this._elm);
            },
            deregisterInteractionHandler: (type, handler) => {
                this.registry.unlisten(type, handler);
            }
        };
        this._foundation = new MDCFloatingLabelFoundation(this._mdcAdapter);
    }
    ngOnInit() {
        this.initId();
    }
    ngAfterContentInit() {
        this._foundation.init();
    }
    ngOnDestroy() {
        this._foundation.destroy();
    }
    shake(shouldShake) {
        this._foundation.shake(shouldShake);
    }
    float(shouldFloat) {
        this._foundation.float(shouldFloat);
    }
    getWidth() {
        return this._foundation.getWidth();
    }
    isLabelElement() {
        return this._elm.nativeElement.nodeName.toLowerCase() === 'label';
    }
}
MdcFloatingLabelDirective.ɵfac = function MdcFloatingLabelDirective_Factory(t) { return new (t || MdcFloatingLabelDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry)); };
MdcFloatingLabelDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcFloatingLabelDirective, selectors: [["", "mdcFloatingLabel", ""]], hostVars: 3, hostBindings: function MdcFloatingLabelDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("for", ctx.for);
        ɵngcc0.ɵɵclassProp("mdc-floating-label", ctx._cls);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: AbstractMdcLabel, useExisting: forwardRef(() => MdcFloatingLabelDirective) }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcFloatingLabelDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: MdcEventRegistry }
];
MdcFloatingLabelDirective.propDecorators = {
    for: [{ type: HostBinding, args: ['attr.for',] }],
    _cls: [{ type: HostBinding, args: ['class.mdc-floating-label',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcFloatingLabelDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcFloatingLabel]',
                providers: [{ provide: AbstractMdcLabel, useExisting: forwardRef(() => MdcFloatingLabelDirective) }]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: MdcEventRegistry }]; }, { for: [{
            type: HostBinding,
            args: ['attr.for']
        }], _cls: [{
            type: HostBinding,
            args: ['class.mdc-floating-label']
        }] }); })();

/**
 * When placed on a child element of an <code>mdcFocusTrap</code>, the focus trap
 * will try to move focus to this element when the focus trap is activated.
 */
class MdcFocusInitialDirective extends AbstractMdcFocusInitial {
    constructor(_elm) {
        super();
        this._elm = _elm;
        /** @internal */ this.priority = 100;
    }
}
MdcFocusInitialDirective.ɵfac = function MdcFocusInitialDirective_Factory(t) { return new (t || MdcFocusInitialDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcFocusInitialDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcFocusInitialDirective, selectors: [["", "mdcFocusInitial", ""]], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: AbstractMdcFocusInitial, useExisting: forwardRef(() => MdcFocusInitialDirective) }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcFocusInitialDirective.ctorParameters = () => [
    { type: ElementRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcFocusInitialDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcFocusInitial]',
                providers: [{ provide: AbstractMdcFocusInitial, useExisting: forwardRef(() => MdcFocusInitialDirective) }]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
let activeTrap = null;
/** @docs-private */
class FocusTrapHandleImpl {
    constructor(_elm, focusElm, skipFocus) {
        this._elm = _elm;
        this._active = true;
        this.trap = null;
        if (activeTrap)
            // Stacking focus tracks (i.e. changing to another focus trap, and returning
            // to the previous on deactivation) is not supported:
            throw new Error('An mdcFocusTrap is already active.');
        this.trap = new focusTrap.FocusTrap(_elm.nativeElement, {
            initialFocusEl: focusElm || undefined,
            skipInitialFocus: skipFocus
        });
        this.trap.trapFocus();
        activeTrap = this;
    }
    untrap() {
        this._active = false;
        if (activeTrap === this) {
            activeTrap = null;
            this.trap.releaseFocus();
        }
    }
    get active() {
        return this._active;
    }
}
/**
 * Directive for trapping the tab key focus within an element. To be used
 * for e.g. modal dialogs, where focus must be constrained for an accesssible experience.
 *
 * This will only trap the keyboard focus (when using tab or shift+tab). It will not prevent the focus from moving
 * out of the trapped region due to mouse interaction. You can use a background scrim element that overlays
 * the window to achieve that. (Like `mdcDialog` does).
 *
 * Use `mdcFocusInitial` on a child element if a specific element needs to get
 * focus upon activation of the trap. In the absense of an `mdcFocusInitial`,
 * or when that element can't be focused, the focus trap will activate the first tabbable
 * child element of the focus trap.
 */
class MdcFocusTrapDirective extends AbstractMdcFocusTrap {
    constructor(_elm) {
        super();
        this._elm = _elm;
        this.trap = null;
    }
    ngOnDestroy() {
        // if this element is destroyed, it must not leave the trap in activated state:
        if (this.trap)
            this.trap.untrap();
        this.trap = null;
    }
    /** @docs-private */
    trapFocus() {
        var _a;
        let focusInitial = null;
        this._focusInitials.forEach(focus => focusInitial = (focusInitial == null || focusInitial.priority <= focus.priority) ? focus : focusInitial);
        this.trap = new FocusTrapHandleImpl(this._elm, (_a = focusInitial) === null || _a === void 0 ? void 0 : _a._elm.nativeElement, false);
        return this.trap;
    }
}
MdcFocusTrapDirective.ɵfac = function MdcFocusTrapDirective_Factory(t) { return new (t || MdcFocusTrapDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcFocusTrapDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcFocusTrapDirective, selectors: [["", "mdcFocusTrap", ""], ["", "mdcDialog", ""], ["", "mdcDrawer", ""]], contentQueries: function MdcFocusTrapDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, AbstractMdcFocusInitial, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._focusInitials = _t);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: AbstractMdcFocusTrap, useExisting: forwardRef(() => MdcFocusTrapDirective) }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcFocusTrapDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcFocusTrapDirective.propDecorators = {
    _focusInitials: [{ type: ContentChildren, args: [AbstractMdcFocusInitial, { descendants: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcFocusTrapDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcFocusTrap],[mdcDialog],[mdcDrawer]',
                providers: [{ provide: AbstractMdcFocusTrap, useExisting: forwardRef(() => MdcFocusTrapDirective) }]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _focusInitials: [{
            type: ContentChildren,
            args: [AbstractMdcFocusInitial, { descendants: true }]
        }] }); })();
const FOCUS_TRAP_DIRECTIVES = [
    MdcFocusInitialDirective, MdcFocusTrapDirective
];

let nextId$1 = 1;
class MdcFormFieldInputDirective extends AbstractMdcInput {
    constructor(_elm, _cntr) {
        super();
        this._elm = _elm;
        this._cntr = _cntr;
        this._id = null;
        this._disabled = false;
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get disabled() {
        return this._cntr ? !!this._cntr.disabled : this._disabled;
    }
    set disabled(value) {
        this._disabled = asBoolean(value);
    }
}
MdcFormFieldInputDirective.ɵfac = function MdcFormFieldInputDirective_Factory(t) { return new (t || MdcFormFieldInputDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgControl, 10)); };
MdcFormFieldInputDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcFormFieldInputDirective, selectors: [["input", "mdcFormFieldInput", ""], ["textarea", "mdcFormFieldInput", ""]], hostVars: 2, hostBindings: function MdcFormFieldInputDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("id", ctx.id)("disabled", ctx.disabled);
    } }, inputs: { id: "id", disabled: "disabled" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: AbstractMdcInput, useExisting: forwardRef(() => MdcFormFieldInputDirective) }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcFormFieldInputDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }] }
];
MdcFormFieldInputDirective.propDecorators = {
    id: [{ type: HostBinding }, { type: Input }],
    disabled: [{ type: HostBinding }, { type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcFormFieldInputDirective, [{
        type: Directive,
        args: [{
                selector: 'input[mdcFormFieldInput], textarea[mdcFormFieldInput]',
                providers: [{ provide: AbstractMdcInput, useExisting: forwardRef(() => MdcFormFieldInputDirective) }]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }]; }, { id: [{
            type: HostBinding
        }, {
            type: Input
        }], disabled: [{
            type: HostBinding
        }, {
            type: Input
        }] }); })();
class MdcFormFieldLabelDirective extends AbstractMdcLabel {
    constructor(_elm) {
        super();
        this._elm = _elm;
        this.for = null;
    }
}
MdcFormFieldLabelDirective.ɵfac = function MdcFormFieldLabelDirective_Factory(t) { return new (t || MdcFormFieldLabelDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcFormFieldLabelDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcFormFieldLabelDirective, selectors: [["label", "mdcFormFieldLabel", ""]], hostVars: 1, hostBindings: function MdcFormFieldLabelDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("for", ctx.for);
    } }, inputs: { for: "for" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: AbstractMdcLabel, useExisting: forwardRef(() => MdcFormFieldLabelDirective) }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcFormFieldLabelDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcFormFieldLabelDirective.propDecorators = {
    for: [{ type: HostBinding }, { type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcFormFieldLabelDirective, [{
        type: Directive,
        args: [{
                selector: 'label[mdcFormFieldLabel]',
                providers: [{ provide: AbstractMdcLabel, useExisting: forwardRef(() => MdcFormFieldLabelDirective) }]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { for: [{
            type: HostBinding
        }, {
            type: Input
        }] }); })();
class MdcFormFieldDirective {
    constructor(renderer, root, registry) {
        this.renderer = renderer;
        this.root = root;
        this.registry = registry;
        /** @internal */
        this._cls = true;
        this._alignEnd = false;
        this.mdcAdapter = {
            registerInteractionHandler: (type, handler) => {
                this.registry.listen(this.renderer, type, handler, this.root);
            },
            deregisterInteractionHandler: (type, handler) => {
                this.registry.unlisten(type, handler);
            },
            activateInputRipple: () => {
                if (this.rippleChild)
                    this.rippleChild.activateRipple();
            },
            deactivateInputRipple: () => {
                if (this.rippleChild)
                    this.rippleChild.deactivateRipple();
            }
        };
        this.foundation = null;
    }
    ngAfterContentInit() {
        if (this.mdcInput != null && this.mdcLabel != null) {
            if (this.mdcInput.id == null && this.mdcLabel.for == null)
                this.mdcInput.id = this.mdcLabel.for = `mdc-form-input-${nextId$1++}`;
            else if (this.mdcInput.id == null)
                this.mdcInput.id = this.mdcLabel.for;
            else if (this.mdcLabel.for == null)
                this.mdcLabel.for = this.mdcInput.id;
        }
        this.foundation = new MDCFormFieldFoundation(this.mdcAdapter);
        this.foundation.init();
    }
    ngOnDestroy() {
        var _a;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        this.foundation = null;
    }
    get alignEnd() {
        return this._alignEnd;
    }
    set alignEnd(val) {
        this._alignEnd = asBoolean(val);
    }
}
MdcFormFieldDirective.ɵfac = function MdcFormFieldDirective_Factory(t) { return new (t || MdcFormFieldDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry)); };
MdcFormFieldDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcFormFieldDirective, selectors: [["", "mdcFormField", ""]], contentQueries: function MdcFormFieldDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, AbstractMdcRipple, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, AbstractMdcInput, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, AbstractMdcLabel, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.rippleChild = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.mdcInput = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.mdcLabel = _t.first);
    } }, hostVars: 4, hostBindings: function MdcFormFieldDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-form-field", ctx._cls)("mdc-form-field--align-end", ctx.alignEnd);
    } }, inputs: { alignEnd: "alignEnd" } });
MdcFormFieldDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: MdcEventRegistry }
];
MdcFormFieldDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-form-field',] }],
    rippleChild: [{ type: ContentChild, args: [AbstractMdcRipple,] }],
    mdcInput: [{ type: ContentChild, args: [AbstractMdcInput,] }],
    mdcLabel: [{ type: ContentChild, args: [AbstractMdcLabel,] }],
    alignEnd: [{ type: Input }, { type: HostBinding, args: ['class.mdc-form-field--align-end',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcFormFieldDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcFormField]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: MdcEventRegistry }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-form-field']
        }], alignEnd: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.mdc-form-field--align-end']
        }], rippleChild: [{
            type: ContentChild,
            args: [AbstractMdcRipple]
        }], mdcInput: [{
            type: ContentChild,
            args: [AbstractMdcInput]
        }], mdcLabel: [{
            type: ContentChild,
            args: [AbstractMdcLabel]
        }] }); })();
const FORM_FIELD_DIRECTIVES = [
    MdcFormFieldInputDirective,
    MdcFormFieldLabelDirective,
    MdcFormFieldDirective
];

/**
 * Directive for an icon button. Icon buttons can be used with a font icon library such as
 * <a href="https://material.io/tools/icons" target="_blank">Google Material Icons</a>, SVG
 * elements or images. They provide material styling and a ripple to the icon. Use it on anchor and
 * button tags. For toggling icon buttons, see `MdcIconToggleDirective`.
 */
class MdcIconButtonDirective extends AbstractMdcIcon {
    constructor(_elm, renderer, registry, doc) {
        super(_elm, renderer, registry, doc);
        /** @internal */
        this._cls = true;
    }
    ngAfterContentInit() {
        this.initRipple(true);
    }
    ngOnDestroy() {
        this.destroyRipple();
    }
}
MdcIconButtonDirective.ɵfac = function MdcIconButtonDirective_Factory(t) { return new (t || MdcIconButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcIconButtonDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcIconButtonDirective, selectors: [["button", "mdcIconButton", ""], ["a", "mdcIconButton", ""]], hostVars: 2, hostBindings: function MdcIconButtonDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-icon-button", ctx._cls);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: AbstractMdcRipple, useExisting: forwardRef(() => MdcIconButtonDirective) },
            { provide: AbstractMdcIcon, useExisting: forwardRef(() => MdcIconButtonDirective) }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcIconButtonDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: MdcEventRegistry },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcIconButtonDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-icon-button',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcIconButtonDirective, [{
        type: Directive,
        args: [{
                selector: 'button[mdcIconButton],a[mdcIconButton]',
                providers: [
                    { provide: AbstractMdcRipple, useExisting: forwardRef(() => MdcIconButtonDirective) },
                    { provide: AbstractMdcIcon, useExisting: forwardRef(() => MdcIconButtonDirective) }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: MdcEventRegistry }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-icon-button']
        }] }); })();
/**
 * Directive for the icon to display on one of the toggle states of an `mdcIconToggle`. See
 * `MdcIconToggleDirective` for more information.
 */
class MdcIconDirective {
    constructor() {
        /** @internal */
        this._cls = true;
        /** @internal */
        this._on = false;
    }
    /**
     * Set this input to false to remove the ripple effect from the surface.
     */
    get mdcIcon() {
        return this._on ? 'on' : '';
    }
    set mdcIcon(value) {
        this._on = value === 'on';
    }
}
MdcIconDirective.ɵfac = function MdcIconDirective_Factory(t) { return new (t || MdcIconDirective)(); };
MdcIconDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcIconDirective, selectors: [["", "mdcIcon", ""]], hostVars: 4, hostBindings: function MdcIconDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-icon-button__icon", ctx._cls)("mdc-icon-button__icon--on", ctx._on);
    } }, inputs: { mdcIcon: "mdcIcon" } });
MdcIconDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-icon-button__icon',] }],
    _on: [{ type: HostBinding, args: ['class.mdc-icon-button__icon--on',] }],
    mdcIcon: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcIconDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcIcon]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-icon-button__icon']
        }], _on: [{
            type: HostBinding,
            args: ['class.mdc-icon-button__icon--on']
        }], mdcIcon: [{
            type: Input
        }] }); })();
/**
 * Directive for creating a Material Design icon toggle button: a button that toggles state, and
 * switches the icon based on the value of the toggle.
 *
 * When the applied icon font uses CSS pseudo elements, add a child element for the actual icon,
 * and give that element the <code>mdcIconButtonIcon</code> directive. The icon button will
 * then update the child element with the correct icon if it is toggled.
 */
class MdcIconToggleDirective extends AbstractMdcIcon {
    constructor(_elm, rndr, registry, doc) {
        super(_elm, rndr, registry, doc);
        /** @internal */
        this._cls = true;
        /**
         * The aria-label to assign to the icon toggle. You can override the value for the
         * on respectively off state by assigning to property `labelOn` or `labelOff`.
         */
        this.label = null;
        /**
         * The aria-label to assign to the icon toggle when it is on. If this input has no value,
         * the aria-label will default to the value of the `label` input.
         */
        this.labelOn = null;
        /**
         * The aria-label to assign to the icon toggle when it is off. If this input has no value,
         * the aria-label will default to the value of the `label` input.
         */
        this.labelOff = null;
        /**
         * Event emitted when the state of the icon toggle changes (for example when a user clicks
         * the icon).
         */
        this.onChange = new EventEmitter();
        this._onChange = () => { };
        this._onTouched = () => { };
        this._on = false;
        this._disabled = false;
        this.toggleAdapter = {
            addClass: (className) => this._renderer.addClass(this._elm.nativeElement, className),
            removeClass: (className) => this._renderer.removeClass(this._elm.nativeElement, className),
            // TODO return mdc-icon-button__icon--on for on...
            hasClass: (className) => this._elm.nativeElement.classList.contains(className),
            setAttr: (name, value) => this._renderer.setAttribute(this._elm.nativeElement, name, value),
            notifyChange: (evtData) => {
                this._on = evtData.isOn;
                this._onChange(this._on);
                this.onChange.emit(this._on);
            }
        };
        this.toggleFoundation = null;
    }
    ngAfterContentInit() {
        this.initRipple(true);
        this.toggleFoundation = new MDCIconButtonToggleFoundation(this.toggleAdapter);
        this.toggleFoundation.init();
    }
    ngOnDestroy() {
        var _a;
        this.destroyRipple();
        (_a = this.toggleFoundation) === null || _a === void 0 ? void 0 : _a.destroy();
        this.toggleFoundation = null;
    }
    /** @internal */
    writeValue(obj) {
        this.on = !!obj;
    }
    /** @internal */
    registerOnChange(onChange) {
        this._onChange = onChange;
    }
    /** @internal */
    registerOnTouched(onTouched) {
        this._onTouched = onTouched;
    }
    /** @internal */
    setDisabledState(disabled) {
        this._disabled = disabled;
    }
    /**
     * The current state of the icon (true for on/pressed, false for off/unpressed).
     */
    get on() {
        return this.toggleFoundation ? this.toggleFoundation.isOn() : this._on;
    }
    set on(value) {
        const old = this.toggleFoundation ? this.toggleFoundation.isOn() : this._on;
        this._on = asBoolean(value);
        if (this.toggleFoundation)
            this.toggleFoundation.toggle(this._on);
        if (this._on !== old)
            this.onChange.emit(this._on);
    }
    /** @internal */
    get _label() {
        return this._on ? (this.labelOn || this.label) : (this.labelOff || this.label);
    }
    /** @internal */
    _onClick() {
        var _a;
        (_a = this.toggleFoundation) === null || _a === void 0 ? void 0 : _a.handleClick();
    }
    /** @internal */
    _onBlur() {
        this._onTouched();
    }
    /**
     * To disable the icon, set this input to true.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = asBoolean(value);
    }
}
MdcIconToggleDirective.ɵfac = function MdcIconToggleDirective_Factory(t) { return new (t || MdcIconToggleDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcIconToggleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcIconToggleDirective, selectors: [["", "mdcIconToggle", ""]], hostVars: 4, hostBindings: function MdcIconToggleDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MdcIconToggleDirective_click_HostBindingHandler() { return ctx._onClick(); })("blur", function MdcIconToggleDirective_blur_HostBindingHandler() { return ctx._onBlur(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("disabled", ctx.disabled);
        ɵngcc0.ɵɵattribute("aria-label", ctx._label);
        ɵngcc0.ɵɵclassProp("mdc-icon-button", ctx._cls);
    } }, inputs: { label: "label", labelOn: "labelOn", labelOff: "labelOff", on: "on", disabled: "disabled" }, outputs: { onChange: "onChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: AbstractMdcRipple, useExisting: forwardRef(() => MdcIconToggleDirective) },
            { provide: AbstractMdcIcon, useExisting: forwardRef(() => MdcIconToggleDirective) }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcIconToggleDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: MdcEventRegistry },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcIconToggleDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-icon-button',] }],
    label: [{ type: Input }],
    labelOn: [{ type: Input }],
    labelOff: [{ type: Input }],
    onChange: [{ type: Output }],
    on: [{ type: Input }],
    _label: [{ type: HostBinding, args: ['attr.aria-label',] }],
    _onClick: [{ type: HostListener, args: ['click',] }],
    _onBlur: [{ type: HostListener, args: ['blur',] }],
    disabled: [{ type: Input }, { type: HostBinding }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcIconToggleDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcIconToggle]',
                providers: [
                    { provide: AbstractMdcRipple, useExisting: forwardRef(() => MdcIconToggleDirective) },
                    { provide: AbstractMdcIcon, useExisting: forwardRef(() => MdcIconToggleDirective) }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: MdcEventRegistry }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-icon-button']
        }], label: [{
            type: Input
        }], labelOn: [{
            type: Input
        }], labelOff: [{
            type: Input
        }], onChange: [{
            type: Output
        }], on: [{
            type: Input
        }], _label: [{
            type: HostBinding,
            args: ['attr.aria-label']
        }], 
    /** @internal */
    _onClick: [{
            type: HostListener,
            args: ['click']
        }], 
    /** @internal */
    _onBlur: [{
            type: HostListener,
            args: ['blur']
        }], disabled: [{
            type: Input
        }, {
            type: HostBinding
        }] }); })();
/**
 * Directive for adding Angular Forms (<code>ControlValueAccessor</code>) behavior to an
 * <code>MdcIconToggleDirective</code>. Allows the use of the Angular Forms API with
 * icon toggle buttons, e.g. binding to <code>[(ngModel)]</code>, form validation, etc.
 */
class MdcFormsIconButtonDirective {
    constructor(mdcIconButton) {
        this.mdcIconButton = mdcIconButton;
    }
    /** @docs-private */
    writeValue(obj) {
        this.mdcIconButton.writeValue(obj);
    }
    /** @docs-private */
    registerOnChange(onChange) {
        this.mdcIconButton.registerOnChange(onChange);
    }
    /** @docs-private */
    registerOnTouched(onTouched) {
        this.mdcIconButton.registerOnTouched(onTouched);
    }
    /** @docs-private */
    setDisabledState(disabled) {
        this.mdcIconButton.setDisabledState(disabled);
    }
}
MdcFormsIconButtonDirective.ɵfac = function MdcFormsIconButtonDirective_Factory(t) { return new (t || MdcFormsIconButtonDirective)(ɵngcc0.ɵɵdirectiveInject(MdcIconToggleDirective, 2)); };
MdcFormsIconButtonDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcFormsIconButtonDirective, selectors: [["", "mdcIconToggle", "", "formControlName", ""], ["", "mdcIconToggle", "", "formControl", ""], ["", "mdcIconToggle", "", "ngModel", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MdcFormsIconButtonDirective), multi: true }
        ])] });
MdcFormsIconButtonDirective.ctorParameters = () => [
    { type: MdcIconToggleDirective, decorators: [{ type: Self }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcFormsIconButtonDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcIconToggle][formControlName],[mdcIconToggle][formControl],[mdcIconToggle][ngModel]',
                providers: [
                    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MdcFormsIconButtonDirective), multi: true }
                ]
            }]
    }], function () { return [{ type: MdcIconToggleDirective, decorators: [{
                type: Self
            }] }]; }, null); })();
const ICON_BUTTON_DIRECTIVES = [
    MdcIconDirective, MdcIconButtonDirective, MdcIconToggleDirective, MdcFormsIconButtonDirective
];

const CLASS_INDETERMINATE = 'mdc-linear-progress--indeterminate';
const CLASS_REVERSED = 'mdc-linear-progress--reversed';
/**
 * Directive for creating a Material Design linear progress indicator.
 * The current implementation will add and manage all DOM child elements that
 * are required for the wrapped <code>mdc-linear-progress</code> component.
 * Future implementations will also support supplying (customized)
 * DOM children.
 */
class MdcLinearProgressDirective {
    constructor(_rndr, _root) {
        this._rndr = _rndr;
        this._root = _root;
        /** @internal */
        this._cls = true;
        /** @internal */
        this._role = 'progressbar';
        /** @internal */
        this._min = 0;
        /** @internal */
        this._max = 1;
        /** @internal */
        this._indeterminate = false;
        /** @internal */
        this._reverse = false;
        this._progress = 0;
        this._buffer = 1;
        this._closed = false;
        this._elmBuffer = null;
        this._elmPrimaryBar = null;
        /**
         * Label indicationg how the progress bar should be announced to the user.
         * Determines the ària-label` attribute value.
         */
        this.label = null;
        this.mdcAdapter = {
            addClass: (className) => {
                if (className !== CLASS_INDETERMINATE && className != CLASS_REVERSED)
                    this._rndr.addClass(this._root.nativeElement, className);
            },
            getPrimaryBar: () => this._elmPrimaryBar,
            getBuffer: () => this._elmBuffer,
            hasClass: (className) => {
                if (className === CLASS_INDETERMINATE)
                    return this._indeterminate;
                if (className === CLASS_REVERSED)
                    return this._reverse;
                return this._root.nativeElement.classList.contains(className);
            },
            removeClass: (className) => {
                if (className !== CLASS_INDETERMINATE && className != CLASS_REVERSED)
                    this._rndr.removeClass(this._root.nativeElement, className);
            },
            setStyle: (el, styleProperty, value) => {
                this._rndr.setStyle(el, styleProperty, value);
            },
            forceLayout: () => this._root.nativeElement.offsetWidth,
            removeAttribute: (name) => this._rndr.removeAttribute(this._root.nativeElement, name),
            setAttribute: (name, value) => this._rndr.setAttribute(this._root.nativeElement, name, value)
        };
        this.foundation = null;
    }
    ngAfterContentInit() {
        this.initElements();
        this.foundation = new MDCLinearProgressFoundation(this.mdcAdapter);
        this.foundation.init();
        this.foundation.setProgress(this._progress);
        this.foundation.setBuffer(this._buffer);
        if (this._closed)
            this.foundation.close();
    }
    ngOnDestroy() {
        var _a;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        this._elmPrimaryBar = null;
        this._elmBuffer = null;
    }
    initElements() {
        this.addElement(this._root.nativeElement, 'div', ['mdc-linear-progress__buffering-dots']);
        this._elmBuffer = this.addElement(this._root.nativeElement, 'div', ['mdc-linear-progress__buffer']);
        this._elmPrimaryBar = this.addElement(this._root.nativeElement, 'div', ['mdc-linear-progress__bar', 'mdc-linear-progress__primary-bar']);
        this.addElement(this._elmPrimaryBar, 'span', ['mdc-linear-progress__bar-inner']);
        const secondaryBar = this.addElement(this._root.nativeElement, 'div', ['mdc-linear-progress__bar', 'mdc-linear-progress__secondary-bar']);
        this.addElement(secondaryBar, 'span', ['mdc-linear-progress__bar-inner']);
    }
    addElement(parent, element, classNames) {
        let child = this._rndr.createElement(element);
        classNames.forEach(name => {
            this._rndr.addClass(child, name);
        });
        this._rndr.appendChild(parent, child);
        return child;
    }
    /**
     * Puts the progress indicator in 'indeterminate' state, signaling
     * that the exact progress on a measured task is not known.
     */
    get indeterminate() {
        return this._indeterminate;
    }
    set indeterminate(value) {
        let newValue = asBoolean(value);
        if (newValue !== this._indeterminate) {
            this._indeterminate = newValue;
            if (this.foundation) {
                this.foundation.setDeterminate(!this._indeterminate);
                if (!this._indeterminate) {
                    this.foundation.setProgress(this._progress);
                    this.foundation.setBuffer(this._buffer);
                }
            }
        }
    }
    /**
     * Reverses the direction of the linear progress indicator.
     */
    get reversed() {
        return this._reverse;
    }
    set reversed(value) {
        var _a;
        this._reverse = asBoolean(value);
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setReverse(this._reverse);
    }
    /**
     * Set the progress, the value should be between [0, 1].
     */
    get progressValue() {
        return this._progress;
    }
    set progressValue(value) {
        var _a;
        this._progress = +value;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setProgress(this._progress);
    }
    /**
     * Set the buffer progress, the value should be between [0, 1].
     */
    get bufferValue() {
        return this._buffer;
    }
    set bufferValue(value) {
        var _a;
        this._buffer = +value;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setBuffer(this._buffer);
    }
    /**
     * When set to true this closes (animates away) the progress bar,
     * when set to false this opens (animates into view) the progress bar.
     */
    get closed() {
        return this._closed;
    }
    set closed(value) {
        var _a, _b;
        let newValue = asBoolean(value);
        if (newValue !== this._closed) {
            this._closed = newValue;
            if (newValue)
                (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.close();
            else
                (_b = this.foundation) === null || _b === void 0 ? void 0 : _b.open();
        }
    }
}
MdcLinearProgressDirective.ɵfac = function MdcLinearProgressDirective_Factory(t) { return new (t || MdcLinearProgressDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcLinearProgressDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcLinearProgressDirective, selectors: [["", "mdcLinearProgress", ""]], hostVars: 10, hostBindings: function MdcLinearProgressDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx._role)("aria-valuemin", ctx._min)("aria-valuemax", ctx._max)("aria-label", ctx.label);
        ɵngcc0.ɵɵclassProp("mdc-linear-progress", ctx._cls)("mdc-linear-progress--indeterminate", ctx.indeterminate)("mdc-linear-progress--reversed", ctx.reversed);
    } }, inputs: { label: "label", indeterminate: "indeterminate", reversed: "reversed", progressValue: "progressValue", bufferValue: "bufferValue", closed: "closed" } });
MdcLinearProgressDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
MdcLinearProgressDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-linear-progress',] }],
    _role: [{ type: HostBinding, args: ['attr.role',] }],
    _min: [{ type: HostBinding, args: ['attr.aria-valuemin',] }],
    _max: [{ type: HostBinding, args: ['attr.aria-valuemax',] }],
    _indeterminate: [{ type: HostBinding, args: ['class.' + CLASS_INDETERMINATE,] }],
    _reverse: [{ type: HostBinding, args: ['class.' + CLASS_REVERSED,] }],
    label: [{ type: HostBinding, args: ['attr.aria-label',] }, { type: Input }],
    indeterminate: [{ type: Input }, { type: HostBinding, args: ['class.' + CLASS_INDETERMINATE,] }],
    reversed: [{ type: Input }, { type: HostBinding, args: ['class.' + CLASS_REVERSED,] }],
    progressValue: [{ type: Input }],
    bufferValue: [{ type: Input }],
    closed: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcLinearProgressDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcLinearProgress]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-linear-progress']
        }], _role: [{
            type: HostBinding,
            args: ['attr.role']
        }], _min: [{
            type: HostBinding,
            args: ['attr.aria-valuemin']
        }], _max: [{
            type: HostBinding,
            args: ['attr.aria-valuemax']
        }], _indeterminate: [{
            type: HostBinding,
            args: ['class.' + CLASS_INDETERMINATE]
        }], _reverse: [{
            type: HostBinding,
            args: ['class.' + CLASS_REVERSED]
        }], label: [{
            type: HostBinding,
            args: ['attr.aria-label']
        }, {
            type: Input
        }], indeterminate: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.' + CLASS_INDETERMINATE]
        }], reversed: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.' + CLASS_REVERSED]
        }], progressValue: [{
            type: Input
        }], bufferValue: [{
            type: Input
        }], closed: [{
            type: Input
        }] }); })();
const LINEAR_PROGRESS_DIRECTIVES = [
    MdcLinearProgressDirective
];

/**
 * The `mdcMenuSurface` is a reusable surface that appears above the content of the page
 * and can be positioned adjacent to an element. It is required as the surface for an `mdcMenu`
 * but can also be used by itself.
 */
class MdcMenuSurfaceDirective {
    constructor(_elm, rndr, doc) {
        this._elm = _elm;
        this.rndr = rndr;
        /** @internal */
        this._cls = true;
        this._open = false;
        this._openFrom = 'ts';
        // the anchor to use if no menuAnchor is provided (a direct parent MdcMenuAnchor if available):
        /** @internal */
        this._parentAnchor = null;
        /**
         * Assign an (optional) element or `mdcMenuAnchor`. If set the menu
         * will position itself relative to this anchor element. Assigning this property is not needed
         * if you wrap your surface inside an `mdcMenuAnchor`.
         */
        this.menuAnchor = null;
        /**
         * Assign any `HTMLElement` to this property to use as the viewport instead of
         * the window object. The menu will choose to open from the top or bottom, and
         * from the left or right, based on the space available inside the viewport.
         *
         * You should probably not use this property. We only use it to keep the documentation
         * snippets on our demo website contained in their window.
         */
        this.viewport = null;
        /**
         * Event emitted when the menu is opened or closed. (When this event is triggered, the
         * surface is starting to open/close, but the animation may not have fully completed
         * yet).
         */
        this.openChange = new EventEmitter();
        /**
         * Event emitted after the menu has fully opened. When this event is emitted the full
         * opening animation has completed, and the menu is visible.
         */
        this.afterOpened = new EventEmitter();
        /**
         * Event emitted after the menu has fully closed. When this event is emitted the full
         * closing animation has completed, and the menu is not visible anymore.
         */
        this.afterClosed = new EventEmitter();
        this._prevFocus = null;
        this._hoisted = false;
        this._fixed = false;
        this._handleBodyClick = (event) => this.handleBodyClick(event);
        this.mdcAdapter = {
            addClass: (className) => this.rndr.addClass(this._elm.nativeElement, className),
            removeClass: (className) => this.rndr.removeClass(this._elm.nativeElement, className),
            hasClass: (className) => {
                if (className === cssClasses$2.ROOT)
                    return true;
                if (className === cssClasses$2.OPEN)
                    return this._open;
                return this._elm.nativeElement.classList.contains(className);
            },
            hasAnchor: () => !!this._parentAnchor || !!this.menuAnchor,
            isElementInContainer: (el) => this._elm.nativeElement.contains(el),
            isFocused: () => this.document.activeElement === this._elm.nativeElement,
            isRtl: () => getComputedStyle(this._elm.nativeElement).getPropertyValue('direction') === 'rtl',
            getInnerDimensions: () => ({ width: this._elm.nativeElement.offsetWidth, height: this._elm.nativeElement.offsetHeight }),
            getAnchorDimensions: () => {
                const anchor = this.menuAnchor || this._parentAnchor;
                if (!anchor)
                    return null;
                if (!this.viewport)
                    return anchor.getBoundingClientRect();
                let viewportRect = this.viewport.getBoundingClientRect();
                let anchorRect = anchor.getBoundingClientRect();
                return {
                    bottom: anchorRect.bottom - viewportRect.top,
                    left: anchorRect.left - viewportRect.left,
                    right: anchorRect.right - viewportRect.left,
                    top: anchorRect.top - viewportRect.top,
                    width: anchorRect.width,
                    height: anchorRect.height
                };
            },
            getWindowDimensions: () => ({
                width: this.viewport ? this.viewport.clientWidth : this.document.defaultView.innerWidth,
                height: this.viewport ? this.viewport.clientHeight : this.document.defaultView.innerHeight
            }),
            getBodyDimensions: () => ({
                width: this.viewport ? this.viewport.scrollWidth : this.document.body.clientWidth,
                height: this.viewport ? this.viewport.scrollHeight : this.document.body.clientHeight
            }),
            getWindowScroll: () => ({
                x: this.viewport ? this.viewport.scrollLeft : this.document.defaultView.pageXOffset,
                y: this.viewport ? this.viewport.scrollTop : this.document.defaultView.pageYOffset
            }),
            setPosition: (position) => {
                let el = this._elm.nativeElement;
                this.rndr.setStyle(el, 'left', 'left' in position ? `${position.left}px` : '');
                this.rndr.setStyle(el, 'right', 'right' in position ? `${position.right}px` : '');
                this.rndr.setStyle(el, 'top', 'top' in position ? `${position.top}px` : '');
                this.rndr.setStyle(el, 'bottom', 'bottom' in position ? `${position.bottom}px` : '');
            },
            setMaxHeight: (height) => this._elm.nativeElement.style.maxHeight = height,
            setTransformOrigin: (origin) => this.rndr.setStyle(this._elm.nativeElement, `${util$2.getTransformPropertyName(this.document.defaultView)}-origin`, origin),
            saveFocus: () => this._prevFocus = this.document.activeElement,
            restoreFocus: () => this._elm.nativeElement.contains(this.document.activeElement) && this._prevFocus
                && this._prevFocus['focus'] && this._prevFocus['focus'](),
            notifyClose: () => {
                this.afterClosed.emit();
                this.document.removeEventListener('click', this._handleBodyClick);
            },
            notifyOpen: () => {
                this.afterOpened.emit();
                this.document.addEventListener('click', this._handleBodyClick);
            }
        };
        /** @docs-private */
        this.foundation = null;
        this.document = doc; // work around ngc issue https://github.com/angular/angular/issues/20351
    }
    ngAfterContentInit() {
        this.foundation = new MDCMenuSurfaceFoundation(this.mdcAdapter);
        this.foundation.init();
        this.foundation.setFixedPosition(this._fixed);
        this.foundation.setIsHoisted(this._hoisted);
        this.updateFoundationCorner();
        if (this._open)
            this.foundation.open();
    }
    ngOnDestroy() {
        var _a;
        // when we're destroying a closing surface, the event listener may not be removed yet:
        this.document.removeEventListener('click', this._handleBodyClick);
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        this.foundation = null;
    }
    /**
     * When this input is defined and does not have value false, the menu will be opened,
     * otherwise the menu will be closed.
     */
    get open() {
        return this._open;
    }
    set open(val) {
        var _a, _b;
        let newValue = asBoolean(val);
        if (newValue !== this._open) {
            this._open = newValue;
            if (newValue)
                (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.open();
            else
                (_b = this.foundation) === null || _b === void 0 ? void 0 : _b.close();
            this.openChange.emit(newValue);
        }
    }
    /** @internal */
    closeWithoutFocusRestore() {
        var _a;
        if (this._open) {
            this._open = false;
            (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.close(true);
            this.openChange.emit(false);
        }
    }
    /**
     * Set this value if you want to customize the direction from which the menu will be opened.
     * Use `tl` for top-left, `br` for bottom-right, etc.
     * When the left/right position depends on the text directionality, use `ts` for top-start,
     * `te` for top-end, etc. Start will map to left in left-to-right text directionality, and to
     * to right in right-to-left text directionality. End maps the other way around.
     * The default value is 'ts'.
     */
    get openFrom() {
        return this._openFrom;
    }
    set openFrom(val) {
        if (val !== this.openFrom) {
            if (['tl', 'tr', 'bl', 'br', 'ts', 'te', 'bs', 'be'].indexOf(val) !== -1)
                this._openFrom = val;
            else
                this._openFrom = 'ts';
            this.updateFoundationCorner();
        }
    }
    updateFoundationCorner() {
        var _a;
        const corner = {
            'tl': Corner.TOP_LEFT,
            'tr': Corner.TOP_RIGHT,
            'bl': Corner.BOTTOM_LEFT,
            'br': Corner.BOTTOM_RIGHT,
            'ts': Corner.TOP_START,
            'te': Corner.TOP_END,
            'bs': Corner.BOTTOM_START,
            'be': Corner.BOTTOM_END
        }[this._openFrom];
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setAnchorCorner(corner);
    }
    /** @internal */
    setFoundationAnchorCorner(corner) {
        var _a;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setAnchorCorner(corner);
    }
    /**
     * Set to a value other then false to hoist the menu surface to the body so that the position offsets
     * are calculated relative to the page and not the anchor. (When a `viewport` is set, hoisting is done to
     * the viewport instead of the body).
     */
    get hoisted() {
        return this._hoisted;
    }
    set hoisted(val) {
        var _a;
        let newValue = asBoolean(val);
        if (newValue !== this._hoisted) {
            this._hoisted = newValue;
            (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setIsHoisted(newValue);
        }
    }
    /**
     * Set to a value other then false use fixed positioning, so that the menu stays in the
     * same place on the window (or viewport) even if the page (or viewport) is
     * scrolled.
     */
    get fixed() {
        return this._fixed;
    }
    set fixed(val) {
        var _a;
        let newValue = asBoolean(val);
        if (newValue !== this._fixed) {
            this._fixed = newValue;
            (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setFixedPosition(newValue);
        }
    }
    // listened after notifyOpen, listening stopped after notifyClose
    /** @internal */
    handleBodyClick(event) {
        if (this.foundation) {
            this.foundation.handleBodyClick(event);
            if (this._open && this._open !== this.foundation.isOpen()) { // if just closed:
                this._open = false;
                this.openChange.emit(false);
            }
        }
    }
    /** @internal */
    handleKeydow(event) {
        if (this.foundation) {
            this.foundation.handleKeydown(event);
            if (this._open && this._open !== this.foundation.isOpen()) { // if just closed:
                this._open = false;
                this.openChange.emit(false);
            }
        }
    }
}
MdcMenuSurfaceDirective.ɵfac = function MdcMenuSurfaceDirective_Factory(t) { return new (t || MdcMenuSurfaceDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcMenuSurfaceDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcMenuSurfaceDirective, selectors: [["", "mdcMenuSurface", ""], ["", "mdcMenu", ""], ["", "mdcSelectMenu", ""]], hostVars: 6, hostBindings: function MdcMenuSurfaceDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function MdcMenuSurfaceDirective_keydown_HostBindingHandler($event) { return ctx.handleKeydow($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-menu-surface", ctx._cls)("mdc-menu-surface--open", ctx.open)("mdc-menu-surface--fixed", ctx.fixed);
    } }, inputs: { menuAnchor: "menuAnchor", viewport: "viewport", open: "open", openFrom: "openFrom", hoisted: "hoisted", fixed: "fixed" }, outputs: { openChange: "openChange", afterOpened: "afterOpened", afterClosed: "afterClosed" } });
MdcMenuSurfaceDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcMenuSurfaceDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-menu-surface',] }],
    menuAnchor: [{ type: Input }],
    viewport: [{ type: Input }],
    openChange: [{ type: Output }],
    afterOpened: [{ type: Output }],
    afterClosed: [{ type: Output }],
    open: [{ type: Input }, { type: HostBinding, args: ['class.mdc-menu-surface--open',] }],
    openFrom: [{ type: Input }],
    hoisted: [{ type: Input }],
    fixed: [{ type: Input }, { type: HostBinding, args: ['class.mdc-menu-surface--fixed',] }],
    handleKeydow: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcMenuSurfaceDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcMenuSurface],[mdcMenu],[mdcSelectMenu]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-menu-surface']
        }], menuAnchor: [{
            type: Input
        }], viewport: [{
            type: Input
        }], openChange: [{
            type: Output
        }], afterOpened: [{
            type: Output
        }], afterClosed: [{
            type: Output
        }], open: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.mdc-menu-surface--open']
        }], openFrom: [{
            type: Input
        }], hoisted: [{
            type: Input
        }], fixed: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.mdc-menu-surface--fixed']
        }], 
    /** @internal */
    handleKeydow: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }] }); })();
/**
 * Defines an anchor to position an `mdcMenuSurface` to.  If this directive is used as the direct parent of an `mdcMenuSurface`,
 * it will automatically be used as the anchor point. (Unless de `mdcMenuSurface` sets another anchor via its `menuAnchor`property).
 */
class MdcMenuAnchorDirective {
    constructor(_elm) {
        this._elm = _elm;
        /** @internal */
        this._cls = true;
    }
    ngAfterContentInit() {
        this.surfaces.changes.subscribe(_ => {
            this.setSurfaces(this);
        });
        this.setSurfaces(this);
    }
    ngOnDestroy() {
        this.setSurfaces(null);
    }
    setSurfaces(anchor) {
        var _a;
        (_a = this.surfaces) === null || _a === void 0 ? void 0 : _a.toArray().forEach(surface => {
            surface._parentAnchor = anchor;
        });
    }
    /** @internal */
    getBoundingClientRect() {
        return this._elm.nativeElement.getBoundingClientRect();
    }
}
MdcMenuAnchorDirective.ɵfac = function MdcMenuAnchorDirective_Factory(t) { return new (t || MdcMenuAnchorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcMenuAnchorDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcMenuAnchorDirective, selectors: [["", "mdcMenuAnchor", ""]], contentQueries: function MdcMenuAnchorDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcMenuSurfaceDirective, false);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.surfaces = _t);
    } }, hostVars: 2, hostBindings: function MdcMenuAnchorDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-menu-surface--anchor", ctx._cls);
    } } });
MdcMenuAnchorDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcMenuAnchorDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-menu-surface--anchor',] }],
    surfaces: [{ type: ContentChildren, args: [MdcMenuSurfaceDirective,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcMenuAnchorDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcMenuAnchor]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-menu-surface--anchor']
        }], surfaces: [{
            type: ContentChildren,
            args: [MdcMenuSurfaceDirective]
        }] }); })();
const MENU_SURFACE_DIRECTIVES = [
    MdcMenuAnchorDirective,
    MdcMenuSurfaceDirective
];

// attributes on list-items that we maintain ourselves, so should be ignored
// in the adapter:
const ANGULAR_ITEM_ATTRIBUTES$1 = [
    strings$1.ARIA_CHECKED_ATTR, strings$1.ARIA_DISABLED_ATTR
];
// classes on list-items that we maintain ourselves, so should be ignored
// in the adapter:
const ANGULAR_ITEM_CLASSES$1 = [
    cssClasses$1.LIST_ITEM_DISABLED_CLASS, cssClasses$3.MENU_SELECTED_LIST_ITEM
];
var FocusOnOpen;
(function (FocusOnOpen) {
    FocusOnOpen[FocusOnOpen["first"] = 0] = "first";
    FocusOnOpen[FocusOnOpen["last"] = 1] = "last";
    FocusOnOpen[FocusOnOpen["root"] = -1] = "root";
})(FocusOnOpen || (FocusOnOpen = {}));
;
let nextId$2 = 1;
/**
 * Directive for a spec aligned material design Menu.
 * This directive should wrap an `mdcList`. The `mdcList` contains the menu items (and possible separators).
 *
 * An `mdcMenu` element will also match with the selector of the menu surface directive, documented
 * <a href="/components/menu-surface#mdcMenuSurface">here: mdcMenuSurface</a>. The
 * <a href="/components/menu-surface#mdcMenuAnchor">mdcMenuAnchor API</a> is documented on the same page.
 *
 * # Accessibility
 *
 * * For `role` and `aria-*` attributes on the list, see documentation for `mdcList`.
 * * The best way to open the menu by user interaction is to use the `mdcMenuTrigger` directive
 *   on the interaction element (e.g. button). This takes care of following ARIA recommended practices
 *   for focusing the correct element, and maintaining proper `aria-*` and `role` attributes on the
 *   interaction element, menu, and list.
 * * When opening the `mdcMenuSurface` programmatic, the program is responsible for all of this.
 *   (including focusing an element of the menu or the menu itself).
 * * The `mdcList` will be made focusable by setting a `"tabindex"="-1"` attribute.
 * * The `mdcList` will get an `aria-orientation=vertical` attribute.
 * * The `mdcList` will get an `aria-hidden=true` attribute when the menu surface is closed.
 */
class MdcMenuDirective {
    constructor(_elm, rndr, surface) {
        this._elm = _elm;
        this.rndr = rndr;
        this.surface = surface;
        this.onDestroy$ = new Subject();
        this.onListChange$ = new Subject();
        /** @internal */
        this.itemsChanged = new EventEmitter();
        /** @internal */
        this.itemValuesChanged = new EventEmitter();
        /** @internal */
        this._cls = true;
        this._id = null;
        this.cachedId = null;
        this._function = MdcListFunction.menu;
        this._lastList = null;
        /**
         * Event emitted when the user selects a value. The passed object contains a value
         * (set to the <code>value</code> of the selected list item), and an index
         * (set to the index of the selected list item).
         */
        this.pick = new EventEmitter();
        this.mdcAdapter = {
            addClassToElementAtIndex: (index, className) => {
                var _a, _b;
                // ignore classes we maintain ourselves
                if (!ANGULAR_ITEM_CLASSES$1.find(c => c === className)) {
                    const elm = (_b = (_a = this._list) === null || _a === void 0 ? void 0 : _a.getItem(index)) === null || _b === void 0 ? void 0 : _b._elm.nativeElement;
                    if (elm)
                        this.rndr.addClass(elm, className);
                }
            },
            removeClassFromElementAtIndex: (index, className) => {
                var _a, _b;
                // ignore classes we maintain ourselves
                if (!ANGULAR_ITEM_CLASSES$1.find(c => c === className)) {
                    const elm = (_b = (_a = this._list) === null || _a === void 0 ? void 0 : _a.getItem(index)) === null || _b === void 0 ? void 0 : _b._elm.nativeElement;
                    if (elm)
                        this.rndr.addClass(elm, className);
                }
            },
            addAttributeToElementAtIndex: (index, attr, value) => {
                var _a, _b;
                // ignore attributes we maintain ourselves
                if (!ANGULAR_ITEM_ATTRIBUTES$1.find(a => a === attr)) {
                    const elm = (_b = (_a = this._list) === null || _a === void 0 ? void 0 : _a.getItem(index)) === null || _b === void 0 ? void 0 : _b._elm.nativeElement;
                    if (elm)
                        this.rndr.setAttribute(elm, attr, value);
                }
            },
            removeAttributeFromElementAtIndex: (index, attr) => {
                var _a, _b;
                // ignore attributes we maintain ourselves
                if (!ANGULAR_ITEM_ATTRIBUTES$1.find(a => a === attr)) {
                    const elm = (_b = (_a = this._list) === null || _a === void 0 ? void 0 : _a.getItem(index)) === null || _b === void 0 ? void 0 : _b._elm.nativeElement;
                    if (elm)
                        this.rndr.removeAttribute(elm, attr);
                }
            },
            elementContainsClass: (element, className) => element.classList.contains(className),
            closeSurface: (skipRestoreFocus) => {
                if (skipRestoreFocus)
                    this.surface.closeWithoutFocusRestore();
                else
                    this.surface.open = false;
            },
            getElementIndex: (element) => { var _a; return (_a = this._list) === null || _a === void 0 ? void 0 : _a._items.toArray().findIndex(i => i._elm.nativeElement === element); },
            notifySelected: (evtData) => {
                this.pick.emit({ index: evtData.index, value: this._list._items.toArray()[evtData.index].value });
            },
            getMenuItemCount: () => { var _a; return ((_a = this._list) === null || _a === void 0 ? void 0 : _a._items.length) || 0; },
            focusItemAtIndex: (index) => { var _a; return (_a = this._list.getItem(index)) === null || _a === void 0 ? void 0 : _a._elm.nativeElement.focus(); },
            focusListRoot: () => { var _a; return (_a = this._list) === null || _a === void 0 ? void 0 : _a._elm.nativeElement.focus(); },
            getSelectedSiblingOfItemAtIndex: () => -1,
            isSelectableItemAtIndex: () => false // menuSelectionGroup not yet supported
        };
        this.foundation = null;
    }
    ngOnInit() {
        // Force setter to be called in case id was not specified.
        this.id = this.id;
    }
    ngAfterContentInit() {
        this._lastList = this._listQuery.first;
        this._listQuery.changes.subscribe(() => {
            var _a;
            if (this._lastList !== this._listQuery.first) {
                this.onListChange$.next();
                (_a = this._lastList) === null || _a === void 0 ? void 0 : _a._setFunction(MdcListFunction.plain);
                this._lastList = this._listQuery.first;
                this.destroyFoundation();
                if (this._lastList)
                    this.initAll();
            }
        });
        this.surface.afterOpened.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            var _a, _b;
            (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.handleMenuSurfaceOpened();
            // reset default focus state for programmatic opening of menu;
            // interactive opening sets the default when the open is triggered
            // (see openAndFocus)
            (_b = this.foundation) === null || _b === void 0 ? void 0 : _b.setDefaultFocusState(DefaultFocusState.NONE);
        });
        this.surface.openChange.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            if (this._list)
                this._list._hidden = !this.surface.open;
        });
        if (this._lastList)
            this.initAll();
    }
    ngOnDestroy() {
        this.onListChange$.next();
        this.onListChange$.complete();
        this.onDestroy$.next();
        this.onDestroy$.complete();
        this.destroyFoundation();
    }
    initAll() {
        var _a, _b;
        Promise.resolve().then(() => this._lastList._setFunction(this._function));
        this.initFoundation();
        this.subscribeItemActions();
        (_a = this._lastList) === null || _a === void 0 ? void 0 : _a.itemsChanged.pipe(takeUntil(this.onListChange$)).subscribe(() => this.itemsChanged.emit());
        (_b = this._lastList) === null || _b === void 0 ? void 0 : _b.itemValuesChanged.pipe(takeUntil(this.onListChange$)).subscribe(() => this.itemValuesChanged.emit());
    }
    initFoundation() {
        this.foundation = new MDCMenuFoundation(this.mdcAdapter);
        this.foundation.init();
        // suitable for programmatic opening, program can focus whatever element it wants:
        this.foundation.setDefaultFocusState(DefaultFocusState.NONE);
        if (this._list)
            this._list._hidden = !this.surface.open;
    }
    destroyFoundation() {
        if (this.foundation) {
            this.foundation.destroy();
            this.foundation = null;
        }
    }
    subscribeItemActions() {
        var _a;
        (_a = this._lastList) === null || _a === void 0 ? void 0 : _a.itemAction.pipe(takeUntil(this.onListChange$)).subscribe(data => {
            var _a;
            (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.handleItemAction(this._list.getItem(data.index)._elm.nativeElement);
        });
    }
    /** @docs-private */
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value || this._newId();
    }
    /** @internal */
    _newId() {
        this.cachedId = this.cachedId || `mdc-menu-${nextId$2++}`;
        return this.cachedId;
    }
    /** @docs-private */
    get open() {
        return this.surface.open;
    }
    /** @docs-private */
    openAndFocus(focus) {
        var _a, _b, _c;
        switch (focus) {
            case FocusOnOpen.first:
                (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setDefaultFocusState(DefaultFocusState.FIRST_ITEM);
                break;
            case FocusOnOpen.last:
                (_b = this.foundation) === null || _b === void 0 ? void 0 : _b.setDefaultFocusState(DefaultFocusState.LAST_ITEM);
                break;
            case FocusOnOpen.root:
            default:
                (_c = this.foundation) === null || _c === void 0 ? void 0 : _c.setDefaultFocusState(DefaultFocusState.LIST_ROOT);
        }
        this.surface.open = true;
    }
    /** @internal */
    doClose() {
        this.surface.open = false;
    }
    /** @internal */
    set _listFunction(val) {
        this._function = val;
        if (this._lastList) // otherwise this will happen in ngAfterContentInit
            this._list._setFunction(val);
    }
    /** @internal */
    get _list() {
        return this._listQuery.first;
    }
    /** @internal */
    _onKeydown(event) {
        var _a;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.handleKeydown(event);
    }
}
MdcMenuDirective.ɵfac = function MdcMenuDirective_Factory(t) { return new (t || MdcMenuDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(MdcMenuSurfaceDirective, 2)); };
MdcMenuDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcMenuDirective, selectors: [["", "mdcMenu", ""], ["", "mdcSelectMenu", ""]], contentQueries: function MdcMenuDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcListDirective, false);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._listQuery = _t);
    } }, hostVars: 3, hostBindings: function MdcMenuDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function MdcMenuDirective_keydown_HostBindingHandler($event) { return ctx._onKeydown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("id", ctx.id);
        ɵngcc0.ɵɵclassProp("mdc-menu", ctx._cls);
    } }, inputs: { id: "id" }, outputs: { itemsChanged: "itemsChanged", itemValuesChanged: "itemValuesChanged", pick: "pick" }, exportAs: ["mdcMenu"] });
MdcMenuDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: MdcMenuSurfaceDirective, decorators: [{ type: Self }] }
];
MdcMenuDirective.propDecorators = {
    itemsChanged: [{ type: Output }],
    itemValuesChanged: [{ type: Output }],
    _cls: [{ type: HostBinding, args: ['class.mdc-menu',] }],
    pick: [{ type: Output }],
    _listQuery: [{ type: ContentChildren, args: [MdcListDirective,] }],
    id: [{ type: HostBinding }, { type: Input }],
    _onKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcMenuDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcMenu],[mdcSelectMenu]',
                exportAs: 'mdcMenu'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: MdcMenuSurfaceDirective, decorators: [{
                type: Self
            }] }]; }, { itemsChanged: [{
            type: Output
        }], itemValuesChanged: [{
            type: Output
        }], _cls: [{
            type: HostBinding,
            args: ['class.mdc-menu']
        }], pick: [{
            type: Output
        }], id: [{
            type: HostBinding
        }, {
            type: Input
        }], 
    /** @internal */
    _onKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], _listQuery: [{
            type: ContentChildren,
            args: [MdcListDirective]
        }] }); })();
/**
 *
 * # Accessibility
 *
 * * `Enter`, `Space`, and `Down Arrow` keys open the menu and place focus on the first item.
 * * `Up Arrow` opens the menu and places focus on the last item
 * * Click/Touch events set focus to the mdcList root element
 *
 * * Attribute `role=button` will be set if the element is not already a button element.
 * * Attribute `aria-haspopup=menu` will be set if an `mdcMenu` is attached.
 * * Attribute `aria-expanded` will be set while the attached menu is open
 * * Attribute `aria-controls` will be set to the id of the attached menu. (And a unique id will be generated,
 *   if none was set on the menu).
 * * `Enter`, `Space`, and `Down-Arrow` will open the menu with the first menu item focused.
 * * `Up-Arrow` will open the menu with the last menu item focused.
 * * Mouse/Touch events will open the menu with the list root element focused. The list root element
 *   will handle keyboard navigation once it receives focus.
 */
class MdcMenuTriggerDirective {
    constructor(elm) {
        /** @internal */
        this._role = 'button';
        this._mdcMenuTrigger = null;
        this.down = {
            enter: false,
            space: false
        };
        if (elm.nativeElement.nodeName.toUpperCase() === 'BUTTON')
            this._role = null;
    }
    /** @internal */
    onClick() {
        var _a, _b;
        if (this.down.enter || this.down.space)
            (_a = this._mdcMenuTrigger) === null || _a === void 0 ? void 0 : _a.openAndFocus(FocusOnOpen.first);
        else
            (_b = this._mdcMenuTrigger) === null || _b === void 0 ? void 0 : _b.openAndFocus(FocusOnOpen.root);
    }
    /** @internal */
    onKeydown(event) {
        var _a, _b;
        this.setDown(event, true);
        const { key, keyCode } = event;
        if (key === 'ArrowUp' || keyCode === 38)
            (_a = this._mdcMenuTrigger) === null || _a === void 0 ? void 0 : _a.openAndFocus(FocusOnOpen.last);
        else if (key === 'ArrowDown' || keyCode === 40)
            (_b = this._mdcMenuTrigger) === null || _b === void 0 ? void 0 : _b.openAndFocus(FocusOnOpen.first);
    }
    /** @internal */
    onKeyup(event) {
        this.setDown(event, false);
    }
    /** @internal */
    get _hasPopup() {
        return this._mdcMenuTrigger ? 'menu' : null;
    }
    /** @internal */
    get _expanded() {
        var _a;
        return ((_a = this._mdcMenuTrigger) === null || _a === void 0 ? void 0 : _a.open) ? 'true' : null;
    }
    /** @internal */
    get _ariaControls() {
        var _a;
        return (_a = this._mdcMenuTrigger) === null || _a === void 0 ? void 0 : _a.id;
    }
    get mdcMenuTrigger() {
        return this._mdcMenuTrigger;
    }
    set mdcMenuTrigger(value) {
        if (value && value.openAndFocus)
            this._mdcMenuTrigger = value;
        else
            this._mdcMenuTrigger = null;
    }
    setDown(event, isDown) {
        const { key, keyCode } = event;
        if (key === 'Enter' || keyCode === 13)
            this.down.enter = isDown;
        else if (key === 'Space' || keyCode === 32)
            this.down.space = isDown;
    }
}
MdcMenuTriggerDirective.ɵfac = function MdcMenuTriggerDirective_Factory(t) { return new (t || MdcMenuTriggerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcMenuTriggerDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcMenuTriggerDirective, selectors: [["", "mdcMenuTrigger", ""]], hostVars: 4, hostBindings: function MdcMenuTriggerDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function MdcMenuTriggerDirective_click_HostBindingHandler() { return ctx.onClick(); })("keydown", function MdcMenuTriggerDirective_keydown_HostBindingHandler($event) { return ctx.onKeydown($event); })("keyup", function MdcMenuTriggerDirective_keyup_HostBindingHandler($event) { return ctx.onKeyup($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx._role)("aria-haspopup", ctx._hasPopup)("aria-expanded", ctx._expanded)("aria-controls", ctx._ariaControls);
    } }, inputs: { mdcMenuTrigger: "mdcMenuTrigger" } });
MdcMenuTriggerDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcMenuTriggerDirective.propDecorators = {
    _role: [{ type: HostBinding, args: ['attr.role',] }],
    onClick: [{ type: HostListener, args: ['click',] }],
    onKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
    onKeyup: [{ type: HostListener, args: ['keyup', ['$event'],] }],
    _hasPopup: [{ type: HostBinding, args: ['attr.aria-haspopup',] }],
    _expanded: [{ type: HostBinding, args: ['attr.aria-expanded',] }],
    _ariaControls: [{ type: HostBinding, args: ['attr.aria-controls',] }],
    mdcMenuTrigger: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcMenuTriggerDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcMenuTrigger]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _role: [{
            type: HostBinding,
            args: ['attr.role']
        }], 
    /** @internal */
    onClick: [{
            type: HostListener,
            args: ['click']
        }], 
    /** @internal */
    onKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], 
    /** @internal */
    onKeyup: [{
            type: HostListener,
            args: ['keyup', ['$event']]
        }], _hasPopup: [{
            type: HostBinding,
            args: ['attr.aria-haspopup']
        }], _expanded: [{
            type: HostBinding,
            args: ['attr.aria-expanded']
        }], _ariaControls: [{
            type: HostBinding,
            args: ['attr.aria-controls']
        }], mdcMenuTrigger: [{
            type: Input
        }] }); })();
const MENU_DIRECTIVES = [
    MdcMenuDirective, MdcMenuTriggerDirective
];

/**
 * This directive styles the notch of an `mdcNotchedOutline`. It should wrap the (floating)
 * label of an input like `mdcTextField` or `mdcSelect`.
 */
class MdcNotchedOutlineNotchDirective {
    constructor(_elm) {
        this._elm = _elm;
        /** @internal */
        this._cls = true;
    }
}
MdcNotchedOutlineNotchDirective.ɵfac = function MdcNotchedOutlineNotchDirective_Factory(t) { return new (t || MdcNotchedOutlineNotchDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcNotchedOutlineNotchDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcNotchedOutlineNotchDirective, selectors: [["", "mdcNotchedOutlineNotch", ""]], hostVars: 2, hostBindings: function MdcNotchedOutlineNotchDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-notched-outline__notch", ctx._cls);
    } } });
MdcNotchedOutlineNotchDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcNotchedOutlineNotchDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-notched-outline__notch',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcNotchedOutlineNotchDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcNotchedOutlineNotch]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-notched-outline__notch']
        }] }); })();
/**
 * The notched outline is a border around all sides of either an `mdcTextField` or an
 * `mdcSelect`. It should only be used for the outlined variant of these inputs.
 * This directive should wrap an `mdcNotchedOutlineNotch`, which in turn wraps the
 * actual label.
 */
class MdcNotchedOutlineDirective {
    constructor(rndr, root) {
        this.rndr = rndr;
        this.root = root;
        /** @internal */
        this._cls = true;
        this.notchWidth = null;
        this.mdcAdapter = {
            addClass: (name) => this.rndr.addClass(this.root.nativeElement, name),
            removeClass: (name) => this.rndr.removeClass(this.root.nativeElement, name),
            setNotchWidthProperty: (width) => this.rndr.setStyle(this.notch._elm.nativeElement, 'width', `${width}px`),
            removeNotchWidthProperty: () => this.rndr.removeStyle(this.notch._elm.nativeElement, 'width')
        };
        this.foundation = null;
        this.addSurround('mdc-notched-outline__leading');
    }
    ngAfterContentInit() {
        this.addSurround('mdc-notched-outline__trailing');
        if (this.notch)
            this.initFoundation();
        this._notches.changes.subscribe(() => {
            this.destroyFoundation();
            if (this._notches.length > 0)
                this.initFoundation();
        });
    }
    ngOnDestroy() {
        this.destroyFoundation();
    }
    initFoundation() {
        this.foundation = new MDCNotchedOutlineFoundation(this.mdcAdapter);
        this.foundation.init();
        if (this.notchWidth)
            this.foundation.notch(this.notchWidth);
        else
            this.foundation.closeNotch();
    }
    destroyFoundation() {
        if (this.foundation) {
            this.foundation.destroy();
            this.foundation = null;
        }
    }
    addSurround(clazz) {
        let surround = this.rndr.createElement('span');
        this.rndr.addClass(surround, clazz);
        this.rndr.appendChild(this.root.nativeElement, surround);
    }
    get notch() {
        var _a;
        return (_a = this._notches) === null || _a === void 0 ? void 0 : _a.first;
    }
    /**
     * Opens the notched outline.
     *
     * @param width The width of the notch.
     */
    open(width) {
        // TODO we actually want to compare the size here as well as the open/closed state (by dropping !! on both sides)
        // but this reduces the width of the label when the input has a non-empty value. Needs investigation.
        if (!!this.notchWidth !== !!width) {
            this.notchWidth = width;
            if (this.foundation)
                this.foundation.notch(width);
        }
    }
    /**
     * Closes the notched outline.
     */
    close() {
        if (this.notchWidth != null) {
            this.notchWidth = null;
            if (this.foundation)
                this.foundation.closeNotch();
        }
    }
}
MdcNotchedOutlineDirective.ɵfac = function MdcNotchedOutlineDirective_Factory(t) { return new (t || MdcNotchedOutlineDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcNotchedOutlineDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcNotchedOutlineDirective, selectors: [["", "mdcNotchedOutline", ""]], contentQueries: function MdcNotchedOutlineDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcNotchedOutlineNotchDirective, false);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._notches = _t);
    } }, hostVars: 2, hostBindings: function MdcNotchedOutlineDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-notched-outline", ctx._cls);
    } } });
MdcNotchedOutlineDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
MdcNotchedOutlineDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-notched-outline',] }],
    _notches: [{ type: ContentChildren, args: [MdcNotchedOutlineNotchDirective,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcNotchedOutlineDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcNotchedOutline]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-notched-outline']
        }], _notches: [{
            type: ContentChildren,
            args: [MdcNotchedOutlineNotchDirective]
        }] }); })();
const NOTCHED_OUTLINE_DIRECTIVES = [
    MdcNotchedOutlineNotchDirective,
    MdcNotchedOutlineDirective
];

/**
 * Directive for making an element a ripple surface. The ripple can be customized
 * with the provided
 * <a href="https://github.com/material-components/material-components-web/tree/master/packages/mdc-ripple#sass-apis"
 *   target="_blank">Sass Mixins</a>.
 * Alternatively you can set the <code>surface</code> to get a default styled ripple.
 */
class MdcRippleDirective extends AbstractMdcRipple {
    constructor(_elm, renderer, registry, doc) {
        super(_elm, renderer, registry, doc);
        this._elm = _elm;
        this._initialized = false;
        this._on = false;
        this._disabled = null;
        this._surface = false;
        this._dim = null;
    }
    ngAfterContentInit() {
        if (this._on)
            this.initRipple();
        this._initialized = true;
    }
    ngOnDestroy() {
        this.destroyRipple();
    }
    /** @internal */
    isRippleSurfaceDisabled() {
        return this._disabled == null ? super.isRippleSurfaceDisabled() : this._disabled;
    }
    /** @internal */
    computeRippleBoundingRect() {
        if (this._dim == null)
            return super.computeRippleBoundingRect();
        const { left, top } = this._elm.nativeElement.getBoundingClientRect();
        return {
            left,
            top,
            width: this._dim,
            height: this._dim,
            right: left + this._dim,
            bottom: top + this._dim,
        };
    }
    /**
     * Set this input to false to remove the ripple effect from the surface.
     */
    get mdcRipple() {
        return this._on;
    }
    set mdcRipple(value) {
        const newValue = asBoolean(value);
        if (newValue !== this._on) {
            this._on = newValue;
            if (this._initialized) {
                if (newValue)
                    this.initRipple();
                else
                    this.destroyRipple();
            }
        }
    }
    /**
     * When this input has a value other than false, the ripple is unbounded.
     * Surfaces for bounded ripples should have <code>overflow</code> set to hidden,
     * while surfaces for unbounded ripples should have it set to <code>visible</code>.
     */
    get unbounded() {
        return this.isRippleUnbounded();
    }
    set unbounded(value) {
        this.setRippleUnbounded(asBoolean(value));
    }
    /** @internal */
    get _attrUnbounded() {
        return this.unbounded ? "" : null;
    }
    /**
     * This input sets the dimension of the ripple.
     * This input can be set to null for returning to the defaults, which uses the surface
     * element to compute the bounds of the ripple.
     */
    get dimension() {
        return this._dim;
    }
    set dimension(value) {
        this._dim = value == null ? null : +value;
        this.layout();
    }
    /**
     * This input can be used to programmatically enable/disable the ripple.
     * When true, the ripple effect will be disabled, when false the ripple
     * effect will be enabled. When not set, or <code>null</code> (default)
     * the ripple effect enabled/disabled state depend on whether or not the
     * surface element has the <code>disabled</code> attribute set.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = asBooleanOrNull(value);
    }
    /**
     * When this input has a value other than false, the ripple element will get the
     * "mdc-ripple-surface" class. That class has styling for bounded and unbounded
     * ripples in accordance with your theme customizations. Without this property,
     * you have to supply your own ripple styles, using the provided
     * <a href="https://github.com/material-components/material-components-web/tree/master/packages/mdc-ripple#sass-apis"
     *   target="_blank">Sass Mixins</a>.
     *
     * To apply a standard surface ripple, set the value to `true`, `"primary"`, or `"accent"`.
     * The values primary and accent set the ripple color to the theme primary or secondary color.
     */
    get surface() {
        return !!this._surface;
    }
    set surface(value) {
        if (value === 'primary' || value === 'accent')
            this._surface = value;
        else
            this._surface = asBoolean(value);
    }
    get _surfacePrimary() {
        return this._surface === 'primary';
    }
    get _surfaceAccent() {
        return this._surface === 'accent';
    }
}
MdcRippleDirective.ɵfac = function MdcRippleDirective_Factory(t) { return new (t || MdcRippleDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcRippleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcRippleDirective, selectors: [["", "mdcRipple", ""]], hostVars: 7, hostBindings: function MdcRippleDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-mdc-ripple-is-unbounded", ctx._attrUnbounded);
        ɵngcc0.ɵɵclassProp("mdc-ripple-surface", ctx.surface)("mdc-ripple-surface--primary", ctx._surfacePrimary)("mdc-ripple-surface--accent", ctx._surfaceAccent);
    } }, inputs: { mdcRipple: "mdcRipple", unbounded: "unbounded", dimension: "dimension", disabled: "disabled", surface: "surface" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcRippleDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: MdcEventRegistry },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcRippleDirective.propDecorators = {
    mdcRipple: [{ type: Input }],
    unbounded: [{ type: Input }],
    _attrUnbounded: [{ type: HostBinding, args: ['attr.data-mdc-ripple-is-unbounded',] }],
    dimension: [{ type: Input }],
    disabled: [{ type: Input }],
    surface: [{ type: Input }, { type: HostBinding, args: ['class.mdc-ripple-surface',] }],
    _surfacePrimary: [{ type: HostBinding, args: ['class.mdc-ripple-surface--primary',] }],
    _surfaceAccent: [{ type: HostBinding, args: ['class.mdc-ripple-surface--accent',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcRippleDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcRipple]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: MdcEventRegistry }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { mdcRipple: [{
            type: Input
        }], unbounded: [{
            type: Input
        }], _attrUnbounded: [{
            type: HostBinding,
            args: ['attr.data-mdc-ripple-is-unbounded']
        }], dimension: [{
            type: Input
        }], disabled: [{
            type: Input
        }], surface: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.mdc-ripple-surface']
        }], _surfacePrimary: [{
            type: HostBinding,
            args: ['class.mdc-ripple-surface--primary']
        }], _surfaceAccent: [{
            type: HostBinding,
            args: ['class.mdc-ripple-surface--accent']
        }] }); })();

class MdcSelectTextDirectiveBase {
}
MdcSelectTextDirectiveBase.ɵfac = function MdcSelectTextDirectiveBase_Factory(t) { return new (t || MdcSelectTextDirectiveBase)(); };
MdcSelectTextDirectiveBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcSelectTextDirectiveBase });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcSelectTextDirectiveBase, [{
        type: Directive
    }], null, null); })();
applyMixins(MdcSelectTextDirectiveBase, [HasId]);
/**
 * Directive for showing the text of the currently selected `mdcSelect` item. It is the responsibility
 * of the host component to set the actual text (see examples). This makes the `mdcSelect` more flexible,
 * so that e.g. the text of options can also contain markup to style parts of it differently.
 * When no value is selected, the embedded text must be empty.
 *
 * # Accessibility
 * * When no `id` is assigned, the component will generate a unique `id`, so that the `mdcSelectAnchor`
 *   and `mdcList` for this select can be labelled (with `aria-labelledBy`) appropriately.
 * * The element will be made focusable and tabbable (with `tabindex=0`), unless disabled.
 * * The `aria-disabled` will get a value based on the `disabled` property of the `mdcSelect`.
 * * The `aria-required` will get a value based on the `required` property of the `mdcSelect`.
 * * The `role` attribute will be set to `button`.
 * * The  `aria-haspopup` attribute will be set to `listbox`.
 * * The `aria-labelledBy` attribute will list the ids of the `mdcFloatinglabel` and the `mdcSelectText` self.
 * * The `aria-expanded` attribute will reflect whether this element is focused (the menu-surface is open).
 */
class MdcSelectTextDirective extends MdcSelectTextDirectiveBase {
    constructor(_elm, select) {
        super();
        this._elm = _elm;
        this.select = select;
        /** @internal */
        this._cls = true;
        /** @internal */
        this._role = 'button';
        /** @internal */
        this._haspop = 'listbox';
        /** @internal */
        this._labelledBy = null;
    }
    ngOnInit() {
        this.initId();
    }
    /** @internal */
    _onFocus() {
        var _a;
        (_a = this.select.foundation) === null || _a === void 0 ? void 0 : _a.handleFocus();
    }
    /** @internal */
    _onBlur() {
        this.select.onBlur();
    }
    /** @internal */
    _onKeydown(event) {
        var _a;
        (_a = this.select.foundation) === null || _a === void 0 ? void 0 : _a.handleKeydown(event);
    }
    /** @internal */
    _onClick(event) {
        var _a;
        (_a = this.select.foundation) === null || _a === void 0 ? void 0 : _a.handleClick(this.getNormalizedXCoordinate(event));
    }
    getNormalizedXCoordinate(event) {
        const targetClientRect = event.target.getBoundingClientRect();
        const xCoordinate = !!(event.touches) ? event.touches[0].clientX : event.clientX;
        return xCoordinate - targetClientRect.left;
    }
}
MdcSelectTextDirective.ɵfac = function MdcSelectTextDirective_Factory(t) { return new (t || MdcSelectTextDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(forwardRef(() => MdcSelectDirective), 5)); };
MdcSelectTextDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcSelectTextDirective, selectors: [["", "mdcSelectText", ""]], hostVars: 5, hostBindings: function MdcSelectTextDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focus", function MdcSelectTextDirective_focus_HostBindingHandler() { return ctx._onFocus(); })("blur", function MdcSelectTextDirective_blur_HostBindingHandler() { return ctx._onBlur(); })("keydown", function MdcSelectTextDirective_keydown_HostBindingHandler($event) { return ctx._onKeydown($event); })("click", function MdcSelectTextDirective_click_HostBindingHandler($event) { return ctx._onClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx._role)("aria-haspopup", ctx._haspop)("aria-labelledby", ctx._labelledBy);
        ɵngcc0.ɵɵclassProp("mdc-select__selected-text", ctx._cls);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcSelectTextDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: MdcSelectDirective, decorators: [{ type: Host }, { type: SkipSelf }, { type: Inject, args: [forwardRef(() => MdcSelectDirective),] }] }
];
MdcSelectTextDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-select__selected-text',] }],
    _role: [{ type: HostBinding, args: ['attr.role',] }],
    _haspop: [{ type: HostBinding, args: ['attr.aria-haspopup',] }],
    _labelledBy: [{ type: HostBinding, args: ['attr.aria-labelledby',] }],
    _onFocus: [{ type: HostListener, args: ['focus',] }],
    _onBlur: [{ type: HostListener, args: ['blur',] }],
    _onKeydown: [{ type: HostListener, args: ['keydown', ['$event'],] }],
    _onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcSelectTextDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcSelectText]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: MdcSelectDirective, decorators: [{
                type: Host
            }, {
                type: SkipSelf
            }, {
                type: Inject,
                args: [forwardRef(() => MdcSelectDirective)]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-select__selected-text']
        }], _role: [{
            type: HostBinding,
            args: ['attr.role']
        }], _haspop: [{
            type: HostBinding,
            args: ['attr.aria-haspopup']
        }], _labelledBy: [{
            type: HostBinding,
            args: ['attr.aria-labelledby']
        }], 
    /** @internal */
    _onFocus: [{
            type: HostListener,
            args: ['focus']
        }], 
    /** @internal */
    _onBlur: [{
            type: HostListener,
            args: ['blur']
        }], 
    /** @internal */
    _onKeydown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], 
    /** @internal */
    _onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();
/**
 * The `mdcSelectAnchor` should be the first child of an `mdcSelect`. It contains the dropdown-icon,
 * `mdcSelectText`, `mdcFloatingLabel`, ripples, and may contain an optional `mdcNotchedOutline`.
 * See the examples for the required structure of these directives.
 */
class MdcSelectAnchorDirective extends AbstractMdcRipple {
    constructor(_elm, rndr, registry, select, doc) {
        super(_elm, rndr, registry, doc);
        this._elm = _elm;
        this.rndr = rndr;
        this.select = select;
        this.onDestroy$ = new Subject();
        this.onLabelsChange$ = new Subject();
        /** @internal */
        this._cls = true;
        this._bottomLineElm = null;
        /** @internal */
        this.bottomLineFoundation = null;
        this.mdcLineRippleAdapter = {
            addClass: (className) => this.rndr.addClass(this._bottomLineElm, className),
            removeClass: (className) => this.rndr.removeClass(this._bottomLineElm, className),
            hasClass: (className) => this._bottomLineElm.classList.contains(className),
            setStyle: (name, value) => this.rndr.setStyle(this._bottomLineElm, name, value),
            registerEventHandler: (evtType, handler) => this._registry.listenElm(this.rndr, evtType, handler, this._bottomLineElm),
            deregisterEventHandler: (evtType, handler) => this._registry.unlisten(evtType, handler)
        };
    }
    ngAfterContentInit() {
        merge(this._floatingLabels.changes, this._outlines.changes).pipe(takeUntil(this.onDestroy$), debounceTime(1)).subscribe(() => {
            this.reconstructComponent();
        });
        merge(this._floatingLabels.changes, this._texts.changes).pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            var _a, _b;
            this.onLabelsChange$.next();
            (_a = this._label) === null || _a === void 0 ? void 0 : _a.idChange().pipe(takeUntil(this.onLabelsChange$)).subscribe(() => {
                this.computeLabelledBy();
            });
            (_b = this._text) === null || _b === void 0 ? void 0 : _b.idChange().pipe(takeUntil(this.onLabelsChange$)).subscribe(() => {
                this.computeLabelledBy();
            });
            this.computeLabelledBy();
        });
        this.addIcon();
        this.initComponent();
        this.computeLabelledBy();
    }
    ngOnDestroy() {
        this.onLabelsChange$.next();
        this.onLabelsChange$.complete();
        this.onDestroy$.next();
        this.onDestroy$.complete();
        this.destroyRipple();
        this.destroyLineRipple();
    }
    initComponent() {
        if (!this._outline) {
            this.initLineRipple();
            this.initRipple();
        }
    }
    destroyComponent() {
        this.destroyRipple();
        this.destroyLineRipple();
    }
    reconstructComponent() {
        this.destroyComponent();
        this.initComponent();
    }
    addIcon() {
        const icon = this.rndr.createElement('i');
        this.rndr.addClass(icon, 'mdc-select__dropdown-icon');
        if (this._elm.nativeElement.children.length > 0)
            this.rndr.insertBefore(this._elm.nativeElement, icon, this._elm.nativeElement.children.item(0));
        else
            this.rndr.appendChild(this._elm.nativeElement, icon);
    }
    initLineRipple() {
        if (!this._bottomLineElm) {
            this._bottomLineElm = this.rndr.createElement('div');
            this.rndr.addClass(this._bottomLineElm, 'mdc-line-ripple');
            this.rndr.appendChild(this._elm.nativeElement, this._bottomLineElm);
            this.bottomLineFoundation = new MDCLineRippleFoundation(this.mdcLineRippleAdapter);
            this.bottomLineFoundation.init();
        }
    }
    destroyLineRipple() {
        if (this._bottomLineElm) {
            this.bottomLineFoundation.destroy();
            this.bottomLineFoundation = null;
            this.rndr.removeChild(this._elm.nativeElement, this._bottomLineElm);
            this._bottomLineElm = null;
        }
    }
    computeLabelledBy() {
        var _a, _b;
        let ids = [];
        const labelId = (_a = this._label) === null || _a === void 0 ? void 0 : _a.id;
        if (labelId)
            ids.push(labelId);
        const textId = (_b = this._text) === null || _b === void 0 ? void 0 : _b.id;
        if (textId)
            ids.push(textId);
        if (this._text)
            this._text._labelledBy = ids.join(' ');
        this.select.setListLabelledBy(labelId || null); // the list should only use the id of the label
    }
    /** @internal */
    get _outline() {
        var _a;
        return (_a = this._outlines) === null || _a === void 0 ? void 0 : _a.first;
    }
    /** @internal */
    get _label() {
        var _a;
        return (_a = this._floatingLabels) === null || _a === void 0 ? void 0 : _a.first;
    }
    /** @internal */
    get _text() {
        var _a;
        return (_a = this._texts) === null || _a === void 0 ? void 0 : _a.first;
    }
}
MdcSelectAnchorDirective.ɵfac = function MdcSelectAnchorDirective_Factory(t) { return new (t || MdcSelectAnchorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(forwardRef(() => MdcSelectDirective), 5), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcSelectAnchorDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcSelectAnchorDirective, selectors: [["", "mdcSelectAnchor", ""]], contentQueries: function MdcSelectAnchorDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcFloatingLabelDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcNotchedOutlineDirective, false);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcSelectTextDirective, false);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._floatingLabels = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._outlines = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._texts = _t);
    } }, hostVars: 2, hostBindings: function MdcSelectAnchorDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-select__anchor", ctx._cls);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcSelectAnchorDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: MdcEventRegistry },
    { type: MdcSelectDirective, decorators: [{ type: Host }, { type: SkipSelf }, { type: Inject, args: [forwardRef(() => MdcSelectDirective),] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcSelectAnchorDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-select__anchor',] }],
    _floatingLabels: [{ type: ContentChildren, args: [MdcFloatingLabelDirective, { descendants: true },] }],
    _outlines: [{ type: ContentChildren, args: [MdcNotchedOutlineDirective,] }],
    _texts: [{ type: ContentChildren, args: [MdcSelectTextDirective,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcSelectAnchorDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcSelectAnchor]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: MdcEventRegistry }, { type: MdcSelectDirective, decorators: [{
                type: Host
            }, {
                type: SkipSelf
            }, {
                type: Inject,
                args: [forwardRef(() => MdcSelectDirective)]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-select__anchor']
        }], _floatingLabels: [{
            type: ContentChildren,
            args: [MdcFloatingLabelDirective, { descendants: true }]
        }], _outlines: [{
            type: ContentChildren,
            args: [MdcNotchedOutlineDirective]
        }], _texts: [{
            type: ContentChildren,
            args: [MdcSelectTextDirective]
        }] }); })();
/**
 * Directive for the options list of an `mdcSelect`. This directive should be the second (last) child
 * of an `mdcSelect`, and should wrap an `mdcList` with all selection options.
 * See the examples for the required structure of these directives.
 *
 * An `mdcSelectMenu` element will also match with the selector of the menu surface directive, documented
 * <a href="/components/menu-surface#mdcMenuSurface">here: mdcMenuSurface API</a>.
 */
class MdcSelectMenuDirective {
    constructor(_menu, _surface) {
        this._menu = _menu;
        this._surface = _surface;
        /** @internal */
        this._cls = true;
    }
}
MdcSelectMenuDirective.ɵfac = function MdcSelectMenuDirective_Factory(t) { return new (t || MdcSelectMenuDirective)(ɵngcc0.ɵɵdirectiveInject(MdcMenuDirective, 2), ɵngcc0.ɵɵdirectiveInject(MdcMenuSurfaceDirective, 2)); };
MdcSelectMenuDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcSelectMenuDirective, selectors: [["", "mdcSelectMenu", ""]], hostVars: 2, hostBindings: function MdcSelectMenuDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-select__menu", ctx._cls);
    } } });
MdcSelectMenuDirective.ctorParameters = () => [
    { type: MdcMenuDirective, decorators: [{ type: Self }] },
    { type: MdcMenuSurfaceDirective, decorators: [{ type: Self }] }
];
MdcSelectMenuDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-select__menu',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcSelectMenuDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcSelectMenu]'
            }]
    }], function () { return [{ type: MdcMenuDirective, decorators: [{
                type: Self
            }] }, { type: MdcMenuSurfaceDirective, decorators: [{
                type: Self
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-select__menu']
        }] }); })();
/** @docs-private */
var ValueSource;
(function (ValueSource) {
    ValueSource[ValueSource["control"] = 0] = "control";
    ValueSource[ValueSource["foundation"] = 1] = "foundation";
    ValueSource[ValueSource["program"] = 2] = "program";
})(ValueSource || (ValueSource = {}));
;
/**
 * Directive for a spec aligned material design 'Select Control'. This directive should contain
 * and `mdcSelectAnchor` and an `mdcSelectMenu`. See the examples for the required structure of
 * these directives.
 *
 * If leaving the select empty should be a valid option, include an `mdcListItem` as first element in the list,
 * with an ampty string as `value`.
 *
 * # Accessibility
 * * This directive implements the aria practices recommendations for a
 *   [listbox](https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html).
 *   Most `aria-*` and `role` attributes affect the embedded `mdcSelectAnchor`, and `mdcList`, and are
 *   explained in the documentation for these directives.
 */
class MdcSelectDirective {
    constructor(elm, rndr, doc) {
        this.elm = elm;
        this.rndr = rndr;
        /** @internal */
        this._cls = true;
        this.onDestroy$ = new Subject();
        this.onMenuChange$ = new Subject();
        this.onItemsChange$ = new Subject();
        this._onChange = () => { };
        this._onTouched = () => { };
        this._lastMenu = null;
        this._value = null;
        this._valueSource = null;
        this._disabled = false;
        this._required = false;
        this._listLabelledBy = null;
        /**
         * emits the value of the item when the selected item changes
         */
        this.valueChange = new EventEmitter();
        this.mdcAdapter = {
            addClass: (className) => this.rndr.addClass(this.elm.nativeElement, className),
            removeClass: (className) => this.rndr.removeClass(this.elm.nativeElement, className),
            hasClass: (className) => this.elm.nativeElement.classList.contains(className),
            activateBottomLine: () => { var _a, _b; return (_b = (_a = this.anchor) === null || _a === void 0 ? void 0 : _a.bottomLineFoundation) === null || _b === void 0 ? void 0 : _b.activate(); },
            deactivateBottomLine: () => { var _a, _b; return (_b = (_a = this.anchor) === null || _a === void 0 ? void 0 : _a.bottomLineFoundation) === null || _b === void 0 ? void 0 : _b.deactivate(); },
            getSelectedMenuItem: () => { var _a; return (_a = this.getSelectedItem()) === null || _a === void 0 ? void 0 : _a._elm.nativeElement; },
            hasLabel: () => !!this.label,
            floatLabel: (shouldFloat) => { var _a; return (_a = this.label) === null || _a === void 0 ? void 0 : _a.float(shouldFloat); },
            getLabelWidth: () => { var _a; return ((_a = this.label) === null || _a === void 0 ? void 0 : _a.getWidth()) || 0; },
            hasOutline: () => { var _a; return !!((_a = this.anchor) === null || _a === void 0 ? void 0 : _a._outline); },
            notchOutline: (labelWidth) => { var _a; return (_a = this.anchor) === null || _a === void 0 ? void 0 : _a._outline.open(labelWidth); },
            closeOutline: () => { var _a; return (_a = this.anchor) === null || _a === void 0 ? void 0 : _a._outline.close(); },
            setRippleCenter: (normalizedX) => { var _a, _b; return (_b = (_a = this.anchor) === null || _a === void 0 ? void 0 : _a.bottomLineFoundation) === null || _b === void 0 ? void 0 : _b.setRippleCenter(normalizedX); },
            notifyChange: (value) => this.updateValue(value, ValueSource.foundation),
            // setSelectedText does nothing, library consumer should set the text; gives them more freedom to e.g. also use markup:
            setSelectedText: () => undefined,
            isSelectedTextFocused: () => { var _a; return !!(this.document.activeElement && this.document.activeElement === ((_a = this.text) === null || _a === void 0 ? void 0 : _a._elm.nativeElement)); },
            getSelectedTextAttr: (attr) => { var _a; return (_a = this.text) === null || _a === void 0 ? void 0 : _a._elm.nativeElement.getAttribute(attr); },
            setSelectedTextAttr: (attr, value) => this.text ? this.rndr.setAttribute(this.text._elm.nativeElement, attr, value) : undefined,
            openMenu: () => this.menu.openAndFocus(null),
            closeMenu: () => this.menu.doClose(),
            getAnchorElement: () => this.anchor._elm.nativeElement,
            setMenuAnchorElement: (anchorEl) => this.surface.menuAnchor = anchorEl,
            setMenuAnchorCorner: (anchorCorner) => this.surface.setFoundationAnchorCorner(anchorCorner),
            setMenuWrapFocus: () => undefined,
            setAttributeAtIndex: (index, name, value) => {
                var _a, _b, _c;
                if (name != strings$2.ARIA_SELECTED_ATTR) {
                    const item = (_c = (_b = (_a = this.menu) === null || _a === void 0 ? void 0 : _a._list) === null || _b === void 0 ? void 0 : _b.getItem(index)) === null || _c === void 0 ? void 0 : _c._elm.nativeElement;
                    if (item)
                        this.rndr.setAttribute(item, name, value);
                }
            },
            removeAttributeAtIndex: (index, name) => {
                var _a, _b, _c;
                if (name !== strings$2.ARIA_SELECTED_ATTR) {
                    const item = (_c = (_b = (_a = this.menu) === null || _a === void 0 ? void 0 : _a._list) === null || _b === void 0 ? void 0 : _b.getItem(index)) === null || _c === void 0 ? void 0 : _c._elm.nativeElement;
                    if (item)
                        this.rndr.removeAttribute(item, name);
                }
            },
            focusMenuItemAtIndex: (index) => {
                var _a, _b, _c;
                const item = (_c = (_b = (_a = this.menu) === null || _a === void 0 ? void 0 : _a._list) === null || _b === void 0 ? void 0 : _b.getItem(index)) === null || _c === void 0 ? void 0 : _c._elm.nativeElement;
                if (item)
                    item.focus();
            },
            getMenuItemCount: () => { var _a, _b; return ((_b = (_a = this.menu) === null || _a === void 0 ? void 0 : _a._list) === null || _b === void 0 ? void 0 : _b.getItems().length) || 0; },
            getMenuItemValues: () => { var _a, _b; return ((_b = (_a = this.menu) === null || _a === void 0 ? void 0 : _a._list) === null || _b === void 0 ? void 0 : _b.getItems().map(item => item.value || '')) || []; },
            // foundation uses this to 'setSelectedText', but that's ignored in our implementation (see remark on setSelectedText):
            getMenuItemTextAtIndex: () => '',
            getMenuItemAttr: (menuItem, attr) => {
                var _a, _b, _c;
                if (attr === strings$2.VALUE_ATTR)
                    return ((_c = (_b = (_a = this.menu) === null || _a === void 0 ? void 0 : _a._list) === null || _b === void 0 ? void 0 : _b.getItemByElement(menuItem)) === null || _c === void 0 ? void 0 : _c.value) || null;
                return menuItem.getAttribute(attr);
            },
            addClassAtIndex: (index, className) => {
                var _a, _b;
                const item = (_b = (_a = this.menu) === null || _a === void 0 ? void 0 : _a._list) === null || _b === void 0 ? void 0 : _b.getItem(index);
                if (item && className === cssClasses$4.SELECTED_ITEM_CLASS) {
                    item.active = true;
                }
                else if (item)
                    this.rndr.addClass(item._elm.nativeElement, className);
            },
            removeClassAtIndex: (index, className) => {
                var _a, _b;
                const item = (_b = (_a = this.menu) === null || _a === void 0 ? void 0 : _a._list) === null || _b === void 0 ? void 0 : _b.getItem(index);
                if (item && className === cssClasses$4.SELECTED_ITEM_CLASS) {
                    item.active = false;
                }
                else if (item)
                    this.rndr.removeClass(this.menu._list.getItem(index)._elm.nativeElement, className);
            }
        };
        /** @internal */
        this.foundation = null;
        this.document = doc;
    }
    ngAfterContentInit() {
        this._lastMenu = this._menus.first;
        this._menus.changes.subscribe(() => {
            var _a;
            if (this._lastMenu !== this._menus.first) {
                this.onMenuChange$.next();
                (_a = this._lastMenu) === null || _a === void 0 ? void 0 : _a._menu.itemValuesChanged.pipe(takeUntil(this.onMenuChange$)).subscribe(() => this.onItemsChange$.next());
                this._lastMenu = this._menus.first;
                this.setupMenuHandlers();
            }
        });
        this._lists.changes.subscribe(() => this.initListLabel());
        merge(this.onMenuChange$, 
        // the foundation initializes with the values of the items, so if they change, the foundation must be reconstructed:
        this.onItemsChange$, 
        // mdcSelectText change needs a complete re-init as well:
        this._texts.changes, 
        // when an outline is added/removed, a re-init is needed as well:
        this._outlines.changes).pipe(takeUntil(this.onDestroy$), debounceTime(1)).subscribe(() => {
            this.reconstructComponent();
        });
        this.initComponent();
        this.setupMenuHandlers();
        this.initListLabel();
    }
    ngOnDestroy() {
        this.onMenuChange$.next();
        this.onMenuChange$.complete();
        this.onDestroy$.next();
        this.onDestroy$.complete();
        this.onItemsChange$.complete();
        this.destroyComponent();
    }
    initComponent() {
        this.foundation = new class extends MDCSelectFoundation {
            isValid() {
                //TODO: required effect on validity in combination with @angular/forms
                //TODO: setValid/aria-invalid/helpertext validity
                return super.isValid();
            }
        }(this.mdcAdapter, {
            helperText: undefined,
            leadingIcon: undefined
        });
        this.foundation.init();
        // foundation needs a call to setDisabled (even when false), because otherwise
        // tabindex will not be set correctly:
        this.foundation.setDisabled(this._disabled);
        this.foundation.setRequired(this._required);
        // foundation only updates aria-expanded on open/close, not on initialization:
        this.mdcAdapter.setSelectedTextAttr('aria-expanded', `${this.surface.open}`);
        // TODO: it looks like the foundation doesn't update aria-expanded when the surface is
        //  opened programmatically.
    }
    destroyComponent() {
        var _a;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        this.foundation = null;
    }
    reconstructComponent() {
        this.destroyComponent();
        this.initComponent();
    }
    setupMenuHandlers() {
        if (this.menu) {
            this.menu._listFunction = MdcListFunction.select;
            this.menu.pick.pipe(takeUntil(this.onMenuChange$)).subscribe((evt) => {
                var _a;
                (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.handleMenuItemAction(evt.index);
            });
            this.surface.afterOpened.pipe(takeUntil(this.onMenuChange$)).subscribe(() => {
                var _a;
                (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.handleMenuOpened();
            });
            this.surface.afterClosed.pipe(takeUntil(this.onMenuChange$)).subscribe(() => {
                var _a;
                (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.handleMenuClosed();
            });
        }
    }
    initListLabel() {
        this._lists.forEach(list => {
            list.labelledBy = this._listLabelledBy;
        });
    }
    /**
     * The value of the selected item.
     */
    get value() {
        return this._value;
    }
    set value(value) {
        this.updateValue(value, ValueSource.program);
    }
    /** @internal */
    updateValue(value, source) {
        const oldSource = this._valueSource;
        try {
            if (!this._valueSource)
                this._valueSource = source;
            if (source === ValueSource.foundation) {
                this._value = value;
                Promise.resolve().then(() => {
                    this.valueChange.emit(value);
                    if (this._valueSource !== ValueSource.control)
                        this._onChange(value);
                });
            }
            else if (value !== this.value) {
                if (this.foundation) {
                    this.foundation.setValue(value); // foundation should also accept null value
                    // foundation will do a nested call for this function with source===foundation
                    // there we will handle the value change and emit to observers (see the if block preceding this)
                }
                else {
                    this._value = value;
                    Promise.resolve().then(() => {
                        this.valueChange.emit(value);
                        if (this._valueSource !== ValueSource.control)
                            this._onChange(value);
                    });
                }
            }
        }
        finally {
            this._valueSource = oldSource;
        }
    }
    /**
     * To disable the select, set this input to a value other then false.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        var _a;
        this._disabled = asBoolean(value);
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setDisabled(this._disabled);
    }
    /**
     * To make the select a required input, set this input to a value other then false.
     */
    get required() {
        return this._required;
    }
    set required(value) {
        var _a;
        this._required = asBoolean(value);
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setRequired(this._required);
    }
    /** @internal */
    get outlined() {
        var _a;
        return !!((_a = this.anchor) === null || _a === void 0 ? void 0 : _a._outline);
    }
    /** @internal */
    get labeled() {
        var _a;
        return !((_a = this.anchor) === null || _a === void 0 ? void 0 : _a._label);
    }
    /** @internal */
    setListLabelledBy(id) {
        this._listLabelledBy = id;
        this.initListLabel();
    }
    /** @internal */
    get expanded() {
        var _a;
        return !!((_a = this.surface) === null || _a === void 0 ? void 0 : _a.open);
    }
    get menu() {
        var _a, _b;
        return (_b = (_a = this._menus) === null || _a === void 0 ? void 0 : _a.first) === null || _b === void 0 ? void 0 : _b._menu;
    }
    get surface() {
        var _a, _b;
        return (_b = (_a = this._menus) === null || _a === void 0 ? void 0 : _a.first) === null || _b === void 0 ? void 0 : _b._surface;
    }
    get anchor() {
        var _a;
        return (_a = this._anchors) === null || _a === void 0 ? void 0 : _a.first;
    }
    get label() {
        var _a;
        return (_a = this.anchor) === null || _a === void 0 ? void 0 : _a._label;
    }
    get text() {
        var _a;
        return (_a = this._texts) === null || _a === void 0 ? void 0 : _a.first;
    }
    getSelectedItem() {
        var _a, _b;
        return (_b = (_a = this.menu) === null || _a === void 0 ? void 0 : _a._list) === null || _b === void 0 ? void 0 : _b.getSelectedItem();
    }
    /** @internal */
    registerOnChange(onChange) {
        this._onChange = onChange;
    }
    /** @internal */
    registerOnTouched(onTouched) {
        this._onTouched = onTouched;
    }
    /** @internal */
    onBlur() {
        var _a;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.handleBlur();
        this._onTouched();
    }
}
MdcSelectDirective.ɵfac = function MdcSelectDirective_Factory(t) { return new (t || MdcSelectDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcSelectDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcSelectDirective, selectors: [["", "mdcSelect", ""]], contentQueries: function MdcSelectDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcSelectAnchorDirective, false);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcNotchedOutlineDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcSelectMenuDirective, false);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcListDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcSelectTextDirective, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._anchors = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._outlines = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._menus = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._lists = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._texts = _t);
    } }, hostVars: 6, hostBindings: function MdcSelectDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-select", ctx._cls)("mdc-select--outlined", ctx.outlined)("mdc-select--no-label", ctx.labeled);
    } }, inputs: { value: "value", disabled: "disabled", required: "required" }, outputs: { valueChange: "valueChange" } });
MdcSelectDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcSelectDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-select',] }],
    valueChange: [{ type: Output }],
    _anchors: [{ type: ContentChildren, args: [MdcSelectAnchorDirective,] }],
    _outlines: [{ type: ContentChildren, args: [MdcNotchedOutlineDirective, { descendants: true },] }],
    _menus: [{ type: ContentChildren, args: [MdcSelectMenuDirective,] }],
    _lists: [{ type: ContentChildren, args: [MdcListDirective, { descendants: true },] }],
    _texts: [{ type: ContentChildren, args: [MdcSelectTextDirective, { descendants: true },] }],
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    required: [{ type: Input }],
    outlined: [{ type: HostBinding, args: ['class.mdc-select--outlined',] }],
    labeled: [{ type: HostBinding, args: ['class.mdc-select--no-label',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcSelectDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcSelect]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-select']
        }], valueChange: [{
            type: Output
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }], required: [{
            type: Input
        }], outlined: [{
            type: HostBinding,
            args: ['class.mdc-select--outlined']
        }], labeled: [{
            type: HostBinding,
            args: ['class.mdc-select--no-label']
        }], _anchors: [{
            type: ContentChildren,
            args: [MdcSelectAnchorDirective]
        }], _outlines: [{
            type: ContentChildren,
            args: [MdcNotchedOutlineDirective, { descendants: true }]
        }], _menus: [{
            type: ContentChildren,
            args: [MdcSelectMenuDirective]
        }], _lists: [{
            type: ContentChildren,
            args: [MdcListDirective, { descendants: true }]
        }], _texts: [{
            type: ContentChildren,
            args: [MdcSelectTextDirective, { descendants: true }]
        }] }); })();
/**
 * Directive for adding Angular Forms (<code>ControlValueAccessor</code>) behavior to an
 * `mdcSelect`. Allows the use of the Angular Forms API with select inputs,
 * e.g. binding to <code>[(ngModel)]</code>, form validation, etc.
 */
class MdcFormsSelectDirective {
    constructor(mdcSelect) {
        this.mdcSelect = mdcSelect;
    }
    /** @docs-private */
    writeValue(obj) {
        this.mdcSelect.updateValue(obj, ValueSource.control);
    }
    /** @docs-private */
    registerOnChange(onChange) {
        this.mdcSelect.registerOnChange(onChange);
    }
    /** @docs-private */
    registerOnTouched(onTouched) {
        this.mdcSelect.registerOnTouched(onTouched);
    }
    /** @docs-private */
    setDisabledState(disabled) {
        this.mdcSelect.disabled = disabled;
    }
}
MdcFormsSelectDirective.ɵfac = function MdcFormsSelectDirective_Factory(t) { return new (t || MdcFormsSelectDirective)(ɵngcc0.ɵɵdirectiveInject(MdcSelectDirective, 2)); };
MdcFormsSelectDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcFormsSelectDirective, selectors: [["", "mdcSelect", "", "formControlName", ""], ["", "mdcSelect", "", "formControl", ""], ["", "mdcSelect", "", "ngModel", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MdcFormsSelectDirective), multi: true }
        ])] });
MdcFormsSelectDirective.ctorParameters = () => [
    { type: MdcSelectDirective, decorators: [{ type: Self }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcFormsSelectDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcSelect][formControlName],[mdcSelect][formControl],[mdcSelect][ngModel]',
                providers: [
                    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MdcFormsSelectDirective), multi: true }
                ]
            }]
    }], function () { return [{ type: MdcSelectDirective, decorators: [{
                type: Self
            }] }]; }, null); })();
const SELECT_DIRECTIVES = [
    MdcSelectTextDirective,
    MdcSelectAnchorDirective,
    MdcSelectMenuDirective,
    MdcSelectDirective,
    MdcFormsSelectDirective
];

/**
 * Directive for creating a Material Design slider input.
 * (Modelled after the <code>&lt;input type="range"/&gt;</code> element).
 * The slider is fully accessible. The current implementation
 * will add and manage all DOM child elements that are required for the wrapped
 * <code>mdc-slider</code> component.
 * Future implementations will also support supplying (customized)
 * DOM children.
 */
class MdcSliderDirective {
    constructor(_rndr, _root, _registry, doc) {
        this._rndr = _rndr;
        this._root = _root;
        this._registry = _registry;
        /** @internal */
        this._cls = true;
        /** @internal */
        this._role = 'slider';
        /**
         * Event emitted when the value changes. The value may change because of user input,
         * or as a side affect of setting new min, max, or step values.
         */
        this.valueChange = new EventEmitter();
        /**
         * Event emitted when the min range value changes. This may happen as a side effect
         * of setting a new max value (when the new max is smaller than the old min).
         */
        this.minValueChange = new EventEmitter();
        /**
         * Event emitted when the max range value changes. This may happen as a side effect
         * of setting a new min value (when the new min is larger than the old max).
         */
        this.maxValueChange = new EventEmitter();
        /**
         * Event emitted when the step value changes. This may happen as a side effect
         * of making the slider discrete.
         */
        this.stepValueChange = new EventEmitter();
        this.trackCntr = null;
        this._elmThumbCntr = null;
        this._elmSliderPin = null;
        this._elmValueMarker = null;
        this._elmTrack = null;
        this._elmTrackMarkerCntr = null;
        this._reinitTabIndex = null;
        this._onChange = (value) => { };
        this._onTouched = () => { };
        this._discrete = false;
        this._markers = false;
        this._disabled = false;
        this._value = 0;
        this._min = 0;
        this._max = 100;
        this._step = 0;
        this._lastWidth = null;
        this.mdcAdapter = {
            hasClass: (className) => {
                if (className === 'mdc-slider--discrete')
                    return this._discrete;
                if (className === 'mdc-slider--display-markers')
                    return this._markers;
                return this._root.nativeElement.classList.contains(className);
            },
            addClass: (className) => {
                this._rndr.addClass(this._root.nativeElement, className);
            },
            removeClass: (className) => {
                this._rndr.removeClass(this._root.nativeElement, className);
            },
            getAttribute: (name) => this._root.nativeElement.getAttribute(name),
            setAttribute: (name, value) => {
                // skip attributes that we control with angular
                if (!/^aria-(value.*|disabled)$/.test(name))
                    this._rndr.setAttribute(this._root.nativeElement, name, value);
            },
            removeAttribute: (name) => { this._rndr.removeAttribute(this._root.nativeElement, name); },
            computeBoundingRect: () => this._root.nativeElement.getBoundingClientRect(),
            getTabIndex: () => this._root.nativeElement.tabIndex,
            registerInteractionHandler: (evtType, handler) => this._registry.listen(this._rndr, evtType, handler, this._root, events.applyPassive()),
            deregisterInteractionHandler: (evtType, handler) => this._registry.unlisten(evtType, handler),
            registerThumbContainerInteractionHandler: (evtType, handler) => this._registry.listenElm(this._rndr, evtType, handler, this._elmThumbCntr, events.applyPassive()),
            deregisterThumbContainerInteractionHandler: (evtType, handler) => this._registry.unlisten(evtType, handler),
            registerBodyInteractionHandler: (evtType, handler) => this._registry.listenElm(this._rndr, evtType, handler, this.document.body),
            deregisterBodyInteractionHandler: (evtType, handler) => this._registry.unlisten(evtType, handler),
            registerResizeHandler: (handler) => this._registry.listenElm(this._rndr, 'resize', handler, this.document.defaultView),
            deregisterResizeHandler: (handler) => this._registry.unlisten('resize', handler),
            notifyInput: () => {
                let newValue = this.asNumber(this.foundation.getValue());
                if (newValue !== this._value) {
                    this._value = newValue;
                    this.notifyValueChanged();
                }
            },
            notifyChange: () => {
                // currently not handling this event, if there is a usecase for this, please
                // create a feature request.
            },
            setThumbContainerStyleProperty: (propertyName, value) => {
                this._rndr.setStyle(this._elmThumbCntr, propertyName, value);
            },
            setTrackStyleProperty: (propertyName, value) => {
                this._rndr.setStyle(this._elmTrack, propertyName, value);
            },
            setMarkerValue: (value) => {
                if (this._elmValueMarker)
                    this._elmValueMarker.innerText = value != null ? value.toLocaleString() : '';
            },
            setTrackMarkers: (step, max, min) => {
                if (this._elmTrackMarkerCntr) {
                    // from https://github.com/material-components/material-components-web/blob/v5.1.0/packages/mdc-slider/component.ts#L141
                    const stepStr = step.toLocaleString();
                    const maxStr = max.toLocaleString();
                    const minStr = min.toLocaleString();
                    const markerAmount = `((${maxStr} - ${minStr}) / ${stepStr})`;
                    const markerWidth = `2px`;
                    const markerBkgdImage = `linear-gradient(to right, currentColor ${markerWidth}, transparent 0)`;
                    const markerBkgdLayout = `0 center / calc((100% - ${markerWidth}) / ${markerAmount}) 100% repeat-x`;
                    const markerBkgdShorthand = `${markerBkgdImage} ${markerBkgdLayout}`;
                    this._rndr.setStyle(this._elmTrackMarkerCntr, 'background', markerBkgdShorthand);
                }
            },
            isRTL: () => getComputedStyle(this._root.nativeElement).direction === 'rtl'
        };
        this.foundation = null;
        this.document = doc; // work around ngc issue https://github.com/angular/angular/issues/20351
    }
    ngAfterContentInit() {
        this.initElements();
        this.initDefaultAttributes();
        this.foundation = new MDCSliderFoundation(this.mdcAdapter);
        this.foundation.init();
        this._lastWidth = this.mdcAdapter.computeBoundingRect().width;
        this.updateValues({});
    }
    ngAfterViewInit() {
        this.updateLayout();
    }
    ngOnDestroy() {
        var _a;
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    ngOnChanges(changes) {
        this._onChanges(changes);
    }
    /** @internal */
    _onChanges(changes) {
        if (this.foundation) {
            if (this.isChanged('discrete', changes) || this.isChanged('markers', changes)) {
                this.foundation.destroy();
                this.initElements();
                this.initDefaultAttributes();
                this.foundation = new MDCSliderFoundation(this.mdcAdapter);
                this.foundation.init();
            }
            this.updateValues(changes);
            this.updateLayout();
        }
    }
    isChanged(name, changes) {
        return changes[name] && changes[name].currentValue !== changes[name].previousValue;
    }
    initElements() {
        // initElements is also called when changes dictate a new Foundation initialization,
        // in which case we create new child elements:
        if (this.trackCntr) {
            this._rndr.removeChild(this._root.nativeElement, this.trackCntr);
            this._rndr.removeChild(this._root.nativeElement, this._elmThumbCntr);
        }
        this.trackCntr = this.addElement(this._root.nativeElement, 'div', ['mdc-slider__track-container']);
        this._elmTrack = this.addElement(this.trackCntr, 'div', ['mdc-slider__track']);
        if (this._discrete && this._markers)
            this._elmTrackMarkerCntr = this.addElement(this.trackCntr, 'div', ['mdc-slider__track-marker-container']);
        else
            this._elmTrackMarkerCntr = null;
        this._elmThumbCntr = this.addElement(this._root.nativeElement, 'div', ['mdc-slider__thumb-container']);
        if (this._discrete) {
            this._elmSliderPin = this.addElement(this._elmThumbCntr, 'div', ['mdc-slider__pin']);
            this._elmValueMarker = this.addElement(this._elmSliderPin, 'div', ['mdc-slider__pin-value-marker']);
        }
        else {
            this._elmSliderPin = null;
            this._elmValueMarker = null;
        }
        const svg = this._rndr.createElement('svg', 'svg');
        this._rndr.addClass(svg, 'mdc-slider__thumb');
        this._rndr.setAttribute(svg, 'width', '21');
        this._rndr.setAttribute(svg, 'height', '21');
        this._rndr.appendChild(this._elmThumbCntr, svg);
        const circle = this._rndr.createElement('circle', 'svg');
        this._rndr.setAttribute(circle, 'cx', '10.5');
        this._rndr.setAttribute(circle, 'cy', '10.5');
        this._rndr.setAttribute(circle, 'r', '7.875');
        this._rndr.appendChild(svg, circle);
        this.addElement(this._elmThumbCntr, 'div', ['mdc-slider__focus-ring']);
    }
    addElement(parent, element, classNames) {
        let child = this._rndr.createElement(element);
        classNames.forEach(name => {
            this._rndr.addClass(child, name);
        });
        this._rndr.appendChild(parent, child);
        return child;
    }
    initDefaultAttributes() {
        if (this._reinitTabIndex)
            // value was set the first time we initialized the foundation,
            // so it should also be set when we reinitialize evrything:
            this._root.nativeElement.tabIndex = this._reinitTabIndex;
        else if (!this._root.nativeElement.hasAttribute('tabindex')) {
            // unless overridden by another tabIndex, we want sliders to
            // participate in tabbing (the foundation will remove the tabIndex
            // when the slider is disabled, reset to the initial value when enabled again):
            this._root.nativeElement.tabIndex = 0;
            this._reinitTabIndex = 0;
        }
        else {
            this._reinitTabIndex = this._root.nativeElement.tabIndex;
        }
    }
    updateValues(changes) {
        if (this._discrete && this._step < 1) {
            // See https://github.com/material-components/material-components-web/issues/1426
            // mdc-slider doesn't allow a discrete step value < 1 currently:
            this._step = 1;
            Promise.resolve().then(() => { this.stepValueChange.emit(this._step); });
        }
        else if (this._step < 0) {
            this._step = 0;
            Promise.resolve().then(() => { this.stepValueChange.emit(this._step); });
        }
        if (this._min > this._max) {
            if (this.isChanged('maxValue', changes)) {
                this._min = this._max;
                Promise.resolve().then(() => { this.minValueChange.emit(this._min); });
            }
            else {
                this._max = this._min;
                Promise.resolve().then(() => { this.maxValueChange.emit(this._max); });
            }
        }
        let currValue = this.asNumber(changes['value'] ? changes['value'].currentValue : this._value);
        if (this._value < this._min)
            this._value = this._min;
        if (this._value > this._max)
            this._value = this._max;
        // find an order in which the changed values will be accepted by the foundation
        // (since the foundation will throw errors for min > max and other conditions):
        if (this._min < this.foundation.getMax()) {
            this.foundation.setMin(this._min);
            this.foundation.setMax(this._max);
        }
        else {
            this.foundation.setMax(this._max);
            this.foundation.setMin(this._min);
        }
        this.foundation.setStep(this._step);
        if (this.foundation.isDisabled() !== this._disabled) {
            // without this check, MDCFoundation may remove the tabIndex incorrectly,
            // preventing the slider from getting focus on keyboard commands:
            this.foundation.setDisabled(this._disabled);
        }
        this.foundation.setValue(this._value);
        // value may have changed during setValue(), due to step settings:
        this._value = this.asNumber(this.foundation.getValue());
        // compare with '!=' as null and undefined are considered the same (for initialisation sake):
        if (currValue !== this._value)
            Promise.resolve().then(() => { this.notifyValueChanged(); });
    }
    updateLayout() {
        let newWidth = this.mdcAdapter.computeBoundingRect().width;
        if (newWidth !== this._lastWidth) {
            this._lastWidth = newWidth;
            this.foundation.layout();
        }
    }
    notifyValueChanged() {
        this.valueChange.emit(this._value);
        this._onChange(this._value);
    }
    /** @internal */
    registerOnChange(onChange) {
        this._onChange = onChange;
    }
    /** @internal */
    registerOnTouched(onTouched) {
        this._onTouched = onTouched;
    }
    /**
     * Make the slider discrete. Note from the wrapped <code>mdc-slider</code>
     * component:
     * <blockquote>If a slider contains a step value it does not mean that the slider is a "discrete" slider.
     * "Discrete slider" is a UX treatment, while having a step value is behavioral.</blockquote>
     */
    get discrete() {
        return this._discrete;
    }
    set discrete(value) {
        this._discrete = asBoolean(value);
    }
    /**
     * Property to enable/disable the display of track markers. Display markers
     * are only supported for discrete sliders. Thus they are only shown when the values
     * of both markers and discrete equal true.
     */
    get markers() {
        return this._markers;
    }
    set markers(value) {
        this._markers = asBoolean(value);
    }
    /**
     * The current value of the slider.
     */
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = this.asNumber(value);
    }
    /**
     * The minumum allowed value of the slider.
     */
    get minValue() {
        return this._min;
    }
    set minValue(value) {
        this._min = this.asNumber(value);
    }
    /**
     * The maximum allowed value of the slider.
     */
    get maxValue() {
        return this._max;
    }
    set maxValue(value) {
        this._max = this.asNumber(value);
    }
    /**
     * Set the step value (or set to 0 for no step value).
     * The step value can be a floating point value &gt;= 0.
     * The slider will quantize all values to match the step value, except for the minimum and
     * maximum, which can always be set.
     * Discrete sliders are required to have a step value other than 0.
     * Note from the wrapped <code>mdc-slider</code> component:
     * <blockquote>If a slider contains a step value it does not mean that the slider is a "discrete" slider.
     * "Discrete slider" is a UX treatment, while having a step value is behavioral.</blockquote>
     */
    get stepValue() {
        return this._step;
    }
    set stepValue(value) {
        this._step = this.asNumber(value);
    }
    /**
     * A property to disable the slider.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = asBoolean(value);
    }
    /** @internal */
    _onBlur() {
        this._onTouched();
    }
    /** @internal */
    asNumber(value) {
        if (value == null)
            return 0;
        let result = +value;
        if (isNaN(result))
            return 0;
        return result;
    }
}
MdcSliderDirective.ɵfac = function MdcSliderDirective_Factory(t) { return new (t || MdcSliderDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcSliderDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcSliderDirective, selectors: [["", "mdcSlider", ""]], hostVars: 11, hostBindings: function MdcSliderDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("blur", function MdcSliderDirective_blur_HostBindingHandler() { return ctx._onBlur(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx._role)("aria-valuenow", ctx.value)("aria-valuemin", ctx.minValue)("aria-valuemax", ctx.maxValue)("aria-disabled", ctx.disabled);
        ɵngcc0.ɵɵclassProp("mdc-slider", ctx._cls)("mdc-slider--discrete", ctx.discrete)("mdc-slider--display-markers", ctx.markers);
    } }, inputs: { discrete: "discrete", markers: "markers", value: "value", minValue: "minValue", maxValue: "maxValue", stepValue: "stepValue", disabled: "disabled" }, outputs: { valueChange: "valueChange", minValueChange: "minValueChange", maxValueChange: "maxValueChange", stepValueChange: "stepValueChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
MdcSliderDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: MdcEventRegistry },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcSliderDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-slider',] }],
    _role: [{ type: HostBinding, args: ['attr.role',] }],
    valueChange: [{ type: Output }],
    minValueChange: [{ type: Output }],
    maxValueChange: [{ type: Output }],
    stepValueChange: [{ type: Output }],
    discrete: [{ type: Input }, { type: HostBinding, args: ['class.mdc-slider--discrete',] }],
    markers: [{ type: Input }, { type: HostBinding, args: ['class.mdc-slider--display-markers',] }],
    value: [{ type: Input }, { type: HostBinding, args: ['attr.aria-valuenow',] }],
    minValue: [{ type: Input }, { type: HostBinding, args: ['attr.aria-valuemin',] }],
    maxValue: [{ type: Input }, { type: HostBinding, args: ['attr.aria-valuemax',] }],
    stepValue: [{ type: Input }],
    disabled: [{ type: Input }, { type: HostBinding, args: ['attr.aria-disabled',] }],
    _onBlur: [{ type: HostListener, args: ['blur',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcSliderDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcSlider]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: MdcEventRegistry }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-slider']
        }], _role: [{
            type: HostBinding,
            args: ['attr.role']
        }], valueChange: [{
            type: Output
        }], minValueChange: [{
            type: Output
        }], maxValueChange: [{
            type: Output
        }], stepValueChange: [{
            type: Output
        }], discrete: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.mdc-slider--discrete']
        }], markers: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.mdc-slider--display-markers']
        }], value: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-valuenow']
        }], minValue: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-valuemin']
        }], maxValue: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-valuemax']
        }], stepValue: [{
            type: Input
        }], disabled: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-disabled']
        }], 
    /** @internal */
    _onBlur: [{
            type: HostListener,
            args: ['blur']
        }] }); })();
/**
 * Directive for adding Angular Forms (<code>ControlValueAccessor</code>) behavior to an
 * <code>MdcSliderDirective</code>. Allows the use of the Angular Forms API with
 * icon toggles, e.g. binding to <code>[(ngModel)]</code>, form validation, etc.
 */
class MdcFormsSliderDirective {
    constructor(mdcSlider) {
        this.mdcSlider = mdcSlider;
    }
    /** @docs-private */
    writeValue(obj) {
        let change = new SimpleChange(this.mdcSlider.value, this.mdcSlider.asNumber(obj), false);
        this.mdcSlider.value = obj;
        this.mdcSlider._onChanges({ value: change });
    }
    /** @docs-private */
    registerOnChange(onChange) {
        this.mdcSlider.registerOnChange(onChange);
    }
    /** @docs-private */
    registerOnTouched(onTouched) {
        this.mdcSlider.registerOnTouched(onTouched);
    }
    /** @docs-private */
    setDisabledState(disabled) {
        this.mdcSlider.disabled = disabled;
    }
}
MdcFormsSliderDirective.ɵfac = function MdcFormsSliderDirective_Factory(t) { return new (t || MdcFormsSliderDirective)(ɵngcc0.ɵɵdirectiveInject(MdcSliderDirective, 2)); };
MdcFormsSliderDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcFormsSliderDirective, selectors: [["", "mdcSlider", "", "formControlName", ""], ["", "mdcSlider", "", "formControl", ""], ["", "mdcSlider", "", "ngModel", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MdcFormsSliderDirective), multi: true }
        ])] });
MdcFormsSliderDirective.ctorParameters = () => [
    { type: MdcSliderDirective, decorators: [{ type: Self }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcFormsSliderDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcSlider][formControlName],[mdcSlider][formControl],[mdcSlider][ngModel]',
                providers: [
                    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MdcFormsSliderDirective), multi: true }
                ]
            }]
    }], function () { return [{ type: MdcSliderDirective, decorators: [{
                type: Self
            }] }]; }, null); })();
const SLIDER_DIRECTIVES = [
    MdcSliderDirective, MdcFormsSliderDirective
];

const CLASS_LEADING = 'mdc-snackbar--leading';
const CLASS_STACKED = 'mdc-snackbar--stacked';
/**
 * This class provides information about a posted snackbar message.
 * It can also be used to subscribe to action clicks.
 */
class MdcSnackbarRef {
}
// internal representation of the snackbar
class MdcSnackbarInfo extends MdcSnackbarRef {
    constructor(message) {
        super();
        this.message = message;
        /** @internal */
        this._action = new Subject();
        /** @internal */
        this._opened = new Subject();
        /** @internal */
        this._closed = new Subject();
    }
    action() {
        return this._action.asObservable();
    }
    afterOpened() {
        return this._opened.asObservable();
    }
    afterClosed() {
        return this._closed.asObservable();
    }
}
/**
 * A service for showing spec-aligned material design snackbar/toast messages.
 */
class MdcSnackbarService {
    constructor(doc) {
        this.onDestroy$ = new Subject();
        this.closed = new Subject();
        this.root = null;
        this.label = null;
        this.actionButton = null;
        this.actionLabel = null;
        this.adapter = {
            addClass: (name) => this.root.classList.add(name),
            announce: () => util$3.announce(this.label, this.label),
            notifyClosed: (reason) => this.closed.next(reason),
            notifyClosing: () => { },
            notifyOpened: () => { var _a; return (_a = this.current) === null || _a === void 0 ? void 0 : _a._opened.next(); },
            notifyOpening: () => { },
            removeClass: (name) => this.root.classList.remove(name)
        };
        this.handleActionClick = (evt) => {
            try {
                (this.queue.length > 0) && this.queue[0]._action.next();
            }
            finally {
                this.foundation.handleActionButtonClick(evt);
            }
        };
        this.handleKeyDown = (evt) => this.foundation.handleKeyDown(evt);
        this.foundation = null;
        this.queue = [];
        this.document = doc;
    }
    init() {
        if (!this.foundation) {
            this.root = this.document.createElement('div');
            this.root.classList.add('mdc-snackbar');
            let surface = this.document.createElement('div');
            surface.classList.add('mdc-snackbar__surface');
            this.root.appendChild(surface);
            this.label = this.document.createElement('div');
            this.label.setAttribute('role', 'status');
            this.label.setAttribute('aria-live', 'polite');
            this.label.classList.add('mdc-snackbar__label');
            surface.appendChild(this.label);
            let actions = this.document.createElement('div');
            actions.classList.add('mdc-snackbar__actions');
            surface.appendChild(actions);
            this.actionButton = this.document.createElement('button');
            this.actionButton.classList.add('mdc-button');
            this.actionButton.classList.add('mdc-snackbar__action');
            this.actionButton.setAttribute('type', 'button');
            actions.appendChild(this.actionButton);
            let ripple = this.document.createElement('div');
            ripple.classList.add('mdc-button__ripple');
            this.actionButton.appendChild(ripple);
            this.actionLabel = this.document.createElement('span');
            this.actionLabel.classList.add('mdc-button__label');
            this.actionButton.appendChild(this.actionLabel);
            this.document.body.appendChild(this.root);
            this.foundation = new MDCSnackbarFoundation(this.adapter);
            this.actionButton.addEventListener('click', this.handleActionClick);
            this.root.addEventListener('keydown', this.handleKeyDown);
            this.closed.pipe(takeUntil(this.onDestroy$)).subscribe(reason => this.closeCurrent(reason));
        }
    }
    /** @internal */
    onDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
        if (this.foundation) {
            this.actionButton.removeEventListener('click', this.handleActionClick);
            this.root.removeEventListener('keydown', this.handleKeyDown);
            this.foundation.destroy();
            this.root.parentElement.removeChild(this.root);
            this.root = null;
            this.label = null;
            this.actionButton = null;
            this.actionLabel = null;
        }
    }
    /**
     * Show a snackbar/toast message. If a snackbar message is already showing, the new
     * message will be queued to show after earlier message have been shown.
     * The returned `MdcSnackbarRef` provides methods to subscribe to opened, closed, and
     * action click events.
     *
     * @param message Queue a snackbar message to show.
     */
    show(message) {
        if (!message)
            throw new Error('message parameter is not set in call to MdcSnackbarService.show');
        this.init();
        const ref = new MdcSnackbarInfo(message);
        this.queue.push(ref);
        if (this.queue.length === 1) {
            // showing needs to be triggered after snackbarRef is returned to caller,
            // so that caller can subscribe to `afterShow` before it is triggered:
            Promise.resolve().then(() => {
                this.showNext();
            });
        }
        return ref;
    }
    showNext() {
        if (this.queue.length === 0)
            return;
        const info = this.queue[0];
        this.label.textContent = info.message.message || '';
        this.actionLabel.textContent = info.message.actionText || '';
        if (info.message.stacked)
            this.root.classList.add(CLASS_STACKED);
        else
            this.root.classList.remove(CLASS_STACKED);
        try {
            this.foundation.setTimeoutMs(info.message.timeout || numbers.DEFAULT_AUTO_DISMISS_TIMEOUT_MS);
        }
        catch (error) {
            console.warn(error.message);
            this.foundation.setTimeoutMs(numbers.DEFAULT_AUTO_DISMISS_TIMEOUT_MS);
        }
        this.foundation.open();
    }
    closeCurrent(reason) {
        const info = this.queue.shift();
        info._closed.next(reason);
        info._opened.complete();
        info._action.complete();
        info._closed.complete();
        if (this.queue.length > 0)
            this.showNext();
    }
    get current() {
        return this.queue.length > 0 ? this.queue[0] : null;
    }
    /**
     * Set this property to true to show snackbars start-aligned instead of center-aligned. Desktop and tablet only.
     */
    get leading() {
        return this.foundation ? this.root.classList.contains(CLASS_LEADING) : false;
    }
    set leading(value) {
        this.init();
        if (value)
            this.root.classList.add(CLASS_LEADING);
        else
            this.root.classList.remove(CLASS_LEADING);
    }
    /**
     * By default the snackbar closes when the user presses ESC, while it's focused. Set this to
     * false to not close the snackbar when the user presses ESC.
     */
    get closeOnEscape() {
        return this.foundation ? this.foundation.getCloseOnEscape() : true;
    }
    set closeOnEscape(value) {
        this.init();
        this.foundation.setCloseOnEscape(!!value);
    }
}
MdcSnackbarService.ɵfac = function MdcSnackbarService_Factory(t) { return new (t || MdcSnackbarService)(ɵngcc0.ɵɵinject(DOCUMENT)); };
MdcSnackbarService.ɵprov = ɵɵdefineInjectable({ factory: function MdcSnackbarService_Factory() { return new MdcSnackbarService(ɵɵinject(DOCUMENT)); }, token: MdcSnackbarService, providedIn: "root" });
MdcSnackbarService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcSnackbarService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

/**
 * Directive for the native input element of an <code>MdcSwitchDirective</code>.
 */
class MdcSwitchInputDirective extends AbstractMdcInput {
    constructor(_elm, _cntr) {
        super();
        this._elm = _elm;
        this._cntr = _cntr;
        /** @internal */
        this._cls = true;
        /** @internal */
        this._role = 'switch';
        this.onDestroy$ = new Subject();
        /** @internal */
        this._checkedChange = new EventEmitter();
        /** @internal */
        this._disabledChange = new EventEmitter();
        /** @internal */
        this._change = new EventEmitter();
        this._id = null;
        this._disabled = false;
        this._checked = false;
    }
    ngOnInit() {
        var _a;
        (_a = this._cntr) === null || _a === void 0 ? void 0 : _a.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe((value) => {
            this.updateValue(value, true);
        });
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
    /** @docs-private */
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    /** @docs-private */
    get disabled() {
        return this._cntr ? !!this._cntr.disabled : this._disabled;
    }
    set disabled(value) {
        const newVal = asBoolean(value);
        if (newVal != this._disabled) {
            this._disabled = asBoolean(newVal);
            this._disabledChange.emit(newVal);
        }
    }
    /** @docs-private */
    get checked() {
        return this._checked;
    }
    set checked(value) {
        this.updateValue(value, false);
    }
    /** @internal */
    _onChange(event) {
        // update checked value, but not via this.checked, so we bypass events being sent to:
        // - _checkedChange -> foundation is already updated via _change
        // - _cntr.control.setValue -> control is already updated through its own handling of user events
        this._checked = this._elm.nativeElement.checked; // bypass 
        this._change.emit(event);
    }
    updateValue(value, fromControl) {
        // When the 'checked' property is the source of the change, we want to coerce boolean
        // values using asBoolean, so that initializing with an attribute with no value works
        // as expected.
        // When the NgControl is the source of the change we don't want that. The value should
        // be interpreted like NgControl/NgForms handles non-boolean values when binding.
        const newVal = fromControl ? !!value : asBoolean(value);
        if (newVal !== this._checked) {
            this._checked = newVal;
            this._checkedChange.emit(newVal);
        }
        if (!fromControl && this._cntr && newVal !== this._cntr.value) {
            this._cntr.control.setValue(newVal);
        }
    }
}
MdcSwitchInputDirective.ɵfac = function MdcSwitchInputDirective_Factory(t) { return new (t || MdcSwitchInputDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgControl, 10)); };
MdcSwitchInputDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcSwitchInputDirective, selectors: [["input", "mdcSwitchInput", "", "type", "checkbox"]], hostVars: 6, hostBindings: function MdcSwitchInputDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("change", function MdcSwitchInputDirective_change_HostBindingHandler($event) { return ctx._onChange($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("id", ctx.id)("disabled", ctx.disabled)("checked", ctx.checked);
        ɵngcc0.ɵɵattribute("role", ctx._role);
        ɵngcc0.ɵɵclassProp("mdc-switch__native-control", ctx._cls);
    } }, inputs: { id: "id", disabled: "disabled", checked: "checked" }, outputs: { _checkedChange: "_checkedChange", _disabledChange: "_disabledChange", _change: "_change" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: AbstractMdcInput, useExisting: forwardRef(() => MdcSwitchInputDirective) }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcSwitchInputDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }] }
];
MdcSwitchInputDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-switch__native-control',] }],
    _role: [{ type: HostBinding, args: ['attr.role',] }],
    _checkedChange: [{ type: Output }],
    _disabledChange: [{ type: Output }],
    _change: [{ type: Output }],
    id: [{ type: HostBinding }, { type: Input }],
    disabled: [{ type: HostBinding }, { type: Input }],
    checked: [{ type: HostBinding }, { type: Input }],
    _onChange: [{ type: HostListener, args: ['change', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcSwitchInputDirective, [{
        type: Directive,
        args: [{
                selector: 'input[mdcSwitchInput][type=checkbox]',
                providers: [{ provide: AbstractMdcInput, useExisting: forwardRef(() => MdcSwitchInputDirective) }]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc1.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-switch__native-control']
        }], _role: [{
            type: HostBinding,
            args: ['attr.role']
        }], _checkedChange: [{
            type: Output
        }], _disabledChange: [{
            type: Output
        }], _change: [{
            type: Output
        }], id: [{
            type: HostBinding
        }, {
            type: Input
        }], disabled: [{
            type: HostBinding
        }, {
            type: Input
        }], checked: [{
            type: HostBinding
        }, {
            type: Input
        }], 
    /** @internal */
    _onChange: [{
            type: HostListener,
            args: ['change', ['$event']]
        }] }); })();
/**
 * Directive for the mandatory thumb element of an `mdcSwitch`. See `mdcSwitch` for more
 * information.
 */
class MdcSwitchThumbDirective {
    constructor(elm, rndr) {
        this.elm = elm;
        this.rndr = rndr;
        /** @internal */
        this._cls = true;
        this.addThumb();
    }
    addThumb() {
        const thumb = this.rndr.createElement('div');
        this.rndr.addClass(thumb, 'mdc-switch__thumb');
        this.rndr.appendChild(this.elm.nativeElement, thumb);
    }
}
MdcSwitchThumbDirective.ɵfac = function MdcSwitchThumbDirective_Factory(t) { return new (t || MdcSwitchThumbDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
MdcSwitchThumbDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcSwitchThumbDirective, selectors: [["", "mdcSwitchThumb", ""]], hostVars: 2, hostBindings: function MdcSwitchThumbDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-switch__thumb-underlay", ctx._cls);
    } } });
MdcSwitchThumbDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
MdcSwitchThumbDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-switch__thumb-underlay',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcSwitchThumbDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcSwitchThumb]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-switch__thumb-underlay']
        }] }); })();
/**
 * Directive for creating a Material Design switch component. The switch is driven by an
 * underlying native checkbox input, which must use the `mdcSwitchInput` directive. The
 * `mdcSwitchInput` must be wrapped by an `mdcSwitchThumb`, which must be a direct child of this
 * `mdcSwitch` directive.
 *
 * The current implementation will add all other required DOM elements (such as the
 * switch-track). Future implementations will also support supplying (customized) elements
 * for those.
 *
 * This directive can be used together with an <code>mdcFormField</code> to
 * easily position switches and their labels, see
 * <a href="/components/form-field">mdcFormField</a>.
 */
class MdcSwitchDirective {
    constructor(rndr, root) {
        this.rndr = rndr;
        this.root = root;
        /** @internal */
        this._cls = true;
        this.onDestroy$ = new Subject();
        this.onInputChange$ = new Subject();
        this.mdcAdapter = {
            addClass: (className) => {
                this.rndr.addClass(this.root.nativeElement, className);
            },
            removeClass: (className) => {
                this.rndr.removeClass(this.root.nativeElement, className);
            },
            setNativeControlAttr: (attr, value) => this.rndr.setAttribute(this._input._elm.nativeElement, attr, value),
            setNativeControlChecked: () => undefined,
            setNativeControlDisabled: () => undefined // nothing to do, enabling/disabling is done directly on the input
        };
        this.foundation = null;
        this.addTrack();
    }
    ngAfterContentInit() {
        if (this._input) {
            this.initFoundation();
        }
        this._inputs.changes.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            if (this.foundation)
                this.foundation.destroy();
            if (this._input)
                this.initFoundation();
            else
                this.foundation = null;
            this.subscribeInputChanges();
        });
        this.subscribeInputChanges();
    }
    ngOnDestroy() {
        this.onInputChange$.next();
        this.onInputChange$.complete();
        this.onDestroy$.next();
        this.onDestroy$.complete();
        if (this.foundation) {
            this.foundation.destroy();
            this.foundation = null;
        }
    }
    initFoundation() {
        this.foundation = new MDCSwitchFoundation(this.mdcAdapter);
        this.foundation.init();
        // The foundation doesn't correctly set the aria-checked attribute and the checked/disabled styling
        // on initialization. So let's help it to not forget that:
        this.foundation.setChecked(this._input.checked);
        this.foundation.setDisabled(this._input.disabled);
    }
    addTrack() {
        const track = this.rndr.createElement('div');
        this.rndr.addClass(track, 'mdc-switch__track');
        this.rndr.appendChild(this.root.nativeElement, track);
    }
    subscribeInputChanges() {
        var _a, _b, _c;
        this.onInputChange$.next();
        (_a = this._input) === null || _a === void 0 ? void 0 : _a._checkedChange.asObservable().pipe(takeUntil(this.onInputChange$)).subscribe(checked => { var _a; return (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setChecked(checked); });
        (_b = this._input) === null || _b === void 0 ? void 0 : _b._disabledChange.asObservable().pipe(takeUntil(this.onInputChange$)).subscribe(disabled => {
            var _a;
            (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setDisabled(disabled);
        });
        (_c = this._input) === null || _c === void 0 ? void 0 : _c._change.asObservable().pipe(takeUntil(this.onInputChange$)).subscribe((event) => {
            var _a;
            (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.handleChange(event);
        });
    }
    get _input() {
        return this._inputs && this._inputs.length > 0 ? this._inputs.first : null;
    }
}
MdcSwitchDirective.ɵfac = function MdcSwitchDirective_Factory(t) { return new (t || MdcSwitchDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcSwitchDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcSwitchDirective, selectors: [["", "mdcSwitch", ""]], contentQueries: function MdcSwitchDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcSwitchInputDirective, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._inputs = _t);
    } }, hostVars: 2, hostBindings: function MdcSwitchDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-switch", ctx._cls);
    } } });
MdcSwitchDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
MdcSwitchDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-switch',] }],
    _inputs: [{ type: ContentChildren, args: [MdcSwitchInputDirective, { descendants: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcSwitchDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcSwitch]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-switch']
        }], _inputs: [{
            type: ContentChildren,
            args: [MdcSwitchInputDirective, { descendants: true }]
        }] }); })();
const SWITCH_DIRECTIVES = [
    MdcSwitchInputDirective,
    MdcSwitchThumbDirective,
    MdcSwitchDirective
];

/**
 * Child directive for an `mdcTabIndicator`. Must be present, and can be assigned
 * the value `underline` (default), or `icon`, to set the type of indicator.
 */
class MdcTabIndicatorContentDirective {
    constructor(_root) {
        this._root = _root;
        /** @internal */
        this._cls = true;
        /** @internal */
        this._type = 'underline';
    }
    /**
      * By default the indicator is represented as an underline. Set this value to
      * `icon` to have it represented as an icon.
      * You can use SVG, or font icon libraries to set the content icon.
      */
    get mdcTabIndicatorContent() {
        return this._type;
    }
    set mdcTabIndicatorContent(value) {
        this._type = value === 'icon' ? value : 'underline';
    }
    get _underline() {
        return this._type === 'underline';
    }
    get _icon() {
        return this._type === 'icon';
    }
}
MdcTabIndicatorContentDirective.ɵfac = function MdcTabIndicatorContentDirective_Factory(t) { return new (t || MdcTabIndicatorContentDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcTabIndicatorContentDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTabIndicatorContentDirective, selectors: [["", "mdcTabIndicatorContent", ""]], hostVars: 6, hostBindings: function MdcTabIndicatorContentDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-tab-indicator__content", ctx._cls)("mdc-tab-indicator__content--underline", ctx._underline)("mdc-tab-indicator__content--icon", ctx._icon);
    } }, inputs: { mdcTabIndicatorContent: "mdcTabIndicatorContent" } });
MdcTabIndicatorContentDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcTabIndicatorContentDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-tab-indicator__content',] }],
    mdcTabIndicatorContent: [{ type: Input }],
    _underline: [{ type: HostBinding, args: ['class.mdc-tab-indicator__content--underline',] }],
    _icon: [{ type: HostBinding, args: ['class.mdc-tab-indicator__content--icon',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTabIndicatorContentDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTabIndicatorContent]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-tab-indicator__content']
        }], mdcTabIndicatorContent: [{
            type: Input
        }], _underline: [{
            type: HostBinding,
            args: ['class.mdc-tab-indicator__content--underline']
        }], _icon: [{
            type: HostBinding,
            args: ['class.mdc-tab-indicator__content--icon']
        }] }); })();
/**
 * Directive for the content (label and optional icon of the tab).
 * This directive must be used as a child of an `mdcTab`, or `mdcTabRouter`.
 */
class MdcTabIndicatorDirective {
    constructor(rndr, root) {
        this.rndr = rndr;
        this.root = root;
        /** @internal */
        this._cls = true;
        this.onDestroy$ = new Subject();
        /** @internal */
        this._type = 'slide';
        this.active = false;
        this.mdcAdapter = {
            addClass: (className) => {
                this.rndr.addClass(this.root.nativeElement, className);
            },
            removeClass: (className) => {
                this.rndr.removeClass(this.root.nativeElement, className);
            },
            computeContentClientRect: () => this._content._root.nativeElement.getBoundingClientRect(),
            setContentStyleProperty: (name, value) => this.rndr.setStyle(this._content._root.nativeElement, name, value)
        };
        this.foundation = null;
    }
    ngAfterContentInit() {
        if (this._content) {
            this.initFoundation();
        }
        this._contents.changes.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.destroyFoundation();
            if (this._content)
                this.initFoundation();
        });
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
        this.destroyFoundation();
    }
    destroyFoundation() {
        let destroy = this.foundation != null;
        if (destroy) {
            this.foundation.destroy();
            this.mdcAdapter.removeClass('mdc-tab-indicator--active');
        }
        this.foundation = null;
        return destroy;
    }
    initFoundation() {
        this.foundation = this._type === 'fade' ?
            new MDCFadingTabIndicatorFoundation(this.mdcAdapter) :
            new MDCSlidingTabIndicatorFoundation(this.mdcAdapter);
        this.foundation.init();
        if (this.active) {
            let clientRect = typeof this.active === 'boolean' ? undefined : this.active;
            this.foundation.activate(clientRect);
        }
    }
    /**
     * By default the indicator is a sliding indicator: when another tab is activated, the indicator
     * animates a slide to the new tab. Set this property `fade` to have a fading animation
     * instead.
     */
    get mdcTabIndicator() {
        return this._type;
    }
    set mdcTabIndicator(value) {
        let newValue = value === 'fade' ? value : 'slide';
        if (newValue !== this._type) {
            this._type = newValue;
            if (this.destroyFoundation())
                this.initFoundation();
        }
    }
    /** @internal */
    activate(previousIndicatorClientRect) {
        this.active = previousIndicatorClientRect || true;
        if (this.foundation)
            this.foundation.activate(previousIndicatorClientRect);
    }
    /** @internal */
    deactivate() {
        this.active = false;
        if (this.foundation)
            this.foundation.deactivate();
    }
    /** @internal */
    get _slide() {
        return this._type === 'fade';
    }
    get _content() {
        return this._contents && this._contents.length > 0 ? this._contents.first : null;
    }
    /** @internal */
    _computeContentClientRect() {
        var _a;
        return (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.computeContentClientRect();
    }
}
MdcTabIndicatorDirective.ɵfac = function MdcTabIndicatorDirective_Factory(t) { return new (t || MdcTabIndicatorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcTabIndicatorDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTabIndicatorDirective, selectors: [["", "mdcTabIndicator", ""]], contentQueries: function MdcTabIndicatorDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcTabIndicatorContentDirective, false);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._contents = _t);
    } }, hostVars: 4, hostBindings: function MdcTabIndicatorDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-tab-indicator", ctx._cls)("mdc-tab-indicator--fade", ctx._slide);
    } }, inputs: { mdcTabIndicator: "mdcTabIndicator" } });
MdcTabIndicatorDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
MdcTabIndicatorDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-tab-indicator',] }],
    _contents: [{ type: ContentChildren, args: [MdcTabIndicatorContentDirective,] }],
    mdcTabIndicator: [{ type: Input }],
    _slide: [{ type: HostBinding, args: ['class.mdc-tab-indicator--fade',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTabIndicatorDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTabIndicator]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-tab-indicator']
        }], mdcTabIndicator: [{
            type: Input
        }], _slide: [{
            type: HostBinding,
            args: ['class.mdc-tab-indicator--fade']
        }], _contents: [{
            type: ContentChildren,
            args: [MdcTabIndicatorContentDirective]
        }] }); })();
const TAB_INDICATOR_DIRECTIVES = [MdcTabIndicatorContentDirective, MdcTabIndicatorDirective];

/**
 * Directive for an optional icon when having a tab bar with icons.
 * This directive must be used as a child of an `mdcTabContent`, and as a sibbling
 * to a following `mdcTabLabel`.
 */
class MdcTabIconDirective {
    constructor() {
        /** @internal */
        this._cls = true;
        /** @internal */
        this._ariaHidden = true;
    }
}
MdcTabIconDirective.ɵfac = function MdcTabIconDirective_Factory(t) { return new (t || MdcTabIconDirective)(); };
MdcTabIconDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTabIconDirective, selectors: [["", "mdcTabIcon", ""]], hostVars: 3, hostBindings: function MdcTabIconDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-hidden", ctx._ariaHidden);
        ɵngcc0.ɵɵclassProp("mdc-tab__icon", ctx._cls);
    } } });
MdcTabIconDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-tab__icon',] }],
    _ariaHidden: [{ type: HostBinding, args: ['attr.aria-hidden',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTabIconDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTabIcon]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-tab__icon']
        }], _ariaHidden: [{
            type: HostBinding,
            args: ['attr.aria-hidden']
        }] }); })();
/**
 * Directive for the text label of a tab.
 * This directive must be used as a child of an `mdcTabContent`.
 * It can be preceded by an optional `mdcTabIcon`.
 */
class MdcTabLabelDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcTabLabelDirective.ɵfac = function MdcTabLabelDirective_Factory(t) { return new (t || MdcTabLabelDirective)(); };
MdcTabLabelDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTabLabelDirective, selectors: [["", "mdcTabLabel", ""]], hostVars: 2, hostBindings: function MdcTabLabelDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-tab__text-label", ctx._cls);
    } } });
MdcTabLabelDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-tab__text-label',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTabLabelDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTabLabel]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-tab__text-label']
        }] }); })();
/**
 * Directive for the content (label and optional icon of the tab).
 * This directive must be used as a child of an `mdcTab`, and
 * can contain an (optional) `mdcTabIcon` and an `mdcTabLabel`.
 */
class MdcTabContentDirective {
    constructor(_root) {
        this._root = _root;
        /** @internal */
        this._cls = true;
    }
}
MdcTabContentDirective.ɵfac = function MdcTabContentDirective_Factory(t) { return new (t || MdcTabContentDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcTabContentDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTabContentDirective, selectors: [["", "mdcTabContent", ""]], hostVars: 2, hostBindings: function MdcTabContentDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-tab__content", ctx._cls);
    } } });
MdcTabContentDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcTabContentDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-tab__content',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTabContentDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTabContent]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-tab__content']
        }] }); })();
class AbstractMdcTabDirective extends AbstractMdcRipple {
    constructor(_rndr, _root, _registry, doc) {
        super(_root, _rndr, _registry, doc);
        this._rndr = _rndr;
        this._root = _root;
        this._registry = _registry;
        /** @internal */
        this._cls = true;
        this.onDestroy$ = new Subject();
        /** @internal */
        this._active = false;
        /** @internal */
        this._role = 'tab';
        /**
         * Event called when the tab is activated.
         */
        this.activate = new EventEmitter();
        this.activationRequest = new ReplaySubject(1);
        /** @internal */
        this._adapter = {
            addClass: (className) => this._rndr.addClass(this._root.nativeElement, className),
            removeClass: (className) => this._rndr.removeClass(this._root.nativeElement, className),
            hasClass: (className) => this._root.nativeElement.classList.contains(className),
            setAttr: (attr, value) => this._rndr.setAttribute(this._root.nativeElement, attr, value),
            activateIndicator: (previousIndicatorClientRect) => { var _a; return (_a = this._indicator) === null || _a === void 0 ? void 0 : _a.activate(previousIndicatorClientRect); },
            deactivateIndicator: () => { var _a; return (_a = this._indicator) === null || _a === void 0 ? void 0 : _a.deactivate(); },
            notifyInteracted: () => this.activationRequest.next(true),
            getOffsetLeft: () => this._root.nativeElement.offsetLeft,
            getOffsetWidth: () => this._root.nativeElement.offsetWidth,
            getContentOffsetLeft: () => this._content._root.nativeElement.offsetLeft,
            getContentOffsetWidth: () => this._content._root.nativeElement.offsetWidth,
            focus: () => this._root.nativeElement.focus()
        };
        /** @internal */
        this._foundation = null;
    }
    ngAfterContentInit() {
        this.addRippleSurface('mdc-tab__ripple');
        this.initRipple();
        let initializer = () => {
            this.destroyFoundation();
            if (this._content && this._indicator)
                this.initFoundation();
        };
        initializer();
        this._contents.changes.pipe(takeUntil(this.onDestroy$)).subscribe(initializer);
        this._indicators.changes.pipe(takeUntil(this.onDestroy$)).subscribe(initializer);
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
        this.destroyRipple();
        this.destroyFoundation();
    }
    destroyFoundation() {
        let destroy = this._foundation != null;
        if (destroy)
            this._foundation.destroy();
        this._foundation = null;
        return destroy;
    }
    initFoundation() {
        this._foundation = new MDCTabFoundation(this._adapter);
        this._foundation.init();
        if (this._active) {
            let clientRect = typeof this._active === 'boolean' ? undefined : this._active;
            this._foundation.activate(clientRect);
        }
        else {
            // foundation doesn't initialize these attributes:
            this._rndr.setAttribute(this._root.nativeElement, 'aria-selected', 'false');
            this._rndr.setAttribute(this._root.nativeElement, 'tabindex', '-1');
        }
    }
    /** @internal */
    getRippleStylingElement() {
        return this.rippleSurface;
    }
    /** @internal */
    _activate(tabIndex, previousIndicatorClientRect) {
        this._active = previousIndicatorClientRect || true;
        if (this._foundation)
            this._foundation.activate(previousIndicatorClientRect);
        this.activate.emit({ tab: this, tabIndex });
    }
    /** @internal */
    _deactivate() {
        this._active = false;
        if (this._foundation)
            this._foundation.deactivate();
    }
    /** @internal */
    _focus() {
        this._adapter.focus();
    }
    /** @internal */
    _computeIndicatorClientRect() {
        var _a;
        return (_a = this._indicator) === null || _a === void 0 ? void 0 : _a._computeContentClientRect();
    }
    /** @internal */
    _computeDimensions() {
        var _a;
        return (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.computeDimensions();
    }
    /** @internal */
    isActive() {
        return !!this._active;
    }
    /** @internal */
    triggerActivation(value = true) {
        // Note: this should not set the _active property. It just notifies the tab-bar
        // that it wants to be activated. The tab-bar will deactivate the previous tab, and activate
        // this one.
        this.activationRequest.next(value);
    }
    /** @internal */
    get activationRequest$() {
        return this.activationRequest.asObservable();
    }
    /** @internal */
    _onClick() {
        if (this._foundation)
            this._foundation.handleClick();
    }
    /** @internal */
    get _indicator() {
        return this._indicators && this._indicators.length > 0 ? this._indicators.first : null;
    }
    /** @internal */
    get _content() {
        return this._contents && this._contents.length > 0 ? this._contents.first : null;
    }
}
AbstractMdcTabDirective.ɵfac = function AbstractMdcTabDirective_Factory(t) { return new (t || AbstractMdcTabDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
AbstractMdcTabDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AbstractMdcTabDirective, contentQueries: function AbstractMdcTabDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcTabContentDirective, false);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcTabIndicatorDirective, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._contents = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._indicators = _t);
    } }, hostVars: 3, hostBindings: function AbstractMdcTabDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function AbstractMdcTabDirective_click_HostBindingHandler() { return ctx._onClick(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx._role);
        ɵngcc0.ɵɵclassProp("mdc-tab", ctx._cls);
    } }, outputs: { activate: "activate" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
AbstractMdcTabDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: MdcEventRegistry },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
AbstractMdcTabDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-tab',] }],
    _role: [{ type: HostBinding, args: ['attr.role',] }],
    _contents: [{ type: ContentChildren, args: [MdcTabContentDirective,] }],
    _indicators: [{ type: ContentChildren, args: [MdcTabIndicatorDirective, { descendants: true },] }],
    activate: [{ type: Output }],
    _onClick: [{ type: HostListener, args: ['click',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbstractMdcTabDirective, [{
        type: Directive
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: MdcEventRegistry }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-tab']
        }], _role: [{
            type: HostBinding,
            args: ['attr.role']
        }], activate: [{
            type: Output
        }], 
    /** @internal */
    _onClick: [{
            type: HostListener,
            args: ['click']
        }], _contents: [{
            type: ContentChildren,
            args: [MdcTabContentDirective]
        }], _indicators: [{
            type: ContentChildren,
            args: [MdcTabIndicatorDirective, { descendants: true }]
        }] }); })();
/**
 * Directive for a tab. This directive must be used as a child of <code>mdcTabBar</code>.
 * When using tabs in combination with angular routes, add a `routerLink` property, so that
 * the `MdcTabRouterDirective` is selected instead of this directive.
 */
class MdcTabDirective extends AbstractMdcTabDirective {
    constructor(rndr, root, registry, doc) {
        super(rndr, root, registry, doc);
    }
    /**
     * Input for activating the tab. Assign a truthy value to activate the tab. A falsy value
     * will have no effect. In order to deactivate the tab, you must activate another tab.
     */
    get active() {
        return this.isActive();
    }
    set active(value) {
        this.triggerActivation(asBoolean(value));
    }
}
MdcTabDirective.ɵfac = function MdcTabDirective_Factory(t) { return new (t || MdcTabDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcTabDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTabDirective, selectors: [["", "mdcTab", "", 3, "routerLink", ""]], inputs: { active: "active" }, exportAs: ["mdcTab"], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: AbstractMdcTabDirective, useExisting: forwardRef(() => MdcTabDirective) }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcTabDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: MdcEventRegistry },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcTabDirective.propDecorators = {
    active: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTabDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTab]:not([routerLink])',
                exportAs: 'mdcTab',
                providers: [{ provide: AbstractMdcTabDirective, useExisting: forwardRef(() => MdcTabDirective) }]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: MdcEventRegistry }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { active: [{
            type: Input
        }] }); })();
const TAB_DIRECTIVES = [MdcTabIconDirective, MdcTabLabelDirective, MdcTabContentDirective, MdcTabDirective];

/**
 * Directive for a the scroll content of an `mdcTabScrollerArea`. This directive must wrap the
 * `mdcTab` directives for each of the tabs.
 */
class MdcTabScrollerContentDirective {
    constructor(_el) {
        this._el = _el;
        /** @internal */
        this._cls = true;
    }
}
MdcTabScrollerContentDirective.ɵfac = function MdcTabScrollerContentDirective_Factory(t) { return new (t || MdcTabScrollerContentDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcTabScrollerContentDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTabScrollerContentDirective, selectors: [["", "mdcTabScrollerContent", ""]], hostVars: 2, hostBindings: function MdcTabScrollerContentDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-tab-scroller__scroll-content", ctx._cls);
    } } });
MdcTabScrollerContentDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcTabScrollerContentDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-tab-scroller__scroll-content',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTabScrollerContentDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTabScrollerContent]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-tab-scroller__scroll-content']
        }] }); })();
/**
 * Directive for a the scroll area of an `mdcTabScroller`. This directive should have exactly one
 * `mdcTabScrollerContent` child directive.
 */
class MdcTabScrollerAreaDirective {
    constructor(_el) {
        this._el = _el;
        /** @internal */
        this._cls = true;
    }
}
MdcTabScrollerAreaDirective.ɵfac = function MdcTabScrollerAreaDirective_Factory(t) { return new (t || MdcTabScrollerAreaDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcTabScrollerAreaDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTabScrollerAreaDirective, selectors: [["", "mdcTabScrollerArea", ""]], hostVars: 2, hostBindings: function MdcTabScrollerAreaDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-tab-scroller__scroll-area", ctx._cls);
    } } });
MdcTabScrollerAreaDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcTabScrollerAreaDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-tab-scroller__scroll-area',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTabScrollerAreaDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTabScrollerArea]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-tab-scroller__scroll-area']
        }] }); })();
/**
 * Directive for a scrollable tab bar. This directive should have exactly one
 * `mdcTabScrollerArea` child directive.
 */
class MdcTabScrollerDirective {
    constructor(_rndr, _el, registry, doc) {
        this._rndr = _rndr;
        this._el = _el;
        this.registry = registry;
        /** @internal */
        this._cls = true;
        this.onDestroy$ = new Subject();
        this._adapter = {
            eventTargetMatchesSelector: (target, selector) => ponyfill.matches(target, selector),
            addClass: (name) => this._rndr.addClass(this._el.nativeElement, name),
            removeClass: (name) => this._rndr.removeClass(this._el.nativeElement, name),
            addScrollAreaClass: (name) => this._rndr.addClass(this._area._el.nativeElement, name),
            setScrollAreaStyleProperty: (name, value) => this._rndr.setStyle(this._area._el.nativeElement, name, value),
            setScrollContentStyleProperty: (name, value) => this._rndr.setStyle(this._content._el.nativeElement, name, value),
            getScrollContentStyleValue: (name) => getComputedStyle(this._content._el.nativeElement).getPropertyValue(name),
            setScrollAreaScrollLeft: (scrollX) => this._area._el.nativeElement.scrollLeft = scrollX,
            getScrollAreaScrollLeft: () => this._area._el.nativeElement.scrollLeft,
            getScrollContentOffsetWidth: () => this._content._el.nativeElement.offsetWidth,
            getScrollAreaOffsetWidth: () => this._area._el.nativeElement.offsetWidth,
            computeScrollAreaClientRect: () => this._area._el.nativeElement.getBoundingClientRect(),
            computeScrollContentClientRect: () => this._content._el.nativeElement.getBoundingClientRect(),
            computeHorizontalScrollbarHeight: () => util$4.computeHorizontalScrollbarHeight(this.document)
        };
        /** @internal */
        this._foundation = null;
        this._handleInteraction = () => this._foundation.handleInteraction();
        this._handleTransitionEnd = (evt) => this._foundation.handleTransitionEnd(evt);
        this.document = doc; // work around ngc issue https://github.com/angular/angular/issues/20351
    }
    ngAfterContentInit() {
        let initializer = () => {
            this.destroyFoundation();
            if (this._content && this._area)
                this.initFoundation();
        };
        initializer();
        this._contents.changes.pipe(takeUntil(this.onDestroy$)).subscribe(initializer);
        this._areas.changes.pipe(takeUntil(this.onDestroy$)).subscribe(initializer);
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
        this.destroyFoundation();
    }
    initFoundation() {
        this._foundation = new MDCTabScrollerFoundation(this._adapter);
        this._foundation.init();
        // manual registration of event listeners, because we need applyPassive, which is not (yet)
        // supported by angular bindings:
        this.registry.listen(this._rndr, 'wheel', this._handleInteraction, this._area._el, events.applyPassive());
        this.registry.listen(this._rndr, 'touchstart', this._handleInteraction, this._area._el, events.applyPassive());
        this.registry.listen(this._rndr, 'pointerdown', this._handleInteraction, this._area._el, events.applyPassive());
        this.registry.listen(this._rndr, 'mousedown', this._handleInteraction, this._area._el, events.applyPassive());
        this.registry.listen(this._rndr, 'keydown', this._handleInteraction, this._area._el, events.applyPassive());
        this.registry.listen(this._rndr, 'transitionend', this._handleTransitionEnd, this._content._el);
    }
    destroyFoundation() {
        let destroy = this._foundation != null;
        if (destroy) {
            this.registry.unlisten('wheel', this._handleInteraction);
            this.registry.unlisten('touchstart', this._handleInteraction);
            this.registry.unlisten('pointerdown', this._handleInteraction);
            this.registry.unlisten('mousedown', this._handleInteraction);
            this.registry.unlisten('keydown', this._handleInteraction);
            this.registry.unlisten('transitionend', this._handleTransitionEnd);
            this._foundation.destroy();
        }
        this._foundation = null;
        return destroy;
    }
    /** @internal */
    _getScrollContentWidth() {
        return this._adapter.getScrollContentOffsetWidth();
    }
    get _area() {
        return this._areas && this._areas.length > 0 ? this._areas.first : null;
    }
    get _content() {
        return this._contents && this._contents.length > 0 ? this._contents.first : null;
    }
}
MdcTabScrollerDirective.ɵfac = function MdcTabScrollerDirective_Factory(t) { return new (t || MdcTabScrollerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcTabScrollerDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTabScrollerDirective, selectors: [["", "mdcTabScroller", ""]], contentQueries: function MdcTabScrollerDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcTabScrollerAreaDirective, false);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcTabScrollerContentDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, AbstractMdcTabDirective, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._areas = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._contents = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._tabs = _t);
    } }, hostVars: 2, hostBindings: function MdcTabScrollerDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-tab-scroller", ctx._cls);
    } } });
MdcTabScrollerDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: MdcEventRegistry },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcTabScrollerDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-tab-scroller',] }],
    _areas: [{ type: ContentChildren, args: [MdcTabScrollerAreaDirective,] }],
    _contents: [{ type: ContentChildren, args: [MdcTabScrollerContentDirective, { descendants: true },] }],
    _tabs: [{ type: ContentChildren, args: [AbstractMdcTabDirective, { descendants: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTabScrollerDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTabScroller]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: MdcEventRegistry }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-tab-scroller']
        }], _areas: [{
            type: ContentChildren,
            args: [MdcTabScrollerAreaDirective]
        }], _contents: [{
            type: ContentChildren,
            args: [MdcTabScrollerContentDirective, { descendants: true }]
        }], _tabs: [{
            type: ContentChildren,
            args: [AbstractMdcTabDirective, { descendants: true }]
        }] }); })();
const TAB_SCROLLER_DIRECTIVES = [MdcTabScrollerContentDirective, MdcTabScrollerAreaDirective, MdcTabScrollerDirective];

/**
 * Directive for a tab bar. This directive must have an `mdcTabScroller` as only child.
 */
class MdcTabBarDirective {
    constructor(_el, doc) {
        this._el = _el;
        /** @internal */
        this._cls = true;
        /** @internal */
        this._role = 'tablist';
        this.onDestroy$ = new Subject();
        this.onTabsChange$ = new Subject();
        /**
         * Event emitted when the active tab changes.
         */
        this.tabChange = new EventEmitter();
        this._adapter = {
            scrollTo: (scrollX) => this._scroller._foundation.scrollTo(scrollX),
            incrementScroll: (scrollXIncrement) => this._scroller._foundation.incrementScroll(scrollXIncrement),
            getScrollPosition: () => this._scroller._foundation.getScrollPosition(),
            getScrollContentWidth: () => this._scroller._getScrollContentWidth(),
            getOffsetWidth: () => this._el.nativeElement.offsetWidth,
            isRTL: () => getComputedStyle(this._el.nativeElement).getPropertyValue('direction') === 'rtl',
            setActiveTab: (index) => this._foundation.activateTab(index),
            activateTabAtIndex: (index, clientRect) => this._tabs.toArray()[index]._activate(index, clientRect),
            deactivateTabAtIndex: (index) => this._tabs.toArray()[index]._deactivate(),
            focusTabAtIndex: (index) => this._tabs.toArray()[index]._focus(),
            getTabIndicatorClientRectAtIndex: (index) => this._tabs.toArray()[index]._computeIndicatorClientRect(),
            getTabDimensionsAtIndex: (index) => this._tabs.toArray()[index]._computeDimensions(),
            getPreviousActiveTabIndex: () => this._tabs.toArray().findIndex(e => e.isActive()),
            getFocusedTabIndex: () => this._tabs.map(t => t._root.nativeElement).indexOf(this.document.activeElement),
            getIndexOfTabById: () => -1,
            getTabListLength: () => this._tabs.length,
            notifyTabActivated: (tabIndex) => this.tabChange.emit({ tab: this._tabs.toArray()[tabIndex], tabIndex })
        };
        this._subscriptions = [];
        this._foundation = null;
        this.document = doc;
    }
    ngAfterContentInit() {
        let scrollersObservable$ = this._scrollers.changes.pipe(takeUntil(this.onDestroy$));
        const tabChangeInit = () => {
            if (this._tabs) {
                this._tabs.changes.pipe(takeUntil(scrollersObservable$), takeUntil(this.onDestroy$)).subscribe(() => {
                    this.onTabsChange$.next();
                });
            }
        };
        scrollersObservable$.subscribe(() => {
            this.onTabsChange$.next();
            tabChangeInit();
        });
        tabChangeInit();
        this.onTabsChange$.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            this.destroyFoundation();
            if (this._tabs)
                this.initFoundation();
        });
        if (this._tabs)
            this.initFoundation();
    }
    ngOnDestroy() {
        this.onTabsChange$.complete();
        this.onDestroy$.next();
        this.onDestroy$.complete();
        this.destroyFoundation();
    }
    initFoundation() {
        this._foundation = new MDCTabBarFoundation(this._adapter);
        this._foundation.init();
        this._listenTabSelected();
    }
    destroyFoundation() {
        this._unlistenTabSelected();
        let destroy = this._foundation != null;
        if (destroy) {
            this._foundation.destroy();
        }
        this._foundation = null;
        return destroy;
    }
    _listenTabSelected() {
        var _a;
        this._unlistenTabSelected();
        this._subscriptions = new Array();
        (_a = this._tabs) === null || _a === void 0 ? void 0 : _a.forEach(tab => {
            this._subscriptions.push(tab.activationRequest$.subscribe(activated => {
                if (activated)
                    this._setActive(tab);
            }));
        });
    }
    _unlistenTabSelected() {
        this._subscriptions.forEach(sub => sub.unsubscribe());
        this._subscriptions = [];
    }
    _setActive(tab) {
        if (this._foundation && this._tabs) {
            let index = this._tabs.toArray().indexOf(tab);
            // This is what foundation.handleTabInteraction would do, but more accessible, without
            // the need for assigned tabIds:
            if (index >= 0)
                this._adapter.setActiveTab(index);
        }
    }
    /** @internal */
    _handleInteraction(event) {
        if (this._foundation)
            this._foundation.handleKeyDown(event);
    }
    get _scroller() {
        return this._scrollers && this._scrollers.length > 0 ? this._scrollers.first : null;
    }
    get _tabs() {
        return this._scroller ? this._scroller._tabs : null;
    }
}
MdcTabBarDirective.ɵfac = function MdcTabBarDirective_Factory(t) { return new (t || MdcTabBarDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcTabBarDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTabBarDirective, selectors: [["", "mdcTabBar", ""]], contentQueries: function MdcTabBarDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcTabScrollerDirective, false);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._scrollers = _t);
    } }, hostVars: 3, hostBindings: function MdcTabBarDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function MdcTabBarDirective_keydown_HostBindingHandler($event) { return ctx._handleInteraction($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx._role);
        ɵngcc0.ɵɵclassProp("mdc-tab-bar", ctx._cls);
    } }, outputs: { tabChange: "tabChange" } });
MdcTabBarDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcTabBarDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-tab-bar',] }],
    _role: [{ type: HostBinding, args: ['attr.role',] }],
    _scrollers: [{ type: ContentChildren, args: [MdcTabScrollerDirective,] }],
    tabChange: [{ type: Output }],
    _handleInteraction: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTabBarDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTabBar]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-tab-bar']
        }], _role: [{
            type: HostBinding,
            args: ['attr.role']
        }], tabChange: [{
            type: Output
        }], 
    /** @internal */
    _handleInteraction: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], _scrollers: [{
            type: ContentChildren,
            args: [MdcTabScrollerDirective]
        }] }); })();
const TAB_BAR_DIRECTIVES = [MdcTabBarDirective];

/**
 * @docs-private
 */
class RouterActiveDetector {
    constructor(component, links, linksWithHrefs, router, link, linkWithHref) {
        this.component = component;
        this.links = links;
        this.linksWithHrefs = linksWithHrefs;
        this.router = router;
        this.link = link;
        this.linkWithHref = linkWithHref;
        this.onDestroy$ = new Subject();
        router.events.pipe(takeUntil(this.onDestroy$)).subscribe(s => {
            if (s instanceof NavigationEnd) {
                this.update();
            }
        });
    }
    /** @internal */
    init() {
        this.links.changes.subscribe(_ => this.update());
        this.linksWithHrefs.changes.subscribe(_ => this.update());
        this.update();
    }
    /** @internal */
    destroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
    /** @internal */
    update() {
        if (!this.links || !this.linksWithHrefs || !this.router.navigated)
            return;
        Promise.resolve().then(() => {
            const hasActiveLinks = this.hasActiveLinks();
            const active = this.component.isRouterActive();
            if (active !== hasActiveLinks) {
                this.component.setRouterActive(hasActiveLinks);
            }
        });
    }
    hasActiveLinks() {
        return (this.link && this.isLinkActive(this.router)(this.link)) ||
            (this.linkWithHref && this.isLinkActive(this.router)(this.linkWithHref)) ||
            this.links.some(this.isLinkActive(this.router)) ||
            this.linksWithHrefs.some(this.isLinkActive(this.router));
    }
    isLinkActive(router) {
        return (link) => router.isActive(link.urlTree, false);
    }
}
RouterActiveDetector.ctorParameters = () => [
    { type: undefined },
    { type: QueryList },
    { type: QueryList },
    { type: Router },
    { type: RouterLink, decorators: [{ type: Optional }] },
    { type: RouterLinkWithHref, decorators: [{ type: Optional }] }
];

/**
 * Directive for a tab that triggers a route change. This directive must be used as a child of
 * `mdcTabBar`. For a tab that doesn't use the angular routing module, drop the `routerLink`
 * attribute.
 *
 * Selector `mdcTabRouter` is provided for backward compatibility and will be deprecated in the future.
 * Use the selector `mdcTab` in combination with a `routerLink` attribute instead.
 */
class MdcTabRouterDirective extends AbstractMdcTabDirective {
    constructor(rndr, root, registry, router, doc, link, linkWithHref) {
        super(rndr, root, registry, doc);
        this.router = router;
        this.link = link;
        this.linkWithHref = linkWithHref;
        this.routerActive = null;
    }
    ngOnDestroy() {
        var _a;
        (_a = this.routerActive) === null || _a === void 0 ? void 0 : _a.destroy();
        this.routerActive = null;
        super.ngOnDestroy();
    }
    ngAfterContentInit() {
        super.ngAfterContentInit();
        this.routerActive = new RouterActiveDetector(this, this._links, this._linksWithHrefs, this.router, this.link, this.linkWithHref);
        this.routerActive.init();
    }
    ngOnChanges() {
        var _a;
        (_a = this.routerActive) === null || _a === void 0 ? void 0 : _a.update();
    }
    /** @internal */
    isRouterActive() {
        return this.isActive();
    }
    /** @internal */
    setRouterActive(activate) {
        this.triggerActivation(activate);
    }
}
MdcTabRouterDirective.ɵfac = function MdcTabRouterDirective_Factory(t) { return new (t || MdcTabRouterDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.RouterLink, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.RouterLinkWithHref, 8)); };
MdcTabRouterDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTabRouterDirective, selectors: [["", "mdcTab", "", "routerLink", ""], ["", "mdcTabRouter", ""]], contentQueries: function MdcTabRouterDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, RouterLink, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, RouterLinkWithHref, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._links = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._linksWithHrefs = _t);
    } }, exportAs: ["mdcTab"], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: AbstractMdcTabDirective, useExisting: forwardRef(() => MdcTabRouterDirective) }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature] });
MdcTabRouterDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: MdcEventRegistry },
    { type: Router },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: RouterLink, decorators: [{ type: Optional }] },
    { type: RouterLinkWithHref, decorators: [{ type: Optional }] }
];
MdcTabRouterDirective.propDecorators = {
    _links: [{ type: ContentChildren, args: [RouterLink, { descendants: true },] }],
    _linksWithHrefs: [{ type: ContentChildren, args: [RouterLinkWithHref, { descendants: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTabRouterDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTab][routerLink],[mdcTabRouter]',
                exportAs: 'mdcTab',
                providers: [{ provide: AbstractMdcTabDirective, useExisting: forwardRef(() => MdcTabRouterDirective) }]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: MdcEventRegistry }, { type: ɵngcc2.Router }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc2.RouterLink, decorators: [{
                type: Optional
            }] }, { type: ɵngcc2.RouterLinkWithHref, decorators: [{
                type: Optional
            }] }]; }, { _links: [{
            type: ContentChildren,
            args: [RouterLink, { descendants: true }]
        }], _linksWithHrefs: [{
            type: ContentChildren,
            args: [RouterLinkWithHref, { descendants: true }]
        }] }); })();
const TAB_ROUTER_DIRECTIVES = [MdcTabRouterDirective];

let nextId$3 = 1;
/**
 * Directive for the native input of an `mdcTextField`.
 */
class MdcTextFieldInputDirective extends AbstractMdcInput {
    constructor(_elm, renderer, _cntr) {
        super();
        this._elm = _elm;
        this.renderer = renderer;
        this._cntr = _cntr;
        /** @internal */
        this._cls = true;
        /** @internal */
        this._labeledBy = null;
        /** @internal */
        this._controls = null;
        /** @internal */
        this._describedBy = null;
        /** @internal */
        this._valueChange = new EventEmitter();
        this.onDestroy$ = new Subject();
        this._id = null;
        this._type = 'text';
        this._value = '';
        this._disabled = false;
        this.cachedId = null;
    }
    ngOnInit() {
        var _a;
        // Force setter to be called in case id was not specified.
        this.id = this.id;
        (_a = this._cntr) === null || _a === void 0 ? void 0 : _a.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
            // (using the value of the elemnt, because the value of the control might be of another type,
            // e.g. the ngModel for type=number inputs is a number)
            this.updateValue(this._elm.nativeElement.value, true);
        });
    }
    ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
    /**
     * Mirrors the <code>id</code> attribute. If no id is assigned, this directive will
     * assign a unique id by itself. If an <code>mdcFloatingLabel</code> for this text-field
     * is available, the <code>mdcFloatingLabel</code> will automatically be associated
     * (either by a `for` attribute on the label, or by an `aria-labelledby` attribute
     * on this input element).
     */
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value || this._newId();
    }
    /**
     * If set to a value other than false, the text-field will be in disabled state.
     */
    get disabled() {
        return this._cntr ? !!this._cntr.disabled : this._disabled;
    }
    set disabled(value) {
        this._disabled = asBoolean(value);
    }
    /** @internal */
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value || 'text';
        // Angular Input is not automatically set on the native input element:
        if (!this._isTextarea()) {
            try {
                this.renderer.setProperty(this._elm.nativeElement, 'type', this._type);
            }
            catch (e) {
                this.renderer.setAttribute(this._elm.nativeElement, 'type', this._type);
            }
        }
    }
    /** @internal */
    get value() {
        return this._value;
    }
    /** @internal */
    set value(value) {
        this.updateValue(value, false);
    }
    updateValue(value, fromControl) {
        const newVal = (value ? `${value}` : '');
        if (newVal !== this._value) {
            this._value = this._elm.nativeElement.value = newVal;
            this._valueChange.emit(this._elm.nativeElement.value);
        }
        if (!fromControl && this._cntr && newVal !== this._cntr.value) {
            this._cntr.control.setValue(newVal); // TODO how to convert to the type of value the controlpects?
        }
    }
    /** @internal */
    _onInput() {
        if (!this._cntr)
            this.updateValue(this._elm.nativeElement.value, false);
    }
    /** @internal */
    get valid() {
        return this._cntr ? !!this._cntr.valid : this._elm.nativeElement.validity.valid;
    }
    /** @internal */
    _isBadInput() {
        return this._elm.nativeElement.validity.badInput;
    }
    /** @internal */
    _isTextarea() {
        return this._elm.nativeElement.nodeName.toLowerCase() === 'textarea';
    }
    /** @internal */
    _newId() {
        this.cachedId = this.cachedId || `mdc-input-${nextId$3++}`;
        return this.cachedId;
    }
}
MdcTextFieldInputDirective.ɵfac = function MdcTextFieldInputDirective_Factory(t) { return new (t || MdcTextFieldInputDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgControl, 10)); };
MdcTextFieldInputDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTextFieldInputDirective, selectors: [["input", "mdcTextFieldInput", ""], ["textarea", "mdcTextFieldInput", ""]], hostVars: 7, hostBindings: function MdcTextFieldInputDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function MdcTextFieldInputDirective_input_HostBindingHandler() { return ctx._onInput(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("id", ctx.id)("disabled", ctx.disabled);
        ɵngcc0.ɵɵattribute("aria-labelledby", ctx._labeledBy)("aria-controls", ctx._controls)("aria-describedby", ctx._describedBy);
        ɵngcc0.ɵɵclassProp("mdc-text-field__input", ctx._cls);
    } }, inputs: { id: "id", disabled: "disabled", type: "type", value: "value" }, outputs: { _valueChange: "_valueChange" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: AbstractMdcInput, useExisting: forwardRef(() => MdcTextFieldInputDirective) }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcTextFieldInputDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }] }
];
MdcTextFieldInputDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-text-field__input',] }],
    _labeledBy: [{ type: HostBinding, args: ['attr.aria-labelledby',] }],
    _controls: [{ type: HostBinding, args: ['attr.aria-controls',] }],
    _describedBy: [{ type: HostBinding, args: ['attr.aria-describedby',] }],
    _valueChange: [{ type: Output }],
    id: [{ type: HostBinding }, { type: Input }],
    disabled: [{ type: HostBinding }, { type: Input }],
    type: [{ type: Input }],
    value: [{ type: Input }],
    _onInput: [{ type: HostListener, args: ['input',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTextFieldInputDirective, [{
        type: Directive,
        args: [{
                selector: 'input[mdcTextFieldInput], textarea[mdcTextFieldInput]',
                providers: [{ provide: AbstractMdcInput, useExisting: forwardRef(() => MdcTextFieldInputDirective) }]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc1.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-text-field__input']
        }], _labeledBy: [{
            type: HostBinding,
            args: ['attr.aria-labelledby']
        }], _controls: [{
            type: HostBinding,
            args: ['attr.aria-controls']
        }], _describedBy: [{
            type: HostBinding,
            args: ['attr.aria-describedby']
        }], _valueChange: [{
            type: Output
        }], id: [{
            type: HostBinding
        }, {
            type: Input
        }], disabled: [{
            type: HostBinding
        }, {
            type: Input
        }], type: [{
            type: Input
        }], value: [{
            type: Input
        }], 
    /** @internal */
    _onInput: [{
            type: HostListener,
            args: ['input']
        }] }); })();
/**
 * Directive for an optional leading or trailing icon on the text-field (see
 * `MdcTextFieldDirective`). An icon before the `mdcTextFieldInput` will be styled
 * as a leading icon. An icon after the `mdcTextFieldInput` will be styles as a
 * trailing icon.
 */
class MdcTextFieldIconDirective {
    constructor(_rndr, _el, _reg) {
        this._rndr = _rndr;
        this._el = _el;
        this._reg = _reg;
        /** @internal */
        this._cls = true;
        /**
         * Event emitted for icon interactions (a click or an 'enter' keypress). When this output is assigned,
         * the icon will also set the `role=button` and `tabindex=0` attributes, unless you give them another
         * explicit value.
         */
        this.interact = new EventEmitter();
        /** @internal */
        this._leading = false;
        /** @internal */
        this._trailing = false;
        this._tabIndex = null;
        this._role = null;
        /** @internal */
        this._textField = null;
        /** @internal */
        this._mdcAdapter = {
            // by returning null for 'tabindex', the foundation will not set tabindex/role attributes when
            // disabled state changes. We want that, because we handle tabindex/role ourselves:
            getAttr: (name) => name === 'tabindex' ? null : this._el.nativeElement.getAttribute(name),
            setAttr: (name, value) => this._rndr.setAttribute(this._el.nativeElement, name, value),
            removeAttr: (name) => this._rndr.removeAttribute(this._el.nativeElement, name),
            setContent: (content) => this._el.nativeElement.textContent = content,
            registerInteractionHandler: (evtType, handler) => this._reg.listen(this._rndr, evtType, handler, this._el),
            deregisterInteractionHandler: (evtType, handler) => this._reg.unlisten(evtType, handler),
            notifyIconAction: () => { var _a; return !((_a = this._textField) === null || _a === void 0 ? void 0 : _a._disabled) && this.interact.emit(); }
        };
        /** @internal */
        this._foundation = new MDCTextFieldIconFoundation(this._mdcAdapter);
    }
    ngAfterContentInit() {
        this._foundation.init();
    }
    ngOnDestroy() {
        var _a;
        (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        this._foundation = null;
    }
    /**
     * The `tabindex` for icons defaults to `null` (no tabindex set) for icons without
     * subscriptions to the `interact` output, and to `0` for icons that have an `interact`
     * binding. You can override this default, by setting a non-null value for this property.
     */
    get tabindex() {
        var _a;
        if (this.interact.observers.length > 0 && this._tabIndex == null && !((_a = this._textField) === null || _a === void 0 ? void 0 : _a._disabled))
            return 0;
        return this._tabIndex;
    }
    set tabindex(value) {
        this._tabIndex = asNumberOrNull(value);
    }
    /**
     * The `role` attribute for icons defaults to `null` (no role set) for icons without
     * subscriptions to the `interact` output, and to `button` for icons that have an `interact`
     * binding. You can override this default, by setting a non-null value for this property.
     */
    get role() {
        var _a;
        if (this.interact.observers.length > 0 && this._role == null && !((_a = this._textField) === null || _a === void 0 ? void 0 : _a._disabled))
            return 'button';
        return this._role;
    }
    set role(value) {
        this._role = value;
    }
}
MdcTextFieldIconDirective.ɵfac = function MdcTextFieldIconDirective_Factory(t) { return new (t || MdcTextFieldIconDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry)); };
MdcTextFieldIconDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTextFieldIconDirective, selectors: [["", "mdcTextFieldIcon", ""]], hostVars: 8, hostBindings: function MdcTextFieldIconDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("tabindex", ctx.tabindex)("role", ctx.role);
        ɵngcc0.ɵɵclassProp("mdc-text-field__icon", ctx._cls)("mdc-text-field__icon--leading", ctx._leading)("mdc-text-field__icon--trailing", ctx._trailing);
    } }, inputs: { tabindex: "tabindex", role: "role" }, outputs: { interact: "interact" } });
MdcTextFieldIconDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: MdcEventRegistry }
];
MdcTextFieldIconDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-text-field__icon',] }],
    interact: [{ type: Output }],
    _leading: [{ type: HostBinding, args: ['class.mdc-text-field__icon--leading',] }],
    _trailing: [{ type: HostBinding, args: ['class.mdc-text-field__icon--trailing',] }],
    tabindex: [{ type: HostBinding, args: ['attr.tabindex',] }, { type: Input }],
    role: [{ type: HostBinding, args: ['attr.role',] }, { type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTextFieldIconDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTextFieldIcon]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: MdcEventRegistry }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-text-field__icon']
        }], interact: [{
            type: Output
        }], _leading: [{
            type: HostBinding,
            args: ['class.mdc-text-field__icon--leading']
        }], _trailing: [{
            type: HostBinding,
            args: ['class.mdc-text-field__icon--trailing']
        }], tabindex: [{
            type: HostBinding,
            args: ['attr.tabindex']
        }, {
            type: Input
        }], role: [{
            type: HostBinding,
            args: ['attr.role']
        }, {
            type: Input
        }] }); })();
/**
 * This directive wraps an optional `mdcTextFieldHelperText`. It should be the next sibling of the
 * associated `mdcTextField` if used. See `mdcTextFieldHelperText` for more info.
 */
class MdcTextFieldHelperLineDirective {
    constructor() {
        /** @internal */
        this._cls = true;
    }
}
MdcTextFieldHelperLineDirective.ɵfac = function MdcTextFieldHelperLineDirective_Factory(t) { return new (t || MdcTextFieldHelperLineDirective)(); };
MdcTextFieldHelperLineDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTextFieldHelperLineDirective, selectors: [["", "mdcTextFieldHelperLine", ""]], hostVars: 2, hostBindings: function MdcTextFieldHelperLineDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-text-field-helper-line", ctx._cls);
    } } });
MdcTextFieldHelperLineDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-text-field-helper-line',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTextFieldHelperLineDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTextFieldHelperLine]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-text-field-helper-line']
        }] }); })();
class MdcTextFieldHelperTextDirectiveBase {
}
MdcTextFieldHelperTextDirectiveBase.ɵfac = function MdcTextFieldHelperTextDirectiveBase_Factory(t) { return new (t || MdcTextFieldHelperTextDirectiveBase)(); };
MdcTextFieldHelperTextDirectiveBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTextFieldHelperTextDirectiveBase });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTextFieldHelperTextDirectiveBase, [{
        type: Directive
    }], null, null); })();
applyMixins(MdcTextFieldHelperTextDirectiveBase, [HasId]);
/**
 * Directive for an optional helper-text to show supplemental information or validation
 * messages for an <code>mdcTextField</code>. This directive should be wrapped inside an
 * `mdcTextFieldHelperLine` that comes directly after the `mdcTextField` it belongs to.
 * Additionally, you must export it as an <code>mdcHelperText</code>, and
 * assign the exported object to the <code>helperText</code> property of the
 * <code>mdcHelperText</code>. See the examples for hints on how to do this.
 *
 * The `mdcTextFieldInput` of the textfield will get `aria-controls` and `aria-describedby`
 * accessibility attributes that point to the `id` of this helpertext element. If no `id` has
 * been assigned, a unique `id` attribute will automatically be assigned. If the `id` attribute
 * is changed, the aria attributes on the `mdcTextFieldInput` will be updated accordingly.
 */
class MdcTextFieldHelperTextDirective extends MdcTextFieldHelperTextDirectiveBase {
    constructor(_rndr, _elm) {
        super();
        this._rndr = _rndr;
        this._elm = _elm;
        /** @internal */
        this._cls = true;
        this._validation = false;
        this._persistent = false;
        /** @internal */
        this._mdcAdapter = {
            addClass: (className) => this._rndr.addClass(this._elm.nativeElement, className),
            removeClass: (className) => this._rndr.removeClass(this._elm.nativeElement, className),
            hasClass: (className) => this._elm.nativeElement.classList.contains(className),
            setAttr: (name, value) => this._rndr.setAttribute(this._elm.nativeElement, name, value),
            removeAttr: (name) => this._rndr.removeAttribute(this._elm.nativeElement, name),
            setContent: () => {
                // helperText content can be set by simply wrapping (dynamic) content in the directive.
                // this is much more powerful than setContent, because it can also include html markup
                // therefore there is no reason to do anything with setContent
                throw new Error("MdcTextFieldHelperTextAdapter.setContent not supported");
            }
        };
        /** @internal */
        this._foundation = null;
    }
    ngOnInit() {
        this.initId();
    }
    ngAfterContentInit() {
        this._foundation = new MDCTextFieldHelperTextFoundation(this._mdcAdapter);
        this._foundation.setPersistent(this._persistent);
        this._foundation.setValidation(this._validation);
    }
    ngOnDestroy() {
        var _a;
        (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        this._foundation = null;
    }
    /**
     * If set to a value other than false, the helper text is treated as a
     * validation message, and only shown when the input is invalid.
     */
    set validation(value) {
        this._validation = asBoolean(value);
        if (this._foundation)
            this._foundation.setValidation(this._validation);
    }
    /**
     * If set to a value other than false, the helper text is always visible.
     * Otherwise the helper text will only be shown when the input has focus
     * (or if `validation` is set, when the input is invalid).
     */
    set persistent(value) {
        this._persistent = asBoolean(value);
        if (this._foundation)
            this._foundation.setPersistent(this._persistent);
    }
}
MdcTextFieldHelperTextDirective.ɵfac = function MdcTextFieldHelperTextDirective_Factory(t) { return new (t || MdcTextFieldHelperTextDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcTextFieldHelperTextDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTextFieldHelperTextDirective, selectors: [["", "mdcTextFieldHelperText", ""]], hostVars: 2, hostBindings: function MdcTextFieldHelperTextDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-text-field-helper-text", ctx._cls);
    } }, inputs: { validation: "validation", persistent: "persistent" }, exportAs: ["mdcHelperText"], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcTextFieldHelperTextDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
MdcTextFieldHelperTextDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-text-field-helper-text',] }],
    validation: [{ type: Input }],
    persistent: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTextFieldHelperTextDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTextFieldHelperText]',
                exportAs: 'mdcHelperText'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-text-field-helper-text']
        }], validation: [{
            type: Input
        }], persistent: [{
            type: Input
        }] }); })();
/**
 * Material design text-field. Text fields can be filled or outlined.
 *
 * Filled text-fields should have the following child directives:
 * * `mdcTextFieldIcon` (optional leading icon)
 * * `mdcTextFieldInput` (required, the native input)
 * * `mdcTextFieldIcon` (optional trailing icon)
 * * `mdcFloatingLabel` (optional floating label)
 *
 * Outlined text-fields should have the following child directives:
 * * `mdcTextFieldIcon` (optional leading icon)
 * * `mdcTextFieldInput` (required, the native input)
 * * `mdcTextFieldIcon` (optional trailing icon)
 * * `mdcNotchedOutline` (the outline, which can also contain an optional `mdcFloatingLabel`)
 *
 * Addditionally the text-field can be followed by an `mdcTextFieldHelperLine` containing an
 * `mdcHelperText`.
 */
class MdcTextFieldDirective extends AbstractMdcRipple {
    constructor(renderer, root, registry, doc) {
        super(root, renderer, registry, doc);
        this.renderer = renderer;
        this.root = root;
        this.registry = registry;
        this.onDestroy$ = new Subject();
        this.onInputChange$ = new Subject();
        this.onHelperTextChange$ = new Subject();
        /** @internal */
        this._cls = true;
        this._leadingIcon = null;
        this._trailingIcon = null;
        this._helperText = null;
        this._bottomLineElm = null;
        this._valid = null;
        this.mdcLineRippleAdapter = {
            addClass: (className) => this.renderer.addClass(this._bottomLineElm, className),
            removeClass: (className) => this.renderer.removeClass(this._bottomLineElm, className),
            hasClass: (className) => this._bottomLineElm.classList.contains(className),
            setStyle: (name, value) => this.renderer.setStyle(this._bottomLineElm, name, value),
            registerEventHandler: (evtType, handler) => this.registry.listenElm(this.renderer, evtType, handler, this._bottomLineElm),
            deregisterEventHandler: (evtType, handler) => this.registry.unlisten(evtType, handler)
        };
        this.mdcAdapter = {
            addClass: (className) => this.renderer.addClass(this.root.nativeElement, className),
            removeClass: (className) => this.renderer.removeClass(this.root.nativeElement, className),
            hasClass: (className) => this.root.nativeElement.classList.contains(className),
            registerTextFieldInteractionHandler: (evtType, handler) => {
                this.registry.listen(this.renderer, evtType, handler, this.root);
            },
            deregisterTextFieldInteractionHandler: (evtType, handler) => {
                this.registry.unlisten(evtType, handler);
            },
            registerInputInteractionHandler: (evtType, handler) => this._input && this.registry.listen(this.renderer, evtType, handler, this._input._elm),
            deregisterInputInteractionHandler: (evtType, handler) => this.registry.unlisten(evtType, handler),
            registerValidationAttributeChangeHandler: (handler) => {
                const getAttributesList = (mutationsList) => mutationsList
                    .map((mutation) => mutation.attributeName)
                    .filter((attrName) => attrName);
                const observer = new MutationObserver((mutationsList) => handler(getAttributesList(mutationsList)));
                observer.observe(this._input._elm.nativeElement, { attributes: true });
                return observer;
            },
            deregisterValidationAttributeChangeHandler: (observer) => observer.disconnect(),
            getNativeInput: () => ({
                value: this._input.value,
                disabled: this._input.disabled,
                maxLength: this._input._elm.nativeElement.maxLength,
                type: this._input.type,
                validity: {
                    valid: this._valid == null ? this._input.valid : !!this._valid,
                    badInput: this._input._isBadInput()
                }
            }),
            isFocused: () => !!this._input && document.activeElement === this._input._elm.nativeElement,
            shakeLabel: (shouldShake) => { var _a; return (_a = this._floatingLabel) === null || _a === void 0 ? void 0 : _a.shake(shouldShake); },
            floatLabel: (shouldFloat) => { var _a; return (_a = this._floatingLabel) === null || _a === void 0 ? void 0 : _a.float(shouldFloat); },
            hasLabel: () => !!this._floatingLabel,
            getLabelWidth: () => this._floatingLabel ? this._floatingLabel.getWidth() : 0,
            activateLineRipple: () => { var _a; return (_a = this.bottomLineFoundation) === null || _a === void 0 ? void 0 : _a.activate(); },
            deactivateLineRipple: () => { var _a; return (_a = this.bottomLineFoundation) === null || _a === void 0 ? void 0 : _a.deactivate(); },
            setLineRippleTransformOrigin: (normalizedX) => { var _a; return (_a = this.bottomLineFoundation) === null || _a === void 0 ? void 0 : _a.setRippleCenter(normalizedX); },
            hasOutline: () => !!this._outline,
            notchOutline: (labelWidth) => { var _a; return (_a = this._outline) === null || _a === void 0 ? void 0 : _a.open(labelWidth); },
            closeOutline: () => { var _a; return (_a = this._outline) === null || _a === void 0 ? void 0 : _a.close(); }
        };
        this.bottomLineFoundation = null;
        this.foundation = null;
    }
    ngAfterContentInit() {
        merge(this._floatingLabels.changes, this._icons.changes, this._inputs.changes, this._outlines.changes, this.onHelperTextChange$).pipe(takeUntil(this.onDestroy$), debounceTime(1)).subscribe(() => {
            this.reconstructComponent();
        });
        this.initComponent();
    }
    ngOnDestroy() {
        this.onInputChange$.next();
        this.onInputChange$.complete();
        this.onDestroy$.next();
        this.onDestroy$.complete();
        this.onHelperTextChange$.complete();
        this.destroyComponent();
    }
    initComponent() {
        var _a, _b, _c;
        if (this._input && !this._outline && !this._input._isTextarea()) {
            this.addRippleSurface('mdc-text-field__ripple', true);
            this.initRipple();
            this.initLineRipple();
        }
        this.attachLabelToInput();
        this.attachHelperTextToInput();
        this.initIcons();
        this.foundation = new MDCTextFieldFoundation(this.mdcAdapter, {
            helperText: ((_a = this.helperText) === null || _a === void 0 ? void 0 : _a._foundation) ? this.helperText._foundation : undefined,
            leadingIcon: ((_b = this._leadingIcon) === null || _b === void 0 ? void 0 : _b._foundation) ? this._leadingIcon._foundation : undefined,
            trailingIcon: ((_c = this._trailingIcon) === null || _c === void 0 ? void 0 : _c._foundation) ? this._trailingIcon._foundation : undefined
        });
        this.foundation.init();
        this.subscribeInputChanges();
        if (this._helperText) {
            this._helperText.idChange().pipe(takeUntil(this.onDestroy$), takeUntil(this.onHelperTextChange$)).subscribe(() => this.attachHelperTextToInput());
        }
    }
    destroyComponent() {
        var _a;
        this.destroyRippleSurface();
        this.destroyRipple();
        this.destroyLineRipple();
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        this.foundation = null;
    }
    reconstructComponent() {
        this.destroyComponent();
        this.initComponent();
        this.recomputeOutline(); // TODO check if we still need this with latest material-components-web
    }
    initLineRipple() {
        if (!this._outline) {
            this._bottomLineElm = this.renderer.createElement('div');
            this.renderer.addClass(this._bottomLineElm, 'mdc-line-ripple');
            this.renderer.appendChild(this.root.nativeElement, this._bottomLineElm);
            this.bottomLineFoundation = new MDCLineRippleFoundation(this.mdcLineRippleAdapter);
            this.bottomLineFoundation.init();
        }
    }
    destroyLineRipple() {
        var _a;
        if (this._bottomLineElm) {
            (_a = this.bottomLineFoundation) === null || _a === void 0 ? void 0 : _a.destroy();
            this.bottomLineFoundation = null;
            this.renderer.removeChild(this.root.nativeElement, this._bottomLineElm);
            this._bottomLineElm = null;
        }
    }
    recomputeOutline() {
        if (this._outline) {
            // the outline may not be valid after re-initialisation, recompute outline when all
            // style/structural changes have been employed:
            setTimeout(() => { var _a; (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.notchOutline(this.foundation.shouldFloat); }, 0);
        }
    }
    initIcons() {
        this._leadingIcon = this.computeLeadingIcon();
        this._trailingIcon = this.computeTrailingIcon(this._leadingIcon);
        this._icons.forEach(icon => {
            icon._textField = this;
            icon._leading = icon === this._leadingIcon;
            icon._trailing = icon === this._trailingIcon;
        });
    }
    computeLeadingIcon() {
        if (this._icons.length > 0) {
            let icon = this._icons.first;
            let prev = this.previousElement(icon._el.nativeElement);
            let last = icon._el.nativeElement;
            while (true) {
                // if it is contained in another element, check the siblings of the container too:
                if (prev == null && last != null && last.parentElement !== this.root.nativeElement)
                    prev = last.parentElement;
                // no more elements before, must be the leading icon:
                if (prev == null)
                    return icon;
                // comes after the text, so it's not the leading icon:
                if (this._input && (prev === this._input._elm.nativeElement || prev.contains(this._input._elm.nativeElement)))
                    return null;
                last = prev;
                prev = this.previousElement(prev);
            }
        }
        return null;
    }
    computeTrailingIcon(leading) {
        if (this._icons.length > 0) {
            let icon = this._icons.last;
            if (icon === leading)
                return null;
            // if not the leading icon, it must be the trailing icon:
            return icon;
        }
        return null;
    }
    previousElement(el) {
        let result = el.previousSibling;
        while (result != null && !(result instanceof Element))
            result = result.previousSibling;
        return result;
    }
    attachLabelToInput() {
        var _a, _b;
        // if the mdcTextField is a LABEL element wrapping the input OR the floatingLabel is NOT a LABEL element,
        //  the input gets an aria-labelledby attaching it to the floatingLabel;
        // otherwise the floatingLabel gets a 'for' attribute, attaching it to the input:
        let first = true;
        const needLabeledBy = this.root.nativeElement.nodeName.toLowerCase() === 'label' || !((_a = this._floatingLabel) === null || _a === void 0 ? void 0 : _a.isLabelElement());
        this._inputs.forEach(input => {
            var _a;
            input._labeledBy = (first && needLabeledBy) ? ((_a = this._floatingLabel) === null || _a === void 0 ? void 0 : _a.id) || null : null;
            first = false;
        });
        first = true;
        (_b = this._floatingLabels) === null || _b === void 0 ? void 0 : _b.forEach(label => {
            var _a, _b;
            label.for = (first && !needLabeledBy && ((_a = this._floatingLabel) === null || _a === void 0 ? void 0 : _a.isLabelElement())) ? ((_b = this._input) === null || _b === void 0 ? void 0 : _b.id) || null : null;
            first = false;
        });
    }
    attachHelperTextToInput() {
        let first = true;
        this._inputs.forEach(input => {
            var _a;
            const assign = first ? ((_a = this._helperText) === null || _a === void 0 ? void 0 : _a.id) || null : null;
            input._controls = assign;
            input._describedBy = assign;
            first = false;
        });
    }
    subscribeInputChanges() {
        var _a;
        this.onInputChange$.next();
        (_a = this._input) === null || _a === void 0 ? void 0 : _a._valueChange.asObservable().pipe(takeUntil(this.onInputChange$)).subscribe((value) => {
            var _a;
            (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setValue(value); // value can be null, but null should be accepted by foundation
        });
    }
    /** @internal */
    getRippleInteractionElement() {
        return this._input._elm;
    }
    /**
     * The <code>valid</code> property provides a way to override the validity checking of the
     * underlying angular form control or native input. A value of true or false will make the
     * text-field validity styling based on this value. A value of <code>null</code>, or
     * <code>undefined</code> will reset the validity styling to the state of the underlying
     * angular form control or native input.
     *
     * For most use cases messing with this input is not be needed.
     * When the input/textarea is an ngControl, the mdcTextField is already aware of that,
     * and is already using the 'valid' property of that control.
     * However, in some specific cases, binding to <code>valid</code> can help. Example:
     * When you want the mdcTextField to go to 'invalid' state only when the underlying
     * control is invalid AND that control's value is changed, you can bind as follows:
     * <code>valid="myControl.valid || !myControl.dirty"</code>.
     */
    set valid(value) {
        var _a, _b, _c;
        if (value == null) {
            this._valid = null; // reset to null, validity now managed by the input control.
            (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.setUseNativeValidation(true);
            // foundation doesn't change style when we switch to native validation;
            // trigger possible new style:
            this.foundation && this.foundation['styleValidity_']((_b = this.mdcAdapter.getNativeInput()) === null || _b === void 0 ? void 0 : _b.validity.valid);
        }
        else if (value !== this._valid) {
            this._valid = asBoolean(value);
            (_c = this.foundation) === null || _c === void 0 ? void 0 : _c.setValid(this._valid);
        }
    }
    /** @internal */
    get _textArea() {
        return this._input._isTextarea();
    }
    /** @internal */
    get outlined() {
        return !!this._outline;
    }
    /** @internal */
    get noLabel() {
        return !this._floatingLabel;
    }
    /** @internal */
    get _leading() {
        return !!this._leadingIcon;
    }
    /** @internal */
    get _trailing() {
        return !!this._trailingIcon;
    }
    /**
     * Assign an <code>mdcTextFieldHelperText</code> (exported as <code>mdcHelperText</code>) to this
     * input to add a helper-text or validation message to the text-field. See the examples for hints
     * on how to do this.
     */
    get helperText() {
        return this._helperText;
    }
    set helperText(helperText) {
        this._helperText = helperText;
        this.onHelperTextChange$.next();
    }
    /** @internal */
    get _disabled() {
        // TODO: this mirrors what the text-field can update itself from adapter.getNativeInput
        //  is there a way to trigger the textfield to re-read that when the disabled state of
        //  the input changes?
        return this._input ? this._input.disabled : false;
    }
    get _input() {
        var _a;
        return (_a = this._inputs) === null || _a === void 0 ? void 0 : _a.first;
    }
    get _floatingLabel() {
        var _a;
        return (_a = this._floatingLabels) === null || _a === void 0 ? void 0 : _a.first;
    }
    get _outline() {
        var _a;
        return (_a = this._outlines) === null || _a === void 0 ? void 0 : _a.first;
    }
}
MdcTextFieldDirective.ɵfac = function MdcTextFieldDirective_Factory(t) { return new (t || MdcTextFieldDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MdcEventRegistry), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcTextFieldDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTextFieldDirective, selectors: [["", "mdcTextField", ""]], contentQueries: function MdcTextFieldDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcTextFieldIconDirective, false);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcTextFieldInputDirective, false);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcFloatingLabelDirective, true);
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcNotchedOutlineDirective, false);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._icons = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._inputs = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._floatingLabels = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._outlines = _t);
    } }, hostVars: 14, hostBindings: function MdcTextFieldDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-text-field", ctx._cls)("mdc-text-field--textarea", ctx._textArea)("mdc-text-field--outlined", ctx.outlined)("mdc-text-field--no-label", ctx.noLabel)("mdc-text-field--with-leading-icon", ctx._leading)("mdc-text-field--with-trailing-icon", ctx._trailing)("mdc-text-field--disabled", ctx._disabled);
    } }, inputs: { valid: "valid", helperText: "helperText" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: AbstractMdcRipple, useExisting: forwardRef(() => MdcTextFieldDirective) }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
MdcTextFieldDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: MdcEventRegistry },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcTextFieldDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-text-field',] }],
    _icons: [{ type: ContentChildren, args: [MdcTextFieldIconDirective,] }],
    _inputs: [{ type: ContentChildren, args: [MdcTextFieldInputDirective,] }],
    _floatingLabels: [{ type: ContentChildren, args: [MdcFloatingLabelDirective, { descendants: true },] }],
    _outlines: [{ type: ContentChildren, args: [MdcNotchedOutlineDirective,] }],
    valid: [{ type: Input }],
    _textArea: [{ type: HostBinding, args: ['class.mdc-text-field--textarea',] }],
    outlined: [{ type: HostBinding, args: ['class.mdc-text-field--outlined',] }],
    noLabel: [{ type: HostBinding, args: ['class.mdc-text-field--no-label',] }],
    _leading: [{ type: HostBinding, args: ['class.mdc-text-field--with-leading-icon',] }],
    _trailing: [{ type: HostBinding, args: ['class.mdc-text-field--with-trailing-icon',] }],
    helperText: [{ type: Input }],
    _disabled: [{ type: HostBinding, args: ['class.mdc-text-field--disabled',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTextFieldDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTextField]',
                providers: [{ provide: AbstractMdcRipple, useExisting: forwardRef(() => MdcTextFieldDirective) }]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: MdcEventRegistry }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-text-field']
        }], valid: [{
            type: Input
        }], _textArea: [{
            type: HostBinding,
            args: ['class.mdc-text-field--textarea']
        }], outlined: [{
            type: HostBinding,
            args: ['class.mdc-text-field--outlined']
        }], noLabel: [{
            type: HostBinding,
            args: ['class.mdc-text-field--no-label']
        }], _leading: [{
            type: HostBinding,
            args: ['class.mdc-text-field--with-leading-icon']
        }], _trailing: [{
            type: HostBinding,
            args: ['class.mdc-text-field--with-trailing-icon']
        }], helperText: [{
            type: Input
        }], _disabled: [{
            type: HostBinding,
            args: ['class.mdc-text-field--disabled']
        }], _icons: [{
            type: ContentChildren,
            args: [MdcTextFieldIconDirective]
        }], _inputs: [{
            type: ContentChildren,
            args: [MdcTextFieldInputDirective]
        }], _floatingLabels: [{
            type: ContentChildren,
            args: [MdcFloatingLabelDirective, { descendants: true }]
        }], _outlines: [{
            type: ContentChildren,
            args: [MdcNotchedOutlineDirective]
        }] }); })();
const TEXT_FIELD_DIRECTIVES = [
    MdcTextFieldInputDirective,
    MdcTextFieldIconDirective,
    MdcTextFieldHelperLineDirective,
    MdcTextFieldHelperTextDirective,
    MdcTextFieldDirective
];

/**
 * A directive for a top-app-bar row. The content of a top-app-bar should always be embedded
 * in <code>mdcTopAppBarRow</code> rows. Multiple rows are allowed, which rows are visible
 * depends on the style of the toolbar, and the scroll position of the content of
 * the page.
 */
class MdcTopAppBarRowDirective {
    constructor(_elm) {
        this._elm = _elm;
        /** @internal */
        this._cls = true;
    }
}
MdcTopAppBarRowDirective.ɵfac = function MdcTopAppBarRowDirective_Factory(t) { return new (t || MdcTopAppBarRowDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcTopAppBarRowDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTopAppBarRowDirective, selectors: [["", "mdcTopAppBarRow", ""]], hostVars: 2, hostBindings: function MdcTopAppBarRowDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-top-app-bar__row", ctx._cls);
    } } });
MdcTopAppBarRowDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcTopAppBarRowDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-top-app-bar__row',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTopAppBarRowDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTopAppBarRow]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-top-app-bar__row']
        }] }); })();
/**
 * A directive for a top-app-bar section. A top-app-bar row should always be composed of
 * <code>mdcTopAppBarSection</code> sections. Multiple sections, with different alignment options,
 * are allowed per row.
 */
class MdcTopAppBarSectionDirective {
    constructor() {
        /** @internal */
        this._cls = true;
        this._alignEnd = false;
        this._alignStart = false;
    }
    /**
     * Make the section align to the start of the toolbar row (default alignment is to the
     * center).
     */
    get alignStart() {
        return this._alignStart;
    }
    set alignStart(val) {
        this._alignStart = asBoolean(val);
    }
    /**
     * Make the section align to the end of the toolbar row (default alignment is to the
     * center).
     */
    get alignEnd() {
        return this._alignEnd;
    }
    set alignEnd(val) {
        this._alignEnd = asBoolean(val);
    }
}
MdcTopAppBarSectionDirective.ɵfac = function MdcTopAppBarSectionDirective_Factory(t) { return new (t || MdcTopAppBarSectionDirective)(); };
MdcTopAppBarSectionDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTopAppBarSectionDirective, selectors: [["", "mdcTopAppBarSection", ""]], hostVars: 6, hostBindings: function MdcTopAppBarSectionDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-top-app-bar__section", ctx._cls)("mdc-top-app-bar__section--align-start", ctx.alignStart)("mdc-top-app-bar__section--align-end", ctx.alignEnd);
    } }, inputs: { alignStart: "alignStart", alignEnd: "alignEnd" } });
MdcTopAppBarSectionDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-top-app-bar__section',] }],
    alignStart: [{ type: Input }, { type: HostBinding, args: ['class.mdc-top-app-bar__section--align-start',] }],
    alignEnd: [{ type: Input }, { type: HostBinding, args: ['class.mdc-top-app-bar__section--align-end',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTopAppBarSectionDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTopAppBarSection]'
            }]
    }], function () { return []; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-top-app-bar__section']
        }], alignStart: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.mdc-top-app-bar__section--align-start']
        }], alignEnd: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.mdc-top-app-bar__section--align-end']
        }] }); })();
/**
 * This directive adds extra styling to toolbar text that represents the title of the toolbar.
 * The directive should be a child of an element with the <code>mdcTopAppBarSection</code> directive.
 */
class MdcTopAppBarTitleDirective {
    constructor(_elm) {
        this._elm = _elm;
        /** @internal */
        this._cls = true;
    }
}
MdcTopAppBarTitleDirective.ɵfac = function MdcTopAppBarTitleDirective_Factory(t) { return new (t || MdcTopAppBarTitleDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcTopAppBarTitleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTopAppBarTitleDirective, selectors: [["", "mdcTopAppBarTitle", ""]], hostVars: 2, hostBindings: function MdcTopAppBarTitleDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-top-app-bar__title", ctx._cls);
    } } });
MdcTopAppBarTitleDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcTopAppBarTitleDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-top-app-bar__title',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTopAppBarTitleDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTopAppBarTitle]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-top-app-bar__title']
        }] }); })();
/**
 * Directive for the navigation icon of a top-app-bar. Typically placed on the
 * far left (for left-to-right languages). The <code>mdcTopAppBarNavIcon</code>
 * directive should be used on a child of an element with the
 * <code>mdcTopAppBarSection</code> directive. It typically opens a navigation menu
 * or drawer.
 */
class MdcTopAppBarNavIconDirective {
    constructor(_elm) {
        this._elm = _elm;
        /** @internal */
        this._cls = true;
    }
}
MdcTopAppBarNavIconDirective.ɵfac = function MdcTopAppBarNavIconDirective_Factory(t) { return new (t || MdcTopAppBarNavIconDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcTopAppBarNavIconDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTopAppBarNavIconDirective, selectors: [["", "mdcTopAppBarNavIcon", ""]], hostVars: 2, hostBindings: function MdcTopAppBarNavIconDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mdc-top-app-bar__navigation-icon", ctx._cls);
    } } });
MdcTopAppBarNavIconDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcTopAppBarNavIconDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-top-app-bar__navigation-icon',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTopAppBarNavIconDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTopAppBarNavIcon]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-top-app-bar__navigation-icon']
        }] }); })();
/**
 * Directive for action items of a top-app-bar. Typically placed on the side
 * opposite the navigation item. The <code>mdcTopAppBarAction</code> directive
 * should be used on a child of an element with the <code>mdcTopAppBarSection</code>
 * directive.
 */
class MdcTopAppBarActionDirective {
    constructor(_elm) {
        this._elm = _elm;
        /** @internal */
        this._cls = true;
        /**
         * A label for the action item. The value will be applied to both the
         * <code>aria-label</code>, and <code>alt</code> attribute of the item.
         */
        this.label = null;
    }
}
MdcTopAppBarActionDirective.ɵfac = function MdcTopAppBarActionDirective_Factory(t) { return new (t || MdcTopAppBarActionDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
MdcTopAppBarActionDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTopAppBarActionDirective, selectors: [["", "mdcTopAppBarAction", ""]], hostVars: 4, hostBindings: function MdcTopAppBarActionDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.label)("alt", ctx.label);
        ɵngcc0.ɵɵclassProp("mdc-top-app-bar__action-item", ctx._cls);
    } }, inputs: { label: "label" } });
MdcTopAppBarActionDirective.ctorParameters = () => [
    { type: ElementRef }
];
MdcTopAppBarActionDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-top-app-bar__action-item',] }],
    label: [{ type: Input }, { type: HostBinding, args: ['attr.aria-label',] }, { type: HostBinding, args: ['attr.alt',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTopAppBarActionDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTopAppBarAction]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-top-app-bar__action-item']
        }], label: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-label']
        }, {
            type: HostBinding,
            args: ['attr.alt']
        }] }); })();
/**
 * A directive for a top-app-bar. All content inside a top-app-bar should be
 * embedded inside <code>mdcTopAppBarRow</code> rows.
 */
class MdcTopAppBarDirective {
    constructor(_rndr, _elm, zone, doc) {
        this._rndr = _rndr;
        this._elm = _elm;
        this.zone = zone;
        /** @internal */
        this._cls = true;
        this.handleScroll = () => {
            var _a;
            if (this.viewport && (this._type === 'short' || this._type === 'fixed'))
                this._updateViewPort();
            (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.handleTargetScroll();
        };
        this.handleResize = () => {
            var _a;
            if (this.viewport && (this._type === 'short' || this._type === 'fixed'))
                this._updateViewPort();
            (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.handleWindowResize();
        };
        this.updateViewport = () => {
            if (this.viewport && (this._type === 'short' || this._type === 'fixed'))
                this._updateViewPort();
        };
        this._viewport = null;
        this._fixedAdjust = null;
        this._type = 'default';
        this._prominent = false;
        this._dense = false;
        this._collapsedOverride = null;
        this._collapsedState = null;
        this.mdcAdapter = {
            hasClass: (className) => {
                if (className === 'mdc-top-app-bar--short-collapsed')
                    // the foundation uses this during initialisation to determine whether
                    // a short top-app-bar should always be displayed collapsed.
                    // our component instead uses the _collapsed field value to override
                    // the collapsed state
                    return false;
                return this._elm.nativeElement.classList.contains(className);
            },
            addClass: (className) => {
                if (className === 'mdc-top-app-bar--short-collapsed')
                    this._collapsedState = true;
                else if (className !== 'mdc-top-app-bar--short-has-action-item')
                    // we add/remove mdc-top-app-bar--short-has-action-item dynamically based on the actual number of items
                    // this is better than the foundation that looks only at the nr of items during initialisation
                    this._rndr.addClass(this._elm.nativeElement, className);
            },
            removeClass: (className) => {
                if (className === 'mdc-top-app-bar--short-collapsed')
                    this._collapsedState = false;
                else
                    this._rndr.removeClass(this._elm.nativeElement, className);
            },
            setStyle: (property, value) => this._rndr.setStyle(this._elm.nativeElement, property, value),
            getTopAppBarHeight: () => this._elm.nativeElement.clientHeight,
            notifyNavigationIconClicked: () => { },
            getViewportScrollY: () => this._viewport ? this._viewport.scrollTop : this.document.defaultView.pageYOffset,
            getTotalActionItems: () => this._actionItems.length
        };
        this.foundation = null;
        /** @internal */
        this._updateViewPort = () => {
            // simulate 'fixed' relative to view position of parent:
            this._elm.nativeElement.style.top = this._viewport.scrollTop + 'px';
        };
        this.document = doc;
    }
    ngAfterContentInit() {
        this.foundationReInit();
    }
    ngOnDestroy() {
        var _a;
        this.removeScrollListeners();
        (_a = this.foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        this.foundation = null;
    }
    foundationReInit() {
        if (this.foundation)
            this.foundation.destroy();
        // undo viewport init specific for a foundation implementation:
        this.removeScrollListeners();
        this._elm.nativeElement.style.top = null;
        // remove classes set by foundations, if we reinitialize/switch foundation:
        this._rndr.removeClass(this._elm.nativeElement, 'mdc-top-app-bar--fixed-scrolled');
        if (this._type === 'short')
            this.foundation = new MDCShortTopAppBarFoundation(this.mdcAdapter);
        else if (this._type === 'fixed')
            this.foundation = new MDCFixedTopAppBarFoundation(this.mdcAdapter);
        else
            this.foundation = new MDCTopAppBarFoundation(this.mdcAdapter);
        this.initFixedAdjust();
        this.zone.runOutsideAngular(() => {
            (this._viewport || this.document.defaultView).addEventListener('scroll', this.handleScroll, events.applyPassive());
            (this._viewport || this.document.defaultView).addEventListener('touchmove', this.updateViewport, events.applyPassive());
            this.document.defaultView.addEventListener('resize', this.handleResize, events.applyPassive());
        });
        if (this.viewport && (this._type === 'short' || this._type === 'fixed'))
            this._updateViewPort();
        this.foundation.init();
    }
    initFixedAdjust() {
        if (this.foundation && this._fixedAdjust) {
            this._rndr.removeClass(this._fixedAdjust, 'mdc-top-app-bar--fixed-adjust');
            this._rndr.removeClass(this._fixedAdjust, 'mdc-top-app-bar--dense-fixed-adjust');
            this._rndr.removeClass(this._fixedAdjust, 'mdc-top-app-bar--short-fixed-adjust');
            this._rndr.removeClass(this._fixedAdjust, 'mdc-top-app-bar--prominent-fixed-adjust');
            this._rndr.removeClass(this._fixedAdjust, 'mdc-top-app-bar--dense-prominent-fixed-adjust');
            if (this.prominent && this.dense)
                this._rndr.addClass(this._fixedAdjust, 'mdc-top-app-bar--dense-prominent-fixed-adjust');
            else if (this._prominent)
                this._rndr.addClass(this._fixedAdjust, 'mdc-top-app-bar--prominent-fixed-adjust');
            else if (this._type === 'short')
                this._rndr.addClass(this._fixedAdjust, 'mdc-top-app-bar--short-fixed-adjust');
            else if (this._dense)
                this._rndr.addClass(this._fixedAdjust, 'mdc-top-app-bar--dense-fixed-adjust');
            else
                this._rndr.addClass(this._fixedAdjust, 'mdc-top-app-bar--fixed-adjust');
        }
    }
    removeScrollListeners() {
        (this._viewport || this.document.defaultView).removeEventListener('scroll', this.handleScroll, events.applyPassive());
        (this._viewport || this.document.defaultView).removeEventListener('touchmove', this.updateViewport, events.applyPassive());
        this.document.defaultView.removeEventListener('resize', this.handleResize, events.applyPassive());
    }
    /**
     * The top-app-bar can have different styles. Set this property to <code>fixed</code>
     * for a top-app-bar fixed to the top of the screen or viewport.
     * Set to <code>short</code> for a top-app-bar that will collapse to the navigation
     * icon side when scrolled.
     * Otherwise, the default is a top-app-bar that scrolls with the content.
     */
    get mdcTopAppBar() {
        return this._type;
    }
    set mdcTopAppBar(val) {
        if (val !== 'short' && val !== 'fixed')
            val = 'default';
        if (val !== this._type) {
            this._type = val;
            if (this.foundation)
                this.foundationReInit();
        }
    }
    /**
     * If set to a value other than false, the top-app-bar will be styled as a taller
     * bar.
     */
    get prominent() {
        return this._prominent;
    }
    set prominent(val) {
        let newValue = asBoolean(val);
        if (newValue !== this._prominent) {
            this._prominent = asBoolean(val);
            this.initFixedAdjust();
        }
    }
    /**
     * If set to a value other than false, the top-app-bar will be styled a bit more
     * compact.
     */
    get dense() {
        return this._dense;
    }
    set dense(val) {
        let newValue = asBoolean(val);
        if (newValue !== this._dense) {
            this._dense = asBoolean(val);
            this.initFixedAdjust();
        }
    }
    /**
     * Set this property to true or false to force the collapsed/uncollapsed state of a short
     * top-app-bar. Set this property to null to return to the default handling, where
     * <code>collapsed</code> is based on the scroll position of the viewport.
     * This property has no effect if the <code>mdcTopAppBar</code> has a value other than
     * <code>short</code>.
     */
    get collapsed() {
        if (this._type !== 'short')
            return false;
        return this._collapsedOverride == null ? !!this._collapsedState : this._collapsedOverride;
    }
    set collapsed(val) {
        this._collapsedOverride = asBooleanOrNull(val);
    }
    /**
     * Top-app-bars are positioned over the rest of their viewport. This means that
     * some of the content will be hidden under the bar, unless the position of that
     * content is changed relative to the bar. Assign the <code>HTMLElement</code>
     * of the content to this property, so that the <code>mdcTopAppBar</code>
     * can add spacing to the content making the top visible when the content is scrolled
     * up.
     */
    get fixedAdjust() {
        return this._fixedAdjust;
    }
    set fixedAdjust(el) {
        if (this._fixedAdjust !== el) {
            this._fixedAdjust = el;
            this.initFixedAdjust();
        }
    }
    /**
     * Assign any <code>HTMLElement</code> to this property to place a top-app-bar fixed to that element
     * (usually the parent container), instead of to the browser window. This property is mainly added for creating nice
     * demos of toolbars embedded inside other pages (such as on this documentation page). It is not recommended to use
     * this for a real application toolbar. The position is kept fixed to the container element by listening
     * for scroll/resize events, and using javascript to recompute the position. This may influence the smoothness
     * of the scrolling experience, especially on mobile devices.
     * The viewport element must have css styling: <code>position: relative</code>, and should have a fixed
     * height.
     */
    get viewport() {
        return this._viewport;
    }
    set viewport(elm) {
        if (this._viewport !== elm) {
            this.removeScrollListeners();
            this._viewport = elm;
            if (this.foundation)
                this.foundationReInit();
        }
    }
    /** @internal */
    get _hasActionItems() {
        return this._type === 'short' && this._actionItems.length > 0;
    }
    /** @internal */
    get _fixed() {
        return this._type === 'fixed';
    }
    /** @internal */
    get _short() {
        return this._type === 'short';
    }
    /** @internal */
    get _position() {
        return this._viewport ? 'absolute' : null;
    }
}
MdcTopAppBarDirective.ɵfac = function MdcTopAppBarDirective_Factory(t) { return new (t || MdcTopAppBarDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcTopAppBarDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcTopAppBarDirective, selectors: [["", "mdcTopAppBar", ""]], contentQueries: function MdcTopAppBarDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, MdcTopAppBarActionDirective, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._actionItems = _t);
    } }, hostVars: 16, hostBindings: function MdcTopAppBarDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("position", ctx._position);
        ɵngcc0.ɵɵclassProp("mdc-top-app-bar", ctx._cls)("mdc-top-app-bar--prominent", ctx.prominent)("mdc-top-app-bar--dense", ctx.dense)("mdc-top-app-bar--short-collapsed", ctx.collapsed)("mdc-top-app-bar--short-has-action-item", ctx._hasActionItems)("mdc-top-app-bar--fixed", ctx._fixed)("mdc-top-app-bar--short", ctx._short);
    } }, inputs: { mdcTopAppBar: "mdcTopAppBar", prominent: "prominent", dense: "dense", collapsed: "collapsed", fixedAdjust: "fixedAdjust", viewport: "viewport" } });
MdcTopAppBarDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: NgZone },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcTopAppBarDirective.propDecorators = {
    _cls: [{ type: HostBinding, args: ['class.mdc-top-app-bar',] }],
    _actionItems: [{ type: ContentChildren, args: [MdcTopAppBarActionDirective, { descendants: true },] }],
    mdcTopAppBar: [{ type: Input }],
    prominent: [{ type: Input }, { type: HostBinding, args: ['class.mdc-top-app-bar--prominent',] }],
    dense: [{ type: Input }, { type: HostBinding, args: ['class.mdc-top-app-bar--dense',] }],
    collapsed: [{ type: Input }, { type: HostBinding, args: ['class.mdc-top-app-bar--short-collapsed',] }],
    fixedAdjust: [{ type: Input }],
    viewport: [{ type: Input }],
    _hasActionItems: [{ type: HostBinding, args: ['class.mdc-top-app-bar--short-has-action-item',] }],
    _fixed: [{ type: HostBinding, args: ['class.mdc-top-app-bar--fixed',] }],
    _short: [{ type: HostBinding, args: ['class.mdc-top-app-bar--short',] }],
    _position: [{ type: HostBinding, args: ['style.position',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcTopAppBarDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcTopAppBar]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { _cls: [{
            type: HostBinding,
            args: ['class.mdc-top-app-bar']
        }], mdcTopAppBar: [{
            type: Input
        }], prominent: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.mdc-top-app-bar--prominent']
        }], dense: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.mdc-top-app-bar--dense']
        }], collapsed: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.mdc-top-app-bar--short-collapsed']
        }], fixedAdjust: [{
            type: Input
        }], viewport: [{
            type: Input
        }], _hasActionItems: [{
            type: HostBinding,
            args: ['class.mdc-top-app-bar--short-has-action-item']
        }], _fixed: [{
            type: HostBinding,
            args: ['class.mdc-top-app-bar--fixed']
        }], _short: [{
            type: HostBinding,
            args: ['class.mdc-top-app-bar--short']
        }], _position: [{
            type: HostBinding,
            args: ['style.position']
        }], _actionItems: [{
            type: ContentChildren,
            args: [MdcTopAppBarActionDirective, { descendants: true }]
        }] }); })();
const TOP_APP_BAR_DIRECTIVES = [
    MdcTopAppBarRowDirective, MdcTopAppBarSectionDirective, MdcTopAppBarTitleDirective, MdcTopAppBarNavIconDirective,
    MdcTopAppBarActionDirective, MdcTopAppBarDirective
];

let scrollbarResizeListenerId = null;
let scrollbarResizeDirectives = 0;
function initScrollbarResizeListener(document) {
    if (scrollbarResizeListenerId)
        return;
    // create an invisible iframe, covering the full width of the window:
    let iframe = document.createElement('iframe');
    iframe.id = scrollbarResizeListenerId = 'scrollbarResizeListener_' + Math.random().toString(36).substr(2, 10);
    iframe.style.cssText = 'position:absolute;margin:0;padding:0;border-width:0;overflow:hidden;height:0;width:100%;background-color:transparent;';
    // make the iframe contentWindow listen to resize events (they will be triggered when the container adds or removes a
    // vertical scrollbar, since it changes the width):
    iframe.onload = function () {
        iframe.contentWindow.addEventListener('resize', function () {
            try {
                let evt = new UIEvent('resize', { view: document.defaultView, cancelable: false, bubbles: true });
                document.defaultView.dispatchEvent(evt);
            }
            catch (e) { }
        });
    };
    // add to the page:
    document.body.appendChild(iframe);
}
function destroyScrollbarResizeListener(document) {
    if (scrollbarResizeListenerId != null) {
        let iframe = document.getElementById(scrollbarResizeListenerId);
        if (iframe)
            iframe.parentElement.removeChild(iframe);
        scrollbarResizeListenerId = null;
    }
}
// TODO: add viewport option to do this for other elements that may
//  get a scrollbar, and therefore influence their childrens layout.
/**
 * Utility directive to trigger window 'resize' events not only when the browser window
 * is resized, but also when the browser window gets a vertical scrollbar.
 * This solves problems with directives that base their layout or position on the
 * width of the document body. When a scrollbar is added, the body width changes, but the browser
 * doesn't fire a 'resize' (or other) event. As long as at least one <code>mdcScrollbarResize</code>
 * directive is active on the page, 'resize' events will also be fired when the body width changes
 * as a consequence of the addition or removal of a vertical toolbar.
 * The directive adds a hidden iframe to the page, that contains the trickery to make this happen.
 * See this <a href="https://gist.github.com/OrganicPanda/8222636" target="_blank">hacky-scrollbar-resize-listener.js
 * github gist</a> for the original idea.
 */
class MdcScrollbarResizeDirective {
    constructor(doc) {
        this._scrollbarResize = false;
        this.document = doc;
    }
    ngOnDestroy() {
        if (this._scrollbarResize) {
            this._scrollbarResize = false;
            --scrollbarResizeDirectives;
            if (scrollbarResizeDirectives <= 0)
                destroyScrollbarResizeListener(this.document);
        }
    }
    /**
     * Set to false to disable triggering resize events because of addition/deletion of a scrollbar.
     * The <code>mdcScrollbarResize</code> behavior is removed after <strong>all</strong>&nbsp;
     * <code>mdcScrollbarResize</code> directives on the page are removed or have the value false.
     */
    get mdcScrollbarResize() {
        return this._scrollbarResize;
    }
    set mdcScrollbarResize(val) {
        let newValue = asBoolean(val);
        if (newValue !== this._scrollbarResize) {
            this._scrollbarResize = newValue;
            if (newValue) {
                ++scrollbarResizeDirectives;
                initScrollbarResizeListener(this.document);
            }
            else {
                --scrollbarResizeDirectives;
                if (scrollbarResizeDirectives <= 0)
                    destroyScrollbarResizeListener(this.document);
            }
        }
    }
}
MdcScrollbarResizeDirective.ɵfac = function MdcScrollbarResizeDirective_Factory(t) { return new (t || MdcScrollbarResizeDirective)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
MdcScrollbarResizeDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MdcScrollbarResizeDirective, selectors: [["", "mdcScrollbarResize", ""]], inputs: { mdcScrollbarResize: "mdcScrollbarResize" } });
MdcScrollbarResizeDirective.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
MdcScrollbarResizeDirective.propDecorators = {
    mdcScrollbarResize: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MdcScrollbarResizeDirective, [{
        type: Directive,
        args: [{
                selector: '[mdcScrollbarResize]'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { mdcScrollbarResize: [{
            type: Input
        }] }); })();

class MaterialModule {
}
MaterialModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MaterialModule });
MaterialModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function MaterialModule_Factory(t) { return new (t || MaterialModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MaterialModule, { declarations: function () { return [MdcButtonIconDirective, MdcButtonLabelDirective, MdcButtonDirective, MdcCardMediaDirective, MdcCardMediaContentDirective, MdcCardActionButtonsDirective, MdcCardActionIconsDirective, MdcCardActionsDirective, MdcCardPrimaryActionDirective, MdcCardDirective, MdcCheckboxInputDirective, MdcCheckboxDirective, MdcChipIconDirective, MdcChipTextDirective, MdcChipPrimaryActionDirective, MdcChipCellDirective, MdcChipDirective, MdcChipSetDirective, MdcDialogDirective, MdcDialogTitleDirective, MdcDialogContentDirective, MdcDialogSurfaceDirective, MdcDialogContainerDirective, MdcDialogActionsDirective, MdcDialogTriggerDirective, MdcDialogDefaultDirective, MdcDialogScrimDirective, MdcDrawerTitleDirective, MdcDrawerSubtitleDirective, MdcDrawerHeaderDirective, MdcDrawerContentDirective, MdcDrawerScrimDirective, MdcDrawerDirective, MdcDrawerAppContent, MdcElevationDirective, MdcFabIconDirective, MdcFabLabelDirective, MdcFabDirective, MdcFloatingLabelDirective, MdcFocusInitialDirective, MdcFocusTrapDirective, MdcFormFieldInputDirective, MdcFormFieldLabelDirective, MdcFormFieldDirective, MdcIconDirective, MdcIconButtonDirective, MdcIconToggleDirective, MdcFormsIconButtonDirective, MdcLinearProgressDirective, MdcListDividerDirective, MdcListItemDirective, MdcListItemTextDirective, MdcListItemPrimaryTextDirective, MdcListItemSecondaryTextDirective, MdcListItemGraphicDirective, MdcListItemMetaDirective, MdcListDirective, MdcListGroupSubHeaderDirective, MdcListGroupDirective, MdcMenuDirective, MdcMenuTriggerDirective, MdcMenuAnchorDirective, MdcMenuSurfaceDirective, MdcNotchedOutlineNotchDirective, MdcNotchedOutlineDirective, MdcRadioInputDirective, MdcRadioDirective, MdcRippleDirective, MdcSelectTextDirective, MdcSelectAnchorDirective, MdcSelectMenuDirective, MdcSelectDirective, MdcFormsSelectDirective, MdcSliderDirective, MdcFormsSliderDirective, MdcSwitchInputDirective, MdcSwitchThumbDirective, MdcSwitchDirective, MdcTabBarDirective, MdcTabIconDirective, MdcTabLabelDirective, MdcTabContentDirective, MdcTabDirective, MdcTabIndicatorContentDirective, MdcTabIndicatorDirective, MdcTabRouterDirective, MdcTabScrollerContentDirective, MdcTabScrollerAreaDirective, MdcTabScrollerDirective, MdcTextFieldInputDirective, MdcTextFieldIconDirective, MdcTextFieldHelperLineDirective, MdcTextFieldHelperTextDirective, MdcTextFieldDirective, MdcTopAppBarRowDirective, MdcTopAppBarSectionDirective, MdcTopAppBarTitleDirective, MdcTopAppBarNavIconDirective, MdcTopAppBarActionDirective, MdcTopAppBarDirective, MdcScrollbarResizeDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [MdcButtonIconDirective, MdcButtonLabelDirective, MdcButtonDirective, MdcCardMediaDirective, MdcCardMediaContentDirective, MdcCardActionButtonsDirective, MdcCardActionIconsDirective, MdcCardActionsDirective, MdcCardPrimaryActionDirective, MdcCardDirective, MdcCheckboxInputDirective, MdcCheckboxDirective, MdcChipIconDirective, MdcChipTextDirective, MdcChipPrimaryActionDirective, MdcChipCellDirective, MdcChipDirective, MdcChipSetDirective, MdcDialogDirective, MdcDialogTitleDirective, MdcDialogContentDirective, MdcDialogSurfaceDirective, MdcDialogContainerDirective, MdcDialogActionsDirective, MdcDialogTriggerDirective, MdcDialogDefaultDirective, MdcDialogScrimDirective, MdcDrawerTitleDirective, MdcDrawerSubtitleDirective, MdcDrawerHeaderDirective, MdcDrawerContentDirective, MdcDrawerScrimDirective, MdcDrawerDirective, MdcDrawerAppContent, MdcElevationDirective, MdcFabIconDirective, MdcFabLabelDirective, MdcFabDirective, MdcFloatingLabelDirective, MdcFocusInitialDirective, MdcFocusTrapDirective, MdcFormFieldInputDirective, MdcFormFieldLabelDirective, MdcFormFieldDirective, MdcIconDirective, MdcIconButtonDirective, MdcIconToggleDirective, MdcFormsIconButtonDirective, MdcLinearProgressDirective, MdcListDividerDirective, MdcListItemDirective, MdcListItemTextDirective, MdcListItemPrimaryTextDirective, MdcListItemSecondaryTextDirective, MdcListItemGraphicDirective, MdcListItemMetaDirective, MdcListDirective, MdcListGroupSubHeaderDirective, MdcListGroupDirective, MdcMenuDirective, MdcMenuTriggerDirective, MdcMenuAnchorDirective, MdcMenuSurfaceDirective, MdcNotchedOutlineNotchDirective, MdcNotchedOutlineDirective, MdcRadioInputDirective, MdcRadioDirective, MdcRippleDirective, MdcSelectTextDirective, MdcSelectAnchorDirective, MdcSelectMenuDirective, MdcSelectDirective, MdcFormsSelectDirective, MdcSliderDirective, MdcFormsSliderDirective, MdcSwitchInputDirective, MdcSwitchThumbDirective, MdcSwitchDirective, MdcTabBarDirective, MdcTabIconDirective, MdcTabLabelDirective, MdcTabContentDirective, MdcTabDirective, MdcTabIndicatorContentDirective, MdcTabIndicatorDirective, MdcTabRouterDirective, MdcTabScrollerContentDirective, MdcTabScrollerAreaDirective, MdcTabScrollerDirective, MdcTextFieldInputDirective, MdcTextFieldIconDirective, MdcTextFieldHelperLineDirective, MdcTextFieldHelperTextDirective, MdcTextFieldDirective, MdcTopAppBarRowDirective, MdcTopAppBarSectionDirective, MdcTopAppBarTitleDirective, MdcTopAppBarNavIconDirective, MdcTopAppBarActionDirective, MdcTopAppBarDirective, MdcScrollbarResizeDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MaterialModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    ...BUTTON_DIRECTIVES,
                    ...CARD_DIRECTIVES,
                    ...CHECKBOX_DIRECTIVES,
                    ...CHIP_DIRECTIVES,
                    ...DIALOG_DIRECTIVES,
                    ...DRAWER_DIRECTIVES,
                    MdcElevationDirective,
                    ...FAB_DIRECTIVES,
                    MdcFloatingLabelDirective,
                    ...FOCUS_TRAP_DIRECTIVES,
                    ...FORM_FIELD_DIRECTIVES,
                    ...ICON_BUTTON_DIRECTIVES,
                    ...LINEAR_PROGRESS_DIRECTIVES,
                    ...LIST_DIRECTIVES,
                    ...MENU_DIRECTIVES,
                    ...MENU_SURFACE_DIRECTIVES,
                    ...NOTCHED_OUTLINE_DIRECTIVES,
                    ...RADIO_DIRECTIVES,
                    MdcRippleDirective,
                    ...SELECT_DIRECTIVES,
                    ...SLIDER_DIRECTIVES,
                    ...SWITCH_DIRECTIVES,
                    ...TAB_BAR_DIRECTIVES,
                    ...TAB_DIRECTIVES,
                    ...TAB_INDICATOR_DIRECTIVES,
                    ...TAB_ROUTER_DIRECTIVES,
                    ...TAB_SCROLLER_DIRECTIVES,
                    ...TEXT_FIELD_DIRECTIVES,
                    TOP_APP_BAR_DIRECTIVES,
                    MdcScrollbarResizeDirective
                ],
                exports: [
                    ...BUTTON_DIRECTIVES,
                    ...CARD_DIRECTIVES,
                    ...CHECKBOX_DIRECTIVES,
                    ...CHIP_DIRECTIVES,
                    ...DIALOG_DIRECTIVES,
                    ...DRAWER_DIRECTIVES,
                    MdcElevationDirective,
                    ...FAB_DIRECTIVES,
                    MdcFloatingLabelDirective,
                    ...FOCUS_TRAP_DIRECTIVES,
                    ...FORM_FIELD_DIRECTIVES,
                    ...ICON_BUTTON_DIRECTIVES,
                    ...LINEAR_PROGRESS_DIRECTIVES,
                    ...LIST_DIRECTIVES,
                    ...MENU_DIRECTIVES,
                    ...MENU_SURFACE_DIRECTIVES,
                    ...NOTCHED_OUTLINE_DIRECTIVES,
                    ...RADIO_DIRECTIVES,
                    MdcRippleDirective,
                    ...SELECT_DIRECTIVES,
                    ...SLIDER_DIRECTIVES,
                    ...SWITCH_DIRECTIVES,
                    ...TAB_BAR_DIRECTIVES,
                    ...TAB_DIRECTIVES,
                    ...TAB_INDICATOR_DIRECTIVES,
                    ...TAB_ROUTER_DIRECTIVES,
                    ...TAB_SCROLLER_DIRECTIVES,
                    ...TEXT_FIELD_DIRECTIVES,
                    TOP_APP_BAR_DIRECTIVES,
                    MdcScrollbarResizeDirective
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractMdcFocusInitial, AbstractMdcFocusTrap, AbstractMdcRipple, AbstractMdcTabDirective, BUTTON_DIRECTIVES, CARD_DIRECTIVES, CHECKBOX_DIRECTIVES, CHIP_DIRECTIVES, ChipEventSource, DIALOG_DIRECTIVES, DRAWER_DIRECTIVES, FAB_DIRECTIVES, FOCUS_TRAP_DIRECTIVES, FORM_FIELD_DIRECTIVES, FocusOnOpen, ICON_BUTTON_DIRECTIVES, LINEAR_PROGRESS_DIRECTIVES, LIST_DIRECTIVES, MENU_DIRECTIVES, MENU_SURFACE_DIRECTIVES, MaterialModule, MdcButtonDirective, MdcButtonIconDirective, MdcButtonLabelDirective, MdcCardActionButtonsDirective, MdcCardActionIconsDirective, MdcCardActionsDirective, MdcCardDirective, MdcCardMediaContentDirective, MdcCardMediaDirective, MdcCardPrimaryActionDirective, MdcCheckboxDirective, MdcCheckboxInputDirective, MdcChipCellDirective, MdcChipDirective, MdcChipIconDirective, MdcChipPrimaryActionDirective, MdcChipSetDirective, MdcChipTextDirective, MdcDialogActionsDirective, MdcDialogContainerDirective, MdcDialogContentDirective, MdcDialogDefaultDirective, MdcDialogDirective, MdcDialogScrimDirective, MdcDialogSurfaceDirective, MdcDialogTitleDirective, MdcDialogTriggerDirective, MdcDrawerAppContent, MdcDrawerContentDirective, MdcDrawerDirective, MdcDrawerHeaderDirective, MdcDrawerScrimDirective, MdcDrawerSubtitleDirective, MdcDrawerTitleDirective, MdcElevationDirective, MdcEventRegistry, MdcFabDirective, MdcFabIconDirective, MdcFabLabelDirective, MdcFloatingLabelDirective, MdcFocusInitialDirective, MdcFocusTrapDirective, MdcFormFieldDirective, MdcFormFieldInputDirective, MdcFormFieldLabelDirective, MdcFormsIconButtonDirective, MdcFormsSelectDirective, MdcFormsSliderDirective, MdcIconButtonDirective, MdcIconDirective, MdcIconToggleDirective, MdcLinearProgressDirective, MdcListDirective, MdcListDividerDirective, MdcListFunction, MdcListGroupDirective, MdcListGroupSubHeaderDirective, MdcListItemDirective, MdcListItemGraphicDirective, MdcListItemMetaDirective, MdcListItemPrimaryTextDirective, MdcListItemSecondaryTextDirective, MdcListItemTextDirective, MdcMenuAnchorDirective, MdcMenuDirective, MdcMenuSurfaceDirective, MdcMenuTriggerDirective, MdcNotchedOutlineDirective, MdcNotchedOutlineNotchDirective, MdcRadioDirective, MdcRadioInputDirective, MdcRippleDirective, MdcScrollbarResizeDirective, MdcSelectAnchorDirective, MdcSelectDirective, MdcSelectMenuDirective, MdcSelectTextDirective, MdcSliderDirective, MdcSnackbarRef, MdcSnackbarService, MdcSwitchDirective, MdcSwitchInputDirective, MdcSwitchThumbDirective, MdcTabBarDirective, MdcTabContentDirective, MdcTabDirective, MdcTabIconDirective, MdcTabIndicatorContentDirective, MdcTabIndicatorDirective, MdcTabLabelDirective, MdcTabRouterDirective, MdcTabScrollerAreaDirective, MdcTabScrollerContentDirective, MdcTabScrollerDirective, MdcTextFieldDirective, MdcTextFieldHelperLineDirective, MdcTextFieldHelperTextDirective, MdcTextFieldIconDirective, MdcTextFieldInputDirective, MdcTopAppBarActionDirective, MdcTopAppBarDirective, MdcTopAppBarNavIconDirective, MdcTopAppBarRowDirective, MdcTopAppBarSectionDirective, MdcTopAppBarTitleDirective, NOTCHED_OUTLINE_DIRECTIVES, RADIO_DIRECTIVES, SELECT_DIRECTIVES, SLIDER_DIRECTIVES, SWITCH_DIRECTIVES, TAB_BAR_DIRECTIVES, TAB_DIRECTIVES, TAB_INDICATOR_DIRECTIVES, TAB_ROUTER_DIRECTIVES, TAB_SCROLLER_DIRECTIVES, TEXT_FIELD_DIRECTIVES, TOP_APP_BAR_DIRECTIVES, AbstractMdcIcon as ɵa, AbstractMdcInput as ɵb, AbstractMdcLabel as ɵc };

//# sourceMappingURL=blox-material.js.map